// This file is auto-generated by @hey-api/openapi-ts

import { z } from 'zod';

/**
 * AccessToken
 */
export const zAccessToken = z.object({
    access_token: z.string(),
    refresh_token: z.string(),
    token_type: z.literal('bearer')
});

/**
 * ActivateExecutivePayload
 */
export const zActivateExecutivePayload = z.object({
    login_email: z.string().nullish(),
    silent: z.boolean().optional().default(false)
});

/**
 * ActivityFeedCompanyRef
 *
 * A company reference on a B4B-source synthetic.
 *
 * Populated on ``kind=pipeline`` / ``kind=trending`` / ``kind=global_intro``
 * — the parent company of the introducing search team. The pipeline's
 * own name is deliberately *not* exposed to the exec (it is internal
 * B4B-side terminology); the exec sees the company that introduced
 * them instead.
 *
 * ``Company`` uses a bigint primary key (no ``uuid`` column), so the
 * routing identity is the ``slug``.
 */
export const zActivityFeedCompanyRef = z.object({
    id: z.number().int(),
    name: z.string().nullish(),
    slug: z.string().nullish()
});

/**
 * ActivityFeedEventRef
 *
 * An event reference on a ``kind=event`` synthetic.
 */
export const zActivityFeedEventRef = z.object({
    uuid: z.string().uuid(),
    title: z.string().nullish(),
    event_date: z.string().datetime().nullish()
});

/**
 * ActivityFeedParticipant
 *
 * A participant on a synthetic activity-feed row.
 *
 * Carries just enough identity for the webapp to render a clickable link
 * to the contact's profile and compose an i18n message. ``person_id``
 * routes to ``/people`` (B4B user) or ``/users`` (exec); ``candidate_uuid``
 * routes to ``/candidates``. Both may be set when the participant is a
 * candidate who also has a Person record.
 */
export const zActivityFeedParticipant = z.object({
    person_id: z.string().uuid().nullish(),
    candidate_uuid: z.string().uuid().nullish(),
    name: z.string().nullish()
});

/**
 * ActivityLogEventType
 */
export const zActivityLogEventType = z.enum(['PIPELINE_CREATED', 'COMMENT_ADDED_PIPELINE']);

/**
 * ActivityTimePeriod
 */
export const zActivityTimePeriod = z.enum([
    'per_quarter',
    'per_year',
    'as_needed'
]);

/**
 * AnnualBudgetRange
 */
export const zAnnualBudgetRange = z.enum([
    '<$100K',
    '$100K-$250K',
    '$250K-$500K',
    '$500K-$1M',
    '$1M-$5M',
    '$5M-$10M',
    '$10M-$100M',
    '>$100M'
]);

/**
 * AssetsManagedRange
 */
export const zAssetsManagedRange = z.enum([
    '<$100M',
    '$100M-$1B',
    '$1B-$10B',
    '>$10B'
]);

/**
 * AutotagPreviewQueued
 */
export const zAutotagPreviewQueued = z.object({
    task_id: z.string(),
    status: z.string().optional().default('queued'),
    status_url: z.string()
});

/**
 * AutotagPreviewRequest
 */
export const zAutotagPreviewRequest = z.object({
    call_notes: z.string().nullish(),
    notion_page_id: z.string().nullish(),
    email: z.string().nullish(),
    linkedin_url: z.string().nullish(),
    first_name: z.string().nullish(),
    last_name: z.string().nullish(),
    company: z.string().nullish()
});

/**
 * AutotagPreviewStatus
 */
export const zAutotagPreviewStatus = z.object({
    task_id: z.string(),
    state: z.string(),
    proposal: z.record(z.unknown()).nullish(),
    message: z.string().nullish(),
    error: z.string().nullish()
});

/**
 * Body_post_candidates_import_from_csv
 */
export const zBodyPostCandidatesImportFromCsv = z.object({
    file: z.string().nullish()
});

/**
 * Body_post_event_landing_image
 */
export const zBodyPostEventLandingImage = z.object({
    file: z.string()
});

/**
 * Body_post_files_image
 */
export const zBodyPostFilesImage = z.object({
    file: z.string()
});

/**
 * Body_post_files_linkedin_resume
 */
export const zBodyPostFilesLinkedinResume = z.object({
    file: z.string()
});

/**
 * Body_post_person_image
 */
export const zBodyPostPersonImage = z.object({
    image: z.string()
});

/**
 * Body_post_token
 */
export const zBodyPostToken = z.object({
    grant_type: z.string(),
    username: z.string().nullish(),
    password: z.string().nullish(),
    scope: z.string().optional().default(''),
    client_id: z.string().nullish(),
    client_secret: z.string().nullish(),
    expired_token: z.string().nullish(),
    refresh_token: z.string().nullish()
});

/**
 * Body_post_utils_mail_send
 */
export const zBodyPostUtilsMailSend = z.object({
    attachments: z.array(z.string()).nullish(),
    recipients: z.string(),
    template_id: z.string(),
    from_email: z.string(),
    from_name: z.string().nullish(),
    subject: z.string().nullish()
});

/**
 * BulkActivateExecutivePayload
 */
export const zBulkActivateExecutivePayload = z.object({
    candidate_uuids: z.array(z.string().uuid()).min(1),
    silent: z.boolean().optional().default(false)
});

/**
 * CandidateActivityEventType
 */
export const zCandidateActivityEventType = z.enum([
    'comment',
    'introduction_facilitated',
    'introduction_not_facilitated',
    'introduction_request',
    'not_liked',
    'not_liked_undo',
    'recommendation_added'
]);

/**
 * CandidateActivityLogEventType
 */
export const zCandidateActivityLogEventType = z.enum([
    'MODULE_CREATED',
    'MODULE_COMPLETED',
    'MODULE_DELETED',
    'MODULE_COMPLETED_UNDO',
    'TRENDING_CAMPAIGN_SCHEDULED',
    'TRENDING_CAMPAIGN_SENT',
    'INTRO_REQUESTED_TRENDING',
    'INTRO_COMPLETED_TRENDING',
    'INTRO_NOT_FACILITATED_TRENDING',
    'LIKED_TRENDING',
    'NOT_LIKED_TRENDING',
    'NOT_LIKED_UNDO_TRENDING',
    'P2P_SCHEDULED',
    'P2P_INTRO_MADE',
    'ADDED_TO_PIPELINE',
    'INTRO_REQUESTED_PIPELINE',
    'INTRO_COMPLETED_PIPELINE',
    'INTRO_NOT_REQUESTED_PIPELINE',
    'INTRO_NOT_FACILITATED_PIPELINE',
    'LIKED_PIPELINE',
    'NOT_LIKED_PIPELINE',
    'NOT_LIKED_UNDO_PIPELINE',
    'INTRO_REQUESTED_GLOBAL',
    'INTRO_COMPLETED_GLOBAL',
    'INTRO_NOT_FACILITATED_GLOBAL'
]);

/**
 * CandidateActivityLatestRecommendation
 */
export const zCandidateActivityLatestRecommendation = z.object({
    event_date: z.string().datetime(),
    event_type: zCandidateActivityLogEventType,
    recommendation_uuid: z.string().uuid(),
    activity_log_id: z.string().uuid().nullish()
});

/**
 * CandidateActivityLogEventTypeHidden
 */
export const zCandidateActivityLogEventTypeHidden = z.enum([
    'P2P_APPROVED',
    'P2P_DECLINED_ADVISOR',
    'P2P_INFO_NEEDED',
    'P2P_PUBLISHED'
]);

/**
 * CandidateActivityLogReferenceType
 */
export const zCandidateActivityLogReferenceType = z.enum([
    'EVALUATION_ACTION',
    'MODULE',
    'PEER',
    'PIPELINE',
    'SUBMISSION'
]);

/**
 * CandidateActivityLogPayload
 */
export const zCandidateActivityLogPayload = z.object({
    actor_id: z.string().uuid().nullish(),
    event_type: zCandidateActivityLogEventType,
    reference_id: z.string().uuid().nullish(),
    reference_type: zCandidateActivityLogReferenceType.nullish()
});

/**
 * CandidateActivityLogTotals
 */
export const zCandidateActivityLogTotals = z.object({
    all: z.number().int(),
    global: z.number().int().nullish().default(0),
    peer: z.number().int().nullish().default(0),
    pipelines: z.number().int().nullish().default(0),
    trending: z.number().int().nullish().default(0)
});

/**
 * CandidateAsyncImportResponse
 */
export const zCandidateAsyncImportResponse = z.object({
    detail: z.string().optional().default('Import started'),
    file_name: z.string().optional().default('')
});

/**
 * CandidateBasicResponse
 */
export const zCandidateBasicResponse = z.object({
    image: z.string().nullish(),
    name: z.string(),
    uuid: z.string().uuid(),
    profile_image_url: z.string().nullable()
});

/**
 * CandidateCompanyMetadataImportItem
 *
 * One metadata row to import. Frontend resolves ``candidate_uuid`` before upload.
 */
export const zCandidateCompanyMetadataImportItem = z.object({
    candidate_uuid: z.string().uuid(),
    custom_keywords: z.array(z.string()).optional(),
    custom_notes: z.string().nullish()
});

/**
 * CandidateCompanyMetadataImportPayload
 */
export const zCandidateCompanyMetadataImportPayload = z.object({
    rows: z.array(zCandidateCompanyMetadataImportItem).min(1)
});

/**
 * CandidateCompanyMetadataPayload
 */
export const zCandidateCompanyMetadataPayload = z.object({
    custom_keywords: z.array(z.string()).optional(),
    custom_notes: z.string().nullish()
});

/**
 * CandidateCompanyMetadataResponse
 */
export const zCandidateCompanyMetadataResponse = z.object({
    uuid: z.string().uuid(),
    candidate_uuid: z.string().uuid(),
    company_id: z.number().int(),
    custom_keywords: z.array(z.string()).optional(),
    custom_notes: z.string().nullish(),
    created: z.string().datetime(),
    last_modified: z.string().datetime()
});

/**
 * CandidateComparePerformanceResponse
 */
export const zCandidateComparePerformanceResponse = z.object({
    candidate_uuid: z.string().uuid(),
    name: z.string(),
    image: z.string().nullish(),
    intro_completed: z.number().int(),
    intro_requests: z.number().int(),
    not_interesting: z.number().int(),
    trendings: z.number().int(),
    pipelines: z.number().int()
});

/**
 * CandidateFavoritePayload
 */
export const zCandidateFavoritePayload = z.object({
    is_favorite: z.boolean()
});

/**
 * CandidateFavoriteResponse
 */
export const zCandidateFavoriteResponse = z.object({
    id: z.number().int(),
    is_favorite: z.boolean(),
    uuid: z.string().uuid()
});

/**
 * CandidateFeedbackFilterPayload
 */
export const zCandidateFeedbackFilterPayload = z.object({
    phrase: z.string().nullish(),
    search_id: z.string().nullish(),
    page: z.number().int().gte(1).optional().default(1),
    page_size: z.number().int().gte(1).lte(1000).optional().default(-1)
});

/**
 * CandidateFeedbackPayload
 */
export const zCandidateFeedbackPayload = z.object({
    candidate_uuid: z.string().uuid().nullish(),
    comment: z.string().min(1),
    company_id: z.number().int().nullish(),
    company_name: z.string().min(1).nullish(),
    person_email: z.string().email().nullish(),
    person_first_name: z.string().nullish(),
    person_last_name: z.string().nullish(),
    from_identity_uuid: z.string().uuid().nullish(),
    person_id: z.string().uuid().nullish(),
    recommendation_uuid: z.string().uuid().nullish(),
    team_uuid: z.string().uuid().nullish()
});

/**
 * CandidateGoalActivitiesPayload
 */
export const zCandidateGoalActivitiesPayload = z.object({
    activities_uuids: z.array(z.string().uuid()).nullable(),
    reference_id: z.string().uuid().nullish(),
    reference_type: zCandidateActivityLogReferenceType.nullish()
});

/**
 * CandidateGoalNotes
 */
export const zCandidateGoalNotes = z.object({
    text: z.string()
});

/**
 * CandidateGoalsLegacyPayload
 */
export const zCandidateGoalsLegacyPayload = z.object({
    long_term: z.string().nullish(),
    short_term: z.string().nullish()
});

/**
 * CandidateHighlight
 */
export const zCandidateHighlight = z.object({
    highlight: z.string().min(1),
    uuid: z.string().uuid().nullish()
});

/**
 * CandidateHighlightCreate
 */
export const zCandidateHighlightCreate = z.object({
    highlight: z.string().min(1)
});

/**
 * CandidateHighlightResponse
 */
export const zCandidateHighlightResponse = z.object({
    highlight: z.string(),
    selected: z.boolean(),
    uuid: z.string().uuid()
});

/**
 * CandidateIntroductionTemplateCreate
 */
export const zCandidateIntroductionTemplateCreate = z.object({
    body: z.string().min(1).max(5000),
    title: z.string().min(1).max(128)
});

/**
 * CandidateIntroductionTemplatePayload
 */
export const zCandidateIntroductionTemplatePayload = z.object({
    body: z.string().min(1).max(5000),
    title: z.string().min(1).max(128),
    uuid: z.string().uuid().nullish()
});

/**
 * CandidateCommentary
 */
export const zCandidateCommentary = z.object({
    highlights: z.array(zCandidateHighlight),
    introduction_templates: z.array(zCandidateIntroductionTemplatePayload)
});

/**
 * CandidateIntroductionTemplateResponse
 */
export const zCandidateIntroductionTemplateResponse = z.object({
    body: z.string().min(1).max(5000),
    title: z.string().min(1).max(128),
    last_modified: z.string().datetime(),
    created: z.string().datetime(),
    hidden: z.boolean(),
    soft_delete: z.boolean(),
    uuid: z.string().uuid()
});

/**
 * CandidateLinkedPersonResponse
 */
export const zCandidateLinkedPersonResponse = z.object({
    uuid: z.string().uuid(),
    email: z.string(),
    first_name: z.string().nullish(),
    last_name: z.string().nullish(),
    name: z.string().nullish(),
    invited: z.boolean(),
    registered: z.boolean(),
    pending: z.boolean()
});

/**
 * CandidateMergePayload
 */
export const zCandidateMergePayload = z.object({
    source_candidate_uuid: z.string().uuid(),
    dry_run: z.boolean().optional().default(false)
});

/**
 * CandidateMergeResponse
 *
 * What a candidate merge would do (dry run), did (applied) or why it was
 * refused (blockers). Same shape in all three cases.
 */
export const zCandidateMergeResponse = z.object({
    applied: z.boolean(),
    source_uuid: z.string().uuid(),
    target_uuid: z.string().uuid(),
    blockers: z.array(z.string()).optional().default([]),
    counts_before: z.record(z.number().int()).optional().default({}),
    moved: z.record(z.number().int()).optional().default({}),
    dropped_as_duplicate: z.record(z.number().int()).optional().default({}),
    self_peers_dropped: z.number().int().optional().default(0),
    identity: z.record(z.unknown()).optional().default({}),
    merged_into_uuid: z.string().uuid().nullish(),
    es_task_id: z.string().nullish()
});

/**
 * CandidatePathway
 *
 * Banff client pathways (API/DB values are lowercase snake_case).
 */
export const zCandidatePathway = z.enum([
    'transition_services',
    'network_services',
    'concierge',
    'banff_access',
    'pro_bono'
]);

/**
 * CandidatePeerPerformanceComparisonResponse
 */
export const zCandidatePeerPerformanceComparisonResponse = z.object({
    candidate: zCandidateComparePerformanceResponse,
    peer: zCandidateComparePerformanceResponse
});

/**
 * CandidatePerformanceSortColumn
 */
export const zCandidatePerformanceSortColumn = z.enum([
    'days_to_quarterly',
    'recommendation_count',
    'request_count',
    'total_facilitated',
    'pipeline_count',
    'full_name',
    'advisor_name'
]);

/**
 * CandidatePipelineStatus
 *
 * Pipeline status that combines RecommendationDraftMode and RecommendationStatus.
 *
 * This enum represents the combined state of a recommendation/submission candidate:
 * - Draft modes (when status=DRAFT): APPROVED, DENIED, READY_FOR_REVIEW, SUGGESTED
 * - Published states: PUBLISHED, SCHEDULED
 * - Draft state: DRAFT (when no specific draft mode is set)
 */
export const zCandidatePipelineStatus = z.enum([
    'approved',
    'denied',
    'ready_for_review',
    'suggested',
    'saved',
    'published',
    'scheduled',
    'undefined'
]);

/**
 * CandidateRecommendationAggregations
 */
export const zCandidateRecommendationAggregations = z.object({
    intro_requests: z.number().int(),
    intro_completed: z.number().int(),
    not_interesting: z.number().int(),
    no_action: z.number().int()
});

/**
 * CandidateShareResponse
 */
export const zCandidateShareResponse = z.object({
    company: z.string().nullish(),
    role: z.string().nullish(),
    image: z.string().nullish(),
    is_client: z.boolean(),
    linkedin_url: z.string().nullish(),
    name: z.string(),
    uuid: z.string().uuid()
});

/**
 * CandidateShowOnboardingSection
 */
export const zCandidateShowOnboardingSection = z.object({
    show_onboarding_section: z.boolean()
});

/**
 * CandidateTasksFilterPayload
 */
export const zCandidateTasksFilterPayload = z.object({
    page: z.number().int().gte(1).optional().default(1),
    page_size: z.number().int().gte(1).lte(1000).optional().default(-1),
    with_goals: z.boolean().nullish()
});

/**
 * CandidateTier
 */
export const zCandidateTier = z.enum([
    'executive_client',
    'former_executive_client',
    'executive_client_1st_degree_referral',
    'executive_client_2nd_degree_referral',
    'advisor_network',
    'enterprise_partner_1st_degree_referral',
    'research',
    'b4b',
    'external'
]);

/**
 * CandidateCompanyRoleResponse
 */
export const zCandidateCompanyRoleResponse = z.object({
    is_client: z.boolean(),
    company: z.string().nullish(),
    role: z.string().nullish(),
    image: z.string().nullish(),
    name: z.string(),
    uuid: z.string().uuid(),
    tier: zCandidateTier,
    profile_image_url: z.string().nullable()
});

/**
 * CandidateType
 *
 * Goal program values used by candidate_goals.program.
 */
export const zCandidateType = z.enum([
    'board_member_aspiring',
    'job_seeker_active',
    'job_seeker_passive',
    'network_builder',
    'new_role_leader',
    'uploaded_network'
]);

/**
 * CandidateUpdateActive
 */
export const zCandidateUpdateActive = z.object({
    active: z.boolean()
});

/**
 * CandidateViewPayload
 */
export const zCandidateViewPayload = z.object({
    has_viewed_activity: z.boolean()
});

/**
 * CandidatesCombinedPerformanceSortColumn
 */
export const zCandidatesCombinedPerformanceSortColumn = z.enum([
    'rank',
    'recommendation_count',
    'request_count',
    'total_facilitated',
    'pipeline_count',
    'peer_activity_count',
    'full_name',
    'advisor_name',
    'type'
]);

/**
 * CandidatesPerformanceFilters
 */
export const zCandidatesPerformanceFilters = z.object({
    advisor_id: z.array(z.string()).nullish()
});

/**
 * CandidatesSortColumn
 */
export const zCandidatesSortColumn = z.enum([
    'advisor_name',
    'current_company',
    '',
    'name',
    'interest_role_board_advisory',
    'interest_role_operating',
    'invoice_status',
    'profile_updated',
    'role',
    'tier'
]);

/**
 * ClerkUserPublicMetadataUpdate
 */
export const zClerkUserPublicMetadataUpdate = z.object({
    onboarding_complete: z.boolean()
});

/**
 * ClientType
 *
 * Client types stored on contender_candidate.type.
 */
export const zClientType = z.enum([
    'private_advisor',
    'positioner_services',
    'brand_strategic_identity',
    'portage_main'
]);

/**
 * CommentPayload
 */
export const zCommentPayload = z.object({
    content: z.string().min(1).max(500),
    team_uuids: z.array(z.string().uuid()).nullish().default([])
});

/**
 * CompaniesFilter
 */
export const zCompaniesFilter = z.enum([
    'all',
    'corporate',
    'free',
    'investor',
    'premium',
    'search'
]);

/**
 * CompaniesSortColumn
 */
export const zCompaniesSortColumn = z.enum([
    'name',
    'payment_status',
    'type',
    'users_count',
    'teams_count'
]);

/**
 * CompaniesSorter
 */
export const zCompaniesSorter = z.enum([
    '',
    'name',
    'status',
    'teams',
    'type',
    'users'
]);

/**
 * CompanyBasicResponse
 */
export const zCompanyBasicResponse = z.object({
    id: z.number().int(),
    name: z.string().nullable(),
    slug: z.string()
});

/**
 * CompanyOwnership
 */
export const zCompanyOwnership = z.enum([
    'Nonprofit',
    'Private',
    'Public',
    'Government'
]);

/**
 * CompanyPeopleCandidateSummary
 */
export const zCompanyPeopleCandidateSummary = z.object({
    uuid: z.string().uuid(),
    name: z.string(),
    role: z.string().nullish(),
    company: z.string().nullish(),
    image: z.string().nullish(),
    is_client: z.boolean(),
    email: z.string().nullish()
});

/**
 * CandidateCompanyMetadataWithCandidateResponse
 */
export const zCandidateCompanyMetadataWithCandidateResponse = z.object({
    uuid: z.string().uuid(),
    candidate_uuid: z.string().uuid(),
    company_id: z.number().int(),
    custom_keywords: z.array(z.string()).optional(),
    custom_notes: z.string().nullish(),
    created: z.string().datetime(),
    last_modified: z.string().datetime(),
    candidate: zCompanyPeopleCandidateSummary
});

/**
 * CompanyPeopleRecommendationType
 */
export const zCompanyPeopleRecommendationType = z.enum(['pipeline', 'trending']);

/**
 * CompanyPeopleScope
 */
export const zCompanyPeopleScope = z.enum([
    'all',
    'shared',
    'metadata_only'
]);

/**
 * CompanyPeopleSortColumn
 */
export const zCompanyPeopleSortColumn = z.enum([
    'name',
    'last_modified',
    'company_team_status',
    'recommendations_count'
]);

/**
 * CompanyPeopleTotalCounts
 */
export const zCompanyPeopleTotalCounts = z.object({
    all: z.number().int(),
    shared: z.number().int(),
    metadata_only: z.number().int(),
    both: z.number().int(),
    team_status_none: z.number().int()
});

/**
 * CompanyPermissions
 */
export const zCompanyPermissions = z.enum([
    'people',
    'pipelines',
    'trending'
]);

/**
 * CompanySector
 *
 * Attributes
 * ----------
 * name : str
 * sector name
 * code : str
 * ICB Sector code
 */
export const zCompanySector = z.object({
    code: z.string(),
    sector: z.string()
});

/**
 * CompanySize
 */
export const zCompanySize = z.enum([
    'under_10m',
    'from_10m_to_50m',
    'from_50m_to_100m',
    'from_100m_to_500m',
    'from_500m_to_1b',
    'from_1b_to_5b',
    'from_5b_to_10b',
    'from_10b_to_50b',
    'from_50b_to_100b',
    'above_100b'
]);

/**
 * CompanyStage
 */
export const zCompanyStage = z.enum([
    'Seed',
    'Early Stage',
    'Established',
    'Pre-IPO/Growth'
]);

/**
 * CompanyTagAssociationCreatePayload
 *
 * Exactly one of ``tag_definition_uuid`` (existing) or ``name`` (create + link).
 */
export const zCompanyTagAssociationCreatePayload = z.object({
    tag_definition_uuid: z.string().uuid().nullish(),
    name: z.string().min(1).max(255).nullish()
});

/**
 * CompanyTagDefinitionResponse
 */
export const zCompanyTagDefinitionResponse = z.object({
    uuid: z.string().uuid(),
    name: z.string(),
    created: z.string().datetime(),
    last_modified: z.string().datetime(),
    usage_count: z.number().int().nullish()
});

/**
 * CompanyTagOnContactResponse
 *
 * After adding a tag to a company candidate.
 */
export const zCompanyTagOnContactResponse = z.object({
    association_uuid: z.string().uuid(),
    tag_definition_uuid: z.string().uuid(),
    name: z.string()
});

/**
 * CompanyTeamMemberResponse
 *
 * Team member information for company response
 */
export const zCompanyTeamMemberResponse = z.object({
    id: z.number().int(),
    role: z.string(),
    person_id: z.string().uuid(),
    is_admin: z.boolean().optional().default(false),
    permit_preregistration_notifications: z.boolean().optional().default(false),
    created: z.string().datetime().nullish()
});

/**
 * CompanyType
 */
export const zCompanyType = z.enum([
    'nonprofit',
    'other',
    'private',
    'public'
]);

/**
 * CompanyUserBasicResponse
 *
 * Basic user information for company response
 */
export const zCompanyUserBasicResponse = z.object({
    id: z.string().uuid(),
    email: z.string(),
    first_name: z.string().nullish(),
    last_name: z.string().nullish(),
    is_admin: z.boolean().optional().default(false),
    permit_preregistration_notifications: z.boolean().optional().default(false),
    created: z.string().datetime().nullish()
});

/**
 * ConnectionStatus
 */
export const zConnectionStatus = z.enum([
    'is_favorite',
    'introduced',
    'introduction_pending'
]);

/**
 * Contact
 */
export const zContact = z.object({
    linkedin: z.string()
});

/**
 * ContactFavoriteResponse
 */
export const zContactFavoriteResponse = z.object({
    contact_uuid: z.string().uuid(),
    is_favorite: z.boolean()
});

/**
 * ContactListsPushResponse
 */
export const zContactListsPushResponse = z.object({
    list_names: z.array(z.string())
});

/**
 * ContactSearchResult
 *
 * One human in the merged person+candidate typeahead.
 *
 * The row carries the identity only, not the login or candidate profile it
 * was found through, so a form that asks "who" can only store the identity
 * (BAN-6065).
 */
export const zContactSearchResult = z.object({
    identity_uuid: z.string().uuid(),
    full_name: z.string().nullish(),
    email: z.string().nullish(),
    image: z.string().nullish(),
    company_name: z.string().nullish(),
    title: z.string().nullish()
});

/**
 * ContactSourceType
 *
 * Source of a contact on the executive client people page.
 */
export const zContactSourceType = z.enum([
    'b4b_intro',
    'event',
    'p2p_intro',
    'referral'
]);

/**
 * ContactEvidenceResponse
 *
 * Debug trace of why a contact appears on the people page.
 *
 * Temporary — will be removed once the people-list rollout is verified.
 */
export const zContactEvidenceResponse = z.object({
    source: zContactSourceType,
    ref_uuid: z.string().uuid().nullish(),
    url: z.string().nullish(),
    subtype: z.string().nullish()
});

/**
 * ContactType
 *
 * Who put the role in front of the client — which is not always a firm.
 *
 * `search_firm_name` answers "who is running this search", and a third of the
 * historical values given for it are not firms at all: "Direct", "(internal
 * recruiter)", "Internal TA" all mean the company approached the client
 * itself. Left as text they never resolve, and they turn up in any ranking of
 * "which firms approach our clients" — a caveat in a retrieval skill would be
 * a request, not a guarantee, so the distinction is a column.
 *
 * Banff relaying a role an advisor heard about is deliberately NOT a contact
 * type here: that answers "how did we learn", which is `reported_by_person_id`.
 */
export const zContactType = z.enum(['search_firm', 'company_itself']);

/**
 * CountriesResponse
 */
export const zCountriesResponse = z.object({
    countries: z.array(z.string())
});

/**
 * CreateClerkUserRequest
 */
export const zCreateClerkUserRequest = z.object({
    password: z.string().min(8),
    first_name: z.string(),
    last_name: z.string(),
    onboarding_complete: z.boolean().optional().default(false),
    suppress_welcome_email: z.boolean().optional().default(false)
});

/**
 * CurrentESIndexResponse
 */
export const zCurrentEsIndexResponse = z.object({
    index_name: z.string().nullish(),
    index_alias: z.string(),
    docs_count: z.number().int(),
    created_at: z.string().datetime().nullish()
});

/**
 * DeclinedStatusFilter
 */
export const zDeclinedStatusFilter = z.enum(['declined', 'not_declined']);

/**
 * DeleteHighlightResponse
 */
export const zDeleteHighlightResponse = z.object({
    highlight: z.string(),
    created: z.string().datetime(),
    last_modified: z.string().datetime(),
    hidden: z.boolean(),
    soft_delete: z.boolean(),
    uuid: z.string().uuid()
});

/**
 * ESMeta
 */
export const zEsMeta = z.object({
    id: z.string().nullish(),
    index: z.string().nullish(),
    __highlights__: z.record(z.string()).nullish()
});

/**
 * ESClickEventPayload
 */
export const zEsClickEventPayload = z.object({
    search_id: z.string(),
    query: z.string(),
    document: zEsMeta,
    url: z.string()
});

/**
 * EmailCategory
 *
 * A group of email types, e.g. everything about events. Only events are
 * sorted so far; other email types have no category yet.
 */
export const zEmailCategory = z.enum(['events']);

/**
 * EmailEventType
 */
export const zEmailEventType = z.enum([
    'admin_new_pipeline',
    'invitation_clerk',
    'new_pipeline_submission',
    'p2p_introduction',
    'p2p_notification',
    'person_welcome',
    'requested_candidate_introduction',
    'auto_introduction',
    'auto_introduction_checkin',
    'resend_invitation_clerk',
    'share_recommendations',
    'summary',
    'team_new_pipeline',
    'trending_stream',
    'recommendation_draft_status_change',
    'event_invite',
    'event_rsvp_confirmation_accepted',
    'event_rsvp_confirmation_declined',
    'event_rsvp_reminder',
    'event_announcement',
    'executive_invitation_clerk'
]);

/**
 * EmailPreviewResponse
 *
 * A template variant rendered with sample values.
 */
export const zEmailPreviewResponse = z.object({
    subject: z.string(),
    html: z.string()
});

/**
 * EmailPreviewSummary
 *
 * One template variant of an email type that Tools can preview.
 */
export const zEmailPreviewSummary = z.object({
    key: z.string(),
    template: z.string(),
    name: z.string(),
    variant: z.string().nullish()
});

/**
 * EmailTemplateDefaultPayload
 *
 * The text of a type's default template.
 */
export const zEmailTemplateDefaultPayload = z.object({
    subject: z.string().min(1).max(512),
    body: z.string().min(1),
    name: z.string().max(256).nullish(),
    description: z.string().nullish()
});

/**
 * EmailTemplateType
 *
 * Type of email template (e.g. event invite, RSVP confirmation).
 */
export const zEmailTemplateType = z.enum([
    'event_invite',
    'event_rsvp_confirmation_accepted',
    'event_rsvp_confirmation_declined',
    'event_rsvp_reminder',
    'event_announcement'
]);

/**
 * EmailTemplateCreatePayload
 *
 * Payload for creating an email template.
 */
export const zEmailTemplateCreatePayload = z.object({
    template_type: zEmailTemplateType,
    subject: z.string().min(1).max(512),
    body: z.string().min(1),
    name: z.string().max(256).nullish(),
    description: z.string().nullish()
});

/**
 * EmailTemplateResponse
 *
 * Email template as returned by the API. Includes allowed_placeholders for substitution.
 */
export const zEmailTemplateResponse = z.object({
    uuid: z.string().uuid(),
    template_type: zEmailTemplateType,
    subject: z.string(),
    body: z.string(),
    name: z.string().nullish(),
    description: z.string().nullish(),
    event_uuid: z.string().uuid().nullish(),
    hidden: z.boolean().optional().default(false),
    created_at: z.string().datetime(),
    updated_at: z.string().datetime(),
    created_by_person_uuid: z.string().uuid().nullish(),
    allowed_placeholders: z.array(z.string()).optional(),
    category: zEmailCategory.nullish()
});

/**
 * EmailTemplateDefaultResponse
 *
 * The default template of one type.
 */
export const zEmailTemplateDefaultResponse = z.object({
    template_type: zEmailTemplateType,
    email_template: zEmailTemplateResponse
});

/**
 * EmailTemplateUpdatePayload
 *
 * Payload for updating an email template (all fields optional).
 */
export const zEmailTemplateUpdatePayload = z.object({
    template_type: zEmailTemplateType.nullish(),
    subject: z.string().min(1).max(512).nullish(),
    body: z.string().min(1).nullish(),
    name: z.string().max(256).nullish(),
    description: z.string().nullish()
});

/**
 * EmailTypeResponse
 *
 * One kind of email Contender sends.
 */
export const zEmailTypeResponse = z.object({
    type: zEmailEventType,
    category: zEmailCategory.nullish(),
    internal: z.boolean(),
    editable: z.boolean(),
    placeholders: z.array(z.string()).optional(),
    previews: z.array(zEmailPreviewSummary).optional()
});

/**
 * EvaluationAction
 */
export const zEvaluationAction = z.enum([
    'commented',
    'completed',
    'facilitated',
    'favorited',
    'favorited_undo',
    'introduction_not_facilitated',
    'introduction_not_requested',
    'not_liked',
    'not_liked_undo',
    'recommendation_added',
    'recommendation_draft_approved',
    'recommendation_draft_denied',
    'recommendation_draft_ready_for_review',
    'recommendation_draft_suggested',
    'recommendation_draft_saved',
    'scored',
    'viewed'
]);

/**
 * EventCategory
 *
 * Event category/tag for the events feature.
 */
export const zEventCategory = z.enum([
    'co_host',
    'conference',
    'dinner',
    'panel',
    'partner',
    'webinar'
]);

/**
 * EventCreatePayload
 *
 * Payload for creating an event.
 */
export const zEventCreatePayload = z.object({
    title: z.string().min(1).max(512),
    categories: z.array(zEventCategory).nullish(),
    category: zEventCategory.nullish(),
    description: z.string().nullish(),
    event_date: z.string().datetime().nullish(),
    event_timezone: z.string().max(64).nullish(),
    location: z.string().max(512).nullish(),
    max_participants: z.number().int().gte(1).lte(32767).nullish(),
    additional_link: z.string().max(1024).nullish(),
    draft: z.boolean().optional().default(true),
    rsvp_enabled: z.boolean().optional().default(true),
    notes: z.string().nullish(),
    invite_sender_email: z.string().email().max(320).nullish(),
    invite_sender_name: z.string().max(256).nullish()
});

/**
 * EventEmailPreviewPayload
 *
 * Preview any event email: a saved template (the event's own or a shared
 * default), optionally with edited text, or unsaved text of a given type.
 */
export const zEventEmailPreviewPayload = z.object({
    email_template_uuid: z.string().uuid().nullish(),
    template_type: zEmailTemplateType.nullish(),
    subject: z.string().max(512).nullish(),
    body: z.string().nullish(),
    email: z.string().nullish()
});

/**
 * EventEmailTemplateCreatePayload
 *
 * Payload for adding a template to an event.
 */
export const zEventEmailTemplateCreatePayload = z.object({
    template_type: zEmailTemplateType,
    subject: z.string().min(1).max(512),
    body: z.string().min(1),
    name: z.string().max(256).nullish(),
    description: z.string().nullish()
});

/**
 * EventEmailTemplateUpdatePayload
 *
 * Payload for editing an event's template (all fields optional). The type
 * cannot change.
 */
export const zEventEmailTemplateUpdatePayload = z.object({
    subject: z.string().min(1).max(512).nullish(),
    body: z.string().min(1).nullish(),
    name: z.string().max(256).nullish(),
    description: z.string().nullish()
});

/**
 * EventGuestClientType
 *
 * Client-type classification for event guests, mirroring the users-table
 * company-type breakdown (see `OrgType`, `UserType`, and webapp's
 * `useOptionsCompanyType`).
 *
 * A guest whose person has a role at a company of a given enterprise
 * OrgType (SEARCH, INVESTOR, CORPORATE, ADVISORY) carries that value
 * (possibly several, for multi-role guests) -- this wins over candidate
 * linkage. A guest with a `candidate_uuid` and no such enterprise role is
 * EXECUTIVE. A guest with neither (standalone guests, roleless person
 * guests) is unclassified and carries none of these values.
 */
export const zEventGuestClientType = z.enum([
    'executive',
    'search',
    'investor',
    'corporate',
    'advisory'
]);

/**
 * EventGuestStatus
 *
 * Status of a guest for an event.
 */
export const zEventGuestStatus = z.enum([
    'cant_go',
    'going',
    'invited',
    'need_invite'
]);

/**
 * AddGuestItem
 *
 * One guest to add to an event. Provide person_uuid, candidate_uuid, or standalone fields.
 */
export const zAddGuestItem = z.object({
    person_uuid: z.string().uuid().nullish(),
    candidate_uuid: z.string().uuid().nullish(),
    guest_first_name: z.string().max(64).nullish(),
    guest_last_name: z.string().max(64).nullish(),
    guest_role: z.string().max(256).nullish(),
    guest_company: z.string().max(256).nullish(),
    guest_email: z.string().email().max(256).nullish(),
    status: zEventGuestStatus.nullish(),
    invite_sent_at: z.string().datetime().nullish()
});

/**
 * AddGuestsPayload
 *
 * Payload for adding guests to an event.
 */
export const zAddGuestsPayload = z.object({
    guests: z.array(zAddGuestItem).min(1)
});

/**
 * EventGuestPatchPayload
 *
 * Banff Admin payload to update an event guest (e.g. RSVP / invite status).
 */
export const zEventGuestPatchPayload = z.object({
    status: zEventGuestStatus
});

/**
 * EventGuestRsvpSummary
 *
 * Guest summary for RSVP landing: display name and current status.
 */
export const zEventGuestRsvpSummary = z.object({
    name: z.string().nullish(),
    status: zEventGuestStatus
});

/**
 * EventGuestTotalCounts
 */
export const zEventGuestTotalCounts = z.object({
    all: z.number().int(),
    need_invite: z.number().int(),
    invited: z.number().int(),
    going: z.number().int(),
    cant_go: z.number().int()
});

/**
 * EventGuestsBulkStatusPayload
 *
 * Set one status on many guests of an event.
 */
export const zEventGuestsBulkStatusPayload = z.object({
    guest_uuids: z.array(z.string().uuid()).min(1),
    status: zEventGuestStatus
});

/**
 * EventGuestsSelectionPayload
 *
 * Filters resolving the full matching guest set (select-all).
 */
export const zEventGuestsSelectionPayload = z.object({
    status: zEventGuestStatus.nullish(),
    client_type: z.array(zEventGuestClientType).nullish(),
    phrase: z.string().nullish()
});

/**
 * EventGuestsSortColumn
 *
 * Sort columns for GET /events/{event_uuid}/guests.
 *
 * No RELEVANCE value on purpose: best-match ranking is never a value a
 * client can request. It's the implicit default when a search `phrase` is
 * present and `sort` is omitted -- see get_event_guests / documentation.
 */
export const zEventGuestsSortColumn = z.enum([
    'created',
    'name',
    'status'
]);

/**
 * EventRsvpPublicResponse
 *
 * Event details for the public RSVP landing page (no internal fields).
 */
export const zEventRsvpPublicResponse = z.object({
    uuid: z.string().uuid(),
    title: z.string(),
    categories: z.array(zEventCategory),
    category: zEventCategory.nullish(),
    description: z.string().nullish(),
    event_date: z.string().datetime().nullish(),
    event_timezone: z.string().nullish(),
    event_date_local: z.string().datetime().nullish(),
    location: z.string().nullish(),
    max_participants: z.number().int().nullish(),
    additional_link: z.string().nullish(),
    draft: z.boolean().optional().default(false),
    rsvp_enabled: z.boolean().optional().default(true),
    landing_image: z.string().nullish()
});

/**
 * EventRsvpLandingResponse
 *
 * Response for GET RSVP by token: event details + guest so front can show landing and form.
 */
export const zEventRsvpLandingResponse = z.object({
    event: zEventRsvpPublicResponse,
    guest: zEventGuestRsvpSummary,
    is_preview: z.boolean().optional().default(false),
    event_is_draft: z.boolean().optional().default(false)
});

/**
 * EventTypeFilter
 */
export const zEventTypeFilter = z.enum([
    'global',
    'peer',
    'pipeline',
    'trending'
]);

/**
 * EventUpdatePayload
 *
 * Payload for updating an event (all fields optional).
 */
export const zEventUpdatePayload = z.object({
    title: z.string().min(1).max(512).nullish(),
    categories: z.array(zEventCategory).nullish(),
    category: zEventCategory.nullish(),
    description: z.string().nullish(),
    event_date: z.string().datetime().nullish(),
    event_timezone: z.string().max(64).nullish(),
    location: z.string().max(512).nullish(),
    max_participants: z.number().int().gte(1).lte(32767).nullish(),
    additional_link: z.string().max(1024).nullish(),
    draft: z.boolean().nullish(),
    rsvp_enabled: z.boolean().nullish(),
    notes: z.string().nullish(),
    invite_email_subject: z.string().max(512).nullish(),
    invite_email_body: z.string().nullish(),
    invite_sender_email: z.string().email().max(320).nullish(),
    invite_sender_name: z.string().max(256).nullish()
});

/**
 * ExecutiveAccessLevel
 */
export const zExecutiveAccessLevel = z.enum(['full', 'readonly']);

/**
 * ExecutiveActivityFilter
 */
export const zExecutiveActivityFilter = z.object({
    kinds: z.array(z.enum([
        'activity_log',
        'event',
        'peer',
        'pipeline',
        'trending',
        'global_intro',
        'referral',
        'comment'
    ])).nullish(),
    page: z.number().int().gte(1).optional().default(1),
    size: z.number().int().gte(1).lte(1000).optional().default(20)
});

/**
 * ExecutiveClientEventAttendee
 *
 * A fellow attendee shown to an executive client on their event view.
 *
 * Only attendees the exec already knows (in their People collection) are
 * listed for upcoming events; everyone who attended is listed for past
 * events. PII beyond name/role/company is intentionally omitted — use the
 * People page for full contact detail.
 */
export const zExecutiveClientEventAttendee = z.object({
    identity_uuid: z.string().uuid().nullish(),
    person_uuid: z.string().uuid().nullish(),
    candidate_uuid: z.string().uuid().nullish(),
    full_name: z.string().nullish(),
    current_role: z.string().nullish(),
    current_company: z.string().nullish(),
    profile_img: z.string().nullish(),
    profile_image_url: z.string().nullable()
});

/**
 * ExecutiveClientEventListItem
 *
 * One event in an executive client's event list.
 *
 * Lighter than :class:`ExecutiveClientEventResponse`: same event info and
 * the exec's own RSVP status, plus headline attendee counts — but no
 * per-attendee detail. For upcoming events, ``known_attendees_count`` and
 * ``other_attendees_count`` follow the same People-collection rules as the
 * detail endpoint.
 */
export const zExecutiveClientEventListItem = z.object({
    event: zEventRsvpPublicResponse,
    my_status: zEventGuestStatus,
    is_past: z.boolean(),
    shows_attendees: z.boolean(),
    going_count: z.number().int().gte(0).optional().default(0),
    known_attendees_count: z.number().int().gte(0).optional().default(0),
    other_attendees_count: z.number().int().gte(0).optional().default(0)
});

/**
 * ExecutiveClientEventResponse
 *
 * Event detail for an external executive client who is a guest.
 *
 * Attendee visibility:
 * - Webinars never show attendees (``shows_attendees=False``).
 * - Upcoming events list only RSVP'd (going) attendees the exec already
 * knows (i.e. in their People collection independent of this event), plus
 * a count of the remaining RSVP'd attendees in ``other_attendees_count``.
 * - Past events list everyone who attended (all become contacts), and
 * ``other_attendees_count`` is 0.
 */
export const zExecutiveClientEventResponse = z.object({
    event: zEventRsvpPublicResponse,
    my_status: zEventGuestStatus,
    is_past: z.boolean(),
    shows_attendees: z.boolean(),
    attendees: z.array(zExecutiveClientEventAttendee).optional(),
    other_attendees_count: z.number().int().gte(0).optional().default(0)
});

/**
 * ExecutiveClientRsvpUpdatePayload
 *
 * Payload for the exec-scoped RSVP PATCH: just the new status.
 *
 * Auth/identity come from the route (executive access + path person), so no
 * token is needed unlike the public RSVP flow.
 */
export const zExecutiveClientRsvpUpdatePayload = z.object({
    status: z.enum(['going', 'cant_go'])
});

/**
 * ExecutiveClientSettingsResponse
 */
export const zExecutiveClientSettingsResponse = z.object({
    person_uuid: z.string().uuid(),
    first_name: z.string().nullish(),
    last_name: z.string().nullish(),
    email: z.string(),
    candidate_uuid: z.string().uuid().nullish(),
    receive_trending_emails: z.boolean(),
    receive_pipeline_emails: z.boolean(),
    access_level: z.string(),
    payment_status: z.string(),
    hiring_pipeline_limit: z.number().int()
});

/**
 * ExecutivePaymentStatus
 */
export const zExecutivePaymentStatus = z.enum(['free', 'premium']);

/**
 * ExecutivePeopleAggregationsResponse
 *
 * Faceted counts for the exec people page filters (BAN-5769).
 *
 * Each dimension is ``{value: count}`` over the phrase-matched contact set
 * with all *other* active filters applied (exclude-self faceting), so sibling
 * counts stay visible after a multi-select. uuid/id-keyed dimensions
 * (``company_id`` / ``event_uuid``) are resolved to display names by the
 * webapp. Follows the ``PotentialGuestsAggregationsResponse`` convention.
 */
export const zExecutivePeopleAggregationsResponse = z.object({
    source_type: z.record(z.number().int()).optional(),
    company_type: z.record(z.number().int()).optional(),
    industry_expertise: z.record(z.number().int()).optional(),
    function_expertise: z.record(z.number().int()).optional(),
    company_id: z.record(z.number().int()).optional(),
    event_uuid: z.record(z.number().int()).optional(),
    connection_status: z.record(z.number().int()).optional(),
    personal_tag_uuid: z.record(z.number().int()).optional(),
    labels: z.record(z.record(z.string())).optional()
});

/**
 * ExecutiveSettingsResponse
 */
export const zExecutiveSettingsResponse = z.object({
    uuid: z.string().uuid(),
    access_level: z.string(),
    invitation_status: z.string(),
    payment_status: z.string(),
    hiring_pipeline_limit: z.number().int(),
    receive_trending_emails: z.boolean(),
    receive_pipeline_emails: z.boolean(),
    content_access_level: z.string().nullish()
});

/**
 * ExecutiveResponse
 */
export const zExecutiveResponse = z.object({
    person_uuid: z.string().uuid(),
    email: z.string(),
    first_name: z.string().nullish(),
    last_name: z.string().nullish(),
    candidate_uuid: z.string().uuid().nullish(),
    settings: zExecutiveSettingsResponse
});

/**
 * BulkActivateResultItem
 */
export const zBulkActivateResultItem = z.object({
    candidate_uuid: z.string().uuid(),
    status: z.string(),
    error: z.string().nullish(),
    executive: zExecutiveResponse.nullish()
});

/**
 * BulkActivateResponse
 */
export const zBulkActivateResponse = z.object({
    results: z.array(zBulkActivateResultItem),
    activated_count: z.number().int(),
    error_count: z.number().int()
});

/**
 * ExecutiveListResponse
 */
export const zExecutiveListResponse = z.object({
    items: z.array(zExecutiveResponse),
    total: z.number().int()
});

/**
 * ExecutiveTeamResponse
 */
export const zExecutiveTeamResponse = z.object({
    team_uuid: z.string().uuid(),
    team_slug: z.string()
});

/**
 * ExternalIntroductionSubject
 *
 * External person an intro is attributed to, as known after the fact.
 *
 * Unlike RecommendationExternalIntroduction (the create path, where a live
 * request needs a contactable person), corrections often know only a name —
 * email and company must not be required, or they end up fabricated.
 */
export const zExternalIntroductionSubject = z.object({
    name: z.string(),
    company_name: z.string().nullish(),
    email: z.string().email().nullish()
});

/**
 * ExternalPerson
 */
export const zExternalPerson = z.object({
    name: z.string(),
    company_name: z.string().nullish(),
    email: z.string().email().nullish()
});

/**
 * ActivityLogMessage
 */
export const zActivityLogMessage = z.object({
    action: z.string(),
    count: z.number().int().nullish(),
    reference_date: z.string().datetime().nullish(),
    reference_name: z.string().nullish(),
    reference_type: z.string().nullish(),
    company_name: z.string().nullish(),
    team_name: z.string().nullish(),
    team_slug: z.string().nullish(),
    pipeline_slug: z.string().nullish(),
    external_introduction_request_person: zExternalPerson.nullish()
});

/**
 * FTERange
 */
export const zFteRange = z.enum([
    '1-100',
    '101-1,000',
    '1,001-5,000',
    '5,001-10,000',
    '10,001-50,000',
    '50,001-100,000',
    '>100,000'
]);

/**
 * FailedCandidateCompanyMetadataRow
 */
export const zFailedCandidateCompanyMetadataRow = z.object({
    identifier: z.string(),
    reason: z.string()
});

/**
 * FailedCandidateRow
 *
 * Represents a row from the CSV that failed to import
 */
export const zFailedCandidateRow = z.object({
    name: z.string().nullish(),
    role: z.string().nullish(),
    company_name: z.string().nullish(),
    linkedin_url: z.string().nullish(),
    reason: z.string().nullish()
});

/**
 * FailedCandidatesImportRequest
 *
 * Request body for the failed candidates export endpoint
 */
export const zFailedCandidatesImportRequest = z.object({
    failed_rows: z.array(zFailedCandidateRow)
});

/**
 * FeedbackResponse
 */
export const zFeedbackResponse = z.object({
    detail: z.string(),
    requester_name: z.string().nullish(),
    requester_company: z.string().nullish()
});

/**
 * FeedbackSource
 */
export const zFeedbackSource = z.enum([
    'comment',
    'event',
    'feedback'
]);

/**
 * FeedbackType
 */
export const zFeedbackType = z.enum([
    'external',
    'global',
    'intake',
    'pipeline',
    'trending'
]);

/**
 * FilterPresets
 */
export const zFilterPresets = z.enum(['differences', 'similarities']);

/**
 * Function
 */
export const zFunction = z.enum([
    'ceo',
    'climate_and_sustainability',
    'corporate_governance',
    'customer_success',
    'cybersecurity',
    'data_and_analytics',
    'digital',
    'finance',
    'founder',
    'general_management',
    'investors',
    'legal',
    'marketing',
    'operations',
    'other',
    'people',
    'product',
    'risk_and_compliance',
    'sales',
    'strategy',
    'supply_chain',
    'technology'
]);

/**
 * FundType
 *
 * What kind of capital a firm deploys (BAN-XXXX).
 *
 * Multi-select on `company.fund_type`, overridable on `search_team.fund_type`.
 * A genuinely hybrid firm carries both values — there is deliberately no "both"
 * member, and no "other": anything that is not a PE or VC fund is left empty.
 */
export const zFundType = z.enum(['private_equity', 'venture_capital']);

/**
 * FundingRound
 */
export const zFundingRound = z.enum([
    'Series A',
    'Series B',
    'Series C',
    'Series D',
    'Series E',
    'Series F and on'
]);

/**
 * GeneralSearchResponseType
 */
export const zGeneralSearchResponseType = z.enum([
    'candidate',
    'pipeline',
    'submission',
    'team'
]);

/**
 * GeneralSearchResponseValues
 */
export const zGeneralSearchResponseValues = z.object({
    search_metadata: zEsMeta.nullish(),
    candidate_uuid: z.string().nullish(),
    pipeline_slug: z.string().nullish(),
    submission_uuid: z.string().nullish(),
    team_slug: z.string().nullish()
});

/**
 * GeneralSearchResponse
 */
export const zGeneralSearchResponse = z.object({
    name: z.string(),
    type: zGeneralSearchResponseType,
    values: zGeneralSearchResponseValues
});

/**
 * GoalIntroType
 */
export const zGoalIntroType = z.enum([
    'corporate',
    'investor',
    'peer',
    'search'
]);

/**
 * GoalPriority
 */
export const zGoalPriority = z.enum([
    'high',
    'low',
    'medium'
]);

/**
 * GoalStatus
 */
export const zGoalStatus = z.enum([
    'completed',
    'in_progress',
    'not_started'
]);

/**
 * CandidateGoalsPatchPayload
 */
export const zCandidateGoalsPatchPayload = z.object({
    due_date: z.union([
        z.string().datetime(),
        z.unknown()
    ]).nullish(),
    notes: z.string().min(1).nullish(),
    priority: zGoalPriority.nullish(),
    program: zCandidateType.nullish(),
    status: zGoalStatus.nullish(),
    title: z.string().min(1).nullish()
});

/**
 * GoalStatusFilter
 *
 * Filter by goal status.
 */
export const zGoalStatusFilter = z.enum([
    'all',
    'completed',
    'in_progress',
    'not_started'
]);

/**
 * GoalType
 */
export const zGoalType = z.enum(['long_term', 'short_term']);

/**
 * CandidateGoalLegacy
 */
export const zCandidateGoalLegacy = z.object({
    type: zGoalType,
    text: z.string(),
    last_modified: z.string().datetime()
});

/**
 * CandidateGoalResponse
 */
export const zCandidateGoalResponse = z.object({
    candidate_uuid: z.string().uuid(),
    goals: z.array(zCandidateGoalLegacy)
});

/**
 * Highlight
 */
export const zHighlight = z.object({
    last_modified: z.string().datetime(),
    highlight: z.string(),
    created: z.string().datetime(),
    hidden: z.boolean(),
    soft_delete: z.boolean(),
    uuid: z.string().uuid()
});

/**
 * CandidateCommentaryResponseSchema
 */
export const zCandidateCommentaryResponseSchema = z.object({
    highlights: z.array(zHighlight),
    introduction_templates: z.array(zCandidateIntroductionTemplateResponse)
});

/**
 * HighlightGeneratorResponse
 */
export const zHighlightGeneratorResponse = z.object({
    highlights: z.array(z.string()),
    candidate_name: z.string()
});

/**
 * HighlightResponse
 */
export const zHighlightResponse = z.object({
    highlight: z.string(),
    created: z.string().datetime(),
    last_modified: z.string().datetime(),
    hidden: z.boolean(),
    soft_delete: z.boolean(),
    uuid: z.string().uuid()
});

/**
 * HighlightWithSelectedPayload
 */
export const zHighlightWithSelectedPayload = z.object({
    highlight: z.string(),
    is_selected: z.boolean()
});

/**
 * HighlightWithSelectedResponse
 */
export const zHighlightWithSelectedResponse = z.object({
    highlight: z.string(),
    is_selected: z.boolean()
});

/**
 * HomeCandidateFeedbackAction
 */
export const zHomeCandidateFeedbackAction = z.enum([
    'already_met',
    'favorite',
    'not_interested',
    'saved_to_pipeline',
    'shared',
    'viewed'
]);

/**
 * HomeCandidateFeedbackActionPayload
 */
export const zHomeCandidateFeedbackActionPayload = z.object({
    action: zHomeCandidateFeedbackAction
});

/**
 * HomeTeamActivityCounts
 */
export const zHomeTeamActivityCounts = z.object({
    all: z.number().int(),
    completed: z.number().int(),
    pending: z.number().int(),
    unread: z.number().int()
});

/**
 * HomeTeamActivityRecommendedPerson
 *
 * One recommended candidate in a pipeline's activity row.
 *
 * Name and image come from the candidate's own record, so every recommended
 * candidate appears — the counts next to these avatars include the ones with
 * no login. ``uuid`` is a login's uuid, so it is the candidate's activated
 * executive and is absent when they have none; it is never another member of
 * the identity.
 */
export const zHomeTeamActivityRecommendedPerson = z.object({
    name: z.string(),
    first_name: z.string().nullish(),
    last_name: z.string().nullish(),
    image: z.string().nullish(),
    uuid: z.string().uuid().nullish(),
    profile_image_url: z.string().nullable()
});

/**
 * HomeTeamActivityType
 */
export const zHomeTeamActivityType = z.enum([
    'completed',
    'pending',
    'unread'
]);

/**
 * HubSpotFieldSyncResponse
 *
 * Response schema for the HubSpot -> Contender field sync job.
 */
export const zHubSpotFieldSyncResponse = z.object({
    candidates_found: z.number().int().gte(0),
    sync_started: z.boolean(),
    dry_run: z.boolean(),
    would_link: z.number().int().nullish(),
    would_update: z.number().int().nullish(),
    ambiguous: z.number().int().nullish(),
    unmatched: z.number().int().nullish()
});

/**
 * HubSpotInvoiceStatus
 *
 * HubSpot `invoice_status` contact property (enumeration / single-select).
 *
 * Members mirror the option *internal values* HubSpot returns verbatim (which,
 * for this property, equal their labels and contain spaces). Stored in the
 * plain-String `contender_candidate.invoice_status` column -- the same
 * StrEnum-over-String pattern as `CandidateTier` -- so an unknown value from
 * HubSpot (a newly added or renamed option) is logged rather than rejected.
 */
export const zHubSpotInvoiceStatus = z.enum([
    '<30 Days Overdue',
    '30 Days Overdue',
    '60 Days Overdue',
    '90 Days Overdue',
    'Good Standing'
]);

/**
 * ICBIndustry
 */
export const zIcbIndustry = z.enum([
    'Technology',
    'Telecommunications',
    'Health Care',
    'Financials',
    'Real Estate',
    'Consumer Discretionary',
    'Consumer Staples',
    'Industrials',
    'Basic Materials',
    'Energy',
    'Utilities'
]);

/**
 * IdentityCandidateItem
 */
export const zIdentityCandidateItem = z.object({
    uuid: z.string().uuid(),
    email: z.string().nullish(),
    first_name: z.string().nullish(),
    last_name: z.string().nullish(),
    tier: zCandidateTier.nullish()
});

/**
 * IdentityCandidatePayload
 */
export const zIdentityCandidatePayload = z.object({
    candidate_uuid: z.string().uuid()
});

/**
 * IdentityMergePayload
 */
export const zIdentityMergePayload = z.object({
    from_identity_uuid: z.string().uuid(),
    dry_run: z.boolean().optional().default(false)
});

/**
 * IdentityMergeResponse
 *
 * What a merge would do (dry run), did (applied) or why it was refused
 * (blockers). Same shape in all three cases. ``rows`` moved to the surviving
 * identity; ``dropped`` were deleted as duplicates of rows already there.
 */
export const zIdentityMergeResponse = z.object({
    into_identity_uuid: z.string().uuid(),
    from_identity_uuid: z.string().uuid(),
    blockers: z.array(z.string()),
    persons: z.array(z.string().uuid()),
    candidate_uuid: z.string().uuid().nullish(),
    rows: z.record(z.number().int()),
    dropped: z.record(z.number().int()).optional().default({}),
    applied: z.boolean(),
    merge_uuid: z.string().uuid().nullish()
});

/**
 * IdentityPersonPayload
 */
export const zIdentityPersonPayload = z.object({
    person_uuid: z.string().uuid()
});

/**
 * ImageUploadResponse
 */
export const zImageUploadResponse = z.object({
    name: z.string()
});

/**
 * IndexAliasUpdateResponse
 */
export const zIndexAliasUpdateResponse = z.object({
    index_name: z.string(),
    index_alias: z.string(),
    is_updated: z.boolean()
});

/**
 * Industry
 */
export const zIndustry = z.enum([
    'advertisements',
    'automobiles',
    'blockchain_and_crypto',
    'chemicals',
    'climate_and_sustainability',
    'consumer_goods',
    'consumer_services',
    'consumer_tech',
    'education',
    'energy',
    'enterprise_software',
    'financial_services',
    'fintech',
    'government_and_military',
    'healthcare',
    'industrials',
    'insurance',
    'marketplaces',
    'media_and_entertainment',
    'nonprofits',
    'other',
    'pharmaceuticals_and_biotechnology',
    'professional_services',
    'real_estate',
    'retail_and_hospitality',
    'semiconductors_and_it_hardware',
    'telecommunications',
    'transportation',
    'venture_capital_and_private_equity'
]);

/**
 * CandidatesCombinedPerformanceFilters
 */
export const zCandidatesCombinedPerformanceFilters = z.object({
    advisor_id: z.array(z.string()).nullish(),
    candidate_uuid: z.array(z.string()).nullish(),
    function_expertise: z.array(zFunction).nullish(),
    industry_expertise: z.array(zIndustry).nullish(),
    type: z.array(zClientType).nullish(),
    pathway: z.array(zCandidatePathway).nullish()
});

/**
 * ExecutiveClientPeopleFilterData
 */
export const zExecutiveClientPeopleFilterData = z.object({
    source_type: z.array(zContactSourceType).nullish(),
    company_type: z.array(z.string()).nullish(),
    industry_expertise: z.array(zIndustry).nullish(),
    function_expertise: z.array(zFunction).nullish(),
    company_id: z.array(z.number().int()).nullish(),
    event_uuid: z.array(z.string().uuid()).nullish(),
    connection_status: z.array(zConnectionStatus).nullish(),
    personal_tag_uuid: z.array(z.string().uuid()).nullish()
});

/**
 * InterestPersonal
 */
export const zInterestPersonal = z.enum([
    'academia',
    'aerospace_and_space',
    'agriculture',
    'art',
    'film',
    'financial_inclusion',
    'food_and_restaurants',
    'gaming',
    'media',
    'music',
    'outdoor_activities',
    'pets_and_animals',
    'philanthropy_and_non_profits',
    'politics',
    'psychology',
    'public_speaking_and_panels',
    'skiing',
    'sports',
    'travel',
    'wine'
]);

/**
 * InterestProfessional
 */
export const zInterestProfessional = z.enum([
    'ai_and_ml',
    'angel_and_vc_investing',
    'beauty_and_fashion',
    'climate',
    'crypto_and_blockchain',
    'dei',
    'disruptive_technology',
    'ecommerce',
    'education',
    'entrepreneurship',
    'geopolitics',
    'government_and_public_sector',
    'private_equity_operating',
    'wellness',
    'women_in_business'
]);

/**
 * InterestRole
 */
export const zInterestRole = z.enum([
    'seeking_actively',
    'seeking_no',
    'seeking_passively'
]);

/**
 * CandidateExtendedResponse
 */
export const zCandidateExtendedResponse = z.object({
    is_client: z.boolean(),
    company: z.string().nullish(),
    role: z.string().nullish(),
    image: z.string().nullish(),
    name: z.string(),
    uuid: z.string().uuid(),
    first_name: z.string().nullish(),
    function_expertise: z.array(zFunction),
    function_target: z.array(zFunction),
    industry_expertise: z.array(zIndustry),
    industry_target: z.array(zIndustry),
    interest_role_board_advisory: zInterestRole.nullish(),
    interest_role_operating: zInterestRole.nullish(),
    interests_personal: z.array(zInterestPersonal),
    interests_professional: z.array(zInterestProfessional),
    keywords: z.array(z.string()),
    last_name: z.string().nullish(),
    linkedin_url: z.string().nullish(),
    tier: zCandidateTier,
    type: zClientType.nullish(),
    pathway: zCandidatePathway.nullish(),
    profile_image_url: z.string().nullable()
});

/**
 * CandidatesFilters
 */
export const zCandidatesFilters = z.object({
    advisor_id: z.array(z.string()).nullish(),
    function_expertise: z.array(zFunction).nullish(),
    industry_expertise: z.array(zIndustry).nullish(),
    interest_role_board_advisory: z.array(zInterestRole).nullish(),
    interest_role_operating: z.array(zInterestRole).nullish(),
    tier: z.array(zCandidateTier).nullish(),
    type: z.array(zClientType).nullish(),
    pathway: z.array(zCandidatePathway).nullish(),
    invoice_status: z.array(zHubSpotInvoiceStatus).nullish()
});

/**
 * IntroCheckType
 */
export const zIntroCheckType = z.enum(['upcoming_intros', 'overdue_intros']);

/**
 * IntroEmailType
 */
export const zIntroEmailType = z.enum(['auto', 'manual']);

/**
 * IntroStats
 */
export const zIntroStats = z.object({
    intro_type: zGoalIntroType,
    intro_count: z.number().int().optional().default(0),
    intro_log_ids: z.array(z.string().uuid()).nullish()
});

/**
 * IntroTypeEnum
 */
export const zIntroTypeEnum = z.enum([
    'P2P',
    'TRENDING_BATCH',
    'TRENDING_STREAM'
]);

/**
 * IntroductionStatus
 */
export const zIntroductionStatus = z.enum([
    'facilitated',
    'not_facilitated',
    'not_requested',
    'requested'
]);

/**
 * IntroductionStatusContext
 */
export const zIntroductionStatusContext = z.enum(['no_interest', 'unreachable']);

/**
 * IntroductionStatusFilter
 */
export const zIntroductionStatusFilter = z.enum(['never_introduced', 'previously_introduced']);

/**
 * IntroductionSubjectPayload
 *
 * Payload for editing who an existing intro request is for.
 *
 * An introduction has exactly one subject: either an external person
 * (not a platform user) or a platform user the request was made on
 * behalf of.
 */
export const zIntroductionSubjectPayload = z.object({
    external_introduction: zExternalIntroductionSubject.nullish(),
    on_behalf_of_user_uuid: z.string().uuid().nullish(),
    introduction_comment: z.string().min(1).nullish()
});

/**
 * IntroductionType
 */
export const zIntroductionType = z.enum([
    'pipeline',
    'search',
    'team'
]);

/**
 * InvitePreviewPayload
 *
 * Optional payload for sending invite preview. Omit email to send to the current user.
 */
export const zInvitePreviewPayload = z.object({
    email: z.string().nullish(),
    subject: z.string().nullish(),
    body: z.string().nullish()
});

/**
 * LastEventBucket
 *
 * When the guest last attended an event (time buckets for filter/aggregation).
 */
export const zLastEventBucket = z.enum([
    '1_month',
    '3_months',
    '6_months',
    '9_months',
    '12_plus'
]);

/**
 * LinkCandidateResponse
 */
export const zLinkCandidateResponse = z.object({
    uuid: z.string().uuid(),
    search_uuid: z.string().uuid(),
    role_title: z.string(),
    target_company_name: z.string().nullable(),
    client_name: z.string().nullable(),
    search_firm_name: z.string().nullable(),
    received_at: z.string().datetime().nullable(),
    similarity: z.number(),
    reason: z.string()
});

/**
 * LinkedInBatchSyncResponse
 *
 * Response schema for LinkedIn batch sync job.
 */
export const zLinkedInBatchSyncResponse = z.object({
    candidates_found: z.number().int().gte(0),
    sync_started: z.boolean(),
    dry_run: z.boolean(),
    estimated_credits: z.number().int().gte(0),
    errors: z.array(z.record(z.unknown())).optional()
});

/**
 * LinkedInPreviewRequest
 */
export const zLinkedInPreviewRequest = z.object({
    linkedin_url: z.string().nullish(),
    first_name: z.string().nullish(),
    last_name: z.string().nullish(),
    company: z.string().nullish(),
    title: z.string().nullish(),
    fresh: z.boolean().optional().default(false)
});

/**
 * LinkedInPreviewResponse
 */
export const zLinkedInPreviewResponse = z.object({
    linkedin_url: z.string(),
    name: z.string().nullish(),
    headline: z.string().nullish(),
    current_role: z.string().nullish(),
    current_company: z.string().nullish(),
    location: z.string().nullish(),
    photo_url: z.string().nullish(),
    fetched_at: z.string().datetime(),
    cache_hit: z.boolean(),
    matches: z.boolean().nullish()
});

/**
 * LinkedInSyncRequest
 */
export const zLinkedInSyncRequest = z.object({
    replace_photo: z.boolean().optional().default(false),
    fresh: z.boolean().optional().default(false)
});

/**
 * LocationAddress
 *
 * Attributes
 * ----------
 * address_1 : str
 * first line of mailing address (street address)
 * address_2 : str
 * optional second line of mailing address (street address)
 * city : str
 * city or township associated with this address
 * region : str
 * state or province
 * postal_code : str
 * this is the postal code for the address
 * country : str
 * this will be translated into a two-character ISO code
 */
export const zLocationAddress = z.object({
    address_1: z.string(),
    address_2: z.string().nullish(),
    city: z.string(),
    region: z.string(),
    postal_code: z.string(),
    country: z.string()
});

/**
 * LoginCreatePayload
 *
 * A new login for a human: an executive, an enterprise (B4B) user or a
 * Banff admin.
 */
export const zLoginCreatePayload = z.object({
    user_type: z.enum([
        'executive',
        'enterprise',
        'admin'
    ]),
    email: z.string().email(),
    first_name: z.string().min(1),
    last_name: z.string().min(1),
    send_invitation: z.boolean().optional().default(false),
    team_uuid: z.string().uuid().nullish(),
    lead: z.boolean().optional().default(false),
    permit_preregistration_notifications: z.boolean().optional().default(false)
});

/**
 * MarketCapRange
 */
export const zMarketCapRange = z.enum([
    '<$300M',
    '$300M-$2B',
    '$2B-$10B',
    '$10B-$200B',
    '>$200B'
]);

/**
 * MarketSearchAttachedBy
 *
 * How a market-search observation joined its search group.
 */
export const zMarketSearchAttachedBy = z.enum([
    'new',
    'rule',
    'model',
    'advisor'
]);

/**
 * MarketSearchCandidateRef
 */
export const zMarketSearchCandidateRef = z.object({
    uuid: z.string().uuid(),
    full_name: z.string()
});

/**
 * MarketSearchClosePayload
 */
export const zMarketSearchClosePayload = z.object({
    closed_evidence: z.string().max(512).nullish(),
    closed_at: z.string().datetime().nullish()
});

/**
 * MarketSearchGroupMember
 */
export const zMarketSearchGroupMember = z.object({
    uuid: z.string().uuid(),
    is_hub: z.boolean(),
    attached_by: zMarketSearchAttachedBy,
    received_at: z.string().datetime().nullable(),
    client_name: z.string().nullable(),
    search_firm_name: z.string().nullable(),
    search_contact_name: z.string().nullable()
});

/**
 * MarketSearchJobResponse
 *
 * Response schema for the market-search maintenance jobs.
 *
 * The routes queue work rather than doing it: a sweep can run for minutes and
 * the classification catch-up spends most of that waiting on a model, neither
 * of which belongs in a scheduler's HTTP call. The report each job produces is
 * logged and returned as the Celery task result, keyed by `task_id`.
 */
export const zMarketSearchJobResponse = z.object({
    job: z.string(),
    task_id: z.string().nullish(),
    limit: z.number().int().gte(1),
    dry_run: z.boolean()
});

/**
 * MarketSearchLinkPayload
 */
export const zMarketSearchLinkPayload = z.object({
    hub_uuid: z.string().uuid()
});

/**
 * MarketSearchNeedsAttention
 *
 * A name was given and the link it should have is missing.
 */
export const zMarketSearchNeedsAttention = z.enum([
    'target_company_unresolved',
    'firm_unresolved',
    'team_unresolved',
    'contact_unresolved',
    'client_unresolved',
    'unclassified'
]);

/**
 * MarketSearchPersonRef
 *
 * A human by identity, with the name and email of their earliest login.
 */
export const zMarketSearchPersonRef = z.object({
    identity_uuid: z.string().uuid(),
    person_id: z.string().uuid(),
    full_name: z.string().nullable(),
    email: z.string().nullable()
});

/**
 * MarketSearchPipelineRef
 */
export const zMarketSearchPipelineRef = z.object({
    id: z.number().int(),
    uuid: z.string().uuid(),
    name: z.string(),
    slug: z.string()
});

/**
 * MarketSearchReporterRef
 */
export const zMarketSearchReporterRef = z.object({
    id: z.string().uuid(),
    full_name: z.string().nullable()
});

/**
 * MarketSearchResponse
 */
export const zMarketSearchResponse = z.object({
    uuid: z.string().uuid(),
    search_uuid: z.string().uuid(),
    same_search_as_uuid: z.string().uuid().nullable(),
    is_hub: z.boolean(),
    attached_by: z.string(),
    role_title: z.string(),
    role_type: z.string().nullable(),
    seniority: z.string().nullable(),
    functions: z.array(z.string()),
    target_company_name: z.string().nullable(),
    target_company_industry: z.string().nullable(),
    target_company_id: z.number().int().nullable(),
    search_firm_name: z.string().nullable(),
    search_contact_name: z.string().nullable(),
    search_contact_identity_uuid: z.string().uuid().nullable(),
    search_firm_company_id: z.number().int().nullable(),
    search_team_id: z.number().int().nullable(),
    client_name: z.string().nullable(),
    candidate_uuid: z.string().uuid().nullable(),
    status: z.string(),
    closed_at: z.string().datetime().nullable(),
    closed_evidence: z.string().nullable(),
    pipeline_id: z.number().int().nullable(),
    source: z.string(),
    reported_by_person_id: z.string().uuid().nullable(),
    received_at: z.string().datetime().nullable(),
    created: z.string().datetime(),
    last_modified: z.string().datetime()
});

/**
 * MarketSearchSortColumn
 */
export const zMarketSearchSortColumn = z.enum([
    'received_at',
    'created',
    'last_modified',
    'role_title',
    'target_company_name',
    'search_firm_name',
    'client_name',
    'status'
]);

/**
 * MarketSearchSource
 */
export const zMarketSearchSource = z.enum([
    'advisor_note',
    'transcript',
    'notion_backfill',
    'manual'
]);

/**
 * MarketSearchStatus
 */
export const zMarketSearchStatus = z.enum(['active', 'closed']);

/**
 * MarketSearchTeamRef
 */
export const zMarketSearchTeamRef = z.object({
    id: z.number().int(),
    uuid: z.string().uuid(),
    name: z.string(),
    slug: z.string()
});

/**
 * MatchScoreBreakdown
 *
 * The Match score's parts: match = rubric_points + evidence_points - tier_offset, floored at 0.
 *
 * rubric is the RecSys run's 0-100 score (imputed at the run's 35th percentile when the
 * run did not score the candidate); evidence is the 0-1 cart-signal blend.
 */
export const zMatchScoreBreakdown = z.object({
    rubric: z.number(),
    rubric_imputed: z.boolean(),
    rubric_points: z.number(),
    evidence: z.number(),
    evidence_points: z.number(),
    tier_offset: z.number(),
    match: z.number()
});

/**
 * OffLimitsReason
 */
export const zOffLimitsReason = z.enum([
    'EXISTING_RELATIONSHIP',
    'INVESTOR_CONFLICT',
    'OTHER',
    'SEARCH_FIRM_OFF_LIMITS',
    'TEAM_MEMBER_EXISTING_CANDIDATE'
]);

/**
 * CandidateOffLimitsCompany
 */
export const zCandidateOffLimitsCompany = z.object({
    company_id: z.number().int(),
    reason: zOffLimitsReason
});

/**
 * CandidateOffLimitsIdentity
 */
export const zCandidateOffLimitsIdentity = z.object({
    identity_uuid: z.string().uuid(),
    reason: zOffLimitsReason
});

/**
 * OffLimitsCompanyResponseSchema
 */
export const zOffLimitsCompanyResponseSchema = z.object({
    company_id: z.number().int(),
    company_name: z.string(),
    reason: zOffLimitsReason
});

/**
 * OffLimitsIdentityResponseSchema
 *
 * One human this candidate must not be shown to. Name, email and company
 * come from the identity's candidate record when it has one, else from one
 * of its logins; all null for an identity holding neither.
 */
export const zOffLimitsIdentityResponseSchema = z.object({
    identity_uuid: z.string().uuid(),
    full_name: z.string().nullish(),
    email: z.string().nullish(),
    company_name: z.string().nullish(),
    image: z.string().nullish(),
    reason: zOffLimitsReason
});

/**
 * OffLimitsTeamSchema
 */
export const zOffLimitsTeamSchema = z.object({
    candidate_uuid: z.string().uuid(),
    company_slug: z.string().nullish(),
    identity_uuid: z.string().uuid().nullish(),
    reason: zOffLimitsReason,
    team_id: z.number().int(),
    team_uuid: z.string().uuid(),
    team_slug: z.string()
});

/**
 * OperatingHighlights
 */
export const zOperatingHighlights = z.enum([
    'early_stage',
    'venture_capital_backed',
    'private_equity_backed',
    'led_ipo',
    'part_of_ipo',
    'exit'
]);

/**
 * OrgType
 */
export const zOrgType = z.enum([
    'advisory',
    'corporate',
    'executive',
    'investor',
    'search',
    'other'
]);

/**
 * CompanyBasicTypeResponse
 */
export const zCompanyBasicTypeResponse = z.object({
    id: z.number().int(),
    name: z.string().nullable(),
    slug: z.string(),
    type: zOrgType
});

/**
 * CandidateFeedbackPersonResponse
 *
 * The commenter as displayed, filled from the from-identity: the candidate's
 * name when the identity has a candidate, else the earliest login's. ``uuid``
 * and ``email`` are null for a candidate without a login.
 */
export const zCandidateFeedbackPersonResponse = z.object({
    email: z.string().email().nullish(),
    name: z.string(),
    first_name: z.string().nullish(),
    last_name: z.string().nullish(),
    image: z.string().nullish(),
    uuid: z.string().uuid().nullish(),
    company: zCompanyBasicTypeResponse.nullish(),
    profile_image_url: z.string().nullable()
});

/**
 * ExecutiveContactPerson
 *
 * The ``Person`` side of a unified exec contact.
 *
 * Lightweight identity for the individual behind a contact (login/profile
 * record). Present whenever the contact has a ``Person`` row — including
 * candidate-backed contacts whose candidate is linked to a person. ``email``
 * is gated identically to the envelope's top-level email.
 */
export const zExecutiveContactPerson = z.object({
    person_uuid: z.string().uuid(),
    full_name: z.string().nullish(),
    first_name: z.string().nullish(),
    last_name: z.string().nullish(),
    email: z.string().nullish(),
    profile_img: z.string().nullish(),
    notes_external: z.string().nullish(),
    linkedin_url: z.string().nullish(),
    current_role: z.string().nullish(),
    current_company: z.string().nullish(),
    company: zCompanyBasicTypeResponse.nullish()
});

/**
 * MarketSearchCompanyRef
 */
export const zMarketSearchCompanyRef = z.object({
    id: z.number().int(),
    name: z.string().nullable(),
    slug: z.string(),
    type: zOrgType
});

/**
 * MarketSearchContactTeam
 */
export const zMarketSearchContactTeam = z.object({
    id: z.number().int(),
    uuid: z.string().uuid(),
    name: z.string(),
    company: zMarketSearchCompanyRef
});

/**
 * MarketSearchContactOption
 *
 * A person who can be linked as a search's contact, with the teams they sit on.
 */
export const zMarketSearchContactOption = z.object({
    identity_uuid: z.string().uuid(),
    person_id: z.string().uuid(),
    full_name: z.string().nullable(),
    email: z.string().nullable(),
    teams: z.array(zMarketSearchContactTeam)
});

/**
 * MarketSearchPipelineOption
 */
export const zMarketSearchPipelineOption = z.object({
    id: z.number().int(),
    uuid: z.string().uuid(),
    name: z.string(),
    slug: z.string(),
    active: z.boolean(),
    team_name: z.string(),
    company: zMarketSearchCompanyRef.nullable()
});

/**
 * MarketSearchTeamOption
 */
export const zMarketSearchTeamOption = z.object({
    id: z.number().int(),
    uuid: z.string().uuid(),
    name: z.string(),
    slug: z.string(),
    company: zMarketSearchCompanyRef
});

/**
 * PathwayActivityType
 *
 * Executive activity metrics keyed per pathway default targets.
 */
export const zPathwayActivityType = z.enum([
    'narrative_edits',
    'event_invites',
    'check_in_calls',
    'comp_review_offer_support',
    'p2p_intros',
    'b4b_intros',
    'brand_strategic_call'
]);

/**
 * CandidatePathwayActivityTargetPutItem
 */
export const zCandidatePathwayActivityTargetPutItem = z.object({
    activity_type: zPathwayActivityType,
    target_number: z.number().int().gte(0),
    time_period: zActivityTimePeriod
});

/**
 * CandidatePathwayActivityTargetRow
 *
 * One activity row: effective values plus pathway defaults for reset/compare.
 */
export const zCandidatePathwayActivityTargetRow = z.object({
    activity_type: zPathwayActivityType,
    target_number: z.number().int().gte(0),
    time_period: zActivityTimePeriod,
    uses_pathway_default: z.boolean(),
    pathway_default_target_number: z.number().int().gte(0),
    pathway_default_time_period: zActivityTimePeriod
});

/**
 * CandidatePathwayActivityTargetsPutPayload
 */
export const zCandidatePathwayActivityTargetsPutPayload = z.object({
    targets: z.array(zCandidatePathwayActivityTargetPutItem)
});

/**
 * CandidatePathwayActivityTargetsResponse
 *
 * Merged view of pathway defaults and per-candidate overrides.
 */
export const zCandidatePathwayActivityTargetsResponse = z.object({
    candidate_pathway: z.string().nullable(),
    defaults_pathway: z.string().nullable(),
    targets: z.array(zCandidatePathwayActivityTargetRow)
});

/**
 * PathwayActivityDefaultRow
 */
export const zPathwayActivityDefaultRow = z.object({
    id: z.number().int(),
    pathway: zCandidatePathway,
    activity_type: zPathwayActivityType,
    target_number: z.number().int().gte(0),
    time_period: zActivityTimePeriod
});

/**
 * PathwayActivityDefaultUpsertItem
 */
export const zPathwayActivityDefaultUpsertItem = z.object({
    pathway: zCandidatePathway,
    activity_type: zPathwayActivityType,
    target_number: z.number().int().gte(0),
    time_period: zActivityTimePeriod
});

/**
 * PathwayActivityDefaultsListResponse
 */
export const zPathwayActivityDefaultsListResponse = z.object({
    defaults: z.array(zPathwayActivityDefaultRow)
});

/**
 * PathwayActivityDefaultsPutPayload
 */
export const zPathwayActivityDefaultsPutPayload = z.object({
    defaults: z.array(zPathwayActivityDefaultUpsertItem)
});

/**
 * PaymentStatus
 */
export const zPaymentStatus = z.enum(['free', 'premium']);

/**
 * CompaniesFilters
 */
export const zCompaniesFilters = z.object({
    fund_type: z.array(zFundType).nullish(),
    payment_status: z.array(zPaymentStatus).nullish(),
    type: z.array(zOrgType).nullish(),
    has_members: z.boolean().nullish(),
    active: z.boolean().nullish()
});

/**
 * CompanyCreate
 */
export const zCompanyCreate = z.object({
    fund_type: z.array(zFundType).nullish(),
    domain: z.string().nullish(),
    payment_status: zPaymentStatus.optional().default('free'),
    slug: z.string().nullish(),
    stage: zCompanyStage.nullish(),
    customer_type: zOrgType.nullish(),
    organization: z.string().min(1)
});

/**
 * CompanyCreateV1
 *
 * Schema for POST /api/v1/companies.
 *
 * name, type, slug, payment_status and fund_type can be set.
 */
export const zCompanyCreateV1 = z.object({
    organization: z.string().min(1),
    customer_type: zOrgType,
    slug: z.string().nullish(),
    payment_status: zPaymentStatus.nullish().default('free'),
    fund_type: z.array(zFundType).nullish()
});

/**
 * CompanyExtendedResponse
 */
export const zCompanyExtendedResponse = z.object({
    id: z.number().int(),
    name: z.string().nullable(),
    slug: z.string(),
    type: zOrgType,
    fund_type: z.array(zFundType).nullish(),
    payment_status: zPaymentStatus,
    active: z.boolean().optional().default(true)
});

/**
 * CompanyExtendedResponseWithFeatures
 */
export const zCompanyExtendedResponseWithFeatures = z.object({
    id: z.number().int(),
    name: z.string().nullable(),
    slug: z.string(),
    type: zOrgType,
    fund_type: z.array(zFundType).nullish(),
    payment_status: zPaymentStatus,
    active: z.boolean().optional().default(true),
    permissions: z.array(zCompanyPermissions)
});

/**
 * CompanyPatchPayload
 */
export const zCompanyPatchPayload = z.object({
    fund_type: z.array(zFundType).nullish(),
    payment_status: zPaymentStatus.nullish(),
    organization: z.string().min(1).nullish(),
    slug: z.string().nullish(),
    customer_type: zOrgType.nullish(),
    active: z.boolean().nullish()
});

/**
 * CompanyTableResponse
 */
export const zCompanyTableResponse = z.object({
    search_metadata: zEsMeta.nullish(),
    id: z.number().int(),
    name: z.string().nullable(),
    slug: z.string(),
    type: zOrgType,
    fund_type: z.array(zFundType).nullish(),
    payment_status: zPaymentStatus,
    active: z.boolean().optional().default(true),
    permissions: z.array(zCompanyPermissions),
    teams_count: z.number().int(),
    users_count: z.number().int()
});

/**
 * CompanyUpdate
 *
 * Schema for updating an existing company
 */
export const zCompanyUpdate = z.object({
    fund_type: z.array(zFundType).nullish(),
    organization: z.string().min(1).nullish(),
    payment_status: zPaymentStatus.nullish(),
    customer_type: zOrgType.nullish()
});

/**
 * PeerAssigneesUpdatePayload
 */
export const zPeerAssigneesUpdatePayload = z.object({
    assignee_uuids: z.array(z.string().uuid())
});

/**
 * PeerCommentPayload
 */
export const zPeerCommentPayload = z.object({
    context: z.string().min(1)
});

/**
 * PeerCompareAboutResponse
 */
export const zPeerCompareAboutResponse = z.object({
    candidate: zCandidateBasicResponse,
    introduction_templates: z.array(zCandidateIntroductionTemplateResponse)
});

/**
 * PeerCompareGoalResponse
 */
export const zPeerCompareGoalResponse = z.object({
    id: z.string().uuid(),
    title: z.string(),
    program: zCandidateType,
    status: zGoalStatus,
    priority: zGoalPriority.nullish(),
    created: z.string().datetime(),
    due_date: z.string().datetime().nullish(),
    completion_date: z.string().datetime().nullish()
});

/**
 * PeerCompareGoalsResponse
 */
export const zPeerCompareGoalsResponse = z.object({
    candidate: zCandidateBasicResponse,
    goals: z.array(zPeerCompareGoalResponse)
});

/**
 * PeerComparePayload
 */
export const zPeerComparePayload = z.object({
    candidate_uuids: z.array(z.string().uuid())
});

/**
 * PeerEvent
 */
export const zPeerEvent = z.enum([
    'approved',
    'comment',
    'declined_advisor',
    'declined_candidate',
    'info_needed',
    'intro_made',
    'published',
    'scheduled'
]);

/**
 * PeerIntroductionPayload
 */
export const zPeerIntroductionPayload = z.object({
    email_body: z.string().nullish(),
    email_subject: z.string().nullish(),
    email_people_cc: z.array(z.string().uuid()).nullish(),
    from_id: z.string().uuid().nullish(),
    introduced_on: z.string().datetime().nullish()
});

/**
 * PeerStatus
 */
export const zPeerStatus = z.enum([
    'approved',
    'declined_advisor',
    'declined_candidate',
    'info_needed',
    'intro_made',
    'published',
    'scheduled'
]);

/**
 * PeerStatusUpdatePayload
 */
export const zPeerStatusUpdatePayload = z.object({
    context: z.string().min(1).nullish(),
    status: zPeerStatus
});

/**
 * PeerToPeerLastEventResponse
 *
 * Most recent non-webinar event both this peer and the client candidate RSVP'd going.
 */
export const zPeerToPeerLastEventResponse = z.object({
    id: z.number().int(),
    uuid: z.string().uuid(),
    title: z.string(),
    event_date: z.string().datetime().nullish()
});

/**
 * PeerToPeerPublishCandidates
 */
export const zPeerToPeerPublishCandidates = z.object({
    candidate_uuid: z.string().uuid(),
    context: z.string().min(1),
    goal_id: z.string().uuid().nullish(),
    status: z.enum([
        'approved',
        'published',
        'intro_made'
    ])
});

/**
 * PeerToPeerReviewersStatus
 */
export const zPeerToPeerReviewersStatus = z.object({
    status: zPeerStatus,
    uuid: z.string().uuid()
});

/**
 * PeerToPeerTableExecutiveAggregationsResponse
 */
export const zPeerToPeerTableExecutiveAggregationsResponse = z.object({
    introduced: z.number().int(),
    pending: z.number().int(),
    total: z.number().int()
});

/**
 * PeerToPeerTableFilterAggregationsResponse
 */
export const zPeerToPeerTableFilterAggregationsResponse = z.object({
    advisor_uuid: z.record(z.number().int()),
    assignee_uuid: z.record(z.number().int()),
    recommender_uuid: z.record(z.number().int()),
    status: z.record(z.number().int())
});

/**
 * PeerToPeerTableFilterData
 */
export const zPeerToPeerTableFilterData = z.object({
    advisor_uuid: z.array(z.string().uuid()).optional().default([]),
    assignee_uuid: z.array(z.string().uuid()).optional().default([]),
    candidate_uuid: z.array(z.string().uuid()).optional().default([]),
    recommender_uuid: z.array(z.string().uuid()).optional().default([]),
    status: z.array(zPeerStatus).optional().default([])
});

/**
 * PeerToPeerTableSelectAggregationsResponse
 */
export const zPeerToPeerTableSelectAggregationsResponse = z.object({
    industry_expertise: z.record(z.number().int()),
    function_expertise: z.record(z.number().int()),
    industry_target: z.record(z.number().int()),
    function_target: z.record(z.number().int()),
    tier: z.record(z.number().int()),
    interests_personal: z.record(z.number().int()),
    interests_professional: z.record(z.number().int()),
    type: z.record(z.number().int()),
    pathway: z.record(z.number().int())
});

/**
 * PeerToPeerTableSelectFilterData
 */
export const zPeerToPeerTableSelectFilterData = z.object({
    function_expertise: z.array(zFunction).nullish().default([]),
    industry_expertise: z.array(zIndustry).nullish().default([]),
    interests_personal: z.array(zInterestPersonal).nullish().default([]),
    interests_professional: z.array(zInterestProfessional).nullish().default([]),
    function_target: z.array(zFunction).nullish().default([]),
    industry_target: z.array(zIndustry).nullish().default([]),
    tier: z.array(zCandidateTier).nullish(),
    type: z.array(zClientType).nullish(),
    pathway: z.array(zCandidatePathway).nullish()
});

/**
 * PeerToPeerTableSelectSortColumn
 */
export const zPeerToPeerTableSelectSortColumn = z.enum([
    'name',
    'last_peer_status',
    'last_peer_introduced_on',
    'last_event_date',
    'industry_expertise',
    'function_expertise',
    'interests_professional',
    'intros_count',
    'advisor_name',
    'type'
]);

/**
 * PeerToPeerTableSortColumn
 */
export const zPeerToPeerTableSortColumn = z.enum([
    'assignee',
    'candidate_name',
    'candidate_to_name',
    'creator',
    'scheduled',
    'status',
    'updated'
]);

/**
 * PeriodDates
 */
export const zPeriodDates = z.object({
    date_from: z.string().datetime().nullish(),
    date_to: z.string().datetime()
});

/**
 * PeriodStats
 */
export const zPeriodStats = z.object({
    intro_completed: z.number().int(),
    intro_requests: z.number().int(),
    pipeline_created: z.number().int()
});

/**
 * PersonBasicEmailResponse
 */
export const zPersonBasicEmailResponse = z.object({
    email: z.string().email(),
    name: z.string(),
    first_name: z.string().nullish(),
    last_name: z.string().nullish(),
    image: z.string().nullish(),
    uuid: z.string().uuid(),
    profile_image_url: z.string().nullable()
});

/**
 * CandidateGoalTask
 */
export const zCandidateGoalTask = z.object({
    assignee: zPersonBasicEmailResponse,
    created: z.string().datetime(),
    creator: zPersonBasicEmailResponse,
    completion_date: z.string().datetime().nullish(),
    description: z.string().nullish(),
    due_date: z.string().datetime().nullish(),
    id: z.string().uuid(),
    is_completed: z.boolean(),
    last_modified: z.string().datetime(),
    title: z.string(),
    overdue: z.boolean().readonly()
});

/**
 * CandidateSearchResponse
 */
export const zCandidateSearchResponse = z.object({
    company: z.string().nullish(),
    role: z.string().nullish(),
    advisor: zPersonBasicEmailResponse.nullish(),
    email: z.string(),
    first_name: z.string().nullish(),
    function_expertise: z.array(zFunction),
    function_target: z.array(zFunction),
    id: z.number().int(),
    image: z.string().nullish(),
    industry_expertise: z.array(zIndustry),
    industry_target: z.array(zIndustry),
    interest_role_board_advisory: zInterestRole.nullish(),
    interest_role_operating: zInterestRole.nullish(),
    interests_personal: z.array(zInterestPersonal),
    interests_professional: z.array(zInterestProfessional),
    is_client: z.boolean(),
    intro_email_type: zIntroEmailType,
    keywords: z.array(z.string()),
    last_name: z.string().nullish(),
    linkedin_url: z.string().nullish(),
    location: z.string().nullish(),
    name: z.string().nullish(),
    tier: zCandidateTier,
    type: zClientType.nullish(),
    pathway: zCandidatePathway.nullish(),
    uuid: z.string().uuid()
});

/**
 * CandidateSearchResponseWithLinkedPerson
 */
export const zCandidateSearchResponseWithLinkedPerson = z.object({
    company: z.string().nullish(),
    role: z.string().nullish(),
    advisor: zPersonBasicEmailResponse.nullish(),
    email: z.string(),
    first_name: z.string().nullish(),
    function_expertise: z.array(zFunction),
    function_target: z.array(zFunction),
    id: z.number().int(),
    image: z.string().nullish(),
    industry_expertise: z.array(zIndustry),
    industry_target: z.array(zIndustry),
    interest_role_board_advisory: zInterestRole.nullish(),
    interest_role_operating: zInterestRole.nullish(),
    interests_personal: z.array(zInterestPersonal),
    interests_professional: z.array(zInterestProfessional),
    is_client: z.boolean(),
    intro_email_type: zIntroEmailType,
    keywords: z.array(z.string()),
    last_name: z.string().nullish(),
    linkedin_url: z.string().nullish(),
    location: z.string().nullish(),
    name: z.string().nullish(),
    tier: zCandidateTier,
    type: zClientType.nullish(),
    pathway: zCandidatePathway.nullish(),
    uuid: z.string().uuid(),
    person: zCandidateLinkedPersonResponse.nullish()
});

/**
 * PersonBasicResponse
 */
export const zPersonBasicResponse = z.object({
    name: z.string(),
    first_name: z.string().nullish(),
    last_name: z.string().nullish(),
    image: z.string().nullish(),
    uuid: z.string().uuid(),
    profile_image_url: z.string().nullable()
});

/**
 * ActivityFeedItem
 *
 * A single row in the unified exec activity feed.
 *
 * Mixes `CandidateActivityLog` rows (kind="activity_log") with synthetic
 * connection-source rows derived from Event / Peer / SubmissionCandidate /
 * Referrer joins. Activity-log items carry the rich fields (actor,
 * candidate, message, event_type); connection-source items carry
 * structured ``contact`` / ``company`` / ``event_ref`` refs.
 *
 * Message composition is the webapp's responsibility — backend exposes
 * only the components (ids, names, slugs) and the webapp builds the
 * localized string with linkable participants from i18n keys.
 */
export const zActivityFeedItem = z.object({
    kind: z.enum([
        'activity_log',
        'event',
        'peer',
        'pipeline',
        'trending',
        'global_intro',
        'referral',
        'comment'
    ]),
    uuid: z.string().uuid(),
    date: z.string().datetime(),
    event_type: z.string().nullish(),
    actor: zPersonBasicResponse.nullish(),
    candidate: zCandidateBasicResponse.nullish(),
    message: zActivityLogMessage.nullish(),
    reference_type: z.string().nullish(),
    reference_id: z.string().uuid().nullish(),
    contact: zActivityFeedParticipant.nullish(),
    company: zActivityFeedCompanyRef.nullish(),
    event_ref: zActivityFeedEventRef.nullish(),
    referrer: zActivityFeedParticipant.nullish(),
    referred: zActivityFeedParticipant.nullish(),
    content: z.string().nullish()
});

/**
 * CandidateActivityLogGroupMember
 */
export const zCandidateActivityLogGroupMember = z.object({
    actor: zPersonBasicResponse.nullish(),
    date: z.string().datetime(),
    event_type: z.union([
        zCandidateActivityLogEventType,
        zCandidateActivityLogEventTypeHidden
    ]),
    uuid: z.string().uuid(),
    message: zActivityLogMessage,
    reference_id: z.string().uuid().nullish(),
    reference_type: zCandidateActivityLogReferenceType.nullish(),
    latest_recommendation: zCandidateActivityLatestRecommendation.nullish()
});

/**
 * CandidateActivityLogReferenceGroups
 */
export const zCandidateActivityLogReferenceGroups = z.object({
    global: z.array(zCandidateActivityLogGroupMember).nullish(),
    peer: z.array(zCandidateActivityLogGroupMember).nullish(),
    pipeline: z.array(zCandidateActivityLogGroupMember).nullish(),
    trending: z.array(zCandidateActivityLogGroupMember).nullish()
});

/**
 * CandidateActivityLogResponse
 */
export const zCandidateActivityLogResponse = z.object({
    actor: zPersonBasicResponse.nullish(),
    candidate: zCandidateBasicResponse,
    date: z.string().datetime(),
    event_type: zCandidateActivityLogEventType,
    uuid: z.string().uuid(),
    message: zActivityLogMessage,
    reference_id: z.string().uuid().nullish(),
    reference_type: zCandidateActivityLogReferenceType.nullish(),
    recommendation_uuid: z.string().uuid().nullish()
});

/**
 * CandidateActivityLogResponseWithHidden
 */
export const zCandidateActivityLogResponseWithHidden = z.object({
    actor: zPersonBasicResponse.nullish(),
    candidate: zCandidateBasicResponse,
    date: z.string().datetime(),
    event_type: z.union([
        zCandidateActivityLogEventType,
        zCandidateActivityLogEventTypeHidden
    ]),
    uuid: z.string().uuid(),
    message: zActivityLogMessage,
    reference_id: z.string().uuid().nullish(),
    reference_type: zCandidateActivityLogReferenceType.nullish(),
    recommendation_uuid: z.string().uuid().nullish(),
    latest_recommendation: zCandidateActivityLatestRecommendation.nullish()
});

/**
 * CandidateCompanyRoleWithAdvisorResponse
 */
export const zCandidateCompanyRoleWithAdvisorResponse = z.object({
    company: z.string().nullish(),
    role: z.string().nullish(),
    image: z.string().nullish(),
    name: z.string(),
    uuid: z.string().uuid(),
    advisor: zPersonBasicResponse.nullish(),
    first_name: z.string().nullish(),
    is_client: z.boolean(),
    last_name: z.string().nullish(),
    linkedin_url: z.string().nullish(),
    profile_image_url: z.string().nullable()
});

/**
 * CandidateGoal
 */
export const zCandidateGoal = z.object({
    activities: z.array(zCandidateActivityLogResponseWithHidden).nullish(),
    completion_date: z.string().datetime().nullish(),
    created: z.string().datetime(),
    due_date: z.string().datetime().nullish(),
    id: z.string().uuid(),
    intro_stats: z.array(zIntroStats).nullish(),
    priority: zGoalPriority.nullish(),
    program: zCandidateType,
    notes: z.array(zCandidateGoalNotes).nullish(),
    latest_note: z.string().nullable(),
    status: zGoalStatus,
    tasks: z.array(zCandidateGoalTask).nullish(),
    title: z.string(),
    last_modified: z.string().datetime()
});

/**
 * CandidateGoalsResponse
 */
export const zCandidateGoalsResponse = z.object({
    candidate_uuid: z.string().uuid(),
    goals: z.array(zCandidateGoal),
    total_goals: z.number().int().readonly()
});

/**
 * CandidatePerformanceResponse
 */
export const zCandidatePerformanceResponse = z.object({
    candidate: zCandidateCompanyRoleResponse,
    advisor: zPersonBasicResponse,
    introductions_requested_count: z.number().int(),
    recommendation_count: z.number().int(),
    pipeline_count: z.number().int(),
    days_to_quarterly: z.number().int()
});

/**
 * CandidatesCombinedPerformanceResponse
 */
export const zCandidatesCombinedPerformanceResponse = z.object({
    candidate: zCandidateCompanyRoleResponse,
    advisor: zPersonBasicResponse,
    type: zClientType.nullish(),
    pathway: zCandidatePathway.nullish(),
    industry_expertise: z.array(zIndustry),
    function_expertise: z.array(zFunction),
    introductions_facilitated_count: z.number().int(),
    introductions_requested_count: z.number().int(),
    recommendation_count: z.number().int(),
    pipeline_count: z.number().int(),
    peer_activity_count: z.number().int(),
    rank: z.number().int(),
    calculated_rank: z.number()
});

/**
 * CandidatesTableResponse
 */
export const zCandidatesTableResponse = z.object({
    search_metadata: zEsMeta.nullish(),
    __linkedin_profile_last_synced__DO_NOT_USE__: z.string().datetime().nullish(),
    __manual_last_update__DO_NOT_USE__: z.string().datetime().nullish(),
    profile_updated_date: z.string().datetime().nullish(),
    __resume_last_uploaded__DO_NOT_USE__: z.string().datetime().nullish(),
    is_client: z.boolean().nullish(),
    company: z.string().nullish(),
    role: z.string().nullish(),
    image: z.string().nullish(),
    name: z.string(),
    uuid: z.string().uuid(),
    active: z.boolean(),
    advisor: zPersonBasicResponse.nullish(),
    advisor_advisor_id: z.string().uuid().nullish(),
    advisor_advisor_image: z.string().nullish(),
    advisor_advisor_name: z.string().nullish(),
    referred_date: z.string().datetime().nullish(),
    email: z.string(),
    first_name: z.string().nullish(),
    function_expertise: z.array(zFunction),
    function_target: z.array(zFunction),
    industry_expertise: z.array(zIndustry),
    industry_target: z.array(zIndustry),
    interest_role_board_advisory: zInterestRole.nullish(),
    interest_role_operating: zInterestRole.nullish(),
    interests_personal: z.array(zInterestPersonal),
    interests_professional: z.array(zInterestProfessional),
    keywords: z.array(z.string()),
    last_name: z.string().nullish(),
    linkedin_url: z.string().nullish(),
    location: z.string().nullish(),
    tier: zCandidateTier,
    invoice_status: zHubSpotInvoiceStatus.nullish(),
    type: zClientType.nullish(),
    pathway: zCandidatePathway.nullish(),
    profile_image_url: z.string().nullable()
});

/**
 * GroupedActivityLogResponse
 */
export const zGroupedActivityLogResponse = z.object({
    totals: zCandidateActivityLogTotals,
    candidate: zCandidateBasicResponse,
    logs: zCandidateActivityLogReferenceGroups
});

/**
 * HomepageActivityLogResponse
 */
export const zHomepageActivityLogResponse = z.object({
    actor: zPersonBasicResponse.nullish(),
    candidate: zCandidateBasicResponse.nullish(),
    date: z.string().datetime(),
    event_type: z.union([
        zActivityLogEventType,
        zCandidateActivityLogEventType
    ]),
    message: zActivityLogMessage,
    reference_id: z.string().uuid().nullish(),
    reference_type: zCandidateActivityLogReferenceType.nullish(),
    uuid: z.string().uuid()
});

/**
 * IdentityBasicResponse
 */
export const zIdentityBasicResponse = z.object({
    uuid: z.string().uuid(),
    name: z.string().nullish(),
    candidate: zCandidateBasicResponse.nullish(),
    executive_person: zPersonBasicResponse.nullish()
});

/**
 * EventEmailEventItemResponse
 *
 * One email sent for an event, and what SendGrid has told us about it since.
 */
export const zEventEmailEventItemResponse = z.object({
    sendgrid_message_id: z.string(),
    sendgrid_recipient_email: z.string(),
    recipient: zIdentityBasicResponse.nullish(),
    email_event_type: zEmailEventType.nullish(),
    batch_uuid: z.string().uuid().nullish(),
    sent_at: z.string().datetime().nullish(),
    delivered_at: z.string().datetime().nullish(),
    first_opened_at: z.string().datetime().nullish(),
    last_opened_at: z.string().datetime().nullish(),
    open_count: z.number().int(),
    click_count: z.number().int(),
    failed_at: z.string().datetime().nullish(),
    failure: z.enum(['dropped', 'bounce']).nullish()
});

/**
 * EventEmailBatchResponse
 *
 * One send run for an event: the invites sent in one go, one reminder pass,
 * one RSVP confirmation. Counts are of emails, not of SendGrid events: an
 * email opened twice is one opened email.
 */
export const zEventEmailBatchResponse = z.object({
    batch_uuid: z.string().uuid(),
    email_event_type: zEmailEventType.nullish(),
    sent_at: z.string().datetime().nullish(),
    email_count: z.number().int(),
    delivered_count: z.number().int(),
    opened_count: z.number().int(),
    clicked_count: z.number().int(),
    failed_count: z.number().int(),
    email_template: zEmailTemplateResponse.nullish(),
    first_emails: z.array(zEventEmailEventItemResponse)
});

/**
 * IdentityEmailItemResponse
 *
 * One email sent to this human, and what SendGrid has told us about it since.
 */
export const zIdentityEmailItemResponse = z.object({
    sendgrid_message_id: z.string(),
    sendgrid_recipient_email: z.string(),
    recipient: zIdentityBasicResponse.nullish(),
    email_event_type: zEmailEventType.nullish(),
    batch_uuid: z.string().uuid().nullish(),
    sent_at: z.string().datetime().nullish(),
    delivered_at: z.string().datetime().nullish(),
    first_opened_at: z.string().datetime().nullish(),
    last_opened_at: z.string().datetime().nullish(),
    open_count: z.number().int(),
    click_count: z.number().int(),
    failed_at: z.string().datetime().nullish(),
    failure: z.enum(['dropped', 'bounce']).nullish()
});

/**
 * PeerActivityResponse
 */
export const zPeerActivityResponse = z.object({
    context: z.string().nullish(),
    created: z.string().datetime(),
    creator: zPersonBasicResponse,
    event: zPeerEvent,
    id: z.string().uuid(),
    last_modified: z.string().datetime()
});

/**
 * PeerComparePeerToPeerResponse
 */
export const zPeerComparePeerToPeerResponse = z.object({
    id: z.string().uuid(),
    created: z.string().datetime(),
    last_modified: z.string().datetime(),
    introduced_on: z.string().datetime().nullish(),
    candidate: zCandidateCompanyRoleWithAdvisorResponse,
    status: zPeerStatus
});

/**
 * PeerCompareP2PResponse
 */
export const zPeerCompareP2pResponse = z.object({
    candidate: zCandidateBasicResponse,
    matches: z.array(zPeerComparePeerToPeerResponse)
});

/**
 * PeerToPeerBasicESResponse
 */
export const zPeerToPeerBasicEsResponse = z.object({
    assignees: z.array(zPersonBasicEmailResponse),
    candidate: zCandidateCompanyRoleWithAdvisorResponse,
    candidate_to: zCandidateCompanyRoleWithAdvisorResponse,
    context: z.string().nullish(),
    created: z.string().datetime(),
    creator: zPersonBasicEmailResponse,
    id: z.string().uuid(),
    introduced_on: z.string().datetime().nullish(),
    last_modified: z.string().datetime(),
    status: zPeerStatus,
    reviewers: z.array(zPersonBasicEmailResponse),
    reviewers_statuses: z.array(zPeerToPeerReviewersStatus)
});

/**
 * PeerToPeerBasicResponse
 */
export const zPeerToPeerBasicResponse = z.object({
    assignees: z.array(zPersonBasicEmailResponse),
    candidate: zCandidateCompanyRoleWithAdvisorResponse,
    candidate_to: zCandidateCompanyRoleWithAdvisorResponse,
    context: z.string().nullish(),
    created: z.string().datetime(),
    creator: zPersonBasicEmailResponse,
    id: z.string().uuid(),
    introduced_on: z.string().datetime().nullish(),
    last_modified: z.string().datetime(),
    status: zPeerStatus
});

/**
 * PeerCommentResponse
 */
export const zPeerCommentResponse = z.object({
    context: z.string(),
    created: z.string().datetime(),
    creator: zPersonBasicResponse,
    id: z.string().uuid(),
    last_modified: z.string().datetime(),
    peer: zPeerToPeerBasicResponse
});

/**
 * PeerToPeerExtendedResponse
 */
export const zPeerToPeerExtendedResponse = z.object({
    assignees: z.array(zPersonBasicEmailResponse),
    candidate: zCandidateCompanyRoleWithAdvisorResponse,
    candidate_to: zCandidateCompanyRoleWithAdvisorResponse,
    context: z.string().nullish(),
    created: z.string().datetime(),
    creator: zPersonBasicEmailResponse,
    id: z.string().uuid(),
    introduced_on: z.string().datetime().nullish(),
    last_modified: z.string().datetime(),
    status: zPeerStatus,
    email_body: z.string().nullish(),
    email_sender: zPersonBasicEmailResponse.nullish(),
    email_subject: z.string().nullish(),
    email_cc: z.array(zPersonBasicEmailResponse).nullish(),
    reviewers: z.array(zPersonBasicEmailResponse),
    reviewers_status: z.record(zPeerStatus)
});

/**
 * PeerToPeerSelectResponse
 */
export const zPeerToPeerSelectResponse = z.object({
    is_client: z.boolean(),
    company: z.string().nullish(),
    role: z.string().nullish(),
    image: z.string().nullish(),
    name: z.string(),
    uuid: z.string().uuid(),
    first_name: z.string().nullish(),
    function_expertise: z.array(zFunction),
    function_target: z.array(zFunction),
    industry_expertise: z.array(zIndustry),
    industry_target: z.array(zIndustry),
    interest_role_board_advisory: zInterestRole.nullish(),
    interest_role_operating: zInterestRole.nullish(),
    interests_personal: z.array(zInterestPersonal),
    interests_professional: z.array(zInterestProfessional),
    keywords: z.array(z.string()),
    last_name: z.string().nullish(),
    linkedin_url: z.string().nullish(),
    tier: zCandidateTier,
    type: zClientType.nullish(),
    pathway: zCandidatePathway.nullish(),
    advisor: zPersonBasicResponse.nullish(),
    intros_count: z.number().int().optional().default(0),
    last_peer_introduced_on: z.string().datetime().nullish(),
    last_peer_status: zPeerStatus.nullish(),
    last_event_date: z.string().datetime().nullish(),
    last_event: zPeerToPeerLastEventResponse.nullish(),
    client_has_peer_as_referrer: z.boolean().optional().default(false),
    peer_has_client_as_referrer: z.boolean().optional().default(false),
    location: z.string().nullish(),
    invoice_status: zHubSpotInvoiceStatus.nullish(),
    profile_image_url: z.string().nullable()
});

/**
 * PersonClerkPasswordPut
 *
 * Set a user's Clerk password (admin on v1, self-service on v2 ``/current``).
 */
export const zPersonClerkPasswordPut = z.object({
    new_password: z.string()
});

/**
 * PersonCurrentExternalPatch
 *
 * Schema for self-service updates of external person fields.
 */
export const zPersonCurrentExternalPatch = z.object({
    email: z.string().email().nullish(),
    first_name: z.string().min(1).nullish(),
    last_name: z.string().min(1).nullish(),
    notes_external: z.string().min(1).nullish(),
    linkedin_url: z.string().min(1).nullish()
});

/**
 * PersonCurrentExternalResponse
 */
export const zPersonCurrentExternalResponse = z.object({
    uuid: z.string().uuid(),
    email: z.string().email(),
    first_name: z.string().nullish(),
    last_name: z.string().nullish(),
    notes_external: z.string().nullish(),
    linkedin_url: z.string().nullish()
});

/**
 * PersonEmailNotificationsPatch
 *
 * Schema for updating a person's email notification preferences.
 */
export const zPersonEmailNotificationsPatch = z.object({
    permit_preregistration_notifications: z.boolean()
});

/**
 * PersonInnerDocSchema
 */
export const zPersonInnerDocSchema = z.object({
    email: z.string().email(),
    first_name: z.string().nullish(),
    name: z.string(),
    last_name: z.string().nullish(),
    image: z.string().nullish(),
    uuid: z.string().uuid(),
    profile_image_url: z.string().nullable()
});

/**
 * PersonPasswordUpdatedResponse
 *
 * Returned after a successful Clerk password update.
 */
export const zPersonPasswordUpdatedResponse = z.object({
    email: z.string().email()
});

/**
 * PersonPatch
 *
 * Schema for partially updating a person's profile.
 */
export const zPersonPatch = z.object({
    email: z.string().email().nullish(),
    first_name: z.string().min(1).nullish(),
    last_name: z.string().min(1).nullish(),
    notes_external: z.string().min(1).nullish(),
    notes_internal: z.string().min(1).nullish(),
    linkedin_url: z.string().min(1).nullish(),
    wants_intros: z.boolean().nullish(),
    wants_intro_followups: z.boolean().nullish(),
    handle_intros_as_exec: z.boolean().nullish()
});

/**
 * PersonSearchResponse
 */
export const zPersonSearchResponse = z.object({
    search_metadata: zEsMeta.nullish(),
    first_name: z.string().min(1).nullish(),
    last_name: z.string().min(1).nullish(),
    email: z.string().email(),
    company: zCompanyBasicTypeResponse.nullish(),
    full_name: z.string().nullish(),
    id: z.string().uuid(),
    uuid: z.string().uuid()
});

/**
 * PersonalContactTagItem
 *
 * Tag label on a contact (executive people list, profiles, etc.).
 */
export const zPersonalContactTagItem = z.object({
    uuid: z.string().uuid(),
    name: z.string()
});

/**
 * ExecutivePeopleDetailResponse
 *
 * Person-only contact detail for the executive client people page.
 */
export const zExecutivePeopleDetailResponse = z.object({
    person_uuid: z.string().uuid(),
    identity_uuid: z.string().uuid().nullish(),
    full_name: z.string().nullish(),
    first_name: z.string().nullish(),
    last_name: z.string().nullish(),
    email: z.string().nullish(),
    profile_img: z.string().nullish(),
    notes_external: z.string().nullish(),
    linkedin_url: z.string().nullish(),
    current_role: z.string().nullish(),
    current_company: z.string().nullish(),
    company: zCompanyBasicTypeResponse.nullish(),
    source_types: z.array(zContactSourceType).optional(),
    evidence: zContactEvidenceResponse.nullish(),
    personal_tags: z.array(zPersonalContactTagItem).optional(),
    is_favorite: z.boolean().optional().default(false),
    was_introduced: z.boolean().optional().default(false),
    profile_image_url: z.string().nullable()
});

/**
 * ExecutivePeopleResultItem
 *
 * A single contact in the exec's people page.
 *
 * Canonical typed contact item for the people page.
 */
export const zExecutivePeopleResultItem = z.object({
    object_type: z.enum(['candidate', 'person']),
    contact_key: z.string(),
    candidate_uuid: z.string().nullish(),
    person_uuid: z.string().nullish(),
    full_name: z.string().nullish(),
    email: z.string().nullish(),
    current_company: z.string().nullish(),
    current_role: z.string().nullish(),
    profile_img: z.string().nullish(),
    source_types: z.array(zContactSourceType).optional(),
    evidence: zContactEvidenceResponse.nullish(),
    personal_tags: z.array(zPersonalContactTagItem).optional(),
    is_favorite: z.boolean().optional().default(false),
    was_introduced: z.boolean().optional().default(false),
    profile_image_url: z.string().nullable()
});

/**
 * PersonalTagAssociationCreatePayload
 *
 * Exactly one of ``tag_definition_uuid`` (existing) or ``name`` (create + link).
 */
export const zPersonalTagAssociationCreatePayload = z.object({
    tag_definition_uuid: z.string().uuid().nullish(),
    name: z.string().min(1).max(255).nullish()
});

/**
 * PersonalTagDefinitionCreatePayload
 */
export const zPersonalTagDefinitionCreatePayload = z.object({
    name: z.string().min(1).max(255)
});

/**
 * PersonalTagDefinitionPatchPayload
 */
export const zPersonalTagDefinitionPatchPayload = z.object({
    name: z.string().min(1).max(255)
});

/**
 * PersonalTagDefinitionResponse
 */
export const zPersonalTagDefinitionResponse = z.object({
    uuid: z.string().uuid(),
    name: z.string(),
    created: z.string().datetime(),
    last_modified: z.string().datetime(),
    usage_count: z.number().int().nullish()
});

/**
 * PersonalTagOnContactResponse
 *
 * After adding a tag to a contact.
 */
export const zPersonalTagOnContactResponse = z.object({
    association_uuid: z.string().uuid(),
    tag_definition_uuid: z.string().uuid(),
    name: z.string()
});

/**
 * PipelineActive
 */
export const zPipelineActive = z.object({
    active: z.boolean()
});

/**
 * PipelineAttendees
 */
export const zPipelineAttendees = z.enum([
    '1-10',
    '11-20',
    '21-50'
]);

/**
 * PipelineCandidateSortColumn
 */
export const zPipelineCandidateSortColumn = z.enum([
    'assignee_name',
    'created',
    'interest_role_board_advisory',
    'interest_role_operating',
    'name',
    'not_accepting_end_date',
    'operating_highlights',
    'pipeline_status',
    'recommended_on',
    'tier',
    'tier_rank',
    'under_represented',
    'warm'
]);

/**
 * PipelineCandidateTeamStatus
 */
export const zPipelineCandidateTeamStatus = z.object({
    action: zEvaluationAction,
    created: z.string().datetime().nullish()
});

/**
 * PipelineObjective
 */
export const zPipelineObjective = z.enum([
    'Board/Advisory',
    'Backable Executive',
    'General',
    'Operating',
    'Other'
]);

/**
 * PipelineRoleType
 */
export const zPipelineRoleType = z.enum([
    'BOARD',
    'EXECUTIVE',
    'GENERAL',
    'OPERATING',
    'OTHER'
]);

/**
 * PipelineRoleTypeWithNull
 */
export const zPipelineRoleTypeWithNull = z.enum([
    'BOARD',
    'EXECUTIVE',
    'GENERAL',
    'OPERATING',
    'OTHER',
    'null'
]);

/**
 * PipelineStatus
 */
export const zPipelineStatus = z.enum(['active', 'closed']);

/**
 * PipelineTransferPayload
 *
 * Payload for transferring pipelines to another team.
 */
export const zPipelineTransferPayload = z.object({
    target_team_uuid: z.string().uuid(),
    pipeline_uuids: z.array(z.string().uuid()).min(1)
});

/**
 * PipelineTransferResponse
 *
 * Response for pipeline transfer operation.
 */
export const zPipelineTransferResponse = z.object({
    transferred_count: z.number().int(),
    pipeline_uuids: z.array(z.string().uuid()),
    target_team_uuid: z.string().uuid(),
    warnings: z.array(z.string()).optional()
});

/**
 * PipelineType
 */
export const zPipelineType = z.enum([
    'HIRING',
    'NETWORKING',
    'EVENT',
    'RESEARCH',
    'OTHER'
]);

/**
 * CreatePipelinePayload
 */
export const zCreatePipelinePayload = z.object({
    is_visible_to_team: z.boolean().nullish(),
    keywords: z.array(z.string().min(1)),
    placed_candidate_id: z.string().uuid().nullish(),
    is_proactive: z.boolean().optional().default(false),
    is_notification_enabled: z.boolean().nullish(),
    attendees: zPipelineAttendees.nullish(),
    company: z.string().min(1).nullish(),
    company_size: zCompanySize.nullish(),
    company_type: zCompanyType.nullish(),
    event_date: z.string().datetime().nullish(),
    event_name: z.string().nullish(),
    function_expertise: z.array(zFunction).min(1),
    industry_expertise: z.array(zIndustry).min(1),
    is_urg: z.boolean().nullish(),
    location: z.string().min(1).nullish(),
    name: z.string().min(1),
    notes: z.string().min(1).nullish(),
    pipeline_type: zPipelineType.nullish(),
    point_of_contact_person_id: z.string().uuid().nullish(),
    purpose: z.string().nullish(),
    role_type: zPipelineRoleType
});

/**
 * PipelineBasicHiddenResponse
 */
export const zPipelineBasicHiddenResponse = z.object({
    name: z.string(),
    pipeline_type: zPipelineType.optional().default('OTHER'),
    slug: z.string(),
    is_visible_to_team: z.boolean(),
    hidden: z.boolean().optional().default(true)
});

/**
 * PipelineBasicResponse
 */
export const zPipelineBasicResponse = z.object({
    name: z.string(),
    pipeline_type: zPipelineType.optional().default('OTHER'),
    slug: z.string()
});

/**
 * PipelineBasicV2Response
 */
export const zPipelineBasicV2Response = z.object({
    company: z.string().nullish(),
    pipeline_type: zPipelineType.optional().default('OTHER'),
    role: z.string(),
    slug: z.string(),
    uuid: z.string().uuid()
});

/**
 * CandidateActivityEvent
 */
export const zCandidateActivityEvent = z.object({
    comment_uuid: z.string().uuid().nullish(),
    context: z.string().nullish(),
    external_introduction_request_person: zExternalPerson.nullish(),
    date: z.string().datetime(),
    event_type: zCandidateActivityEventType,
    pipeline: zPipelineBasicV2Response.nullish(),
    recommendation_uuid: z.string().uuid().nullish(),
    user: zPersonBasicResponse,
    uuid: z.string().uuid(),
    team_uuid: z.string().uuid().nullish()
});

/**
 * PipelineExternalResponse
 */
export const zPipelineExternalResponse = z.object({
    created: z.string().datetime(),
    company: z.string().nullish(),
    formatted_name: z.string(),
    last_modified: z.string().datetime(),
    type: zPipelineType.optional().default('OTHER'),
    role: z.string(),
    slug: z.string(),
    uuid: z.string().uuid()
});

/**
 * PipelineTypeFilter
 */
export const zPipelineTypeFilter = z.enum([
    'hiring',
    'networking',
    'other',
    'research',
    'event'
]);

/**
 * PipelinesAdvancedSearch
 */
export const zPipelinesAdvancedSearch = z.object({
    title: z.array(z.string()).nullish(),
    location: z.array(z.string()).nullish(),
    notes: z.array(z.string()).nullish()
});

/**
 * PipelinesAggregationsResponse
 */
export const zPipelinesAggregationsResponse = z.object({
    status: z.record(z.number().int()),
    industry_expertise: z.record(z.number().int()),
    function_expertise: z.record(z.number().int()),
    is_proactive: z.record(z.number().int()),
    company_size: z.record(z.number().int()),
    has_completed_intro: z.record(z.number().int()),
    team_type: z.record(z.number().int()),
    pipeline_type: z.record(z.number().int()),
    team_uuid: z.record(z.number().int()),
    team_company_slug: z.record(z.number().int())
});

/**
 * PipelinesFilters
 */
export const zPipelinesFilters = z.object({
    status: z.array(zPipelineStatus).nullish(),
    industry_expertise: z.array(zIndustry).nullish(),
    function_expertise: z.array(zFunction).nullish(),
    is_proactive: z.array(z.boolean()).nullish(),
    company_size: z.array(zCompanySize).nullish(),
    has_completed_intro: z.array(z.boolean()).nullish(),
    team_type: z.array(zOrgType).nullish(),
    pipeline_type: z.array(zPipelineType).nullish(),
    team_uuid: z.array(z.string()).nullish(),
    company: z.array(z.string()).nullish()
});

/**
 * PipelinesSortColumn
 */
export const zPipelinesSortColumn = z.enum([
    '',
    'role',
    'role_type',
    'created',
    'last_modified',
    'industry_expertise',
    'function_expertise',
    'is_proactive',
    'company',
    'has_completed_intro',
    'recommendations_count',
    'introductions_count',
    'last_submission',
    'recommendations',
    'active',
    'team_type'
]);

/**
 * PositionResponse
 */
export const zPositionResponse = z.object({
    dates: z.string().nullish(),
    duration: z.string().nullish(),
    location: z.string().nullish(),
    summary: z.string().nullish(),
    name: z.string()
});

/**
 * CompanyResponse
 */
export const zCompanyResponse = z.object({
    dates: z.string().nullish(),
    name: z.string(),
    positions: z.array(zPositionResponse).default([])
});

/**
 * PositionUploadResponse
 */
export const zPositionUploadResponse = z.object({
    dates: z.string().nullish(),
    duration: z.string().nullish(),
    location: z.string().nullish(),
    summary: z.string().nullish(),
    name: z.string()
});

/**
 * CompanyUploadResponse
 */
export const zCompanyUploadResponse = z.object({
    dates: z.string().nullish(),
    name: z.string(),
    positions: z.array(zPositionUploadResponse)
});

/**
 * PostPersonClerkUserResponse
 */
export const zPostPersonClerkUserResponse = z.object({
    person: zPersonBasicResponse,
    clerk_user_id: z.string()
});

/**
 * PotentialGuestSortColumn
 *
 * Sort columns for potential guests search (event guest list).
 */
export const zPotentialGuestSortColumn = z.enum([
    'advisor_name',
    'created',
    'events_attended_count',
    'events_invited_count',
    'last_event_date',
    'name',
    'email',
    'source_type',
    'tier',
    'underrepresented',
    'warm'
]);

/**
 * PotentialGuestSourceType
 *
 * Source of a potential guest in the pool.
 */
export const zPotentialGuestSourceType = z.enum([
    'candidate',
    'event_guest',
    'user'
]);

/**
 * EventGuestItemResponse
 *
 * A guest on an event's guest list (polymorphic on source type, like potential guests).
 *
 * Always includes resolved name, role, company, email for display, plus
 * source_type, person_uuid/candidate_uuid for linking, and event-guest fields (id, uuid, status).
 */
export const zEventGuestItemResponse = z.object({
    source_type: zPotentialGuestSourceType,
    id: z.number().int(),
    uuid: z.string().uuid(),
    identity_uuid: z.string().uuid().nullish(),
    person_uuid: z.string().uuid().nullish(),
    candidate_uuid: z.string().uuid().nullish(),
    invoice_status: zHubSpotInvoiceStatus.nullish(),
    is_executive: z.boolean().optional().default(false),
    name: z.string().nullish(),
    role: z.string().nullish(),
    company: z.string().nullish(),
    email: z.string().nullish(),
    status: zEventGuestStatus,
    invite_sent_at: z.string().datetime().nullish(),
    created: z.string().datetime(),
    referrers: z.array(zPersonBasicResponse).nullish(),
    client_types: z.array(zEventGuestClientType).optional()
});

/**
 * AddGuestsResponse
 *
 * Response after adding guests to an event.
 */
export const zAddGuestsResponse = z.object({
    added: z.array(zEventGuestItemResponse)
});

/**
 * EventGuestWithEventItemResponse
 *
 * An event guest with the event it belongs to (for listing all guests across events).
 */
export const zEventGuestWithEventItemResponse = z.object({
    event_uuid: z.string().uuid(),
    event_title: z.string(),
    guest: zEventGuestItemResponse
});

/**
 * EventGuestsPage[EventGuestItemResponse]
 */
export const zEventGuestsPageEventGuestItemResponse = z.object({
    page_count: z.number().int().gte(0),
    page: z.number().int().gte(1),
    search_id: z.string().nullish(),
    results: z.array(zEventGuestItemResponse),
    size: z.number().int().gte(1),
    total_counts: zEventGuestTotalCounts
});

/**
 * EventGuestsSelectionResponse
 *
 * All guests matching the selection filters (no pagination).
 */
export const zEventGuestsSelectionResponse = z.object({
    results: z.array(zEventGuestItemResponse),
    count: z.number().int()
});

/**
 * EventResponse
 *
 * Event with optional guest list.
 */
export const zEventResponse = z.object({
    id: z.number().int(),
    uuid: z.string().uuid(),
    title: z.string(),
    categories: z.array(zEventCategory),
    category: zEventCategory.nullish(),
    draft: z.boolean(),
    rsvp_enabled: z.boolean(),
    description: z.string().nullish(),
    notes: z.string().nullish(),
    event_date: z.string().datetime().nullish(),
    event_timezone: z.string().nullish(),
    event_date_local: z.string().datetime().nullish(),
    location: z.string().nullish(),
    max_participants: z.number().int().nullish(),
    additional_link: z.string().nullish(),
    invite_email_subject: z.string().nullish(),
    invite_email_body: z.string().nullish(),
    invite_sender_email: z.string().nullish(),
    invite_sender_name: z.string().nullish(),
    landing_image: z.string().nullish(),
    created: z.string().datetime(),
    last_modified: z.string().datetime(),
    guests_count: z.number().int().optional().default(0),
    actual_guests_count: z.number().int().optional().default(0),
    guests: z.array(zEventGuestItemResponse).nullish(),
    my_status: zEventGuestStatus.nullish(),
    is_past: z.boolean().nullish()
});

/**
 * PotentialGuestEmailItemResponse
 *
 * Stripped-down potential guest row for email selection/export flows.
 */
export const zPotentialGuestEmailItemResponse = z.object({
    source_type: zPotentialGuestSourceType,
    person_uuid: z.string().uuid().nullish(),
    candidate_uuid: z.string().uuid().nullish(),
    email: z.string().nullish()
});

/**
 * PotentialGuestItem
 *
 * A single potential guest for event guest lists.
 *
 * Drawn from B4B users (non-advisory), candidates, or standalone event
 * guests from previous events. When a person is both a user and a candidate,
 * they appear once (as user) with optional candidate_uuid set.
 */
export const zPotentialGuestItem = z.object({
    source_type: zPotentialGuestSourceType,
    identity_uuid: z.string().uuid().nullish(),
    person_uuid: z.string().uuid().nullish(),
    candidate_uuid: z.string().uuid().nullish(),
    is_executive: z.boolean().optional().default(false),
    name: z.string().nullish(),
    role: z.string().nullish(),
    company: z.string().nullish(),
    email: z.string().nullish(),
    created: z.string().datetime().nullish(),
    last_event_date: z.string().datetime().nullish(),
    events_attended_count: z.number().int().optional().default(0),
    events_invited_count: z.number().int().optional().default(0),
    tier: zCandidateTier.nullish(),
    candidate_type: zClientType.nullish(),
    pathway: zCandidatePathway.nullish(),
    industry: z.array(zIndustry).nullish(),
    function: z.array(zFunction).nullish(),
    operating_highlights: z.array(zOperatingHighlights).nullish(),
    interest_role_operating: zInterestRole.nullish(),
    interest_role_board: zInterestRole.nullish(),
    keywords: z.array(z.string()).nullish(),
    underrepresented: z.boolean().nullish(),
    warm: z.boolean().nullish(),
    invoice_status: zHubSpotInvoiceStatus.nullish(),
    referrers: z.array(zPersonBasicResponse).nullish(),
    advisor: zPersonBasicResponse.nullish(),
    client_types: z.array(zEventGuestClientType).optional()
});

/**
 * PotentialGuestSelectionKey
 *
 * Identity key for selecting a potential guest row.
 */
export const zPotentialGuestSelectionKey = z.object({
    source_type: zPotentialGuestSourceType,
    person_uuid: z.string().uuid().nullish(),
    candidate_uuid: z.string().uuid().nullish(),
    email: z.string().nullish()
});

/**
 * PotentialGuestsAggregationsResponse
 *
 * Aggregation totals for potential guests filters.
 */
export const zPotentialGuestsAggregationsResponse = z.object({
    source_type: z.record(z.number().int()).optional(),
    client_type: z.record(z.number().int()).optional(),
    tier: z.record(z.number().int()).optional(),
    candidate_type: z.record(z.number().int()).optional(),
    pathway: z.record(z.number().int()).optional(),
    advisor_id: z.record(z.number().int()).optional(),
    event_uuids: z.record(z.number().int()).optional(),
    company_ids: z.record(z.number().int()).optional(),
    has_attended_events: z.record(z.number().int()).optional(),
    has_invited_events: z.record(z.number().int()).optional(),
    industry_expertise: z.record(z.number().int()).optional(),
    function_expertise: z.record(z.number().int()).optional(),
    operating_highlights: z.record(z.number().int()).optional(),
    interest_role_operating: z.record(z.number().int()).optional(),
    interest_role_board: z.record(z.number().int()).optional(),
    last_event: z.record(z.number().int()).optional()
});

/**
 * PotentialGuestsEmailsResponse
 *
 * Selected potential guest rows for client-side email list assembly.
 */
export const zPotentialGuestsEmailsResponse = z.object({
    results: z.array(zPotentialGuestEmailItemResponse).optional(),
    count: z.number().int().gte(0).optional().default(0)
});

/**
 * PotentialGuestsFilters
 *
 * Filters for potential guests search.
 */
export const zPotentialGuestsFilters = z.object({
    source_type: z.array(zPotentialGuestSourceType).nullish(),
    client_type: z.array(zEventGuestClientType).nullish(),
    tier: z.array(zCandidateTier).nullish(),
    candidate_type: z.array(zClientType).nullish(),
    pathway: z.array(zCandidatePathway).nullish(),
    advisor_id: z.array(z.string().uuid()).nullish(),
    event_uuids: z.array(z.string().uuid()).nullish(),
    company_ids: z.array(z.number().int()).nullish(),
    has_attended_events: z.boolean().nullish(),
    has_invited_events: z.boolean().nullish(),
    events_attended_count_min: z.number().int().gte(0).nullish(),
    events_attended_count_max: z.number().int().gte(0).nullish(),
    events_invited_count_min: z.number().int().gte(0).nullish(),
    events_invited_count_max: z.number().int().gte(0).nullish(),
    last_event_date_after: z.string().datetime().nullish(),
    last_event_date_before: z.string().datetime().nullish(),
    industry_expertise: z.array(zIndustry).nullish(),
    function_expertise: z.array(zFunction).nullish(),
    operating_highlights: z.array(zOperatingHighlights).nullish(),
    interest_role_operating: z.array(zInterestRole).nullish(),
    interest_role_board: z.array(zInterestRole).nullish(),
    last_event: z.array(zLastEventBucket).nullish()
});

/**
 * PotentialGuestsEmailsPayload
 *
 * Payload for resolving potential guest emails from search filters + selection mode.
 */
export const zPotentialGuestsEmailsPayload = z.object({
    phrase: z.string().nullish(),
    filter_data: zPotentialGuestsFilters.nullish(),
    include_inactive: z.boolean().optional().default(false),
    selection_mode: z.enum(['explicit', 'all_matching']).optional().default('explicit'),
    included_items: z.array(zPotentialGuestSelectionKey).optional(),
    excluded_items: z.array(zPotentialGuestSelectionKey).optional()
});

/**
 * PotentialGuestsSearchResponse
 *
 * Paginated response for potential guests search with optional aggregations.
 */
export const zPotentialGuestsSearchResponse = z.object({
    results: z.array(zPotentialGuestItem),
    page: z.number().int().gte(1),
    page_count: z.number().int().gte(0),
    size: z.number().int().gte(1),
    total_counts: z.record(z.number().int()),
    aggregations: zPotentialGuestsAggregationsResponse.nullish()
});

/**
 * PriorCompany
 *
 * Attributes
 * ----------
 * selected : bool
 * indicates whether or not this company should be presented to teams in the
 * user experience as part of the candidate's work history
 * company : str
 * the name of the company
 */
export const zPriorCompany = z.object({
    selected: z.boolean().optional().default(false),
    company: z.string()
});

/**
 * CandidateExperience
 *
 * Attributes
 * ----------
 * current_company : str
 * the current company a candidate is employed in some capacity at
 * current_role : str
 * the current role a candidate occupies
 * prior_companies : list[PriorCompany]
 * these are the companies a candidate has worked at prior to their current
 * company
 */
export const zCandidateExperience = z.object({
    current_company: z.string().nullish(),
    current_role: z.string().nullish(),
    prior_companies: z.array(zPriorCompany).optional().default([])
});

/**
 * PutHighlightResponse
 */
export const zPutHighlightResponse = z.object({
    highlight: z.string(),
    created: z.string().datetime(),
    last_modified: z.string().datetime(),
    hidden: z.boolean(),
    soft_delete: z.boolean(),
    uuid: z.string().uuid()
});

/**
 * PutIntroductionTemplatePayload
 */
export const zPutIntroductionTemplatePayload = z.object({
    body: z.string().min(1).max(5000),
    title: z.string().min(1).max(128)
});

/**
 * QueuedMessageResponse
 *
 * Response for endpoints that queue an email task (202 Accepted).
 */
export const zQueuedMessageResponse = z.object({
    message: z.string()
});

/**
 * RecommendationBioResponse
 */
export const zRecommendationBioResponse = z.object({
    about: z.string().nullish(),
    candidate: zCandidateShareResponse,
    highlights: z.array(z.string()),
    presenter: zPersonBasicResponse.nullish()
});

/**
 * RecommendationCandidateBasicResponse
 */
export const zRecommendationCandidateBasicResponse = z.object({
    candidate: zCandidateBasicResponse
});

/**
 * RecommendationCandidatePipelinesResponse
 */
export const zRecommendationCandidatePipelinesResponse = z.object({
    candidate: zCandidateBasicResponse,
    pipeline: zPipelineBasicV2Response.nullish(),
    uuid: z.string().uuid()
});

/**
 * RecommendationCommentaryPayload
 */
export const zRecommendationCommentaryPayload = z.object({
    about: z.string().min(1).nullish(),
    highlights: z.array(z.string().min(1))
});

/**
 * RecommendationCommentsPayload
 */
export const zRecommendationCommentsPayload = z.object({
    team_comments: z.string().min(1).max(500).nullish()
});

/**
 * RecommendationDraftMode
 */
export const zRecommendationDraftMode = z.enum([
    'approved',
    'denied',
    'ready_for_review',
    'suggested',
    'saved'
]);

/**
 * RecommendationExternalIntroduction
 */
export const zRecommendationExternalIntroduction = z.object({
    name: z.string(),
    company_name: z.string(),
    email: z.string().email()
});

/**
 * RecommendationFilterStatus
 */
export const zRecommendationFilterStatus = z.enum([
    'all',
    'intro_requests',
    'intro_completed',
    'not_interesting'
]);

/**
 * RecommendationIntroEmailType
 */
export const zRecommendationIntroEmailType = z.object({
    intro_email_type: zIntroEmailType
});

/**
 * RecommendationIntroduction
 */
export const zRecommendationIntroduction = z.object({
    on_behalf_of_user_uuid: z.string().uuid().nullish(),
    already_known: z.boolean().nullish(),
    introduce: z.boolean(),
    external_introduction: zRecommendationExternalIntroduction.nullish(),
    intro_email_cc_list: z.array(z.string().email()).optional().default([]),
    intro_email_type: zIntroEmailType.optional().default('manual'),
    log_only: z.boolean().nullish().default(false),
    introduction_comment: z.string().min(1).nullish()
});

/**
 * RecommendationIntroductionResponse
 */
export const zRecommendationIntroductionResponse = z.object({
    advisor: zPersonBasicResponse.nullish(),
    date: z.string().datetime().nullish(),
    status_context: zIntroductionStatusContext.nullish(),
    resolved_date: z.string().datetime().nullish(),
    person: zPersonBasicResponse.nullish(),
    introduction_status: zIntroductionStatus.nullish(),
    already_known: z.boolean().nullish(),
    is_liked: z.boolean().nullish(),
    uuid: z.string().uuid()
});

/**
 * RecommendationIsLiked
 */
export const zRecommendationIsLiked = z.object({
    is_liked: z.boolean().nullish()
});

/**
 * RecommendationOffLimits
 */
export const zRecommendationOffLimits = z.object({
    team_slugs: z.array(z.string())
});

/**
 * RecommendationPreviewResponse
 *
 * Preview/guest version of a recommendation with limited fields for unauthenticated access.
 */
export const zRecommendationPreviewResponse = z.object({
    candidate: zCandidateBasicResponse,
    uuid: z.string().uuid()
});

/**
 * RecommendationPublishedNotificationType
 */
export const zRecommendationPublishedNotificationType = z.enum([
    'batch',
    'stream',
    'stream_plain',
    'stream_plain_v2'
]);

/**
 * RecommendationReviewState
 */
export const zRecommendationReviewState = z.enum([
    'interesting',
    'intro_made',
    'intro_requested',
    'intro_unavailable',
    'needs_review',
    'not_interesting'
]);

/**
 * CandidateItem
 */
export const zCandidateItem = z.object({
    search_metadata: zEsMeta.nullish(),
    is_favorite: z.boolean(),
    activity_count: z.number().int(),
    activity_last_on: z.string().datetime().nullish(),
    activity_last_viewed_on: z.string().datetime().nullish(),
    candidate: zCandidateExtendedResponse,
    expires_on: z.string().datetime().nullish(),
    is_viewed: z.boolean(),
    published_on: z.string().datetime(),
    status: zRecommendationReviewState,
    uuid: z.string().uuid(),
    draft_mode: zRecommendationDraftMode.nullish(),
    draft_assignee: zPersonBasicResponse.nullish()
});

/**
 * CandidateRecommendationsFilterData
 */
export const zCandidateRecommendationsFilterData = z.object({
    company_id: z.array(z.number().int()),
    company_type: z.array(zOrgType),
    response: z.array(zRecommendationReviewState),
    role_type: z.array(zPipelineRoleType),
    type: z.array(zIntroductionType)
});

/**
 * IntroductionStatusPayload
 */
export const zIntroductionStatusPayload = z.object({
    context: z.string().min(1).max(500).nullish(),
    external_introduction: zRecommendationExternalIntroduction.nullish(),
    log_only: z.boolean().nullish().default(false),
    person_id: z.string().uuid().nullish(),
    status: zRecommendationReviewState
});

/**
 * RecommendationSource
 *
 * Where a recommendation originated.
 *
 * MANUAL - created by an advisor in Contender (default for all existing recs)
 * CLAUDE - created by an AI-assisted flow (reserved)
 * RECSYS - pushed in from the RecSys (Brief Match) app
 */
export const zRecommendationSource = z.enum([
    'manual',
    'claude',
    'recsys'
]);

/**
 * RecommendationStatus
 */
export const zRecommendationStatusOutput = z.enum([
    'draft',
    'published',
    'scheduled'
]);

/**
 * PipelineCandidatesFilterResponse
 */
export const zPipelineCandidatesFilterResponse = z.object({
    search_metadata: zEsMeta.nullish(),
    email: z.string(),
    name: z.string().nullish(),
    image: z.string().nullish(),
    uuid: z.string().optional().default(''),
    current_company: z.string().nullish(),
    current_role: z.string().nullish(),
    function_expertise: z.array(zFunction).optional(),
    industry_expertise: z.array(zIndustry).optional(),
    interest_role_operating: zInterestRole.nullish(),
    operating_highlights: z.array(zOperatingHighlights).optional(),
    interest_role_board_advisory: zInterestRole.nullish(),
    tier: zCandidateTier.nullish(),
    advisor: zPersonBasicResponse.nullish(),
    connection_status: zRecommendationStatusOutput.nullish(),
    pipeline_status: zRecommendationStatusOutput.nullish(),
    warm: z.boolean().optional().default(false),
    created: z.string().datetime().nullish(),
    keywords: z.array(z.string()).optional(),
    notes: z.string().nullish(),
    is_urg: z.boolean().optional().default(false),
    referrers: z.array(zPersonBasicResponse).optional(),
    profile_image_url: z.string().nullable()
});

/**
 * RecommendationStatusFilter
 */
export const zRecommendationStatusFilter = z.enum(['never_recommended', 'previously_recommended']);

/**
 * PipelineCandidatesFilters
 */
export const zPipelineCandidatesFilters = z.object({
    advisor_id: z.array(z.string().uuid()).nullish(),
    function_expertise: z.array(zFunction).nullish(),
    industry_expertise: z.array(zIndustry).nullish(),
    declined_status: z.array(zDeclinedStatusFilter).nullish(),
    introduction_status: z.array(zIntroductionStatusFilter).nullish(),
    is_accepting_intros: z.array(z.boolean()).nullish(),
    recommendation_status: z.array(zRecommendationStatusFilter).nullish(),
    pipeline_status: z.array(zCandidatePipelineStatus).nullish(),
    recsys_suggested: z.array(z.boolean()).nullish(),
    warm: z.array(z.boolean()).nullish(),
    tier: z.array(zCandidateTier).nullish(),
    type: z.array(zClientType).nullish(),
    pathway: z.array(zCandidatePathway).nullish(),
    underrepresented: z.array(z.boolean()).nullish(),
    operating_highlights: z.array(zOperatingHighlights).nullish()
});

/**
 * RecommendationType
 */
export const zRecommendationType = z.enum(['trendings', 'pipelines']);

/**
 * RecommendationsFilter
 */
export const zRecommendationsFilter = z.enum([
    'all',
    'intro',
    'introduction',
    'noIntro',
    'pipeline',
    'search',
    'viewed'
]);

/**
 * RecommendationsSortColumn
 */
export const zRecommendationsSortColumn = z.enum([
    'intro_made_on',
    'intro_requested_on',
    'not_interested_on',
    'published_on'
]);

/**
 * RecommendationsSorter
 */
export const zRecommendationsSorter = z.enum([
    'advisor',
    'already_known',
    'comments',
    'company_name',
    'company_type',
    '',
    'name',
    'introduction_date',
    'introduction_facilitated',
    'introduction_requested',
    'introduction_status',
    'review_status',
    'sent_date',
    'team',
    'team_member',
    'type',
    'viewed_date'
]);

/**
 * RecsysAssignee
 */
export const zRecsysAssignee = z.object({
    person_uuid: z.string().uuid(),
    name: z.string()
});

/**
 * RecsysAssigneesResponse
 */
export const zRecsysAssigneesResponse = z.object({
    assignees: z.array(zRecsysAssignee).optional()
});

/**
 * RecsysCandidateContextPair
 */
export const zRecsysCandidateContextPair = z.object({
    candidate_uuid: z.string().uuid(),
    pipeline_uuid: z.string().uuid()
});

/**
 * RecsysCandidateContextRequest
 */
export const zRecsysCandidateContextRequest = z.object({
    pairs: z.array(zRecsysCandidateContextPair).min(1).max(500)
});

/**
 * RecsysCandidateSuggestion
 */
export const zRecsysCandidateSuggestion = z.object({
    candidate_uuid: z.string().uuid(),
    assignee_person_uuid: z.string().uuid().nullish()
});

/**
 * RecsysFeedbackPayload
 */
export const zRecsysFeedbackPayload = z.object({
    verdict: z.enum(['good', 'bad']),
    note: z.string().max(512).nullish()
});

/**
 * RecsysOpportunityBadMatchPayload
 */
export const zRecsysOpportunityBadMatchPayload = z.object({
    comment: z.string().nullish()
});

/**
 * RecsysOpportunityProvenance
 */
export const zRecsysOpportunityProvenance = z.object({
    inbound: z.boolean().optional().default(false),
    outbound: z.boolean().optional().default(false),
    manual: z.boolean().optional().default(false),
    mutual: z.boolean().optional().default(false)
});

/**
 * RecsysOpportunityRationaleResponse
 */
export const zRecsysOpportunityRationaleResponse = z.object({
    rationale: z.unknown().nullish()
});

/**
 * RecsysOpportunityReviewPayload
 */
export const zRecsysOpportunityReviewPayload = z.object({
    reviewed: z.boolean().optional().default(true)
});

/**
 * RecsysOpportunityTeam
 */
export const zRecsysOpportunityTeam = z.object({
    uuid: z.string().uuid(),
    name: z.string(),
    slug: z.string(),
    company: z.string().nullish()
});

/**
 * RecsysOpportunityPipeline
 */
export const zRecsysOpportunityPipeline = z.object({
    uuid: z.string().uuid(),
    role: z.string(),
    slug: z.string(),
    company: z.string().nullish(),
    pipeline_type: zPipelineType.nullish(),
    created: z.string().datetime().nullish(),
    company_type: zOrgType.nullish(),
    notes: z.string().nullish(),
    function_expertise: z.array(zFunction),
    industry_expertise: z.array(zIndustry),
    team: zRecsysOpportunityTeam
});

/**
 * RecsysCandidateOpportunityItem
 */
export const zRecsysCandidateOpportunityItem = z.object({
    pipeline: zRecsysOpportunityPipeline,
    rank: z.number().int(),
    fit_score: z.number().int().nullish(),
    provenance: zRecsysOpportunityProvenance.optional(),
    recommendation_id: z.string().nullish(),
    rationale: z.unknown().nullish(),
    has_rationale: z.boolean().optional().default(false),
    reviewed: z.boolean().optional().default(false),
    assessment: z.string().nullish(),
    warm: z.boolean().optional().default(false),
    last_action: zPipelineCandidateTeamStatus.nullish(),
    already_recommended: z.boolean().optional().default(false),
    recommendation_uuid: z.string().uuid().nullish(),
    pipeline_status: zCandidatePipelineStatus.nullish(),
    draft_assignee: zPersonBasicResponse.nullish()
});

/**
 * RecsysCandidateOpportunitiesResponse
 */
export const zRecsysCandidateOpportunitiesResponse = z.object({
    total: z.number().int().optional().default(0),
    already_recommended_count: z.number().int().optional().default(0),
    items: z.array(zRecsysCandidateOpportunityItem).optional()
});

/**
 * RecsysRecommendationCandidate
 */
export const zRecsysRecommendationCandidate = z.object({
    uuid: z.string().uuid(),
    name: z.string().nullish(),
    formatted_role: z.string().nullish(),
    current_role: z.string().nullish(),
    current_company: z.string().nullish(),
    tier: zCandidateTier.nullish(),
    profile_image_url: z.string().nullish()
});

/**
 * RecsysPipelineRecommendationItem
 */
export const zRecsysPipelineRecommendationItem = z.object({
    candidate: zRecsysRecommendationCandidate,
    recommendation_id: z.string().nullish(),
    rank: z.number().int().nullish(),
    tier: z.string().nullish(),
    score: z.number().nullish(),
    reasons: z.array(z.string()).optional(),
    cautions: z.array(z.string()).optional(),
    rationale: z.unknown().nullish(),
    already_on_pipeline: z.boolean().optional().default(false),
    recommendation_uuid: z.string().uuid().nullish(),
    pipeline_status: zCandidatePipelineStatus.nullish(),
    draft_assignee: zPersonBasicResponse.nullish()
});

/**
 * RecsysPipelineRecommendationsResponse
 */
export const zRecsysPipelineRecommendationsResponse = z.object({
    total: z.number().int().optional().default(0),
    computed_at: z.string().nullish(),
    algorithm_version: z.string().nullish(),
    run_id: z.string().nullish(),
    already_on_pipeline_count: z.number().int().optional().default(0),
    items: z.array(zRecsysPipelineRecommendationItem).optional()
});

/**
 * RecsysSuggestedRecommendations
 */
export const zRecsysSuggestedRecommendations = z.object({
    pipeline_uuid: z.string().uuid(),
    candidates: z.array(zRecsysCandidateSuggestion).min(1).max(200),
    author_person_uuid: z.string().uuid(),
    comment: z.string().max(512).nullish(),
    draft_mode: zRecommendationDraftMode.nullish(),
    autosuggested: z.boolean().optional().default(false)
});

/**
 * RecsysSuggestedRecommendationsResponse
 */
export const zRecsysSuggestedRecommendationsResponse = z.object({
    created: z.array(z.string().uuid()).optional(),
    skipped: z.array(z.string().uuid()).optional(),
    not_found: z.array(z.string().uuid()).optional(),
    off_limits: z.array(z.string().uuid()).optional()
});

/**
 * ReferrerBasicResponse
 */
export const zReferrerBasicResponse = z.object({
    image: z.string().nullish(),
    name: z.string(),
    uuid: z.string().uuid()
});

/**
 * RecsysCandidateTeamContext
 */
export const zRecsysCandidateTeamContext = z.object({
    candidate_uuid: z.string().uuid(),
    pipeline_uuid: z.string().uuid(),
    team_uuid: z.string().uuid(),
    warm: z.boolean(),
    last_action: zPipelineCandidateTeamStatus.nullish(),
    referrers: z.array(zReferrerBasicResponse).optional()
});

/**
 * RecsysCandidateContextResponse
 */
export const zRecsysCandidateContextResponse = z.object({
    results: z.array(zRecsysCandidateTeamContext).optional(),
    not_found_pipelines: z.array(z.string().uuid()).optional(),
    not_found_candidates: z.array(z.string().uuid()).optional()
});

/**
 * RefreshTeamInsightsResponse
 *
 * Response schema for the refresh_team_insights job.
 *
 * The route queues work rather than doing it: the sweep makes LLM calls per stale
 * team, which does not belong in a scheduler's HTTP call. The refreshed/failed
 * counts are logged and returned as the Celery task result, keyed by `task_id`.
 */
export const zRefreshTeamInsightsResponse = z.object({
    job: z.string(),
    task_id: z.string().nullish(),
    limit: z.number().int().nullish()
});

/**
 * ReindexAsyncResponse
 *
 * Response for async reindex operations.
 */
export const zReindexAsyncResponse = z.object({
    task_id: z.string(),
    status: z.string(),
    message: z.string(),
    status_url: z.string()
});

/**
 * ReindexMetadata
 */
export const zReindexMetadata = z.object({
    success: z.number().int(),
    failed: z.number().int(),
    time_taken: z.string(),
    error: z.string().nullish()
});

/**
 * ElasticsearchReindexResponse
 */
export const zElasticsearchReindexResponse = z.object({
    is_successful: z.boolean(),
    index_name: z.string(),
    metadata: zReindexMetadata
});

/**
 * ReindexStatusResponse
 *
 * Response for reindex status checks.
 *
 * Fields are populated based on task state:
 * - PENDING: Only task_id, state, message
 * - PROGRESS: task_id, state, phase, index, index_alias, message
 * - SUCCESS: task_id, state, message, result
 * - FAILURE: task_id, state, message, error
 */
export const zReindexStatusResponse = z.object({
    task_id: z.string(),
    state: z.string(),
    phase: z.string().nullish(),
    index: z.string().nullish(),
    index_alias: z.string().nullish(),
    message: z.string().nullish(),
    result: zElasticsearchReindexResponse.nullish(),
    error: z.string().nullish()
});

/**
 * RejectionReasonEnum
 */
export const zRejectionReasonEnum = z.enum(['noInterest', 'unreachable']);

/**
 * RecommendationStatus
 */
export const zRecommendationStatusInput = z.object({
    skip_notifications: z.boolean().optional().default(false),
    introduced: z.boolean(),
    reason: zRejectionReasonEnum.nullish()
});

/**
 * ReminderPreviewPayload
 *
 * Optional payload for sending reminder (nudge) preview. Omit email to use current user.
 */
export const zReminderPreviewPayload = z.object({
    email: z.string().nullish()
});

/**
 * RequestSource
 *
 * Where an intro request originated, from the evaluation_history event linkage.
 */
export const zRequestSource = z.enum([
    'pipeline',
    'trending',
    'global'
]);

/**
 * IntroRequestItem
 *
 * One candidate a team requested an intro to (a COMPLETED evaluation_history event).
 */
export const zIntroRequestItem = z.object({
    candidate_uuid: z.string(),
    name: z.string(),
    role: z.string().nullish(),
    company: z.string().nullish(),
    headline: z.string().nullish(),
    source: zRequestSource,
    requested_date: z.string().date(),
    requester_name: z.string().nullish()
});

/**
 * ResolvePersonCandidateByEmailRequest
 */
export const zResolvePersonCandidateByEmailRequest = z.object({
    emails: z.array(z.string().email()).min(1)
});

/**
 * ResolvePersonCandidateByEmailResult
 */
export const zResolvePersonCandidateByEmailResult = z.object({
    email: z.string().email(),
    person_uuid: z.string().uuid().nullish(),
    candidate_uuid: z.string().uuid().nullish(),
    person: zPersonBasicResponse.nullish(),
    candidate: zCandidateBasicResponse.nullish(),
    person_active: z.boolean().nullish(),
    identity_uuid: z.string().uuid().nullish()
});

/**
 * ResolvePersonCandidateByEmailResponse
 */
export const zResolvePersonCandidateByEmailResponse = z.object({
    results: z.array(zResolvePersonCandidateByEmailResult)
});

/**
 * ResolvedReferenceResponse
 */
export const zResolvedReferenceResponse = z.object({
    given: z.string().nullable(),
    resolved: z.boolean(),
    resolved_id: z.union([
        z.number().int(),
        z.string().uuid()
    ]).nullable(),
    resolved_name: z.string().nullable()
});

/**
 * ResolutionResponse
 */
export const zResolutionResponse = z.object({
    target_company: zResolvedReferenceResponse,
    search_firm: zResolvedReferenceResponse,
    search_team: zResolvedReferenceResponse,
    client: zResolvedReferenceResponse,
    search_contact: zResolvedReferenceResponse
});

/**
 * MarketSearchCreateResponse
 *
 * What happened, what resolved, and what a person should confirm.
 */
export const zMarketSearchCreateResponse = z.object({
    outcome: z.enum([
        'created',
        'linked',
        'existing'
    ]),
    observation: zMarketSearchResponse,
    resolution: zResolutionResponse,
    link_candidates: z.array(zLinkCandidateResponse),
    message: z.string()
});

/**
 * ResponseType
 */
export const zResponseType = z.enum([
    'intro_requests',
    'intro_completed',
    'not_interesting',
    'no_action'
]);

/**
 * ResumeHeader
 */
export const zResumeHeader = z.object({
    candidate_name: z.string().nullish(),
    first_name: z.string().nullish(),
    last_name: z.string().nullish(),
    location: z.string(),
    title: z.string()
});

/**
 * RevenueRange
 */
export const zRevenueRange = z.enum([
    '<$10M',
    '$10M-$100M',
    '$100M-$500M',
    '>$500M'
]);

/**
 * Role
 */
export const zRole = z.enum([
    'Used For Notifications Applicable to All People',
    'Unassigned Team Member',
    'Banff Admin',
    'Banff Candidate',
    'Banff Client',
    'Executive Client',
    'Executive Team Lead',
    'Investor Team Lead',
    'Investor Team Member',
    'Banff Applicant',
    'Search Team Lead',
    'Search Team Member',
    'Corporate Team Lead',
    'Corporate Team Member'
]);

/**
 * RsvpPreviewPayload
 *
 * Payload for POST RSVP preview: send confirmation email preview to the current user.
 */
export const zRsvpPreviewPayload = z.object({
    status: z.enum(['going', 'cant_go'])
});

/**
 * RsvpUpdatePayload
 *
 * Payload for PATCH RSVP: token and new status.
 */
export const zRsvpUpdatePayload = z.object({
    token: z.string(),
    status: z.enum(['going', 'cant_go'])
});

/**
 * SchoolResponse
 */
export const zSchoolResponse = z.object({
    degree: z.string().nullish(),
    name: z.string().nullish(),
    dates: z.string().nullish()
});

/**
 * LinkedInResumeResponse
 */
export const zLinkedInResumeResponse = z.object({
    awards: z.array(z.string()).default([]),
    certifications: z.array(z.string()).default([]),
    experience: z.array(zCompanyResponse).default([]),
    file_name: z.string(),
    headline: z.string(),
    languages: z.array(z.string()).default([]),
    last_modified: z.string().datetime(),
    linkedin_url: z.string().nullable(),
    location: z.string(),
    name: z.string(),
    patents: z.array(z.string()).default([]),
    publications: z.array(z.string()).default([]),
    education: z.array(zSchoolResponse).default([]),
    skills: z.array(z.string()).default([]),
    summary: z.string().nullish(),
    version: z.number().int()
});

/**
 * CandidateCompareBackgroundResponse
 */
export const zCandidateCompareBackgroundResponse = z.object({
    image: z.string().nullish(),
    name: z.string(),
    uuid: z.string().uuid(),
    role: z.string().nullish(),
    company: z.string().nullish(),
    industry_expertise: z.array(zIndustry).nullish(),
    function_expertise: z.array(zFunction).nullish(),
    interest_role_operating: zInterestRole.nullish(),
    interest_role_board_advisory: zInterestRole.nullish(),
    resume: zLinkedInResumeResponse.nullish()
});

/**
 * CandidateExternalResponse
 */
export const zCandidateExternalResponse = z.object({
    __linkedin_profile_last_synced__DO_NOT_USE__: z.string().datetime().nullish(),
    __manual_last_update__DO_NOT_USE__: z.string().datetime().nullish(),
    profile_updated_date: z.string().datetime().nullish(),
    __resume_last_uploaded__DO_NOT_USE__: z.string().datetime().nullish(),
    company: z.string().nullish(),
    role: z.string().nullish(),
    image: z.string().nullish(),
    is_client: z.boolean(),
    linkedin_url: z.string().nullish(),
    name: z.string(),
    uuid: z.string().uuid(),
    formatted_role: z.string().nullish(),
    location: z.string().nullish(),
    resume: zLinkedInResumeResponse.nullish()
});

/**
 * CandidatePeerBackgroundComparisonResponse
 */
export const zCandidatePeerBackgroundComparisonResponse = z.object({
    candidate: zCandidateCompareBackgroundResponse,
    peer: zCandidateCompareBackgroundResponse
});

/**
 * ESCandidateIndexExternalResult
 */
export const zEsCandidateIndexExternalResult = z.object({
    search_metadata: zEsMeta.nullish(),
    advisor: zPersonInnerDocSchema.nullish(),
    company: z.string().nullish(),
    role: z.string().nullish(),
    date_introduction_facilitated_last: z.string().datetime().nullish(),
    date_recommended_last: z.string().datetime().nullish(),
    email: z.string().email(),
    first_name: z.string().nullish(),
    function_expertise: z.array(zFunction),
    function_target: z.array(zFunction),
    global_introduction_request_person: zPersonInnerDocSchema.nullish(),
    global_introduction_status: zIntroductionStatus.nullish(),
    id: z.string().uuid(),
    image: z.string().nullish(),
    industry_expertise: z.array(zIndustry),
    industry_target: z.array(zIndustry),
    is_client: z.boolean(),
    is_favorite: z.boolean(),
    last_name: z.string().nullish(),
    linkedin_url: z.string().nullish(),
    location: z.string().nullish(),
    name: z.string(),
    operating_highlights: z.array(zOperatingHighlights).nullish(),
    resume: zLinkedInResumeResponse.nullish(),
    uuid: z.string().uuid()
});

/**
 * ESCandidateIndexResult
 */
export const zEsCandidateIndexResult = z.object({
    search_metadata: zEsMeta.nullish(),
    active: z.boolean(),
    advisor: zPersonInnerDocSchema.nullish(),
    advisor_id: z.string().uuid().nullish(),
    company: z.string().nullish(),
    role: z.string().nullish(),
    date_introduction_facilitated_last: z.string().datetime().nullish(),
    date_recommended_last: z.string().datetime().nullish(),
    function_expertise: z.array(zFunction),
    function_target: z.array(zFunction),
    global_introduction_request_person: zPersonInnerDocSchema.nullish(),
    global_introduction_status: zIntroductionStatus.nullish(),
    industry_expertise: z.array(zIndustry),
    industry_target: z.array(zIndustry),
    interest_role_board_advisory: zInterestRole.nullish(),
    interest_role_operating: zInterestRole.nullish(),
    interests_personal: z.array(zInterestPersonal),
    interests_professional: z.array(zInterestProfessional),
    id: z.number().int(),
    is_client: z.boolean().nullish(),
    is_favorite: z.boolean(),
    is_referred: z.boolean().nullish(),
    keywords: z.array(z.string()),
    linkedin_profile_last_synced: z.string().datetime().nullish(),
    linkedin_url: z.string().nullish(),
    location: z.string().nullish(),
    manual_last_update: z.string().datetime().nullish(),
    notes: z.string().nullish(),
    operating_highlights: z.array(zOperatingHighlights).nullish(),
    email: z.string(),
    first_name: z.string().nullish(),
    name: z.string().nullish(),
    last_name: z.string().nullish(),
    image: z.string().nullish(),
    pipelines_count: z.number().int().nullish(),
    referred_date: z.string().datetime().nullish(),
    referrers: z.array(zPersonInnerDocSchema),
    resume: zLinkedInResumeResponse.nullish(),
    resume_last_uploaded: z.string().datetime().nullish(),
    profile_updated_date: z.string().datetime().nullish(),
    team_uuid: z.string().uuid(),
    tier: zCandidateTier,
    type: zClientType.nullish(),
    pathway: zCandidatePathway.nullish(),
    uuid: z.string().uuid(),
    profile_image_url: z.string().nullable()
});

/**
 * SchoolUploadResponse
 */
export const zSchoolUploadResponse = z.object({
    degree: z.string().nullish(),
    name: z.string().nullish(),
    dates: z.string().nullish()
});

/**
 * LinkedInResumeUploadResponse
 */
export const zLinkedInResumeUploadResponseInput = z.object({
    linkedin_url: z.string().nullish(),
    awards: z.array(z.string()),
    certifications: z.array(z.string()),
    experience: z.array(zCompanyUploadResponse),
    file_name: z.string(),
    headline: z.string(),
    languages: z.array(z.string()),
    location: z.string(),
    last_modified: z.string().datetime().nullish(),
    name: z.string(),
    patents: z.array(z.string()),
    publications: z.array(z.string()),
    education: z.array(zSchoolUploadResponse),
    skills: z.array(z.string()),
    summary: z.string().nullish(),
    version: z.number().int()
});

/**
 * LinkedInResumeUploadResponse
 */
export const zLinkedInResumeUploadResponseOutput = z.object({
    linkedin_url: z.string().nullish(),
    awards: z.array(z.string()),
    certifications: z.array(z.string()),
    experience: z.array(zCompanyUploadResponse),
    file_name: z.string(),
    headline: z.string(),
    languages: z.array(z.string()),
    location: z.string(),
    last_modified: z.string().datetime().nullish(),
    name: z.string(),
    patents: z.array(z.string()),
    publications: z.array(z.string()),
    education: z.array(zSchoolUploadResponse),
    skills: z.array(z.string()),
    summary: z.string().nullish(),
    version: z.number().int()
});

/**
 * SearchFirmType
 */
export const zSearchFirmType = z.enum([
    'Both Early Stage and Large/Established',
    'Mostly Early Stage',
    'Mostly Large/Established'
]);

/**
 * CompanyTeamBasicResponse
 *
 * Basic team information for company response
 */
export const zCompanyTeamBasicResponse = z.object({
    id: z.number().int(),
    uuid: z.string().uuid(),
    slug: z.string(),
    team_name: z.string(),
    active: z.boolean().optional().default(true),
    additional_details: z.string().nullish(),
    client_size: zSearchFirmType.nullish(),
    members: z.array(zCompanyTeamMemberResponse).optional().default([])
});

/**
 * CompanyDetailedResponse
 *
 * Detailed company response including teams and users
 */
export const zCompanyDetailedResponse = z.object({
    id: z.number().int(),
    name: z.string().nullable(),
    slug: z.string(),
    type: zOrgType,
    fund_type: z.array(zFundType).nullish(),
    payment_status: zPaymentStatus,
    active: z.boolean().optional().default(true),
    teams_count: z.number().int(),
    users_count: z.number().int(),
    teams: z.array(zCompanyTeamBasicResponse).optional().default([]),
    users: z.array(zCompanyUserBasicResponse).optional().default([])
});

/**
 * RecommendationFilterTeam
 */
export const zRecommendationFilterTeam = z.object({
    active: z.boolean().optional().default(true),
    slug: z.string(),
    name: z.string(),
    uuid: z.string().uuid(),
    additional_details: z.string().nullish(),
    client_size: zSearchFirmType.nullish(),
    company: zCompanyExtendedResponse,
    functional_focus: z.array(zFunction).nullish(),
    has_preregistered_users: z.boolean().nullish(),
    industry_focus: z.array(zIndustry).nullish()
});

/**
 * RecommendationFilterResult
 */
export const zRecommendationFilterResult = z.object({
    comments_count: z.number().int(),
    company: zCompanyExtendedResponse,
    review_status: zRecommendationReviewState,
    team: zRecommendationFilterTeam,
    status: zRecommendationStatusOutput,
    published_on: z.string().datetime().nullable(),
    uuid: z.string().uuid()
});

/**
 * SearchIndex
 */
export const zSearchIndex = z.enum([
    'candidates',
    'companies',
    'peers',
    'people',
    'pipelines',
    'recommendation-candidates',
    'recommendations',
    'submissions',
    'tasks',
    'team-candidates',
    'teams'
]);

/**
 * SendAnnouncementPayload
 *
 * Payload for POST .../announcement/send: which template, to which guests.
 */
export const zSendAnnouncementPayload = z.object({
    email_template_uuid: z.string().uuid(),
    guest_uuids: z.array(z.string().uuid()).min(1)
});

/**
 * SendGridEmailEvent
 *
 * `email_event.sendgrid_event`: the SendGrid events the webhook stores. Our
 * own record of a send is its `sent_email` row.
 */
export const zSendGridEmailEvent = z.enum([
    'bounce',
    'click',
    'delivered',
    'dropped',
    'open'
]);

/**
 * SendInvitePayload
 *
 * Payload for POST .../invite/send. See GuestSendTargetsPayload for targeting.
 */
export const zSendInvitePayload = z.object({
    guest_uuid: z.string().uuid().nullish(),
    guest_uuids: z.array(z.string().uuid()).nullish()
});

/**
 * SendReminderPayload
 *
 * Payload for POST .../reminder/send. See GuestSendTargetsPayload for targeting.
 */
export const zSendReminderPayload = z.object({
    guest_uuid: z.string().uuid().nullish(),
    guest_uuids: z.array(z.string().uuid()).nullish()
});

/**
 * Seniority
 */
export const zSeniority = z.enum([
    'c_suite',
    'president',
    'evp_svp',
    'vp',
    'head_of',
    'board_member',
    'partner',
    'other'
]);

/**
 * MarketSearchCreatePayload
 *
 * One observation of a search in the market.
 *
 * Leave a field out when the source did not state it — never send
 * placeholders like "Not specified". Classification fields are hints from
 * the caller (a model that read the note, or a person); the server fills what
 * is left blank from its title dictionary and validates every value.
 */
export const zMarketSearchCreatePayload = z.object({
    role_title: z.string().min(1).max(512),
    role_type: zPipelineRoleType.nullish(),
    seniority: zSeniority.nullish(),
    functions: z.array(zFunction).optional(),
    target_company_name: z.string().max(512).nullish(),
    target_company_industry: z.string().max(512).nullish(),
    search_firm_name: z.string().max(512).nullish(),
    contact_type: zContactType.nullish(),
    search_contact_name: z.string().max(256).nullish(),
    client_name: z.string().max(256).nullish(),
    candidate_uuid: z.string().uuid().nullish(),
    source: zMarketSearchSource,
    source_text: z.string().max(20000).nullish(),
    received_at: z.string().datetime().nullish(),
    target_company_id: z.number().int().nullish(),
    search_firm_company_id: z.number().int().nullish(),
    search_team_id: z.number().int().nullish(),
    search_contact_identity_uuid: z.string().uuid().nullish()
});

/**
 * MarketSearchDetailResponse
 *
 * Everything one observation holds, and the other observations of its search.
 */
export const zMarketSearchDetailResponse = z.object({
    uuid: z.string().uuid(),
    search_uuid: z.string().uuid(),
    same_search_as_uuid: z.string().uuid().nullable(),
    is_hub: z.boolean(),
    attached_by: zMarketSearchAttachedBy,
    group_size: z.number().int(),
    role_title: z.string(),
    role_type: zPipelineRoleType.nullable(),
    seniority: zSeniority.nullable(),
    functions: z.array(zFunction),
    target_company_name: z.string().nullable(),
    target_company_industry: z.string().nullable(),
    target_company_id: z.number().int().nullable(),
    target_company: zMarketSearchCompanyRef.nullable(),
    search_firm_name: z.string().nullable(),
    contact_type: zContactType.nullable(),
    search_firm_company_id: z.number().int().nullable(),
    search_firm_company: zMarketSearchCompanyRef.nullable(),
    search_team_id: z.number().int().nullable(),
    search_team: zMarketSearchTeamRef.nullable(),
    search_contact_name: z.string().nullable(),
    search_contact_identity_uuid: z.string().uuid().nullable(),
    search_contact: zMarketSearchPersonRef.nullable(),
    client_name: z.string().nullable(),
    candidate_uuid: z.string().uuid().nullable(),
    candidate: zMarketSearchCandidateRef.nullable(),
    status: zMarketSearchStatus,
    closed_at: z.string().datetime().nullable(),
    closed_evidence: z.string().nullable(),
    pipeline_id: z.number().int().nullable(),
    pipeline: zMarketSearchPipelineRef.nullable(),
    source: zMarketSearchSource,
    reported_by_person_id: z.string().uuid().nullable(),
    reported_by: zMarketSearchReporterRef.nullable(),
    received_at: z.string().datetime().nullable(),
    created: z.string().datetime(),
    last_modified: z.string().datetime(),
    source_text: z.string().nullable(),
    notion_page_id: z.string().nullable(),
    extraction_model: z.string().nullable(),
    last_resolved_at: z.string().datetime().nullable(),
    group: z.array(zMarketSearchGroupMember)
});

/**
 * MarketSearchFilters
 *
 * Every filter is optional; values within one list are ORed, filters ANDed.
 */
export const zMarketSearchFilters = z.object({
    status: z.array(zMarketSearchStatus).nullish(),
    role_type: z.array(zPipelineRoleType).nullish(),
    seniority: z.array(zSeniority).nullish(),
    functions: z.array(zFunction).nullish(),
    contact_type: z.array(zContactType).nullish(),
    source: z.array(zMarketSearchSource).nullish(),
    received_after: z.string().datetime().nullish(),
    received_before: z.string().datetime().nullish(),
    target_company_id: z.number().int().nullish(),
    search_firm_company_id: z.number().int().nullish(),
    search_team_id: z.number().int().nullish(),
    search_contact_identity_uuid: z.string().uuid().nullish(),
    candidate_uuid: z.string().uuid().nullish(),
    search_uuid: z.string().uuid().nullish(),
    needs_attention: z.array(zMarketSearchNeedsAttention).nullish()
});

/**
 * MarketSearchRowResponse
 *
 * One observation as the market-search table shows it, links included.
 */
export const zMarketSearchRowResponse = z.object({
    uuid: z.string().uuid(),
    search_uuid: z.string().uuid(),
    same_search_as_uuid: z.string().uuid().nullable(),
    is_hub: z.boolean(),
    attached_by: zMarketSearchAttachedBy,
    group_size: z.number().int(),
    role_title: z.string(),
    role_type: zPipelineRoleType.nullable(),
    seniority: zSeniority.nullable(),
    functions: z.array(zFunction),
    target_company_name: z.string().nullable(),
    target_company_industry: z.string().nullable(),
    target_company_id: z.number().int().nullable(),
    target_company: zMarketSearchCompanyRef.nullable(),
    search_firm_name: z.string().nullable(),
    contact_type: zContactType.nullable(),
    search_firm_company_id: z.number().int().nullable(),
    search_firm_company: zMarketSearchCompanyRef.nullable(),
    search_team_id: z.number().int().nullable(),
    search_team: zMarketSearchTeamRef.nullable(),
    search_contact_name: z.string().nullable(),
    search_contact_identity_uuid: z.string().uuid().nullable(),
    search_contact: zMarketSearchPersonRef.nullable(),
    client_name: z.string().nullable(),
    candidate_uuid: z.string().uuid().nullable(),
    candidate: zMarketSearchCandidateRef.nullable(),
    status: zMarketSearchStatus,
    closed_at: z.string().datetime().nullable(),
    closed_evidence: z.string().nullable(),
    pipeline_id: z.number().int().nullable(),
    pipeline: zMarketSearchPipelineRef.nullable(),
    source: zMarketSearchSource,
    reported_by_person_id: z.string().uuid().nullable(),
    reported_by: zMarketSearchReporterRef.nullable(),
    received_at: z.string().datetime().nullable(),
    created: z.string().datetime(),
    last_modified: z.string().datetime()
});

/**
 * MarketSearchUpdatePayload
 *
 * Change what was recorded. Only the fields sent are touched.
 *
 * Classification, the target company, status and pipeline describe the
 * *search*, so they are written to every observation of it; everything else
 * belongs to this observation alone. Picking a record by id also sets its
 * name; changing a name without an id looks the name up again (exact match
 * only) and clears the link when nothing matches. Sending an id as null
 * unlinks it and keeps the name.
 */
export const zMarketSearchUpdatePayload = z.object({
    role_title: z.string().min(1).max(512).nullish(),
    role_type: zPipelineRoleType.nullish(),
    seniority: zSeniority.nullish(),
    functions: z.array(zFunction).nullish(),
    target_company_name: z.string().max(512).nullish(),
    target_company_industry: z.string().max(512).nullish(),
    target_company_id: z.number().int().nullish(),
    search_firm_name: z.string().max(512).nullish(),
    contact_type: zContactType.nullish(),
    search_firm_company_id: z.number().int().nullish(),
    search_team_id: z.number().int().nullish(),
    search_contact_name: z.string().max(256).nullish(),
    search_contact_identity_uuid: z.string().uuid().nullish(),
    client_name: z.string().max(256).nullish(),
    candidate_uuid: z.string().uuid().nullish(),
    status: zMarketSearchStatus.nullish(),
    closed_at: z.string().datetime().nullish(),
    closed_evidence: z.string().max(512).nullish(),
    pipeline_id: z.number().int().nullish(),
    source_text: z.string().max(20000).nullish(),
    received_at: z.string().datetime().nullish()
});

/**
 * MarketSearchUpdateResponse
 */
export const zMarketSearchUpdateResponse = z.object({
    uuid: z.string().uuid(),
    search_uuid: z.string().uuid(),
    same_search_as_uuid: z.string().uuid().nullable(),
    is_hub: z.boolean(),
    attached_by: zMarketSearchAttachedBy,
    group_size: z.number().int(),
    role_title: z.string(),
    role_type: zPipelineRoleType.nullable(),
    seniority: zSeniority.nullable(),
    functions: z.array(zFunction),
    target_company_name: z.string().nullable(),
    target_company_industry: z.string().nullable(),
    target_company_id: z.number().int().nullable(),
    target_company: zMarketSearchCompanyRef.nullable(),
    search_firm_name: z.string().nullable(),
    contact_type: zContactType.nullable(),
    search_firm_company_id: z.number().int().nullable(),
    search_firm_company: zMarketSearchCompanyRef.nullable(),
    search_team_id: z.number().int().nullable(),
    search_team: zMarketSearchTeamRef.nullable(),
    search_contact_name: z.string().nullable(),
    search_contact_identity_uuid: z.string().uuid().nullable(),
    search_contact: zMarketSearchPersonRef.nullable(),
    client_name: z.string().nullable(),
    candidate_uuid: z.string().uuid().nullable(),
    candidate: zMarketSearchCandidateRef.nullable(),
    status: zMarketSearchStatus,
    closed_at: z.string().datetime().nullable(),
    closed_evidence: z.string().nullable(),
    pipeline_id: z.number().int().nullable(),
    pipeline: zMarketSearchPipelineRef.nullable(),
    source: zMarketSearchSource,
    reported_by_person_id: z.string().uuid().nullable(),
    reported_by: zMarketSearchReporterRef.nullable(),
    received_at: z.string().datetime().nullable(),
    created: z.string().datetime(),
    last_modified: z.string().datetime(),
    source_text: z.string().nullable(),
    notion_page_id: z.string().nullable(),
    extraction_model: z.string().nullable(),
    last_resolved_at: z.string().datetime().nullable(),
    group: z.array(zMarketSearchGroupMember),
    rows_updated: z.number().int()
});

/**
 * ShareRecommendations
 */
export const zShareRecommendations = z.object({
    candidates: z.array(z.string().uuid()).min(1),
    cc: z.array(z.string().email()).optional().default([]),
    bcc: z.array(z.string().email()).optional().default([]),
    footer: z.string().min(1),
    message: z.string().min(1),
    subject: z.string().min(1),
    to: z.array(z.string().email()).min(1)
});

/**
 * ShareRecommendationsResponse
 */
export const zShareRecommendationsResponse = z.object({
    candidates: z.array(z.string().uuid()),
    cc: z.array(z.string()).optional().default([]),
    bcc: z.array(z.string()).optional().default([]),
    footer: z.string(),
    message: z.string(),
    subject: z.string(),
    to: z.array(z.string())
});

/**
 * SortDirection
 */
export const zSortDirection = z.enum(['asc', 'desc']);

/**
 * CandidatePerformanceSort
 */
export const zCandidatePerformanceSort = z.object({
    column: zCandidatePerformanceSortColumn,
    direction: zSortDirection.optional().default('desc')
});

/**
 * CandidatePerformanceFilterSortPayload
 */
export const zCandidatePerformanceFilterSortPayload = z.object({
    page: z.number().int().gte(1).optional().default(1),
    size: z.number().int().gte(1).lte(100).optional().default(-1),
    filter_data: zCandidatesPerformanceFilters.nullish(),
    sort_rules: z.array(zCandidatePerformanceSort)
});

/**
 * CandidateRecommendationsSort
 */
export const zCandidateRecommendationsSort = z.object({
    column: zRecommendationsSortColumn,
    direction: zSortDirection.optional().default('desc')
});

/**
 * CandidateRecommendationsFilterPayload
 */
export const zCandidateRecommendationsFilterPayload = z.object({
    phrase: z.string().nullish(),
    search_id: z.string().nullish(),
    page: z.number().int().gte(1).optional().default(1),
    page_size: z.number().int().gte(1).lte(1000).optional().default(-1),
    date_from: z.string().datetime().nullish(),
    date_to: z.string().datetime().nullish(),
    filter_data: zCandidateRecommendationsFilterData.nullish(),
    sort_rules: z.array(zCandidateRecommendationsSort),
    status: zRecommendationFilterStatus.optional().default('all')
});

/**
 * CandidatesCombinedPerformanceSort
 */
export const zCandidatesCombinedPerformanceSort = z.object({
    column: zCandidatesCombinedPerformanceSortColumn,
    direction: zSortDirection.optional().default('desc')
});

/**
 * CandidatesCombinedPerformanceFilterSortPayload
 */
export const zCandidatesCombinedPerformanceFilterSortPayload = z.object({
    page: z.number().int().gte(1).optional().default(1),
    size: z.number().int().gte(1).lte(100).optional().default(-1),
    filter_data: zCandidatesCombinedPerformanceFilters.nullish(),
    sort_rules: z.array(zCandidatesCombinedPerformanceSort)
});

/**
 * CandidatesSort
 */
export const zCandidatesSort = z.object({
    sort_direction: zSortDirection.nullish().default('desc'),
    sort_column: zCandidatesSortColumn.nullish().default('')
});

/**
 * CandidateSearchData
 */
export const zCandidateSearchData = z.object({
    phrase: z.string().nullish(),
    filter_data: zCandidatesFilters.nullish(),
    page: z.number().int().optional().default(1),
    size: z.number().int().optional().default(10),
    search_id: z.string().nullish(),
    sort_rules: zCandidatesSort
});

/**
 * CompaniesSort
 */
export const zCompaniesSort = z.object({
    column: zCompaniesSortColumn,
    direction: zSortDirection.optional().default('desc')
});

/**
 * CompaniesSearchFilterSortPayload
 */
export const zCompaniesSearchFilterSortPayload = z.object({
    phrase: z.string().nullish(),
    search_id: z.string().nullish(),
    page: z.number().int().gte(1).optional().default(1),
    page_size: z.number().int().gte(1).lte(1000).optional().default(-1),
    filter_data: zCompaniesFilters.nullish(),
    sort_rules: z.array(zCompaniesSort).optional().default([])
});

/**
 * CompanyPeopleSort
 */
export const zCompanyPeopleSort = z.object({
    column: zCompanyPeopleSortColumn,
    direction: zSortDirection
});

/**
 * MarketSearchSort
 */
export const zMarketSearchSort = z.object({
    column: zMarketSearchSortColumn,
    direction: zSortDirection.optional().default('desc')
});

/**
 * MarketSearchSearchPayload
 */
export const zMarketSearchSearchPayload = z.object({
    phrase: z.string().nullish(),
    search_id: z.string().nullish(),
    page: z.number().int().gte(1).optional().default(1),
    page_size: z.number().int().gte(1).lte(1000).optional().default(-1),
    filter_data: zMarketSearchFilters.nullish(),
    sort_rules: z.array(zMarketSearchSort).optional().default([])
});

/**
 * PeerToPeerTableSelectSort
 */
export const zPeerToPeerTableSelectSort = z.object({
    column: zPeerToPeerTableSelectSortColumn,
    direction: zSortDirection.optional().default('desc')
});

/**
 * PeerToPeerTableSelectFilterPayload
 */
export const zPeerToPeerTableSelectFilterPayload = z.object({
    phrase: z.string().nullish(),
    search_id: z.string().nullish(),
    page: z.number().int().gte(1).optional().default(1),
    page_size: z.number().int().gte(1).lte(1000).optional().default(-1),
    filter_data: zPeerToPeerTableSelectFilterData.nullish(),
    include_inactive: z.boolean().optional().default(false),
    sort_rules: z.array(zPeerToPeerTableSelectSort)
});

/**
 * PeerToPeerTableSort
 */
export const zPeerToPeerTableSort = z.object({
    column: zPeerToPeerTableSortColumn,
    direction: zSortDirection.optional().default('desc')
});

/**
 * PeerToPeerTableExecutivePayload
 */
export const zPeerToPeerTableExecutivePayload = z.object({
    phrase: z.string().nullish(),
    search_id: z.string().nullish(),
    page: z.number().int().gte(1).optional().default(1),
    page_size: z.number().int().gte(1).lte(1000).optional().default(-1),
    sort_rules: z.array(zPeerToPeerTableSort)
});

/**
 * PeerToPeerTableFilterPayload
 */
export const zPeerToPeerTableFilterPayload = z.object({
    phrase: z.string().nullish(),
    search_id: z.string().nullish(),
    page: z.number().int().gte(1).optional().default(1),
    page_size: z.number().int().gte(1).lte(1000).optional().default(-1),
    filter_data: zPeerToPeerTableFilterData.nullish(),
    sort_rules: z.array(zPeerToPeerTableSort)
});

/**
 * PipelineCandidatesSort
 */
export const zPipelineCandidatesSort = z.object({
    column: zPipelineCandidateSortColumn,
    direction: zSortDirection.optional().default('desc')
});

/**
 * PipelineCandidateFilterPayload
 */
export const zPipelineCandidateFilterPayload = z.object({
    phrase: z.string().nullish(),
    search_id: z.string().nullish(),
    page: z.number().int().gte(1).optional().default(1),
    page_size: z.number().int().gte(1).lte(1000).optional().default(-1),
    filter_data: zPipelineCandidatesFilters.nullish(),
    sort_rules: z.array(zPipelineCandidatesSort)
});

/**
 * PipelineCandidateSearchFilterSortPayload
 */
export const zPipelineCandidateSearchFilterSortPayload = z.object({
    phrase: z.string().nullish(),
    search_id: z.string().nullish(),
    page: z.number().int().gte(1).optional().default(1),
    page_size: z.number().int().gte(1).lte(1000).optional().default(-1),
    filter_data: zPipelineCandidatesFilters.nullish(),
    sort_rules: z.array(zPipelineCandidatesSort),
    aggregate_fields: z.array(z.string()).nullish(),
    include_results: z.boolean().optional().default(true),
    include_inactive: z.boolean().optional().default(false),
    suggestion_excluded_picks: z.array(z.string().uuid()).nullish()
});

/**
 * PipelinesSort
 */
export const zPipelinesSort = z.object({
    column: zPipelinesSortColumn,
    direction: zSortDirection.optional().default('desc')
});

/**
 * PipelinesSearchData
 */
export const zPipelinesSearchData = z.object({
    phrase: z.string().nullish(),
    advanced_search: zPipelinesAdvancedSearch.nullish(),
    filter_data: zPipelinesFilters.nullish(),
    page: z.number().int().optional().default(1),
    size: z.number().int().optional().default(10),
    search_id: z.string().nullish(),
    sort_rules: z.array(zPipelinesSort)
});

/**
 * PotentialGuestsSortRule
 *
 * Single sort rule for potential guests.
 */
export const zPotentialGuestsSortRule = z.object({
    column: zPotentialGuestSortColumn,
    direction: zSortDirection.optional().default('asc')
});

/**
 * PotentialGuestsSearchPayload
 *
 * Payload for searching potential guests (users, candidates, event guests).
 */
export const zPotentialGuestsSearchPayload = z.object({
    phrase: z.string().nullish(),
    search_id: z.string().nullish(),
    page: z.number().int().gte(1).optional().default(1),
    page_size: z.number().int().gte(1).lte(1000).optional().default(-1),
    filter_data: zPotentialGuestsFilters.nullish(),
    sort_rules: z.array(zPotentialGuestsSortRule).nullish(),
    include_inactive: z.boolean().optional().default(false),
    include_total: z.boolean().optional().default(true),
    include_aggregations: z.boolean().optional().default(false),
    include_results: z.boolean().optional().default(true)
});

/**
 * SortRule
 */
export const zSortRule = z.object({
    column: z.string(),
    direction: zSortDirection.optional().default('desc')
});

/**
 * ExecutiveClientPeopleSearchPayload
 */
export const zExecutiveClientPeopleSearchPayload = z.object({
    phrase: z.string().nullish(),
    search_id: z.string().nullish(),
    filter_data: zExecutiveClientPeopleFilterData.nullish(),
    page: z.number().int().optional().default(1),
    size: z.number().int().optional().default(10),
    sort_rules: z.array(zSortRule).optional()
});

/**
 * SourceCompanyTags
 */
export const zSourceCompanyTags = z.enum([
    'acrew_tier_1',
    'acrew_tier_2',
    'acrew_tier_3'
]);

/**
 * CandidateExternalFullResponse
 */
export const zCandidateExternalFullResponse = z.object({
    __linkedin_profile_last_synced__DO_NOT_USE__: z.string().datetime().nullish(),
    __manual_last_update__DO_NOT_USE__: z.string().datetime().nullish(),
    profile_updated_date: z.string().datetime().nullish(),
    __resume_last_uploaded__DO_NOT_USE__: z.string().datetime().nullish(),
    company: z.string().nullish(),
    role: z.string().nullish(),
    image: z.string().nullish(),
    is_client: z.boolean(),
    linkedin_url: z.string().nullish(),
    name: z.string(),
    uuid: z.string().uuid(),
    formatted_role: z.string().nullish(),
    location: z.string().nullish(),
    resume: zLinkedInResumeResponse.nullish(),
    identity_uuid: z.string().uuid().nullish(),
    interest_role_board_advisory: zInterestRole.nullish(),
    interest_role_operating: zInterestRole.nullish(),
    function_expertise: z.array(zFunction),
    industry_expertise: z.array(zIndustry),
    operating_highlights: z.array(zOperatingHighlights),
    source_company_tags: z.array(zSourceCompanyTags).nullish(),
    interests_personal: z.array(zInterestPersonal),
    interests_professional: z.array(zInterestProfessional),
    interests_notes: z.string().nullish(),
    wants_intros: z.boolean().nullish(),
    interest_relocation: z.boolean().nullish(),
    interest_relocation_notes: z.string().nullish()
});

/**
 * CandidateExternalFullResponseWithTeamContext
 *
 * Candidate response with team-specific context fields.
 *
 * This extends CandidateExternalFullResponse with fields that are only
 * meaningful in the context of a specific team. Use this schema for
 * endpoints that return a candidate in a team context.
 */
export const zCandidateExternalFullResponseWithTeamContext = z.object({
    __linkedin_profile_last_synced__DO_NOT_USE__: z.string().datetime().nullish(),
    __manual_last_update__DO_NOT_USE__: z.string().datetime().nullish(),
    profile_updated_date: z.string().datetime().nullish(),
    __resume_last_uploaded__DO_NOT_USE__: z.string().datetime().nullish(),
    company: z.string().nullish(),
    role: z.string().nullish(),
    image: z.string().nullish(),
    is_client: z.boolean(),
    linkedin_url: z.string().nullish(),
    name: z.string(),
    uuid: z.string().uuid(),
    formatted_role: z.string().nullish(),
    location: z.string().nullish(),
    resume: zLinkedInResumeResponse.nullish(),
    identity_uuid: z.string().uuid().nullish(),
    interest_role_board_advisory: zInterestRole.nullish(),
    interest_role_operating: zInterestRole.nullish(),
    function_expertise: z.array(zFunction),
    industry_expertise: z.array(zIndustry),
    operating_highlights: z.array(zOperatingHighlights),
    source_company_tags: z.array(zSourceCompanyTags).nullish(),
    interests_personal: z.array(zInterestPersonal),
    interests_professional: z.array(zInterestProfessional),
    interests_notes: z.string().nullish(),
    wants_intros: z.boolean().nullish(),
    interest_relocation: z.boolean().nullish(),
    interest_relocation_notes: z.string().nullish(),
    email: z.string().nullish(),
    team_uuid: z.string().uuid(),
    global_introduction_status: zIntroductionStatus.nullish(),
    global_introduction_request_person: zPersonBasicResponse.nullish(),
    pipelines_count: z.number().int().optional().default(0),
    date_recommended_last: z.string().datetime().nullish(),
    date_introduction_facilitated_last: z.string().datetime().nullish(),
    is_favorite: z.boolean().optional().default(false),
    company_metadata: z.array(zCandidateCompanyMetadataResponse).optional(),
    personal_tags: z.array(zPersonalContactTagItem).optional()
});

/**
 * CandidateInternalFullResponse
 */
export const zCandidateInternalFullResponse = z.object({
    first_name: z.string().min(1).nullish(),
    last_name: z.string().min(1).nullish(),
    company: z.string().nullish(),
    role: z.string().nullish(),
    image: z.string().nullish(),
    is_client: z.boolean(),
    linkedin_url: z.string().nullish(),
    name: z.string(),
    uuid: z.string().uuid(),
    active: z.boolean(),
    merged_into_uuid: z.string().uuid().nullish(),
    advisor: zPersonBasicResponse.nullish(),
    client_owner: zPersonBasicResponse.nullish(),
    is_urg: z.boolean().nullish(),
    email: z.string(),
    function_expertise: z.array(zFunction),
    function_target: z.array(zFunction),
    long_term_goals: z.array(z.string()),
    id: z.number().int(),
    person_id: z.string().uuid().nullish(),
    identity_uuid: z.string().uuid().nullish(),
    industry_expertise: z.array(zIndustry),
    industry_target: z.array(zIndustry),
    interest_role_board_advisory: zInterestRole.nullish(),
    interest_role_operating: zInterestRole.nullish(),
    interests_personal: z.array(zInterestPersonal),
    interests_professional: z.array(zInterestProfessional),
    interests_notes: z.string().nullish(),
    invoice_status: zHubSpotInvoiceStatus.nullish(),
    hubspot_id: z.string().nullish(),
    wants_intros: z.boolean().nullish(),
    interest_relocation: z.boolean().nullish(),
    interest_relocation_notes: z.string().nullish(),
    intro_email_type: zIntroEmailType,
    is_accepting_intros: z.boolean(),
    keywords: z.array(z.string()),
    kickoff_date: z.string().datetime().nullish(),
    location: z.string().nullish(),
    manual_last_update: z.string().datetime().nullish(),
    manual_update_person_id: z.string().uuid().nullish(),
    network_target: z.string().nullish(),
    not_accepting_start_date: z.string().datetime().nullish(),
    not_accepting_end_date: z.string().datetime().nullish(),
    notes: z.string().nullish(),
    operating_highlights: z.array(zOperatingHighlights),
    passions: z.string().nullish(),
    referrers: z.array(zReferrerBasicResponse),
    resume: zLinkedInResumeResponse.nullish(),
    profile_updated_date: z.string().datetime().nullish(),
    resume_last_uploaded: z.string().datetime().nullish(),
    short_term_goals: z.array(z.string()),
    source_company_tags: z.array(zSourceCompanyTags).nullish(),
    tier: zCandidateTier,
    type: zClientType.nullish(),
    pathway: zCandidatePathway.nullish()
});

/**
 * CandidateInternalFullResponseWithLinkedPerson
 */
export const zCandidateInternalFullResponseWithLinkedPerson = z.object({
    first_name: z.string().min(1).nullish(),
    last_name: z.string().min(1).nullish(),
    company: z.string().nullish(),
    role: z.string().nullish(),
    image: z.string().nullish(),
    is_client: z.boolean(),
    linkedin_url: z.string().nullish(),
    name: z.string(),
    uuid: z.string().uuid(),
    active: z.boolean(),
    merged_into_uuid: z.string().uuid().nullish(),
    advisor: zPersonBasicResponse.nullish(),
    client_owner: zPersonBasicResponse.nullish(),
    is_urg: z.boolean().nullish(),
    email: z.string(),
    function_expertise: z.array(zFunction),
    function_target: z.array(zFunction),
    long_term_goals: z.array(z.string()),
    id: z.number().int(),
    person_id: z.string().uuid().nullish(),
    identity_uuid: z.string().uuid().nullish(),
    industry_expertise: z.array(zIndustry),
    industry_target: z.array(zIndustry),
    interest_role_board_advisory: zInterestRole.nullish(),
    interest_role_operating: zInterestRole.nullish(),
    interests_personal: z.array(zInterestPersonal),
    interests_professional: z.array(zInterestProfessional),
    interests_notes: z.string().nullish(),
    invoice_status: zHubSpotInvoiceStatus.nullish(),
    hubspot_id: z.string().nullish(),
    wants_intros: z.boolean().nullish(),
    interest_relocation: z.boolean().nullish(),
    interest_relocation_notes: z.string().nullish(),
    intro_email_type: zIntroEmailType,
    is_accepting_intros: z.boolean(),
    keywords: z.array(z.string()),
    kickoff_date: z.string().datetime().nullish(),
    location: z.string().nullish(),
    manual_last_update: z.string().datetime().nullish(),
    manual_update_person_id: z.string().uuid().nullish(),
    network_target: z.string().nullish(),
    not_accepting_start_date: z.string().datetime().nullish(),
    not_accepting_end_date: z.string().datetime().nullish(),
    notes: z.string().nullish(),
    operating_highlights: z.array(zOperatingHighlights),
    passions: z.string().nullish(),
    referrers: z.array(zReferrerBasicResponse),
    resume: zLinkedInResumeResponse.nullish(),
    profile_updated_date: z.string().datetime().nullish(),
    resume_last_uploaded: z.string().datetime().nullish(),
    short_term_goals: z.array(z.string()),
    source_company_tags: z.array(zSourceCompanyTags).nullish(),
    tier: zCandidateTier,
    type: zClientType.nullish(),
    pathway: zCandidatePathway.nullish(),
    person: zCandidateLinkedPersonResponse.nullish(),
    company_metadata: z.array(zCandidateCompanyMetadataResponse).optional()
});

/**
 * CreateCandidate
 */
export const zCreateCandidate = z.object({
    first_name: z.string().min(1),
    last_name: z.string().min(1),
    email: z.string().email(),
    linkedin_url: z.string().nullish(),
    advisor_uuid: z.string().uuid().nullish(),
    last_company: z.string().min(1).nullish(),
    last_role: z.string().min(1).nullish(),
    client_owner_uuid: z.string().uuid().nullish(),
    is_urg: z.boolean().optional().default(false),
    function_expertise: z.array(zFunction),
    function_target: z.array(zFunction),
    industry_expertise: z.array(zIndustry),
    industry_target: z.array(zIndustry),
    interest_role_board_advisory: zInterestRole.nullish(),
    interest_role_operating: zInterestRole.nullish(),
    interests_personal: z.array(zInterestPersonal).nullish().default([]),
    interests_professional: z.array(zInterestProfessional).nullish().default([]),
    interests_notes: z.string().min(1).nullish(),
    wants_intros: z.boolean().nullish(),
    interest_relocation: z.boolean().nullish(),
    interest_relocation_notes: z.string().min(1).nullish(),
    intro_email_type: zIntroEmailType.optional().default('manual'),
    kickoff_date: z.string().datetime().nullish(),
    not_accepting_start_date: z.string().datetime().nullish(),
    not_accepting_end_date: z.string().datetime().nullish(),
    keywords: z.array(z.string().min(1)),
    network_target: z.string().min(1).nullish(),
    notes: z.string().min(1).nullish(),
    operating_highlights: z.array(zOperatingHighlights).nullish(),
    passions: z.string().min(1).nullish(),
    image: z.string().nullish(),
    referrers: z.array(z.string().uuid()),
    resume: zLinkedInResumeUploadResponseInput.nullish(),
    tier: zCandidateTier,
    type: zClientType.nullish(),
    pathway: zCandidatePathway.nullish(),
    source_company_tags: z.array(zSourceCompanyTags).nullish()
});

/**
 * ExecutiveContactDetailResponse
 *
 * Unified detail for one of the exec's contacts (BAN-5755).
 *
 * A single envelope that works whether the contact is candidate-backed or
 * person-only. The canonical relationship fields (``was_introduced``,
 * ``is_favorite``, ``source_types``, ``evidence``, ``personal_tags``) live at
 * the top level so the webapp reads them the same way regardless of type.
 *
 * ``candidate`` carries the full candidate profile when a candidate record
 * exists; ``person`` carries the linked person when one exists — both may be
 * present for a candidate who also has a ``Person`` row. The top-level
 * ``email`` prefers the candidate's (gated) email and falls back to the
 * person's; the same gated values appear on the sub-objects.
 */
export const zExecutiveContactDetailResponse = z.object({
    candidate_uuid: z.string().nullish(),
    person_uuid: z.string().nullish(),
    identity_uuid: z.string().uuid().nullish(),
    email: z.string().nullish(),
    source_types: z.array(zContactSourceType).optional(),
    evidence: zContactEvidenceResponse.nullish(),
    personal_tags: z.array(zPersonalContactTagItem).optional(),
    is_favorite: z.boolean().optional().default(false),
    was_introduced: z.boolean().optional().default(false),
    is_represented: z.boolean().optional().default(false),
    candidate: zCandidateExternalFullResponseWithTeamContext.nullish(),
    person: zExecutiveContactPerson.nullish()
});

/**
 * StatSplitRole
 */
export const zStatSplitRole = z.object({
    board: z.number().int(),
    operating: z.number().int(),
    other: z.number().int()
});

/**
 * PeriodStatsRole
 */
export const zPeriodStatsRole = z.object({
    first_recommendation: z.string().datetime().nullish(),
    all: zStatSplitRole,
    intro_completed: zStatSplitRole,
    intro_requests: zStatSplitRole,
    not_interesting: zStatSplitRole
});

/**
 * CandidateRecommendationsStatsRoleResponse
 */
export const zCandidateRecommendationsStatsRoleResponse = z.object({
    current_period: zPeriodStatsRole,
    current_period_dates: zPeriodDates,
    previous_period: zPeriodStatsRole,
    previous_period_dates: zPeriodDates
});

/**
 * StatSplitSubmission
 */
export const zStatSplitSubmission = z.object({
    global: z.number().int().nullish(),
    pipeline: z.number().int(),
    trending: z.number().int()
});

/**
 * PeriodStatsSubmission
 */
export const zPeriodStatsSubmission = z.object({
    first_recommendation: z.string().datetime().nullish(),
    all: zStatSplitSubmission,
    intro_completed: zStatSplitSubmission,
    intro_requests: zStatSplitSubmission,
    not_interesting: zStatSplitSubmission
});

/**
 * CandidateRecommendationsStatsSubmissionResponse
 */
export const zCandidateRecommendationsStatsSubmissionResponse = z.object({
    current_period: zPeriodStatsSubmission,
    current_period_dates: zPeriodDates,
    previous_period: zPeriodStatsSubmission,
    previous_period_dates: zPeriodDates
});

/**
 * StatSplitTeam
 */
export const zStatSplitTeam = z.object({
    corporate: z.number().int(),
    investor: z.number().int(),
    other: z.number().int(),
    search: z.number().int()
});

/**
 * PeriodStatsTeam
 */
export const zPeriodStatsTeam = z.object({
    first_recommendation: z.string().datetime().nullish(),
    all: zStatSplitTeam,
    intro_completed: zStatSplitTeam,
    intro_requests: zStatSplitTeam,
    not_interesting: zStatSplitTeam
});

/**
 * CandidateRecommendationsStatsTeamResponse
 */
export const zCandidateRecommendationsStatsTeamResponse = z.object({
    current_period: zPeriodStatsTeam,
    current_period_dates: zPeriodDates,
    previous_period: zPeriodStatsTeam,
    previous_period_dates: zPeriodDates
});

/**
 * SubmissionBasicResponse
 */
export const zSubmissionBasicResponse = z.object({
    name: z.string().nullish(),
    uuid: z.string().uuid()
});

/**
 * SubmissionCandidatePipelinesResponse
 */
export const zSubmissionCandidatePipelinesResponse = z.object({
    recommendations: z.array(zRecommendationCandidatePipelinesResponse),
    uuid: z.string().uuid()
});

/**
 * SubmissionCheckSharedResponse
 */
export const zSubmissionCheckSharedResponse = z.object({
    candidate: zCandidateExtendedResponse,
    uuid: z.string().uuid()
});

/**
 * SubmissionFilterCountsResponse
 */
export const zSubmissionFilterCountsResponse = z.object({
    all: z.number().int(),
    interesting: z.number().int(),
    intro_made: z.number().int(),
    intro_requested: z.number().int(),
    intro_unavailable: z.number().int(),
    needs_review: z.number().int(),
    not_interesting: z.number().int()
});

/**
 * SubmissionFilterFilterData
 */
export const zSubmissionFilterFilterData = z.object({
    review_status: z.array(zRecommendationReviewState).nullish()
});

/**
 * SubmissionFilterResponse
 */
export const zSubmissionFilterResponse = z.object({
    page_count: z.number().int(),
    page: z.number().int(),
    results: z.array(zRecommendationFilterResult),
    size: z.number().int(),
    total_counts: zSubmissionFilterCountsResponse
});

/**
 * SubmissionFilterSortColumn
 */
export const zSubmissionFilterSortColumn = z.enum([
    'comments',
    '',
    'review_status',
    'team'
]);

/**
 * SubmissionFilterSortData
 */
export const zSubmissionFilterSortData = z.object({
    column: zSubmissionFilterSortColumn,
    direction: zSortDirection.optional().default('desc')
});

/**
 * SubmissionFilterPayload
 */
export const zSubmissionFilterPayload = z.object({
    page: z.number().int().gte(1).optional().default(1),
    page_size: z.number().int().gte(1).lte(1000).optional().default(-1),
    filter_data: zSubmissionFilterFilterData.nullish(),
    sort_rules: z.array(zSubmissionFilterSortData)
});

/**
 * SubmissionStatus
 */
export const zSubmissionStatus = z.enum([
    'draft',
    'published',
    'scheduled'
]);

/**
 * SubmissionStatusPayload
 */
export const zSubmissionStatusPayload = z.object({
    status: zSubmissionStatus
});

/**
 * SubmissionType
 */
export const zSubmissionType = z.enum([
    'pipeline',
    'scheduled',
    'search',
    'introduction'
]);

/**
 * DeleteTeamEntityResponse
 */
export const zDeleteTeamEntityResponse = z.object({
    entity_type: zSubmissionType,
    objects_processed: z.number().int().optional().default(0),
    slug: z.string(),
    timestamp: z.string().datetime()
});

/**
 * SubmissionSearchFilterSortResponse
 */
export const zSubmissionSearchFilterSortResponse = z.object({
    emails_delivered: z.number().int().default(0),
    emails_opened: z.number().int().default(0),
    advisor: zPersonBasicEmailResponse.nullish(),
    candidate: zPersonBasicEmailResponse.nullish(),
    introduction_request_count: z.number().int().default(0),
    last_executed_in_summary_cron: z.string().datetime().nullish(),
    last_modified: z.string().datetime(),
    name: z.string().nullish(),
    notification_type: zRecommendationPublishedNotificationType.nullish(),
    published_on: z.string().datetime().nullish(),
    recommendations_count: z.number().int(),
    status: zSubmissionStatus,
    type: zSubmissionType.nullish(),
    uuid: z.string().uuid()
});

/**
 * SubmissionV3RecommendationPayload
 */
export const zSubmissionV3RecommendationPayload = z.object({
    candidate_uuid: z.string().uuid(),
    team_uuid: z.string().uuid(),
    uuid: z.string().uuid().nullish(),
    published_on: z.string().datetime().nullish()
});

/**
 * SubmissionV3Payload
 */
export const zSubmissionV3Payload = z.object({
    about: z.string().min(1).nullish(),
    advisor_id: z.string().uuid().nullish(),
    candidate_uuid: z.string().uuid().nullish(),
    goal_id: z.string().uuid().nullish(),
    highlights_with_selected: z.array(zHighlightWithSelectedPayload).nullish().default([]),
    notification_type: zRecommendationPublishedNotificationType.nullish(),
    publish_email_body: z.string().min(1).nullish(),
    publish_email_subject: z.string().min(1).nullish(),
    published_on: z.string().datetime().nullish(),
    recommendations: z.array(zSubmissionV3RecommendationPayload).nullish().default([])
});

/**
 * SubmissionsFilters
 */
export const zSubmissionsFilters = z.object({
    advisor_id: z.array(z.string()).nullish(),
    executive_id: z.array(z.string()).nullish(),
    function_expertise: z.array(zFunction).nullish(),
    industry_expertise: z.array(zIndustry).nullish(),
    notification_type: z.array(zRecommendationPublishedNotificationType).nullish(),
    status: z.array(zSubmissionStatus).nullish(),
    type: z.array(zSubmissionType).nullish()
});

/**
 * SubmissionsSortColumn
 */
export const zSubmissionsSortColumn = z.enum([
    'name',
    'published_on',
    'advisor',
    'notification_type',
    'introduction_request_count',
    'emails_opened',
    'emails_delivered',
    'status'
]);

/**
 * SubmissionsSort
 */
export const zSubmissionsSort = z.object({
    column: zSubmissionsSortColumn,
    direction: zSortDirection.optional().default('desc')
});

/**
 * SubmissionSearchFilterSortPayload
 */
export const zSubmissionSearchFilterSortPayload = z.object({
    phrase: z.string().nullish(),
    search_id: z.string().nullish(),
    page: z.number().int().gte(1).optional().default(1),
    page_size: z.number().int().gte(1).lte(1000).optional().default(-1),
    filter_data: zSubmissionsFilters.nullish(),
    sort_rules: z.array(zSubmissionsSort)
});

/**
 * SuggestionPick
 */
export const zSuggestionPick = z.object({
    candidate_uuid: z.string().uuid(),
    name: z.string(),
    steering: z.boolean()
});

/**
 * SuggestionWeights
 *
 * Dial positions, 0-1 each. Omitted dials use the backtested defaults.
 *
 * Only ratios matter — every signal is min-max normalized across the pool
 * before weighting. The two cart dials have no effect while
 * `selected_team_uuids` is empty.
 */
export const zSuggestionWeights = z.object({
    trended_for_similar: z.number().gte(0).lte(1).nullish(),
    trended_alongside_cart: z.number().gte(0).lte(1).nullish(),
    profile_overlaps_cart: z.number().gte(0).lte(1).nullish(),
    profile_match: z.number().gte(0).lte(1).nullish(),
    interacted_with_similar: z.number().gte(0).lte(1).nullish()
});

/**
 * Summary
 */
export const zSummary = z.object({
    summary: z.string()
});

/**
 * AdminResumeView
 */
export const zAdminResumeView = z.object({
    awards_and_honors: z.array(z.string()).optional(),
    candidate_image: z.string().nullish(),
    candidate_name: z.string(),
    certifications: z.array(z.string()).optional(),
    contact: zContact,
    experience: z.array(zCompanyResponse).optional(),
    header: zResumeHeader,
    is_client: z.boolean().optional().default(false),
    languages: z.array(z.string()).optional(),
    last_updated: z.string().datetime().nullish(),
    patents: z.array(z.string()).optional(),
    profile_image_urn: z.string().nullish(),
    publications: z.array(z.string()).optional(),
    referrals_only: z.boolean().optional().default(false),
    schools: z.array(zSchoolResponse).optional(),
    skills: z.array(z.string()).optional(),
    summary: zSummary.nullish(),
    uuid: z.string().uuid(),
    work_history: zCandidateExperience.nullish()
});

/**
 * SummaryStatus
 */
export const zSummaryStatus = z.enum([
    'ready',
    'pending',
    'none'
]);

/**
 * TailoredHighlightDraft
 */
export const zTailoredHighlightDraft = z.object({
    text: z.string(),
    basis: z.string()
});

/**
 * TailoredHighlightPayload
 */
export const zTailoredHighlightPayload = z.object({
    highlight: z.string().min(1),
    is_selected: z.boolean().optional().default(true),
    generated: z.string().max(2000).nullish()
});

/**
 * SubmissionCandidateDraftV2Payload
 */
export const zSubmissionCandidateDraftV2Payload = z.object({
    candidate_uuid: z.string().uuid(),
    highlight_selections: z.record(z.boolean()).nullish(),
    tailored_highlights: z.array(zTailoredHighlightPayload).max(10).nullish(),
    introduction_template_uuid: z.string().uuid().nullish(),
    intro_email_type: zIntroEmailType.nullish(),
    recommendation_uuid: z.string().uuid().nullish()
});

/**
 * SubmissionDraftV2
 */
export const zSubmissionDraftV2 = z.object({
    skip_notifications: z.boolean().optional().default(false),
    presenter_uuid: z.string().uuid().nullish(),
    advisor_uuid: z.string().uuid().nullish(),
    candidates: z.array(zSubmissionCandidateDraftV2Payload),
    draft_mode: zRecommendationDraftMode.nullish(),
    source: zRecommendationSource.nullish(),
    intro_email_type_manual_override: z.boolean().optional().default(false)
});

/**
 * TailoredHighlightResponse
 */
export const zTailoredHighlightResponse = z.object({
    highlight: z.string(),
    is_selected: z.boolean().optional().default(true),
    generated: z.string().nullish()
});

/**
 * RecommendationDraftBasicResponse
 */
export const zRecommendationDraftBasicResponse = z.object({
    uuid: z.string().uuid(),
    highlight_uuids: z.array(z.string().uuid()).optional().default([]),
    tailored_highlights: z.array(zTailoredHighlightResponse).optional().default([]),
    introduction_template_uuid: z.string().uuid().nullish(),
    source: zRecommendationSource.nullish()
});

/**
 * PipelineCandidateSearchFilterSortResponse
 */
export const zPipelineCandidateSearchFilterSortResponse = z.object({
    search_metadata: zEsMeta.nullish(),
    advisor: zPersonBasicResponse.nullish(),
    client_owner: zPersonBasicResponse.nullish(),
    created: z.string().datetime().nullish(),
    current_company: z.string().nullish(),
    current_role: z.string().nullish(),
    role: z.string().nullish(),
    location: z.string().nullish(),
    interest_role_board_advisory: zInterestRole.nullish(),
    interest_role_operating: zInterestRole.nullish(),
    keywords: z.array(z.string()).nullish(),
    notes: z.string().nullish(),
    function_expertise: z.array(zFunction).optional(),
    industry_expertise: z.array(zIndustry).optional(),
    is_urg: z.boolean().nullish(),
    operating_highlights: z.array(zOperatingHighlights).nullish(),
    email: z.string(),
    name: z.string(),
    image: z.string().nullish(),
    referrers: z.array(zPersonBasicResponse).nullish(),
    tier: zCandidateTier,
    type: zClientType.nullish(),
    pathway: zCandidatePathway.nullish(),
    invoice_status: zHubSpotInvoiceStatus.nullish(),
    warm: z.boolean().nullish(),
    recsys_score: z.number().nullish(),
    suggestion_sources: z.array(z.string()).nullish(),
    suggestion_reasons: z.array(z.string()).nullish(),
    match_score: z.number().nullish(),
    match_breakdown: zMatchScoreBreakdown.nullish(),
    team_status: zPipelineCandidateTeamStatus.nullish(),
    pipeline_status: zCandidatePipelineStatus.nullish(),
    recommendation_uuid: z.string().uuid().nullish(),
    recommendation: zRecommendationDraftBasicResponse.nullish(),
    intro_email_type: zIntroEmailType,
    draft_assignee: zPersonBasicResponse.nullish(),
    recommender: zPersonBasicResponse.nullish(),
    recommended_on: z.string().datetime().nullish(),
    autosuggested: z.boolean().optional().default(false),
    internal_comments_count: z.number().int().nullish().default(0),
    is_accepting_intros: z.boolean().nullish(),
    not_accepting_start_date: z.string().datetime().nullish(),
    not_accepting_end_date: z.string().datetime().nullish(),
    pipeline_off_limits: zOffLimitsTeamSchema.nullish(),
    uuid: z.string().uuid(),
    profile_image_url: z.string().nullable()
});

/**
 * TailoredHighlightsQueued
 */
export const zTailoredHighlightsQueued = z.object({
    task_id: z.string(),
    status: z.string().optional().default('queued'),
    status_url: z.string()
});

/**
 * TailoredHighlightsRequest
 */
export const zTailoredHighlightsRequest = z.object({
    candidate_uuid: z.string().uuid()
});

/**
 * TailoredHighlightsStatus
 */
export const zTailoredHighlightsStatus = z.object({
    task_id: z.string(),
    state: z.string(),
    highlights: z.array(zTailoredHighlightDraft).nullish(),
    model_version: z.string().nullish(),
    error: z.string().nullish()
});

/**
 * TaskCreateUpdatePayload
 */
export const zTaskCreateUpdatePayload = z.object({
    assignee_id: z.string().uuid(),
    candidate_uuid: z.string().uuid(),
    description: z.string().min(1).nullish(),
    due_date: z.string().datetime().nullish(),
    is_completed: z.boolean().nullish().default(false),
    task_module_id: z.string().uuid().nullish(),
    title: z.string().min(1)
});

/**
 * CandidateGoalsPayload
 */
export const zCandidateGoalsPayload = z.object({
    due_date: z.string().datetime().nullish(),
    notes: z.string().min(1).nullish(),
    program: zCandidateType,
    priority: zGoalPriority.nullish(),
    status: zGoalStatus.nullish(),
    tasks: z.array(zTaskCreateUpdatePayload).nullish(),
    title: z.string().min(1)
});

/**
 * TaskCreateUpdateManyPayload
 */
export const zTaskCreateUpdateManyPayload = z.object({
    tasks: z.array(zTaskCreateUpdatePayload)
});

/**
 * TaskCreated
 */
export const zTaskCreated = z.enum([
    'older_than_one_month',
    'one_month_ago',
    'one_week_ago',
    'this_week',
    'today',
    'two_weeks_ago',
    'yesterday'
]);

/**
 * TaskDueDate
 */
export const zTaskDueDate = z.enum(['next_week', 'this_week']);

/**
 * TaskModuleStatus
 */
export const zTaskModuleStatus = z.enum([
    'at_risk',
    'completed',
    'in_progress',
    'no_tasks',
    'not_started',
    'overdue'
]);

/**
 * TaskModuleStatusPayload
 */
export const zTaskModuleStatusPayload = z.object({
    is_completed: z.boolean(),
    mark_tasks_as_completed: z.boolean().nullish().default(false)
});

/**
 * TaskModuleType
 */
export const zTaskModuleType = z.enum([
    'kickoff_onboarding',
    'narrative_refresh',
    'on_hold',
    'other',
    'peer_to_peer',
    'trending'
]);

/**
 * TaskModuleBasicResponse
 */
export const zTaskModuleBasicResponse = z.object({
    created: z.string().datetime(),
    id: z.string().uuid(),
    type: zTaskModuleType
});

/**
 * TaskBasicResponse
 */
export const zTaskBasicResponse = z.object({
    assignee: zPersonBasicEmailResponse,
    candidate: zCandidateBasicResponse,
    created: z.string().datetime(),
    creator: zPersonBasicEmailResponse,
    completion_date: z.string().datetime().nullish(),
    description: z.string().nullish(),
    due_date: z.string().datetime().nullish(),
    id: z.string().uuid(),
    is_completed: z.boolean(),
    last_modified: z.string().datetime(),
    task_module: zTaskModuleBasicResponse.nullable(),
    title: z.string(),
    overdue: z.boolean().readonly()
});

/**
 * TaskModuleCreateUpdatePayload
 */
export const zTaskModuleCreateUpdatePayload = z.object({
    assignee_id: z.string().uuid(),
    candidate_uuid: z.string().uuid(),
    description: z.string().min(1).nullish(),
    due_date: z.string().datetime(),
    is_completed: z.boolean(),
    start_date: z.string().datetime(),
    tasks: z.array(zTaskCreateUpdatePayload).nullish(),
    type: zTaskModuleType
});

/**
 * TaskStatus
 */
export const zTaskStatus = z.enum(['completed', 'incomplete']);

/**
 * TaskStatusPayload
 */
export const zTaskStatusPayload = z.object({
    is_completed: z.boolean()
});

/**
 * TaskTotal
 */
export const zTaskTotal = z.object({
    all: z.number().int(),
    incomplete: z.number().int()
});

/**
 * CandidateOnboardingStatus
 */
export const zCandidateOnboardingStatus = z.object({
    show_onboarding_section: z.boolean().nullish().default(true),
    candidate: zCandidateBasicResponse,
    tasks: z.array(zTaskBasicResponse).nullish(),
    total_counts: zTaskTotal.readonly(),
    onboarding_complete: z.boolean().readonly()
});

/**
 * CandidateTaskModule
 */
export const zCandidateTaskModule = z.object({
    created: z.string().datetime(),
    id: z.string().uuid(),
    type: zTaskModuleType,
    status: zTaskModuleStatus,
    total_counts: zTaskTotal.readonly()
});

/**
 * CandidateTaskModuleResponse
 */
export const zCandidateTaskModuleResponse = z.object({
    module: zCandidateTaskModule.nullish(),
    tasks: z.array(zTaskBasicResponse).nullish().default([])
});

/**
 * TaskModuleResponse
 */
export const zTaskModuleResponse = z.object({
    assignee: zPersonBasicEmailResponse,
    candidate: zCandidateBasicResponse,
    created: z.string().datetime(),
    creator: zPersonBasicEmailResponse,
    description: z.string().nullish(),
    due_date: z.string().datetime(),
    id: z.string().uuid(),
    last_modified: z.string().datetime(),
    start_date: z.string().datetime(),
    status: zTaskModuleStatus,
    tasks: z.array(zTaskBasicResponse).nullish(),
    type: zTaskModuleType,
    total_counts: zTaskTotal.readonly()
});

/**
 * TasksTableFilterAggregationsResponse
 */
export const zTasksTableFilterAggregationsResponse = z.object({
    assignee_id: z.record(z.number().int()),
    candidate_uuid: z.record(z.number().int()),
    created: z.record(z.number().int()),
    due_date: z.record(z.number().int()),
    overdue: z.record(z.number().int()),
    status: z.record(z.number().int())
});

/**
 * TasksTableFilterData
 */
export const zTasksTableFilterData = z.object({
    assignee_uuid: z.array(z.string().uuid()).optional().default([]),
    candidate_uuid: z.array(z.string().uuid()).optional().default([]),
    created: z.array(zTaskCreated).optional().default([]),
    due_date: z.array(zTaskDueDate).optional().default([]),
    overdue: z.array(z.boolean()).optional().default([]),
    status: z.array(zTaskStatus).optional().default([])
});

/**
 * TasksTableSortColumn
 */
export const zTasksTableSortColumn = z.enum([
    'assignee_name',
    'candidate_name',
    'created',
    'completion_date',
    'due_date'
]);

/**
 * TasksTableSort
 */
export const zTasksTableSort = z.object({
    column: zTasksTableSortColumn,
    direction: zSortDirection.optional().default('desc')
});

/**
 * TasksTableFilterPayload
 */
export const zTasksTableFilterPayload = z.object({
    phrase: z.string().nullish(),
    search_id: z.string().nullish(),
    page: z.number().int().gte(1).optional().default(1),
    page_size: z.number().int().gte(1).lte(1000).optional().default(-1),
    filter_data: zTasksTableFilterData.nullish(),
    sort_rules: z.array(zTasksTableSort)
});

/**
 * TeamBasicResponse
 */
export const zTeamBasicResponse = z.object({
    active: z.boolean().optional().default(true),
    slug: z.string(),
    name: z.string()
});

/**
 * CandidateRecommendationResponse
 */
export const zCandidateRecommendationResponse = z.object({
    search_metadata: zEsMeta.nullish(),
    person: zPersonBasicEmailResponse.nullish(),
    type: zIntroductionType,
    about: z.string().nullish(),
    advisor: zPersonBasicEmailResponse.nullish(),
    already_known: z.boolean().nullish(),
    candidate: zCandidateExtendedResponse,
    comment_author: zPersonBasicResponse.nullish(),
    comment_date: z.string().datetime().nullish(),
    company: zCompanyBasicTypeResponse,
    sent_date: z.string().datetime(),
    date_introduction_facilitated: z.string().datetime().nullish(),
    date_last_viewed: z.string().datetime().nullish(),
    highlights: z.array(zCandidateHighlightResponse),
    introduction_date: z.string().datetime().nullish(),
    introduction_status: zIntroductionStatus.nullish(),
    is_liked: z.boolean().nullish(),
    comment: z.string().nullish(),
    make_introduction: z.boolean().nullish(),
    match: z.boolean().nullish(),
    pipeline: zPipelineBasicHiddenResponse.nullish(),
    review_status: zRecommendationReviewState,
    team: zTeamBasicResponse,
    submission: zSubmissionBasicResponse,
    uuid: z.string().uuid(),
    viewed_date: z.string().datetime().nullish()
});

/**
 * PersonMemberRole
 */
export const zPersonMemberRole = z.object({
    company: zCompanyBasicTypeResponse.nullish(),
    role: zRole,
    team_: zTeamBasicResponse.nullish()
});

/**
 * PersonMemberResponse
 */
export const zPersonMemberResponse = z.object({
    first_name: z.string().min(1).nullish(),
    last_name: z.string().min(1).nullish(),
    email: z.string().email(),
    pending: z.boolean(),
    first_login: z.string().datetime().nullish(),
    name: z.string(),
    id: z.string().uuid(),
    image: z.string().nullish(),
    roles: z.array(zPersonMemberRole),
    permit_preregistration_notifications: z.boolean(),
    terms_accepted: z.string().datetime().nullish(),
    profile_image_url: z.string().nullable()
});

/**
 * RecommendationExternalFullResponse
 */
export const zRecommendationExternalFullResponse = z.object({
    introduction_status: zIntroductionStatus.nullish(),
    about: z.string().nullish(),
    candidate: zCandidateExternalFullResponse,
    company: zCompanyBasicResponse,
    highlights: z.array(z.string()),
    introduction_request_person: zPersonBasicResponse.nullish(),
    external_introduction_request_person: zExternalPerson.nullish(),
    intro_email_type: zIntroEmailType,
    is_liked: z.boolean().nullish(),
    pipeline: zPipelineBasicResponse.nullable(),
    team: zTeamBasicResponse,
    uuid: z.string().uuid(),
    draft_mode: zRecommendationDraftMode.nullish(),
    draft_assignee: zPersonBasicResponse.nullish()
});

/**
 * RecommendationsHistoryRecommendation
 */
export const zRecommendationsHistoryRecommendation = z.object({
    advisor: zPersonBasicResponse.nullish(),
    date: z.string().datetime().nullish(),
    status_context: zIntroductionStatusContext.nullish(),
    resolved_date: z.string().datetime().nullish(),
    person: zPersonBasicResponse.nullish(),
    status: zIntroductionStatus.nullish(),
    type: zIntroductionType,
    created: z.string().datetime(),
    pipeline: zPipelineBasicResponse.nullish(),
    team: zTeamBasicResponse
});

/**
 * RecommendationsHistoryResponse
 */
export const zRecommendationsHistoryResponse = z.object({
    candidate: zCandidateBasicResponse,
    recommendations: z.array(zRecommendationsHistoryRecommendation)
});

/**
 * TeamBasicUuidResponse
 */
export const zTeamBasicUuidResponse = z.object({
    active: z.boolean().optional().default(true),
    slug: z.string(),
    name: z.string(),
    uuid: z.string().uuid()
});

/**
 * AllIntrosResponse
 */
export const zAllIntrosResponse = z.object({
    uuid: z.string().uuid(),
    intro_type: zIntroTypeEnum,
    time: z.string().datetime(),
    candidate: zCandidateBasicResponse,
    candidate_to: zCandidateBasicResponse.nullish(),
    team: zTeamBasicUuidResponse.nullish()
});

/**
 * ESRecommendationCandidateIndexResult
 */
export const zEsRecommendationCandidateIndexResult = z.object({
    search_metadata: zEsMeta.nullish(),
    comments_count: z.number().int(),
    company: zCompanyBasicTypeResponse,
    pipeline: zPipelineBasicResponse.nullish(),
    published_on: z.string().datetime(),
    introduction_requested_on: z.string().datetime().nullish(),
    introduction_facilitated_on: z.string().datetime().nullish(),
    not_interested_on: z.string().datetime().nullish(),
    review_status: zRecommendationReviewState,
    team: zTeamBasicUuidResponse,
    uuid: z.string().uuid()
});

/**
 * CandidateFeedbackResult
 */
export const zCandidateFeedbackResult = z.object({
    advisor: zPersonBasicEmailResponse.nullish(),
    candidate: zCandidateBasicResponse.optional(),
    comment: z.string(),
    company: zCompanyBasicTypeResponse.nullish(),
    published_on: z.string().datetime(),
    person: zCandidateFeedbackPersonResponse.nullish(),
    pipeline: zPipelineBasicResponse.nullish(),
    team: zTeamBasicUuidResponse.nullish(),
    source: zFeedbackSource.default('feedback'),
    recommendation: zEsRecommendationCandidateIndexResult.nullish(),
    type: zFeedbackType.default('external'),
    uuid: z.string().uuid(),
    from_identity_uuid: z.string().uuid().nullish(),
    from_candidate_uuid: z.string().uuid().nullish(),
    subject_identity_uuid: z.string().uuid().nullish()
});

/**
 * HomeTeamActivityPipelineResponse
 */
export const zHomeTeamActivityPipelineResponse = z.object({
    introductions_pending: z.number().int(),
    pipeline: zPipelineExternalResponse,
    recommendations_count: z.number().int(),
    recommendations_unread: z.number().int(),
    recommendations: z.array(zHomeTeamActivityRecommendedPerson),
    team: zTeamBasicUuidResponse
});

/**
 * HomeTeamActivityRecommendationResponse
 */
export const zHomeTeamActivityRecommendationResponse = z.object({
    candidate: zCandidateExternalFullResponse,
    date_introduction_facilitated: z.string().datetime(),
    person: zPersonBasicResponse,
    pipeline: zPipelineExternalResponse,
    team: zTeamBasicUuidResponse,
    uuid: z.string().uuid()
});

/**
 * HomeTeamActivityResponse
 */
export const zHomeTeamActivityResponse = z.object({
    page_count: z.number().int().gte(0),
    page: z.number().int().gte(1),
    search_id: z.string().nullish(),
    results: z.array(z.union([zHomeTeamActivityPipelineResponse, zHomeTeamActivityRecommendationResponse])),
    size: z.number().int().gte(1),
    total_counts: zHomeTeamActivityCounts
});

/**
 * PipelinesTableV2Response
 */
export const zPipelinesTableV2Response = z.object({
    search_metadata: zEsMeta.nullish(),
    active: z.boolean(),
    company: z.string().nullish(),
    created: z.string().datetime(),
    last_modified: z.string().datetime(),
    function_expertise: z.array(zFunction),
    industry_expertise: z.array(zIndustry),
    introductions_count: z.number().int(),
    is_proactive: z.boolean(),
    visible_to_team: z.boolean(),
    last_submission: z.string().datetime().nullish(),
    pipeline_type: zPipelineType.optional().default('OTHER'),
    recommendations_count: z.number().int(),
    role: z.string(),
    role_type: zPipelineRoleType,
    slug: z.string(),
    team: zTeamBasicUuidResponse,
    team_company: zCompanyBasicTypeResponse,
    team_type: zOrgType.optional().default('other'),
    uuid: z.string().uuid()
});

/**
 * RecommendationPipelinesResponse
 */
export const zRecommendationPipelinesResponse = z.object({
    published_on: z.string().datetime(),
    is_liked: z.boolean().nullish(),
    pipeline: zPipelineBasicV2Response.nullish(),
    review_status: zRecommendationReviewState,
    uuid: z.string().uuid(),
    team: zTeamBasicUuidResponse.nullish()
});

/**
 * TeamCandidatePipelinesPayload
 */
export const zTeamCandidatePipelinesPayload = z.object({
    pipelines: z.array(z.string().uuid()).min(1),
    team_uuids: z.array(z.string().uuid()).nullish().default([])
});

/**
 * TeamCandidatesFiltersV3
 */
export const zTeamCandidatesFiltersV3 = z.object({
    connection_status: z.array(zConnectionStatus).nullish(),
    function_expertise: z.array(zFunction).nullish(),
    industry_expertise: z.array(zIndustry).nullish(),
    interest_role_board_advisory: z.array(zInterestRole).nullish(),
    interest_role_operating: z.array(zInterestRole).nullish(),
    operating_highlights: z.array(zOperatingHighlights).nullish(),
    source_company_tags: z.array(zSourceCompanyTags).nullish()
});

/**
 * TeamCandidatesSortColumn
 */
export const zTeamCandidatesSortColumn = z.enum(['name']);

/**
 * TeamCandidatesSort
 */
export const zTeamCandidatesSort = z.object({
    column: zTeamCandidatesSortColumn,
    direction: zSortDirection.optional().default('desc')
});

/**
 * TeamCandidatesFilterPayloadV3
 */
export const zTeamCandidatesFilterPayloadV3 = z.object({
    phrase: z.string().nullish(),
    search_id: z.string().nullish(),
    page: z.number().int().gte(1).optional().default(1),
    page_size: z.number().int().gte(1).lte(1000).optional().default(-1),
    filter_data: zTeamCandidatesFiltersV3.optional(),
    sort_rules: z.array(zTeamCandidatesSort),
    team_uuids: z.array(z.string().uuid()).nullish().default([]),
    custom_keywords_filter: z.array(z.string()).nullish()
});

/**
 * TeamCompanyResponse
 */
export const zTeamCompanyResponse = z.object({
    active: z.boolean().optional().default(true),
    slug: z.string(),
    name: z.string(),
    uuid: z.string().uuid(),
    company: zCompanyBasicResponse
});

/**
 * PipelineFullResponse
 */
export const zPipelineFullResponse = z.object({
    is_visible_to_team: z.boolean().nullish(),
    keywords: z.array(z.string()).nullish(),
    placed_candidate: zCandidateBasicResponse.nullish(),
    pipeline_type: zPipelineType.optional().default('OTHER'),
    active: z.boolean(),
    attendees: zPipelineAttendees.nullish(),
    company: z.string().nullish(),
    company_size: zCompanySize.nullish(),
    company_type: zCompanyType.nullish(),
    created: z.string().datetime(),
    creator: zPersonBasicResponse.nullish(),
    event_date: z.string().datetime().nullish(),
    event_name: z.string().nullish(),
    formatted_name: z.string(),
    function_expertise: z.array(zFunction),
    industry_expertise: z.array(zIndustry),
    is_urg: z.boolean(),
    location: z.string().nullish(),
    name: z.string(),
    notes: z.string().nullish(),
    point_of_contact: zPersonBasicResponse.nullish(),
    purpose: z.string().nullish(),
    is_proactive: z.boolean(),
    role_type: zPipelineRoleType,
    role: z.string(),
    team: zTeamCompanyResponse,
    slug: z.string(),
    uuid: z.string().uuid()
});

/**
 * TeamConnectionStatus
 */
export const zTeamConnectionStatus = z.enum([
    'recommendation_added',
    'facilitated',
    'none'
]);

/**
 * CompanyPeopleAggregations
 */
export const zCompanyPeopleAggregations = z.object({
    company_team_status: z.record(z.number().int()).optional(),
    recommendation_type: z.record(z.number().int()).optional()
});

/**
 * CompanyPeopleFilterPayload
 */
export const zCompanyPeopleFilterPayload = z.object({
    phrase: z.string().nullish(),
    search_id: z.string().nullish(),
    page: z.number().int().gte(1).optional().default(1),
    page_size: z.number().int().gte(1).lte(1000).optional().default(25),
    company_people_scope: zCompanyPeopleScope.optional().default('all'),
    company_team_status: z.array(zTeamConnectionStatus).nullish(),
    has_metadata: z.boolean().nullish(),
    is_shared: z.boolean().nullish(),
    sort_rules: z.array(zCompanyPeopleSort).optional()
});

/**
 * CompanyPeopleSharedTeamResponse
 */
export const zCompanyPeopleSharedTeamResponse = z.object({
    team_uuid: z.string().uuid(),
    team_name: z.string(),
    recommendation_types: z.array(zCompanyPeopleRecommendationType).optional(),
    company_team_status: zTeamConnectionStatus,
    date_recommended_last: z.string().datetime().nullish()
});

/**
 * CompanyPeopleRow
 */
export const zCompanyPeopleRow = z.object({
    candidate_uuid: z.string().uuid(),
    name: z.string(),
    role: z.string().nullish(),
    company: z.string().nullish(),
    image: z.string().nullish(),
    is_client: z.boolean(),
    email: z.string().nullish(),
    has_metadata: z.boolean(),
    is_shared: z.boolean(),
    company_metadata: zCandidateCompanyMetadataResponse.nullish(),
    company_team_status: zTeamConnectionStatus,
    recommendations_count: z.number().int().optional().default(0),
    shared_teams: z.array(zCompanyPeopleSharedTeamResponse).optional()
});

/**
 * CompanyPeopleFilterResponse
 */
export const zCompanyPeopleFilterResponse = z.object({
    page: z.number().int(),
    page_count: z.number().int(),
    size: z.number().int(),
    search_id: z.string().nullish(),
    results: z.array(zCompanyPeopleRow),
    total_counts: zCompanyPeopleTotalCounts,
    aggregations: zCompanyPeopleAggregations
});

/**
 * TeamCreate
 */
export const zTeamCreate = z.object({
    company_type: zSearchFirmType,
    slug: z.string().nullish(),
    team_name: z.string().min(1)
});

/**
 * TeamExclusionCriteria
 */
export const zTeamExclusionCriteria = z.enum([
    'basic_investor_teams',
    'has_no_members',
    'inactive',
    'portfolio_company_teams'
]);

/**
 * TeamExtendedFlatResponse
 */
export const zTeamExtendedFlatResponse = z.object({
    active: z.boolean().optional().default(true),
    slug: z.string(),
    name: z.string(),
    uuid: z.string().uuid(),
    additional_details: z.string().nullish(),
    client_size: zSearchFirmType.nullish()
});

/**
 * CandidateTeamResponse
 */
export const zCandidateTeamResponse = z.object({
    uuid: z.string().uuid(),
    company: zCompanyExtendedResponse,
    pipeline: zPipelineBasicResponse.nullish(),
    team: zTeamExtendedFlatResponse,
    published_on: z.string().datetime().nullish(),
    introduction_requested_on: z.string().datetime().nullish(),
    introduction_facilitated_on: z.string().datetime().nullish(),
    not_interested_on: z.string().datetime().nullish(),
    review_status: zRecommendationReviewState
});

/**
 * CandidateCompareRecommendationResponse
 */
export const zCandidateCompareRecommendationResponse = z.object({
    candidate_uuid: z.string().uuid(),
    name: z.string(),
    image: z.string().nullish(),
    teams_count: z.number().int(),
    aggregations: zCandidateRecommendationAggregations,
    candidate_teams: z.array(zCandidateTeamResponse)
});

/**
 * CandidatePeerRecommendationComparisonResponse
 */
export const zCandidatePeerRecommendationComparisonResponse = z.object({
    candidate: zCandidateCompareRecommendationResponse,
    peer: zCandidateCompareRecommendationResponse
});

/**
 * TeamIntroInsight
 *
 * API response: the live candidate list + the stored AI summary (when fresh).
 */
export const zTeamIntroInsight = z.object({
    team_slug: z.string(),
    window_label: z.string(),
    candidates: z.array(zIntroRequestItem),
    summary_status: zSummaryStatus,
    takeaway: z.string().nullish(),
    points: z.array(z.string()).optional().default([]),
    computed_at: z.string().datetime().nullish(),
    model_version: z.string().nullish()
});

/**
 * TeamMembersBulkInvitePayload
 */
export const zTeamMembersBulkInvitePayload = z.object({
    emails: z.array(z.string().email()),
    message: z.string().nullish()
});

/**
 * TeamMembersPost
 */
export const zTeamMembersPost = z.object({
    first_name: z.string().min(1).nullish(),
    last_name: z.string().min(1).nullish(),
    email: z.string().email(),
    person_name: z.string().min(1).nullish(),
    permit_preregistration_notifications: z.boolean().optional().default(false),
    send_invite_email: z.boolean().optional().default(true)
});

/**
 * TeamMergePayload
 *
 * Payload for merging a source team into the target (path) team.
 *
 * The team in the URL is the target/base team that survives; the source
 * team named here is folded into it and then deactivated.
 */
export const zTeamMergePayload = z.object({
    source_team_uuid: z.string().uuid(),
    new_team_name: z.string().min(1).nullish()
});

/**
 * TeamPipelineCandidatesResponse
 */
export const zTeamPipelineCandidatesResponse = z.object({
    search_id: z.string().nullish(),
    pipeline: zPipelineFullResponse,
    recommendations: z.array(zCandidateItem)
});

/**
 * TeamPipelineCandidatesSearchAggregations
 */
export const zTeamPipelineCandidatesSearchAggregations = z.object({
    advisor_id: z.record(z.number().int()).optional(),
    industry_expertise: z.record(z.number().int()).optional(),
    function_expertise: z.record(z.number().int()).optional(),
    is_accepting_intros: z.record(z.number().int()).optional(),
    tier: z.record(z.number().int()).optional(),
    type: z.record(z.number().int()).optional(),
    pathway: z.record(z.number().int()).optional(),
    underrepresented: z.record(z.number().int()).optional(),
    warm: z.record(z.number().int()).optional(),
    recsys_suggested: z.record(z.number().int()).optional(),
    pipeline_status: z.record(z.number().int()).optional(),
    operating_highlights: z.record(z.number().int()).optional(),
    recommendation_status: z.record(z.number().int()).optional(),
    introduction_status: z.record(z.number().int()).optional(),
    declined_status: z.record(z.number().int()).optional()
});

/**
 * TeamPipelinesFilter
 */
export const zTeamPipelinesFilter = z.enum([
    'active',
    'all',
    'closed'
]);

/**
 * TeamPipelinesSorter
 */
export const zTeamPipelinesSorter = z.enum([
    'company',
    'created',
    '',
    'name',
    'introductions',
    'introductions_completed',
    'last_submission',
    'last_modified',
    'recommendations',
    'role_type',
    'status',
    'unreviewed',
    'team_type'
]);

/**
 * TeamPipelinesTablePersonBasicResponse
 */
export const zTeamPipelinesTablePersonBasicResponse = z.object({
    name: z.string(),
    first_name: z.string().nullish(),
    last_name: z.string().nullish(),
    image: z.string().nullish(),
    uuid: z.string().uuid()
});

/**
 * TeamPipelinesTableResponse
 */
export const zTeamPipelinesTableResponse = z.object({
    search_metadata: zEsMeta.nullish(),
    name: z.string(),
    pipeline_type: zPipelineType.optional().default('OTHER'),
    slug: z.string(),
    is_visible_to_team: z.boolean(),
    hidden: z.boolean().optional().default(true),
    active: z.boolean(),
    assoc_member_uuid: z.string().uuid().nullish(),
    company: z.string().nullish(),
    created: z.string().datetime(),
    creator: zTeamPipelinesTablePersonBasicResponse.nullish(),
    function_expertise: z.array(zFunction),
    id: z.number().int(),
    industry_expertise: z.array(zIndustry),
    introductions: z.number().int(),
    introductions_completed_count: z.number().int(),
    introductions_completed_unviewed_count: z.number().int(),
    is_urg: z.boolean(),
    keywords: z.string().nullish(),
    last_modified: z.string().datetime(),
    last_submission: z.string().datetime().nullish(),
    location: z.string().nullish(),
    notes: z.string().nullish(),
    pipeline_last_viewed_on: z.string().datetime().nullish(),
    placement_name: z.string().nullish(),
    placement_uuid: z.string().uuid().nullish(),
    point_of_contact_name: z.string().nullish(),
    point_of_contact_uuid: z.string().uuid().nullish(),
    recommendations_count: z.number().int(),
    recommendations_unviewed_count: z.number().int(),
    recommendations_unviewed_activity_count: z.number().int(),
    role: z.string(),
    role_type: zPipelineObjective,
    team_name: z.string(),
    team_type: zOrgType.optional().default('other'),
    unreviewed_count_new: z.number().int(),
    uuid: z.string().uuid()
});

/**
 * TeamSearchResponse
 */
export const zTeamSearchResponse = z.object({
    search_metadata: zEsMeta.nullish(),
    active: z.boolean().optional().default(true),
    slug: z.string(),
    name: z.string(),
    uuid: z.string().uuid(),
    additional_details: z.string().nullish(),
    company: zCompanyBasicResponse,
    functional_focus: z.array(zFunction).nullish(),
    industry_focus: z.array(zIndustry).nullish()
});

/**
 * TeamStatsResponse
 */
export const zTeamStatsResponse = z.object({
    current_period: zPeriodStats,
    current_period_dates: zPeriodDates
});

/**
 * TeamSuggestionResponse
 */
export const zTeamSuggestionResponse = z.object({
    team_uuid: z.string().uuid(),
    score: z.number(),
    signals: z.record(z.number()),
    reasons: z.array(z.string())
});

/**
 * TeamTransferPayload
 *
 * Payload for transferring a team to a different company.
 */
export const zTeamTransferPayload = z.object({
    target_company_id: z.number().int(),
    new_team_name: z.string().min(1).nullish(),
    new_slug: z.string().nullish()
});

/**
 * TeamTrendingCandidatesResponse
 */
export const zTeamTrendingCandidatesResponse = z.object({
    search_id: z.string().nullish(),
    recommendations: z.array(zCandidateItem)
});

/**
 * TeamType
 *
 * What kind of group a team is (BAN-XXXX).
 *
 * Single-select on `search_team.team_type`. Deliberately binary: it is the one
 * cut that needs no judgement, so it backfills reliably. A fund's talent team
 * is INTERNAL — the talent partner is often exactly who trending wants.
 */
export const zTeamType = z.enum(['internal', 'portfolio_company']);

/**
 * TeamCreateV2
 */
export const zTeamCreateV2 = z.object({
    additional_details: z.string().nullish(),
    client_size: zSearchFirmType,
    functional_focus: z.array(zFunction).nullish(),
    fund_type: z.array(zFundType).nullish(),
    industry_focus: z.array(zIndustry).nullish(),
    team_name: z.string().min(1),
    team_type: zTeamType.nullish()
});

/**
 * CompanyTeamCreate
 */
export const zCompanyTeamCreate = z.object({
    team: zTeamCreateV2,
    company: zCompanyUpdate.nullish()
});

/**
 * TeamAndCompanyCreate
 */
export const zTeamAndCompanyCreate = z.object({
    team: zTeamCreateV2,
    company: zCompanyCreate
});

/**
 * TeamExtendedResponse
 */
export const zTeamExtendedResponse = z.object({
    active: z.boolean().optional().default(true),
    slug: z.string(),
    name: z.string(),
    uuid: z.string().uuid(),
    additional_details: z.string().nullish(),
    company: zCompanyExtendedResponseWithFeatures,
    client_size: zSearchFirmType.nullish(),
    effective_fund_type: z.array(zFundType).nullish(),
    fund_type: z.array(zFundType).nullish(),
    functional_focus: z.array(zFunction).nullish(),
    industry_focus: z.array(zIndustry).nullish(),
    team_type: zTeamType.nullish()
});

/**
 * TeamUpdate
 *
 * PATCH payload: every field optional, only the ones sent are applied.
 */
export const zTeamUpdate = z.object({
    additional_details: z.string().nullish(),
    company_type: zSearchFirmType.nullish(),
    fund_type: z.array(zFundType).nullish(),
    functional_focus: z.array(zFunction).nullish(),
    industry_focus: z.array(zIndustry).nullish(),
    team_name: z.string().min(1).nullish(),
    team_type: zTeamType.nullish(),
    slug: z.string().nullish(),
    active: z.boolean().nullish()
});

/**
 * TeamUpdateV2
 */
export const zTeamUpdateV2 = z.object({
    additional_details: z.string().nullish(),
    client_size: zSearchFirmType,
    functional_focus: z.array(zFunction).nullish(),
    fund_type: z.array(zFundType).nullish(),
    industry_focus: z.array(zIndustry).nullish(),
    team_name: z.string().min(1),
    team_type: zTeamType.nullish()
});

/**
 * TeamWithMembersBasicResponse
 */
export const zTeamWithMembersBasicResponse = z.object({
    members: z.array(zPersonBasicEmailResponse),
    active: z.boolean().optional().default(true),
    slug: z.string(),
    name: z.string()
});

/**
 * PipelineSearchResponse
 */
export const zPipelineSearchResponse = z.object({
    active: z.boolean(),
    company: z.string().nullish(),
    function_expertise: z.array(z.string()).nullish(),
    id: z.number().int(),
    industry_expertise: z.array(z.string()).nullish(),
    keywords: z.array(z.string()).nullish(),
    name: z.string(),
    candidates: z.array(zRecommendationCandidateBasicResponse),
    slug: z.string(),
    search_team: zTeamWithMembersBasicResponse,
    team_type: zOrgType,
    uuid: z.string().uuid()
});

/**
 * TeamsFilters
 */
export const zTeamsFilters = z.object({
    declined_status: z.array(zDeclinedStatusFilter).nullish(),
    exclude: z.array(zTeamExclusionCriteria).nullish(),
    fund_type: z.array(zFundType).nullish(),
    functional_focus: z.array(zFunction).nullish(),
    has_preregistered_users: z.boolean().nullish(),
    industry_focus: z.array(zIndustry).nullish(),
    introduction_status: z.array(zIntroductionStatusFilter).nullish(),
    recommendation_status: z.array(zRecommendationStatusFilter).nullish(),
    team_type: z.array(zOrgType).nullish()
});

/**
 * TeamsSearchTeamResponse
 */
export const zTeamsSearchTeamResponse = z.object({
    search_metadata: zEsMeta.nullish(),
    active: z.boolean().optional().default(true),
    slug: z.string(),
    name: z.string(),
    uuid: z.string().uuid(),
    additional_details: z.string().nullish(),
    client_size: zSearchFirmType.nullish(),
    company: zCompanyExtendedResponse,
    date_recommended: z.string().datetime().nullish(),
    effective_fund_type: z.array(zFundType).nullish(),
    fund_type: z.array(zFundType).nullish(),
    functional_focus: z.array(zFunction).nullish(),
    id: z.number().int(),
    industry_focus: z.array(zIndustry).nullish(),
    is_introduction_requested: z.boolean().nullish(),
    is_off_limits: z.boolean().nullish(),
    team_type: zTeamType.nullish(),
    declined_candidate: z.boolean().nullish(),
    has_no_members: z.boolean().nullish(),
    inactive: z.boolean().nullish(),
    previously_introduced: z.boolean().nullish(),
    previously_introduced_on: z.string().datetime().nullish(),
    previously_shared: z.string().datetime().nullish(),
    has_preregistered_users: z.boolean().nullish(),
    exec_current_role: z.string().nullish(),
    exec_current_company: z.string().nullish(),
    suggestion_score: z.number().nullish(),
    suggestion_reasons: z.array(z.string()).nullish(),
    suggestion_match: z.number().int().gte(0).lte(100).nullish(),
    suggestion_team_created: z.string().datetime().nullish(),
    suggestion_trendings_total: z.number().int().nullish(),
    suggestion_last_trended_on: z.string().datetime().nullish()
});

/**
 * SubmissionV3RecommendationResponse
 */
export const zSubmissionV3RecommendationResponse = z.object({
    candidate: zCandidateSearchResponse,
    team: zTeamsSearchTeamResponse,
    uuid: z.string().uuid(),
    published_on: z.string().datetime().nullish(),
    status: zRecommendationStatusOutput
});

/**
 * SubmissionV3InternalEmailStatsResponse
 */
export const zSubmissionV3InternalEmailStatsResponse = z.object({
    emails_delivered: z.number().int().default(0),
    emails_opened: z.number().int().default(0),
    about: z.string().nullish(),
    advisor: zPersonBasicEmailResponse.nullish(),
    candidate: zCandidateSearchResponse.nullish(),
    recommendations: z.array(zSubmissionV3RecommendationResponse),
    highlights_with_selected: z.array(zHighlightWithSelectedResponse),
    last_executed_in_summary_cron: z.string().datetime().nullish(),
    notification_type: zRecommendationPublishedNotificationType,
    publish_email_body: z.string().nullish(),
    publish_email_subject: z.string().nullish(),
    published_on: z.string().datetime().nullish(),
    status: zSubmissionStatus,
    type: zSubmissionType.nullish(),
    uuid: z.string().uuid()
});

/**
 * SubmissionV3InternalResponse
 */
export const zSubmissionV3InternalResponse = z.object({
    about: z.string().nullish(),
    advisor: zPersonBasicEmailResponse.nullish(),
    candidate: zCandidateSearchResponse.nullish(),
    recommendations: z.array(zSubmissionV3RecommendationResponse),
    highlights_with_selected: z.array(zHighlightWithSelectedResponse),
    last_executed_in_summary_cron: z.string().datetime().nullish(),
    notification_type: zRecommendationPublishedNotificationType,
    publish_email_body: z.string().nullish(),
    publish_email_subject: z.string().nullish(),
    published_on: z.string().datetime().nullish(),
    status: zSubmissionStatus,
    type: zSubmissionType.nullish(),
    uuid: z.string().uuid()
});

/**
 * TeamsSuggestedPayload
 */
export const zTeamsSuggestedPayload = z.object({
    candidate_uuid: z.string().uuid(),
    limit: z.number().int().gte(1).lte(200).optional().default(60),
    selected_team_uuids: z.array(z.string().uuid()).max(1000).optional(),
    weights: zSuggestionWeights.nullish()
});

/**
 * TeamsSuggestedResponse
 */
export const zTeamsSuggestedResponse = z.object({
    candidate_uuid: z.string().uuid(),
    results: z.array(zTeamSuggestionResponse)
});

/**
 * TotalCounts
 */
export const zTotalCounts = z.object({
    all: z.number().int()
});

/**
 * Page[AllIntrosResponse]
 */
export const zPageAllIntrosResponse = z.object({
    page_count: z.number().int().gte(0),
    page: z.number().int().gte(1),
    search_id: z.string().nullish(),
    results: z.array(zAllIntrosResponse),
    size: z.number().int().gte(1),
    total_counts: zTotalCounts
});

/**
 * Page[CandidateActivityEvent]
 */
export const zPageCandidateActivityEvent = z.object({
    page_count: z.number().int().gte(0),
    page: z.number().int().gte(1),
    search_id: z.string().nullish(),
    results: z.array(zCandidateActivityEvent),
    size: z.number().int().gte(1),
    total_counts: zTotalCounts
});

/**
 * Page[CandidateActivityLogResponse]
 */
export const zPageCandidateActivityLogResponse = z.object({
    page_count: z.number().int().gte(0),
    page: z.number().int().gte(1),
    search_id: z.string().nullish(),
    results: z.array(zCandidateActivityLogResponse),
    size: z.number().int().gte(1),
    total_counts: zTotalCounts
});

/**
 * Page[CandidateCompanyMetadataWithCandidateResponse]
 */
export const zPageCandidateCompanyMetadataWithCandidateResponse = z.object({
    page_count: z.number().int().gte(0),
    page: z.number().int().gte(1),
    search_id: z.string().nullish(),
    results: z.array(zCandidateCompanyMetadataWithCandidateResponse),
    size: z.number().int().gte(1),
    total_counts: zTotalCounts
});

/**
 * Page[CandidateExtendedResponse]
 */
export const zPageCandidateExtendedResponse = z.object({
    page_count: z.number().int().gte(0),
    page: z.number().int().gte(1),
    search_id: z.string().nullish(),
    results: z.array(zCandidateExtendedResponse),
    size: z.number().int().gte(1),
    total_counts: zTotalCounts
});

/**
 * Page[CandidateRecommendationResponse]
 */
export const zPageCandidateRecommendationResponse = z.object({
    page_count: z.number().int().gte(0),
    page: z.number().int().gte(1),
    search_id: z.string().nullish(),
    results: z.array(zCandidateRecommendationResponse),
    size: z.number().int().gte(1),
    total_counts: zTotalCounts
});

/**
 * Page[CandidateSearchResponseWithLinkedPerson]
 */
export const zPageCandidateSearchResponseWithLinkedPerson = z.object({
    page_count: z.number().int().gte(0),
    page: z.number().int().gte(1),
    search_id: z.string().nullish(),
    results: z.array(zCandidateSearchResponseWithLinkedPerson),
    size: z.number().int().gte(1),
    total_counts: zTotalCounts
});

/**
 * Page[CandidatesTableResponse]
 */
export const zPageCandidatesTableResponse = z.object({
    page_count: z.number().int().gte(0),
    page: z.number().int().gte(1),
    search_id: z.string().nullish(),
    results: z.array(zCandidatesTableResponse),
    size: z.number().int().gte(1),
    total_counts: zTotalCounts
});

/**
 * Page[CompanyTableResponse]
 */
export const zPageCompanyTableResponse = z.object({
    page_count: z.number().int().gte(0),
    page: z.number().int().gte(1),
    search_id: z.string().nullish(),
    results: z.array(zCompanyTableResponse),
    size: z.number().int().gte(1),
    total_counts: zTotalCounts
});

/**
 * Page[ContactSearchResult]
 */
export const zPageContactSearchResult = z.object({
    page_count: z.number().int().gte(0),
    page: z.number().int().gte(1),
    search_id: z.string().nullish(),
    results: z.array(zContactSearchResult),
    size: z.number().int().gte(1),
    total_counts: zTotalCounts
});

/**
 * Page[ESRecommendationCandidateIndexResult]
 */
export const zPageEsRecommendationCandidateIndexResult = z.object({
    page_count: z.number().int().gte(0),
    page: z.number().int().gte(1),
    search_id: z.string().nullish(),
    results: z.array(zEsRecommendationCandidateIndexResult),
    size: z.number().int().gte(1),
    total_counts: zTotalCounts
});

/**
 * Page[EmailTemplateResponse]
 */
export const zPageEmailTemplateResponse = z.object({
    page_count: z.number().int().gte(0),
    page: z.number().int().gte(1),
    search_id: z.string().nullish(),
    results: z.array(zEmailTemplateResponse),
    size: z.number().int().gte(1),
    total_counts: zTotalCounts
});

/**
 * Page[EventEmailBatchResponse]
 */
export const zPageEventEmailBatchResponse = z.object({
    page_count: z.number().int().gte(0),
    page: z.number().int().gte(1),
    search_id: z.string().nullish(),
    results: z.array(zEventEmailBatchResponse),
    size: z.number().int().gte(1),
    total_counts: zTotalCounts
});

/**
 * Page[EventEmailEventItemResponse]
 */
export const zPageEventEmailEventItemResponse = z.object({
    page_count: z.number().int().gte(0),
    page: z.number().int().gte(1),
    search_id: z.string().nullish(),
    results: z.array(zEventEmailEventItemResponse),
    size: z.number().int().gte(1),
    total_counts: zTotalCounts
});

/**
 * Page[EventGuestWithEventItemResponse]
 */
export const zPageEventGuestWithEventItemResponse = z.object({
    page_count: z.number().int().gte(0),
    page: z.number().int().gte(1),
    search_id: z.string().nullish(),
    results: z.array(zEventGuestWithEventItemResponse),
    size: z.number().int().gte(1),
    total_counts: zTotalCounts
});

/**
 * Page[EventResponse]
 */
export const zPageEventResponse = z.object({
    page_count: z.number().int().gte(0),
    page: z.number().int().gte(1),
    search_id: z.string().nullish(),
    results: z.array(zEventResponse),
    size: z.number().int().gte(1),
    total_counts: zTotalCounts
});

/**
 * Page[ExecutiveClientEventListItem]
 */
export const zPageExecutiveClientEventListItem = z.object({
    page_count: z.number().int().gte(0),
    page: z.number().int().gte(1),
    search_id: z.string().nullish(),
    results: z.array(zExecutiveClientEventListItem),
    size: z.number().int().gte(1),
    total_counts: zTotalCounts
});

/**
 * Page[GeneralSearchResponse]
 */
export const zPageGeneralSearchResponse = z.object({
    page_count: z.number().int().gte(0),
    page: z.number().int().gte(1),
    search_id: z.string().nullish(),
    results: z.array(zGeneralSearchResponse),
    size: z.number().int().gte(1),
    total_counts: zTotalCounts
});

/**
 * Page[HomepageActivityLogResponse]
 */
export const zPageHomepageActivityLogResponse = z.object({
    page_count: z.number().int().gte(0),
    page: z.number().int().gte(1),
    search_id: z.string().nullish(),
    results: z.array(zHomepageActivityLogResponse),
    size: z.number().int().gte(1),
    total_counts: zTotalCounts
});

/**
 * Page[IdentityEmailItemResponse]
 */
export const zPageIdentityEmailItemResponse = z.object({
    page_count: z.number().int().gte(0),
    page: z.number().int().gte(1),
    search_id: z.string().nullish(),
    results: z.array(zIdentityEmailItemResponse),
    size: z.number().int().gte(1),
    total_counts: zTotalCounts
});

/**
 * Page[PeerActivityResponse]
 */
export const zPagePeerActivityResponse = z.object({
    page_count: z.number().int().gte(0),
    page: z.number().int().gte(1),
    search_id: z.string().nullish(),
    results: z.array(zPeerActivityResponse),
    size: z.number().int().gte(1),
    total_counts: zTotalCounts
});

/**
 * Page[PersonBasicEmailResponse]
 */
export const zPagePersonBasicEmailResponse = z.object({
    page_count: z.number().int().gte(0),
    page: z.number().int().gte(1),
    search_id: z.string().nullish(),
    results: z.array(zPersonBasicEmailResponse),
    size: z.number().int().gte(1),
    total_counts: zTotalCounts
});

/**
 * Page[PersonSearchResponse]
 */
export const zPagePersonSearchResponse = z.object({
    page_count: z.number().int().gte(0),
    page: z.number().int().gte(1),
    search_id: z.string().nullish(),
    results: z.array(zPersonSearchResponse),
    size: z.number().int().gte(1),
    total_counts: zTotalCounts
});

/**
 * Page[PipelineSearchResponse]
 */
export const zPagePipelineSearchResponse = z.object({
    page_count: z.number().int().gte(0),
    page: z.number().int().gte(1),
    search_id: z.string().nullish(),
    results: z.array(zPipelineSearchResponse),
    size: z.number().int().gte(1),
    total_counts: zTotalCounts
});

/**
 * Page[TeamPipelinesTableResponse]
 */
export const zPageTeamPipelinesTableResponse = z.object({
    page_count: z.number().int().gte(0),
    page: z.number().int().gte(1),
    search_id: z.string().nullish(),
    results: z.array(zTeamPipelinesTableResponse),
    size: z.number().int().gte(1),
    total_counts: zTotalCounts
});

/**
 * Page[TeamSearchResponse]
 */
export const zPageTeamSearchResponse = z.object({
    page_count: z.number().int().gte(0),
    page: z.number().int().gte(1),
    search_id: z.string().nullish(),
    results: z.array(zTeamSearchResponse),
    size: z.number().int().gte(1),
    total_counts: zTotalCounts
});

/**
 * PostPage[ActivityFeedItem]
 */
export const zPostPageActivityFeedItem = z.object({
    page_count: z.number().int().gte(0),
    page: z.number().int().gte(1),
    search_id: z.string().nullish(),
    results: z.array(zActivityFeedItem),
    size: z.number().int().gte(1),
    total_counts: zTotalCounts
});

/**
 * PostPage[CompanyDetailedResponse]
 */
export const zPostPageCompanyDetailedResponse = z.object({
    page_count: z.number().int().gte(0),
    page: z.number().int().gte(1),
    search_id: z.string().nullish(),
    results: z.array(zCompanyDetailedResponse),
    size: z.number().int().gte(1),
    total_counts: zTotalCounts
});

/**
 * PostPage[MarketSearchRowResponse]
 */
export const zPostPageMarketSearchRowResponse = z.object({
    page_count: z.number().int().gte(0),
    page: z.number().int().gte(1),
    search_id: z.string().nullish(),
    results: z.array(zMarketSearchRowResponse),
    size: z.number().int().gte(1),
    total_counts: zTotalCounts
});

/**
 * TotalCountsCandidateCompanyMetadataImportResponse
 */
export const zTotalCountsCandidateCompanyMetadataImportResponse = z.object({
    all: z.number().int().optional().default(0),
    succeeded: z.number().int().optional().default(0),
    failed: z.number().int().optional().default(0)
});

/**
 * CandidateCompanyMetadataImportResponse
 */
export const zCandidateCompanyMetadataImportResponse = z.object({
    total_counts: zTotalCountsCandidateCompanyMetadataImportResponse,
    failed_rows: z.array(zFailedCandidateCompanyMetadataRow).optional()
});

/**
 * TotalCountsResponse
 */
export const zTotalCountsResponse = z.object({
    all: z.number().int()
});

/**
 * CandidateFeedbackFilterResponse
 */
export const zCandidateFeedbackFilterResponse = z.object({
    page_count: z.number().int(),
    page: z.number().int(),
    results: z.array(zCandidateFeedbackResult),
    search_id: z.string().nullish(),
    size: z.number().int(),
    total_counts: zTotalCountsResponse
});

/**
 * CandidateTaskModulesResponse
 */
export const zCandidateTaskModulesResponse = z.object({
    page_count: z.number().int(),
    page: z.number().int(),
    results: z.array(zCandidateTaskModuleResponse),
    size: z.number().int(),
    total_counts: zTotalCountsResponse
});

/**
 * CandidatesCombinedPerformancePaginatedResponse
 */
export const zCandidatesCombinedPerformancePaginatedResponse = z.object({
    page_count: z.number().int(),
    page: z.number().int(),
    results: z.array(zCandidatesCombinedPerformanceResponse),
    size: z.number().int(),
    total_counts: zTotalCountsResponse
});

/**
 * CandidatesPerformancePaginatedResponse
 */
export const zCandidatesPerformancePaginatedResponse = z.object({
    page_count: z.number().int(),
    page: z.number().int(),
    results: z.array(zCandidatePerformanceResponse),
    size: z.number().int(),
    total_counts: zTotalCountsResponse
});

/**
 * ExecutivePeopleSearchResponse
 */
export const zExecutivePeopleSearchResponse = z.object({
    page_count: z.number().int(),
    page: z.number().int(),
    results: z.array(zExecutivePeopleResultItem),
    size: z.number().int(),
    total_counts: zTotalCountsResponse,
    aggregations: zExecutivePeopleAggregationsResponse.optional(),
    search_id: z.string().nullish()
});

/**
 * HomeCandidatesResponse
 */
export const zHomeCandidatesResponse = z.object({
    results: z.array(zEsCandidateIndexExternalResult),
    search_id: z.string(),
    total_counts: zTotalCountsResponse
});

/**
 * PaginatedPipelinesTableResponse
 */
export const zPaginatedPipelinesTableResponse = z.object({
    page_count: z.number().int(),
    page: z.number().int(),
    results: z.array(zPipelinesTableV2Response),
    size: z.number().int(),
    total_counts: zTotalCountsResponse,
    aggregations: zPipelinesAggregationsResponse
});

/**
 * PeerToPeerTableExecutiveResponse
 */
export const zPeerToPeerTableExecutiveResponse = z.object({
    page_count: z.number().int(),
    page: z.number().int(),
    results: z.array(zPeerToPeerBasicResponse),
    size: z.number().int(),
    total_counts: zTotalCountsResponse,
    aggregations: zPeerToPeerTableExecutiveAggregationsResponse
});

/**
 * PeerToPeerTableResponse
 */
export const zPeerToPeerTableResponse = z.object({
    page_count: z.number().int(),
    page: z.number().int(),
    results: z.array(zPeerToPeerBasicEsResponse),
    size: z.number().int(),
    total_counts: zTotalCountsResponse,
    aggregations: zPeerToPeerTableFilterAggregationsResponse
});

/**
 * PeerToPeerTableSelectResponse
 */
export const zPeerToPeerTableSelectResponse = z.object({
    page_count: z.number().int(),
    page: z.number().int(),
    results: z.array(zPeerToPeerSelectResponse),
    size: z.number().int(),
    total_counts: zTotalCountsResponse,
    aggregations: zPeerToPeerTableSelectAggregationsResponse
});

/**
 * PipelineCandidatesFilterPaginatedResponse
 */
export const zPipelineCandidatesFilterPaginatedResponse = z.object({
    page_count: z.number().int(),
    page: z.number().int(),
    results: z.array(zPipelineCandidatesFilterResponse),
    size: z.number().int(),
    total_counts: zTotalCountsResponse
});

/**
 * SubmissionsSearchFilterSortPaginatedResponse
 */
export const zSubmissionsSearchFilterSortPaginatedResponse = z.object({
    page_count: z.number().int(),
    page: z.number().int(),
    results: z.array(zSubmissionSearchFilterSortResponse),
    size: z.number().int(),
    total_counts: zTotalCountsResponse,
    search_id: z.string().nullish()
});

/**
 * TasksTableResponse
 */
export const zTasksTableResponse = z.object({
    page_count: z.number().int(),
    page: z.number().int(),
    results: z.array(zTaskBasicResponse),
    size: z.number().int(),
    total_counts: zTotalCountsResponse,
    aggregations: zTasksTableFilterAggregationsResponse
});

/**
 * TeamPipelineCandidatesSearchFilterSortResponse
 */
export const zTeamPipelineCandidatesSearchFilterSortResponse = z.object({
    search_id: z.string().nullish(),
    page_count: z.number().int(),
    page: z.number().int(),
    aggregations: zTeamPipelineCandidatesSearchAggregations,
    results: z.array(zPipelineCandidateSearchFilterSortResponse),
    size: z.number().int(),
    total_counts: zTotalCountsResponse,
    suggestion_basis: z.string().nullish(),
    suggestion_picks: z.array(zSuggestionPick).nullish()
});

/**
 * TeamsSearchFilterPaginatedResponse
 */
export const zTeamsSearchFilterPaginatedResponse = z.object({
    page_count: z.number().int(),
    page: z.number().int(),
    results_hidden: z.array(zOffLimitsTeamSchema),
    results: z.array(zTeamsSearchTeamResponse),
    search_id: z.string(),
    size: z.number().int(),
    total_counts: zTotalCountsResponse
});

/**
 * TrendingCandidateResponse
 */
export const zTrendingCandidateResponse = z.object({
    candidate: zCandidateCompanyRoleResponse,
    advisor: zPersonBasicResponse,
    favorite_count: z.number().int(),
    introductions_facilitated_count: z.number().int(),
    introductions_requested_count: z.number().int(),
    recommendation_count: z.number().int(),
    rank: z.number()
});

/**
 * TrendingCandidateSortColumn
 */
export const zTrendingCandidateSortColumn = z.enum(['rank']);

/**
 * TrendingCandidateSort
 */
export const zTrendingCandidateSort = z.object({
    column: zTrendingCandidateSortColumn,
    direction: zSortDirection.optional().default('desc')
});

/**
 * TrendingCandidatesFilters
 */
export const zTrendingCandidatesFilters = z.object({
    advisor_id: z.array(z.string()).nullish(),
    function_expertise: z.array(zFunction).nullish(),
    industry_expertise: z.array(zIndustry).nullish(),
    type: z.array(zClientType).nullish(),
    pathway: z.array(zCandidatePathway).nullish()
});

/**
 * TrendingCandidateFilterSortPayload
 */
export const zTrendingCandidateFilterSortPayload = z.object({
    page: z.number().int().gte(1).optional().default(1),
    size: z.number().int().gte(1).lte(100).optional().default(-1),
    filter_data: zTrendingCandidatesFilters.nullish(),
    sort_rules: z.array(zTrendingCandidateSort)
});

/**
 * TrendingCandidatesPaginatedResponse
 */
export const zTrendingCandidatesPaginatedResponse = z.object({
    page_count: z.number().int(),
    page: z.number().int(),
    results: z.array(zTrendingCandidateResponse),
    size: z.number().int(),
    total_counts: zTotalCountsResponse
});

/**
 * TrendingMessageKeysResponse
 *
 * What a Plain trending email's subject and message can say.
 */
export const zTrendingMessageKeysResponse = z.object({
    default_message: z.string(),
    default_subject: z.string(),
    link_keys: z.array(z.string()),
    message_keys: z.array(z.string()),
    subject_keys: z.array(z.string())
});

/**
 * TrendingMessageResponse
 *
 * A message an advisor wrote for one candidate's Trending campaigns.
 * Campaigns that sent the same body text count as one message.
 */
export const zTrendingMessageResponse = z.object({
    advisor: zPersonBasicResponse.nullish(),
    body: z.string(),
    last_used_on: z.string().datetime(),
    subject: z.string().nullish(),
    submission_uuid: z.string().uuid(),
    times_used: z.number().int()
});

/**
 * TrendingScheduleCampaignSpreads
 */
export const zTrendingScheduleCampaignSpreads = z.enum(['first_available', 'custom']);

/**
 * TrendingSchedulePayload
 */
export const zTrendingSchedulePayload = z.object({
    campaign_spread: zTrendingScheduleCampaignSpreads.optional().default('first_available'),
    campaign_start_date: z.string().datetime().optional(),
    campaign_weeks: z.number().int().nullish(),
    team_uuids: z.array(z.string().uuid()).optional().default([])
});

/**
 * TrendingSchedulingMethod
 */
export const zTrendingSchedulingMethod = z.enum(['first_available', 'optimized']);

/**
 * TrendingScheduleTeamSubmission
 */
export const zTrendingScheduleTeamSubmission = z.object({
    team_uuid: z.string().uuid(),
    scheduling_method: zTrendingSchedulingMethod,
    scheduled_date: z.string().datetime(),
    blackout_dates: z.array(z.string().datetime())
});

/**
 * TrendingScheduleResponse
 */
export const zTrendingScheduleResponse = z.object({
    campaign_spread: zTrendingScheduleCampaignSpreads,
    optimized_submissions: z.array(zTrendingScheduleTeamSubmission),
    campaign_start_date: z.string().datetime(),
    campaign_weeks: z.number().int(),
    display_weeks: z.number().int(),
    team_uuids: z.array(z.string().uuid()),
    starts_today: z.boolean()
});

/**
 * TrendingSuggestionRanking
 *
 * Which trending team ranking a `suggested` team search uses.
 */
export const zTrendingSuggestionRanking = z.enum(['top', 'explore']);

/**
 * TeamsSuggestedRestriction
 *
 * Restrict a team search to the candidate's trending suggestion pool.
 *
 * The pool is the full ranking chosen by `ranking` (see
 * app/helpers/team_suggestions.py) after the trending hygiene exclusions;
 * every other filter, the search phrase, paging and totals compose with it
 * server-side. Without a phrase the results come back in rank order.
 */
export const zTeamsSuggestedRestriction = z.object({
    selected_team_uuids: z.array(z.string().uuid()).max(1000).optional(),
    weights: zSuggestionWeights.nullish(),
    ranking: zTrendingSuggestionRanking.optional().default('top')
});

/**
 * TeamsSearchFilterPayload
 */
export const zTeamsSearchFilterPayload = z.object({
    phrase: z.string().nullish(),
    search_id: z.string().nullish(),
    page: z.number().int().gte(1).optional().default(1),
    page_size: z.number().int().gte(1).lte(1000).optional().default(-1),
    candidate_uuid: z.string().uuid(),
    filter_data: zTeamsFilters.nullish(),
    published_on: z.string().datetime().nullish(),
    team_uuids: z.array(z.string().uuid()).nullish(),
    suggested: zTeamsSuggestedRestriction.nullish()
});

/**
 * TypeFilter
 */
export const zTypeFilter = z.enum([
    'role',
    'submission',
    'team'
]);

/**
 * UUIDResponse
 */
export const zUuidResponse = z.object({
    uuid: z.string().uuid()
});

/**
 * ActivityEventResponse
 */
export const zActivityEventResponse = z.object({
    action: zEvaluationAction,
    advisor: zPersonBasicResponse.nullish(),
    candidate: zUuidResponse,
    created: z.string().datetime(),
    id: z.number().int(),
    last_modified: z.string().datetime(),
    person: zPersonBasicResponse.nullish(),
    pipeline: zUuidResponse.nullish(),
    recommendation: zUuidResponse.nullish(),
    team: zUuidResponse
});

/**
 * CommentResponse
 */
export const zCommentResponse = z.object({
    candidate: zUuidResponse.nullish(),
    person: zPersonBasicResponse.nullish(),
    content: z.string(),
    created: z.string().datetime(),
    id: z.string().uuid(),
    last_modified: z.string().datetime(),
    pipeline: zUuidResponse.nullish(),
    recommendation: zUuidResponse.nullish(),
    subject_identity_uuid: z.string().uuid(),
    team: zUuidResponse
});

/**
 * InternalCommentResponse
 */
export const zInternalCommentResponse = z.object({
    candidate: zUuidResponse,
    person: zPersonBasicResponse,
    content: z.string(),
    created: z.string().datetime(),
    id: z.string().uuid(),
    last_modified: z.string().datetime(),
    pipeline: zUuidResponse.nullish(),
    recommendation: zUuidResponse.nullish(),
    team: zUuidResponse
});

/**
 * Page[CommentResponse]
 */
export const zPageCommentResponse = z.object({
    page_count: z.number().int().gte(0),
    page: z.number().int().gte(1),
    search_id: z.string().nullish(),
    results: z.array(zCommentResponse),
    size: z.number().int().gte(1),
    total_counts: zTotalCounts
});

/**
 * Page[InternalCommentResponse]
 */
export const zPageInternalCommentResponse = z.object({
    page_count: z.number().int().gte(0),
    page: z.number().int().gte(1),
    search_id: z.string().nullish(),
    results: z.array(zInternalCommentResponse),
    size: z.number().int().gte(1),
    total_counts: zTotalCounts
});

/**
 * UndoExecutiveActivationBlocker
 *
 * Why an executive activation can no longer be undone.
 */
export const zUndoExecutiveActivationBlocker = z.enum(['invitation_sent', 'team_has_content']);

/**
 * UpdateCandidate
 *
 * Body of ``PATCH /api/v2/candidates/{candidate_uuid}``: a JSON merge patch
 * (RFC 7396). A field that is absent is left alone; ``null`` clears it. Fields
 * ``CreateCandidate`` requires cannot be cleared. No cross-field rules: any
 * combination of tier, advisor, client owner, type and pathway is accepted.
 *
 * The fields are ``CreateCandidate``'s, all optional, except the ones written
 * as rows elsewhere: ``referrers`` (their own endpoints), the blackout dates
 * and ``resume``.
 */
export const zUpdateCandidate = z.object({
    first_name: z.string().min(1).nullish(),
    last_name: z.string().min(1).nullish(),
    linkedin_url: z.string().nullish(),
    advisor_uuid: z.string().uuid().nullish(),
    email: z.string().email().nullish(),
    company: z.string().min(1).nullish(),
    role: z.string().min(1).nullish(),
    client_owner_uuid: z.string().uuid().nullish(),
    is_urg: z.boolean().nullish(),
    function_expertise: z.array(zFunction).nullish(),
    function_target: z.array(zFunction).nullish(),
    industry_expertise: z.array(zIndustry).nullish(),
    industry_target: z.array(zIndustry).nullish(),
    interest_role_board_advisory: zInterestRole.nullish(),
    interest_role_operating: zInterestRole.nullish(),
    interests_personal: z.array(zInterestPersonal).nullish(),
    interests_professional: z.array(zInterestProfessional).nullish(),
    interests_notes: z.string().min(1).nullish(),
    wants_intros: z.boolean().nullish(),
    interest_relocation: z.boolean().nullish(),
    interest_relocation_notes: z.string().min(1).nullish(),
    intro_email_type: zIntroEmailType.nullish(),
    kickoff_date: z.string().datetime().nullish(),
    keywords: z.array(z.string().min(1)).nullish(),
    network_target: z.string().min(1).nullish(),
    notes: z.string().min(1).nullish(),
    operating_highlights: z.array(zOperatingHighlights).nullish(),
    passions: z.string().min(1).nullish(),
    image: z.string().nullish(),
    tier: zCandidateTier.nullish(),
    type: zClientType.nullish(),
    pathway: zCandidatePathway.nullish(),
    source_company_tags: z.array(zSourceCompanyTags).nullish()
});

/**
 * UpdateExecutiveClientSettingsPayload
 */
export const zUpdateExecutiveClientSettingsPayload = z.object({
    first_name: z.string().nullish(),
    last_name: z.string().nullish(),
    email: z.string().nullish(),
    receive_trending_emails: z.boolean().nullish(),
    receive_pipeline_emails: z.boolean().nullish()
});

/**
 * UpdateExecutiveSettingsPayload
 */
export const zUpdateExecutiveSettingsPayload = z.object({
    access_level: zExecutiveAccessLevel.nullish(),
    payment_status: zExecutivePaymentStatus.nullish(),
    hiring_pipeline_limit: z.number().int().gte(0).nullish(),
    receive_trending_emails: z.boolean().nullish(),
    receive_pipeline_emails: z.boolean().nullish(),
    content_access_level: z.string().nullish(),
    email: z.string().nullish()
});

/**
 * UpdateMultipleRecommendationDraftPayload
 */
export const zUpdateMultipleRecommendationDraftPayload = z.object({
    recommendation_uuids: z.array(z.string().uuid()).min(1),
    draft_mode: zRecommendationDraftMode.nullish(),
    draft_assignee_id: z.string().uuid().nullish()
});

/**
 * UpdatePipelinePayload
 */
export const zUpdatePipelinePayload = z.object({
    is_visible_to_team: z.boolean().nullish(),
    keywords: z.array(z.string().min(1)),
    placed_candidate_id: z.string().uuid().nullish(),
    is_proactive: z.boolean().optional().default(false),
    attendees: zPipelineAttendees.nullish(),
    company: z.string().min(1).nullish(),
    company_size: zCompanySize.nullish(),
    company_type: zCompanyType.nullish(),
    event_date: z.string().datetime().nullish(),
    event_name: z.string().nullish(),
    function_expertise: z.array(zFunction).min(1),
    industry_expertise: z.array(zIndustry).min(1),
    is_urg: z.boolean().nullish(),
    location: z.string().min(1).nullish(),
    name: z.string().min(1),
    notes: z.string().min(1).nullish(),
    pipeline_type: zPipelineType.nullish(),
    point_of_contact_person_id: z.string().uuid().nullish(),
    purpose: z.string().nullish(),
    role_type: zPipelineRoleType
});

/**
 * UserBulkDeleteResult
 *
 * One requested uuid. ``clerk_error`` is set when the row was deleted but
 * the Clerk user could not be: the login still exists in Clerk and has to be
 * removed there by hand.
 */
export const zUserBulkDeleteResult = z.object({
    user_uuid: z.string().uuid(),
    status: z.enum([
        'deleted',
        'not_found',
        'error'
    ]),
    error: z.string().nullish(),
    clerk_error: z.string().nullish()
});

/**
 * UserCompanyPayload
 */
export const zUserCompanyPayload = z.object({
    company_id: z.number().int()
});

/**
 * UserInvitationPersonBasicResponse
 *
 * Basic person fields for invitation sender/recipient.
 */
export const zUserInvitationPersonBasicResponse = z.object({
    uuid: z.string().uuid(),
    email: z.string().email(),
    first_name: z.string().nullish(),
    last_name: z.string().nullish(),
    full_name: z.string().nullish()
});

/**
 * UserInviteResponse
 */
export const zUserInviteResponse = z.object({
    company: zCompanyBasicTypeResponse,
    email: z.string().email(),
    full_name: z.string(),
    teams: z.array(zTeamBasicResponse),
    uuid: z.string().uuid()
});

/**
 * UserTeamBasicResponse
 *
 * Basic team information for user response
 */
export const zUserTeamBasicResponse = z.object({
    id: z.number().int(),
    uuid: z.string().uuid(),
    slug: z.string(),
    team_name: z.string()
});

/**
 * UserInvitationResponse
 *
 * Invitation history record for a user.
 */
export const zUserInvitationResponse = z.object({
    id: z.number().int(),
    created: z.string().datetime(),
    last_modified: z.string().datetime(),
    reminder_sent: z.string().datetime().nullish(),
    clerk_invitation_id: z.string().nullish(),
    from_id: z.string().uuid().nullish(),
    to_id: z.string().uuid().nullish(),
    team_id: z.number().int().nullish(),
    sender: zUserInvitationPersonBasicResponse.nullish(),
    recipient: zUserInvitationPersonBasicResponse.nullish(),
    team: zUserTeamBasicResponse.nullish()
});

/**
 * UserRoleResponse
 *
 * Role information for user response
 */
export const zUserRoleResponse = z.object({
    id: z.number().int(),
    role: zRole,
    company_id: z.number().int().nullish(),
    company: zCompanyBasicTypeResponse.nullish(),
    team_id: z.number().int().nullish(),
    team: zUserTeamBasicResponse.nullish()
});

/**
 * UserTeamPayload
 */
export const zUserTeamPayload = z.object({
    team_uuid: z.string().uuid(),
    lead: z.boolean().optional().default(false)
});

/**
 * UserType
 *
 * Classification for users list / detail
 */
export const zUserType = z.enum([
    'executive',
    'enterprise',
    'admin'
]);

/**
 * AdminUserDetailedResponse
 *
 * Admin-only detailed user response including invitation history.
 */
export const zAdminUserDetailedResponse = z.object({
    id: z.string().uuid(),
    uuid: z.string().uuid(),
    email: z.string().email(),
    first_name: z.string().nullish(),
    last_name: z.string().nullish(),
    full_name: z.string().nullish(),
    company: zCompanyExtendedResponse.nullish(),
    created: z.string().datetime(),
    first_login: z.string().datetime().nullish(),
    last_login: z.string().datetime().nullish(),
    active: z.boolean(),
    pending: z.boolean(),
    permit_preregistration_notifications: z.boolean(),
    notes_external: z.string().nullish(),
    notes_internal: z.string().nullish(),
    linkedin_url: z.string().nullish(),
    wants_intros: z.boolean().nullish(),
    wants_intro_followups: z.boolean().nullish(),
    handle_intros_as_exec: z.boolean().nullish(),
    teams_count: z.number().int(),
    teams: z.array(zUserTeamBasicResponse).optional().default([]),
    roles: z.array(zUserRoleResponse).optional().default([]),
    identity_uuid: z.string().uuid().nullish(),
    candidate_uuid: z.string().uuid().nullish(),
    candidate: zCandidateBasicResponse.nullish(),
    user_type: zUserType,
    search_metadata: zEsMeta.nullish(),
    invitations: z.array(zUserInvitationResponse).optional().default([]),
    undo_executive_activation_blocker: zUndoExecutiveActivationBlocker.nullish()
});

/**
 * IdentityPersonItem
 */
export const zIdentityPersonItem = z.object({
    uuid: z.string().uuid(),
    email: z.string(),
    first_name: z.string().nullish(),
    last_name: z.string().nullish(),
    name: z.string().nullish(),
    is_activated_executive: z.boolean(),
    registered: z.boolean(),
    user: zAdminUserDetailedResponse
});

/**
 * IdentityResponse
 */
export const zIdentityResponse = z.object({
    identity_uuid: z.string().uuid(),
    candidate: zIdentityCandidateItem.nullish(),
    executive_person_uuid: z.string().uuid().nullish(),
    persons: z.array(zIdentityPersonItem),
    merged_into_uuid: z.string().uuid().nullish()
});

/**
 * PeoplePost
 */
export const zPeoplePost = z.object({
    first_name: z.string().min(1).nullish(),
    last_name: z.string().min(1).nullish(),
    email: z.string().email(),
    person_name: z.string().min(1).nullish(),
    permit_preregistration_notifications: z.boolean().optional().default(false),
    send_invite_email: z.boolean().optional().default(true),
    additional_details: z.string().nullish(),
    company_type: zSearchFirmType.nullish(),
    fund_type: z.array(zFundType).nullish(),
    functional_focus: z.array(zFunction).nullish(),
    industry_focus: z.array(zIndustry).nullish(),
    team_name: z.string().min(1).nullish(),
    team_type: zTeamType.nullish(),
    team_slug: z.string().nullish(),
    organization: z.string().min(1).nullish(),
    payment_status: zPaymentStatus.nullish(),
    customer_type: zOrgType.nullish(),
    company_slug: z.string().nullish(),
    role: zRole,
    user_type: zUserType
});

/**
 * UserDetailedResponse
 *
 * Detailed user response including company and role information
 */
export const zUserDetailedResponse = z.object({
    id: z.string().uuid(),
    uuid: z.string().uuid(),
    email: z.string().email(),
    first_name: z.string().nullish(),
    last_name: z.string().nullish(),
    full_name: z.string().nullish(),
    company: zCompanyExtendedResponse.nullish(),
    created: z.string().datetime(),
    first_login: z.string().datetime().nullish(),
    last_login: z.string().datetime().nullish(),
    active: z.boolean(),
    pending: z.boolean(),
    permit_preregistration_notifications: z.boolean(),
    notes_external: z.string().nullish(),
    notes_internal: z.string().nullish(),
    linkedin_url: z.string().nullish(),
    wants_intros: z.boolean().nullish(),
    wants_intro_followups: z.boolean().nullish(),
    handle_intros_as_exec: z.boolean().nullish(),
    teams_count: z.number().int(),
    teams: z.array(zUserTeamBasicResponse).optional().default([]),
    roles: z.array(zUserRoleResponse).optional().default([]),
    identity_uuid: z.string().uuid().nullish(),
    candidate_uuid: z.string().uuid().nullish(),
    candidate: zCandidateBasicResponse.nullish(),
    user_type: zUserType,
    search_metadata: zEsMeta.nullish()
});

/**
 * UserUpdatePayload
 *
 * Payload for updating user/person fields.
 */
export const zUserUpdatePayload = z.object({
    active: z.boolean().nullish(),
    permit_preregistration_notifications: z.boolean().nullish()
});

/**
 * UsersAggregationsResponse
 *
 * Aggregation totals for users search filters
 */
export const zUsersAggregationsResponse = z.object({
    companies: z.record(z.number().int()).optional().default({}),
    roles: z.record(z.number().int()).optional().default({}),
    company_types: z.record(z.number().int()).optional().default({}),
    active: z.record(z.number().int()).optional().default({}),
    is_admin: z.record(z.number().int()).optional().default({}),
    registered: z.record(z.number().int()).optional().default({}),
    preregistered: z.record(z.number().int()).optional().default({}),
    user_type: z.record(z.number().int()).optional().default({})
});

/**
 * UsersBulkDeletePayload
 *
 * At most 500 per call, so one call is one checked batch.
 */
export const zUsersBulkDeletePayload = z.object({
    user_uuids: z.array(z.string().uuid()).min(1).max(500)
});

/**
 * UsersBulkDeleteResponse
 */
export const zUsersBulkDeleteResponse = z.object({
    results: z.array(zUserBulkDeleteResult),
    deleted_count: z.number().int(),
    not_found_count: z.number().int(),
    error_count: z.number().int()
});

/**
 * UsersFilters
 */
export const zUsersFilters = z.object({
    role: z.array(zRole).nullish(),
    company_id: z.array(z.number().int()).nullish(),
    company_type: z.array(zOrgType).nullish(),
    team_id: z.array(z.number().int()).nullish(),
    company_payment_status: z.array(zPaymentStatus).nullish(),
    active: z.boolean().nullish(),
    is_admin: z.boolean().nullish(),
    registered: z.boolean().nullish(),
    preregistered: z.boolean().nullish(),
    user_type: z.array(zUserType).nullish(),
    wants_intros: z.boolean().nullish()
});

/**
 * UsersPostPage[UserDetailedResponse]
 */
export const zUsersPostPageUserDetailedResponse = z.object({
    page_count: z.number().int().gte(0),
    page: z.number().int().gte(1),
    search_id: z.string().nullish(),
    results: z.array(zUserDetailedResponse),
    size: z.number().int().gte(1),
    total_counts: zTotalCounts,
    aggregations: zUsersAggregationsResponse.nullish()
});

/**
 * UsersSortColumn
 */
export const zUsersSortColumn = z.enum([
    'email',
    'first_name',
    'last_name',
    'full_name',
    'created',
    'last_login',
    'teams_count',
    'active',
    'company_name',
    'company_type',
    'user_type'
]);

/**
 * UsersSort
 */
export const zUsersSort = z.object({
    column: zUsersSortColumn,
    direction: zSortDirection.optional().default('desc')
});

/**
 * UsersSearchFilterSortPayload
 */
export const zUsersSearchFilterSortPayload = z.object({
    phrase: z.string().nullish(),
    search_id: z.string().nullish(),
    page: z.number().int().gte(1).optional().default(1),
    page_size: z.number().int().gte(1).lte(1000).optional().default(-1),
    filter_data: zUsersFilters.nullish(),
    sort_rules: z.array(zUsersSort).optional().default([]),
    include_aggregations: z.boolean().optional().default(false)
});

/**
 * ValidationError
 */
export const zValidationError = z.object({
    loc: z.array(z.union([z.string(), z.number().int()])),
    msg: z.string(),
    type: z.string(),
    input: z.unknown().optional(),
    ctx: z.record(z.unknown()).optional()
});

/**
 * HTTPValidationError
 */
export const zHttpValidationError = z.object({
    detail: z.array(zValidationError).optional()
});

/**
 * ValuationRange
 */
export const zValuationRange = z.enum([
    '<$1M',
    '$1M-$10M',
    '$10M-$100M',
    '$100M-$1B',
    '>$1B'
]);

/**
 * CustomerCompany
 *
 * Attributes
 * ----------
 * slug : str
 * used as the unique identifier for any company
 * team_count : int
 * number of associated teams, default is -1
 * user_count : int
 * number of associated persons, default is -1
 */
export const zCustomerCompany = z.object({
    alias: z.string().nullish(),
    assets_managed: zAssetsManagedRange.nullish(),
    budget: zAnnualBudgetRange.nullish(),
    company_type: zCompanyOwnership.nullish(),
    domain: z.string().nullish(),
    employees: zFteRange.nullish(),
    funding_round: zFundingRound.nullish(),
    hq_location: zLocationAddress.nullish(),
    industry_keywords: z.string().nullish(),
    industry: zIcbIndustry.nullish(),
    market_cap: zMarketCapRange.nullish(),
    morningstar_industry: z.string().nullish(),
    name: z.string(),
    payment_status: zPaymentStatus.optional().default('free'),
    revenue: zRevenueRange.nullish(),
    sector: zCompanySector.nullish(),
    stage: zCompanyStage.nullish(),
    stock_symbol: z.string().nullish(),
    type: zOrgType,
    valuation: zValuationRange.nullish(),
    id: z.number().int(),
    slug: z.string(),
    team_count: z.number().int().optional().default(-1),
    user_count: z.number().int().optional().default(-1)
});

/**
 * PersonRole
 */
export const zPersonRole = z.object({
    company: zCustomerCompany.nullish(),
    team_slug: z.string().nullish(),
    team_active: z.boolean().nullish(),
    title: zRole
});

/**
 * PersonV1CurrentResponse
 *
 * GET ``/api/v1/people/current`` — legacy person payload with a signed profile image URL.
 */
export const zPersonV1CurrentResponse = z.object({
    country: z.string().nullish(),
    email: z.string().email(),
    first_login: z.string().datetime().nullish(),
    first_name: z.string().nullish(),
    has_set_password: z.boolean().optional().default(true),
    id: z.string().uuid().nullish(),
    last_login: z.string().datetime().nullish(),
    last_name: z.string().nullish(),
    last_team_visit_slug: z.string().nullish(),
    name: z.string().nullish(),
    newly_invited: z.boolean().optional().default(false),
    notes_external: z.string().nullish(),
    linkedin_url: z.string().nullish(),
    person_image: z.string().nullish(),
    person_name: z.string().nullish(),
    is_executive: z.boolean().optional().default(false),
    roles: z.array(zPersonRole).optional(),
    uuid: z.string().uuid(),
    profile_image_url: z.string().nullable()
});

/**
 * VerificationResponse
 */
export const zVerificationResponse = z.object({
    detail: z.string()
});

/**
 * ElasticsearchAggregationsResponse
 */
export const zAppSchemasEsCandidateSchemaElasticsearchAggregationsResponse = z.object({
    connection_status: z.record(z.number().int()).nullish(),
    function_expertise: z.record(z.number().int()).nullish(),
    industry_expertise: z.record(z.number().int()).nullish(),
    interest_role_board_advisory: z.record(z.number().int()).nullish(),
    interest_role_operating: z.record(z.number().int()).nullish(),
    operating_highlights: z.record(z.number().int()).nullish(),
    source_company_tags: z.record(z.number().int()).nullish(),
    custom_keywords: z.record(z.number().int()).nullish()
});

/**
 * TeamCandidatesFilterResponse
 */
export const zTeamCandidatesFilterResponse = z.object({
    aggregations: zAppSchemasEsCandidateSchemaElasticsearchAggregationsResponse,
    page_count: z.number().int(),
    page: z.number().int(),
    results: z.array(zEsCandidateIndexResult),
    search_id: z.string().nullish(),
    size: z.number().int(),
    total_counts: zTotalCountsResponse
});

/**
 * ElasticsearchAggregationsResponse
 */
export const zAppSchemasEsRecommendationCandidateSchemaElasticsearchAggregationsResponse = z.object({
    company_id: z.record(z.number().int()),
    company_type: z.record(z.number().int()),
    review_status: z.record(z.number().int()),
    role_type: z.record(z.number().int()),
    type: z.record(z.number().int())
});

/**
 * CandidateRecommendationsFilterResponse
 */
export const zCandidateRecommendationsFilterResponse = z.object({
    aggregations: zAppSchemasEsRecommendationCandidateSchemaElasticsearchAggregationsResponse,
    page_count: z.number().int(),
    page: z.number().int(),
    results: z.array(zEsRecommendationCandidateIndexResult),
    search_id: z.string().nullish(),
    size: z.number().int(),
    total_counts: zTotalCountsResponse
});

/**
 * CandidateBasicResponse
 */
export const zCandidateBasicResponseWritable = z.object({
    image: z.string().nullish(),
    name: z.string(),
    uuid: z.string().uuid()
});

/**
 * AdminUserDetailedResponse
 *
 * Admin-only detailed user response including invitation history.
 */
export const zAdminUserDetailedResponseWritable = z.object({
    id: z.string().uuid(),
    uuid: z.string().uuid(),
    email: z.string().email(),
    first_name: z.string().nullish(),
    last_name: z.string().nullish(),
    full_name: z.string().nullish(),
    company: zCompanyExtendedResponse.nullish(),
    created: z.string().datetime(),
    first_login: z.string().datetime().nullish(),
    last_login: z.string().datetime().nullish(),
    active: z.boolean(),
    pending: z.boolean(),
    permit_preregistration_notifications: z.boolean(),
    notes_external: z.string().nullish(),
    notes_internal: z.string().nullish(),
    linkedin_url: z.string().nullish(),
    wants_intros: z.boolean().nullish(),
    wants_intro_followups: z.boolean().nullish(),
    handle_intros_as_exec: z.boolean().nullish(),
    teams_count: z.number().int(),
    teams: z.array(zUserTeamBasicResponse).optional().default([]),
    roles: z.array(zUserRoleResponse).optional().default([]),
    identity_uuid: z.string().uuid().nullish(),
    candidate_uuid: z.string().uuid().nullish(),
    candidate: zCandidateBasicResponseWritable.nullish(),
    user_type: zUserType,
    search_metadata: zEsMeta.nullish(),
    invitations: z.array(zUserInvitationResponse).optional().default([]),
    undo_executive_activation_blocker: zUndoExecutiveActivationBlocker.nullish()
});

/**
 * AllIntrosResponse
 */
export const zAllIntrosResponseWritable = z.object({
    uuid: z.string().uuid(),
    intro_type: zIntroTypeEnum,
    time: z.string().datetime(),
    candidate: zCandidateBasicResponseWritable,
    candidate_to: zCandidateBasicResponseWritable.nullish(),
    team: zTeamBasicUuidResponse.nullish()
});

/**
 * CandidateCompanyRoleResponse
 */
export const zCandidateCompanyRoleResponseWritable = z.object({
    is_client: z.boolean(),
    company: z.string().nullish(),
    role: z.string().nullish(),
    image: z.string().nullish(),
    name: z.string(),
    uuid: z.string().uuid(),
    tier: zCandidateTier
});

/**
 * CandidateExtendedResponse
 */
export const zCandidateExtendedResponseWritable = z.object({
    is_client: z.boolean(),
    company: z.string().nullish(),
    role: z.string().nullish(),
    image: z.string().nullish(),
    name: z.string(),
    uuid: z.string().uuid(),
    first_name: z.string().nullish(),
    function_expertise: z.array(zFunction),
    function_target: z.array(zFunction),
    industry_expertise: z.array(zIndustry),
    industry_target: z.array(zIndustry),
    interest_role_board_advisory: zInterestRole.nullish(),
    interest_role_operating: zInterestRole.nullish(),
    interests_personal: z.array(zInterestPersonal),
    interests_professional: z.array(zInterestProfessional),
    keywords: z.array(z.string()),
    last_name: z.string().nullish(),
    linkedin_url: z.string().nullish(),
    tier: zCandidateTier,
    type: zClientType.nullish(),
    pathway: zCandidatePathway.nullish()
});

/**
 * CandidateFeedbackPersonResponse
 *
 * The commenter as displayed, filled from the from-identity: the candidate's
 * name when the identity has a candidate, else the earliest login's. ``uuid``
 * and ``email`` are null for a candidate without a login.
 */
export const zCandidateFeedbackPersonResponseWritable = z.object({
    email: z.string().email().nullish(),
    name: z.string(),
    first_name: z.string().nullish(),
    last_name: z.string().nullish(),
    image: z.string().nullish(),
    uuid: z.string().uuid().nullish(),
    company: zCompanyBasicTypeResponse.nullish()
});

/**
 * CandidateTaskModule
 */
export const zCandidateTaskModuleWritable = z.object({
    created: z.string().datetime(),
    id: z.string().uuid(),
    type: zTaskModuleType,
    status: zTaskModuleStatus
});

/**
 * ExecutiveClientEventAttendee
 *
 * A fellow attendee shown to an executive client on their event view.
 *
 * Only attendees the exec already knows (in their People collection) are
 * listed for upcoming events; everyone who attended is listed for past
 * events. PII beyond name/role/company is intentionally omitted — use the
 * People page for full contact detail.
 */
export const zExecutiveClientEventAttendeeWritable = z.object({
    identity_uuid: z.string().uuid().nullish(),
    person_uuid: z.string().uuid().nullish(),
    candidate_uuid: z.string().uuid().nullish(),
    full_name: z.string().nullish(),
    current_role: z.string().nullish(),
    current_company: z.string().nullish(),
    profile_img: z.string().nullish()
});

/**
 * ExecutiveClientEventResponse
 *
 * Event detail for an external executive client who is a guest.
 *
 * Attendee visibility:
 * - Webinars never show attendees (``shows_attendees=False``).
 * - Upcoming events list only RSVP'd (going) attendees the exec already
 * knows (i.e. in their People collection independent of this event), plus
 * a count of the remaining RSVP'd attendees in ``other_attendees_count``.
 * - Past events list everyone who attended (all become contacts), and
 * ``other_attendees_count`` is 0.
 */
export const zExecutiveClientEventResponseWritable = z.object({
    event: zEventRsvpPublicResponse,
    my_status: zEventGuestStatus,
    is_past: z.boolean(),
    shows_attendees: z.boolean(),
    attendees: z.array(zExecutiveClientEventAttendeeWritable).optional(),
    other_attendees_count: z.number().int().gte(0).optional().default(0)
});

/**
 * ExecutivePeopleDetailResponse
 *
 * Person-only contact detail for the executive client people page.
 */
export const zExecutivePeopleDetailResponseWritable = z.object({
    person_uuid: z.string().uuid(),
    identity_uuid: z.string().uuid().nullish(),
    full_name: z.string().nullish(),
    first_name: z.string().nullish(),
    last_name: z.string().nullish(),
    email: z.string().nullish(),
    profile_img: z.string().nullish(),
    notes_external: z.string().nullish(),
    linkedin_url: z.string().nullish(),
    current_role: z.string().nullish(),
    current_company: z.string().nullish(),
    company: zCompanyBasicTypeResponse.nullish(),
    source_types: z.array(zContactSourceType).optional(),
    evidence: zContactEvidenceResponse.nullish(),
    personal_tags: z.array(zPersonalContactTagItem).optional(),
    is_favorite: z.boolean().optional().default(false),
    was_introduced: z.boolean().optional().default(false)
});

/**
 * ExecutivePeopleResultItem
 *
 * A single contact in the exec's people page.
 *
 * Canonical typed contact item for the people page.
 */
export const zExecutivePeopleResultItemWritable = z.object({
    object_type: z.enum(['candidate', 'person']),
    contact_key: z.string(),
    candidate_uuid: z.string().nullish(),
    person_uuid: z.string().nullish(),
    full_name: z.string().nullish(),
    email: z.string().nullish(),
    current_company: z.string().nullish(),
    current_role: z.string().nullish(),
    profile_img: z.string().nullish(),
    source_types: z.array(zContactSourceType).optional(),
    evidence: zContactEvidenceResponse.nullish(),
    personal_tags: z.array(zPersonalContactTagItem).optional(),
    is_favorite: z.boolean().optional().default(false),
    was_introduced: z.boolean().optional().default(false)
});

/**
 * ExecutivePeopleSearchResponse
 */
export const zExecutivePeopleSearchResponseWritable = z.object({
    page_count: z.number().int(),
    page: z.number().int(),
    results: z.array(zExecutivePeopleResultItemWritable),
    size: z.number().int(),
    total_counts: zTotalCountsResponse,
    aggregations: zExecutivePeopleAggregationsResponse.optional(),
    search_id: z.string().nullish()
});

/**
 * HomeTeamActivityRecommendedPerson
 *
 * One recommended candidate in a pipeline's activity row.
 *
 * Name and image come from the candidate's own record, so every recommended
 * candidate appears — the counts next to these avatars include the ones with
 * no login. ``uuid`` is a login's uuid, so it is the candidate's activated
 * executive and is absent when they have none; it is never another member of
 * the identity.
 */
export const zHomeTeamActivityRecommendedPersonWritable = z.object({
    name: z.string(),
    first_name: z.string().nullish(),
    last_name: z.string().nullish(),
    image: z.string().nullish(),
    uuid: z.string().uuid().nullish()
});

/**
 * HomeTeamActivityPipelineResponse
 */
export const zHomeTeamActivityPipelineResponseWritable = z.object({
    introductions_pending: z.number().int(),
    pipeline: zPipelineExternalResponse,
    recommendations_count: z.number().int(),
    recommendations_unread: z.number().int(),
    recommendations: z.array(zHomeTeamActivityRecommendedPersonWritable),
    team: zTeamBasicUuidResponse
});

/**
 * IdentityPersonItem
 */
export const zIdentityPersonItemWritable = z.object({
    uuid: z.string().uuid(),
    email: z.string(),
    first_name: z.string().nullish(),
    last_name: z.string().nullish(),
    name: z.string().nullish(),
    is_activated_executive: z.boolean(),
    registered: z.boolean(),
    user: zAdminUserDetailedResponseWritable
});

/**
 * IdentityResponse
 */
export const zIdentityResponseWritable = z.object({
    identity_uuid: z.string().uuid(),
    candidate: zIdentityCandidateItem.nullish(),
    executive_person_uuid: z.string().uuid().nullish(),
    persons: z.array(zIdentityPersonItemWritable),
    merged_into_uuid: z.string().uuid().nullish()
});

/**
 * Page[AllIntrosResponse]
 */
export const zPageAllIntrosResponseWritable = z.object({
    page_count: z.number().int().gte(0),
    page: z.number().int().gte(1),
    search_id: z.string().nullish(),
    results: z.array(zAllIntrosResponseWritable),
    size: z.number().int().gte(1),
    total_counts: zTotalCounts
});

/**
 * Page[CandidateExtendedResponse]
 */
export const zPageCandidateExtendedResponseWritable = z.object({
    page_count: z.number().int().gte(0),
    page: z.number().int().gte(1),
    search_id: z.string().nullish(),
    results: z.array(zCandidateExtendedResponseWritable),
    size: z.number().int().gte(1),
    total_counts: zTotalCounts
});

/**
 * PeerCompareAboutResponse
 */
export const zPeerCompareAboutResponseWritable = z.object({
    candidate: zCandidateBasicResponseWritable,
    introduction_templates: z.array(zCandidateIntroductionTemplateResponse)
});

/**
 * PeerCompareGoalsResponse
 */
export const zPeerCompareGoalsResponseWritable = z.object({
    candidate: zCandidateBasicResponseWritable,
    goals: z.array(zPeerCompareGoalResponse)
});

/**
 * PersonBasicEmailResponse
 */
export const zPersonBasicEmailResponseWritable = z.object({
    email: z.string().email(),
    name: z.string(),
    first_name: z.string().nullish(),
    last_name: z.string().nullish(),
    image: z.string().nullish(),
    uuid: z.string().uuid()
});

/**
 * CandidateFeedbackResult
 */
export const zCandidateFeedbackResultWritable = z.object({
    advisor: zPersonBasicEmailResponseWritable.nullish(),
    candidate: zCandidateBasicResponseWritable.optional(),
    comment: z.string(),
    company: zCompanyBasicTypeResponse.nullish(),
    published_on: z.string().datetime(),
    person: zCandidateFeedbackPersonResponseWritable.nullish(),
    pipeline: zPipelineBasicResponse.nullish(),
    team: zTeamBasicUuidResponse.nullish(),
    source: zFeedbackSource.default('feedback'),
    recommendation: zEsRecommendationCandidateIndexResult.nullish(),
    type: zFeedbackType.default('external'),
    uuid: z.string().uuid(),
    from_identity_uuid: z.string().uuid().nullish(),
    from_candidate_uuid: z.string().uuid().nullish(),
    subject_identity_uuid: z.string().uuid().nullish()
});

/**
 * CandidateFeedbackFilterResponse
 */
export const zCandidateFeedbackFilterResponseWritable = z.object({
    page_count: z.number().int(),
    page: z.number().int(),
    results: z.array(zCandidateFeedbackResultWritable),
    search_id: z.string().nullish(),
    size: z.number().int(),
    total_counts: zTotalCountsResponse
});

/**
 * CandidateGoalTask
 */
export const zCandidateGoalTaskWritable = z.object({
    assignee: zPersonBasicEmailResponseWritable,
    created: z.string().datetime(),
    creator: zPersonBasicEmailResponseWritable,
    completion_date: z.string().datetime().nullish(),
    description: z.string().nullish(),
    due_date: z.string().datetime().nullish(),
    id: z.string().uuid(),
    is_completed: z.boolean(),
    last_modified: z.string().datetime(),
    title: z.string()
});

/**
 * CandidateSearchResponse
 */
export const zCandidateSearchResponseWritable = z.object({
    company: z.string().nullish(),
    role: z.string().nullish(),
    advisor: zPersonBasicEmailResponseWritable.nullish(),
    email: z.string(),
    first_name: z.string().nullish(),
    function_expertise: z.array(zFunction),
    function_target: z.array(zFunction),
    id: z.number().int(),
    image: z.string().nullish(),
    industry_expertise: z.array(zIndustry),
    industry_target: z.array(zIndustry),
    interest_role_board_advisory: zInterestRole.nullish(),
    interest_role_operating: zInterestRole.nullish(),
    interests_personal: z.array(zInterestPersonal),
    interests_professional: z.array(zInterestProfessional),
    is_client: z.boolean(),
    intro_email_type: zIntroEmailType,
    keywords: z.array(z.string()),
    last_name: z.string().nullish(),
    linkedin_url: z.string().nullish(),
    location: z.string().nullish(),
    name: z.string().nullish(),
    tier: zCandidateTier,
    type: zClientType.nullish(),
    pathway: zCandidatePathway.nullish(),
    uuid: z.string().uuid()
});

/**
 * CandidateSearchResponseWithLinkedPerson
 */
export const zCandidateSearchResponseWithLinkedPersonWritable = z.object({
    company: z.string().nullish(),
    role: z.string().nullish(),
    advisor: zPersonBasicEmailResponseWritable.nullish(),
    email: z.string(),
    first_name: z.string().nullish(),
    function_expertise: z.array(zFunction),
    function_target: z.array(zFunction),
    id: z.number().int(),
    image: z.string().nullish(),
    industry_expertise: z.array(zIndustry),
    industry_target: z.array(zIndustry),
    interest_role_board_advisory: zInterestRole.nullish(),
    interest_role_operating: zInterestRole.nullish(),
    interests_personal: z.array(zInterestPersonal),
    interests_professional: z.array(zInterestProfessional),
    is_client: z.boolean(),
    intro_email_type: zIntroEmailType,
    keywords: z.array(z.string()),
    last_name: z.string().nullish(),
    linkedin_url: z.string().nullish(),
    location: z.string().nullish(),
    name: z.string().nullish(),
    tier: zCandidateTier,
    type: zClientType.nullish(),
    pathway: zCandidatePathway.nullish(),
    uuid: z.string().uuid(),
    person: zCandidateLinkedPersonResponse.nullish()
});

/**
 * Page[CandidateSearchResponseWithLinkedPerson]
 */
export const zPageCandidateSearchResponseWithLinkedPersonWritable = z.object({
    page_count: z.number().int().gte(0),
    page: z.number().int().gte(1),
    search_id: z.string().nullish(),
    results: z.array(zCandidateSearchResponseWithLinkedPersonWritable),
    size: z.number().int().gte(1),
    total_counts: zTotalCounts
});

/**
 * Page[PersonBasicEmailResponse]
 */
export const zPagePersonBasicEmailResponseWritable = z.object({
    page_count: z.number().int().gte(0),
    page: z.number().int().gte(1),
    search_id: z.string().nullish(),
    results: z.array(zPersonBasicEmailResponseWritable),
    size: z.number().int().gte(1),
    total_counts: zTotalCounts
});

/**
 * PersonBasicResponse
 */
export const zPersonBasicResponseWritable = z.object({
    name: z.string(),
    first_name: z.string().nullish(),
    last_name: z.string().nullish(),
    image: z.string().nullish(),
    uuid: z.string().uuid()
});

/**
 * ActivityEventResponse
 */
export const zActivityEventResponseWritable = z.object({
    action: zEvaluationAction,
    advisor: zPersonBasicResponseWritable.nullish(),
    candidate: zUuidResponse,
    created: z.string().datetime(),
    id: z.number().int(),
    last_modified: z.string().datetime(),
    person: zPersonBasicResponseWritable.nullish(),
    pipeline: zUuidResponse.nullish(),
    recommendation: zUuidResponse.nullish(),
    team: zUuidResponse
});

/**
 * ActivityFeedItem
 *
 * A single row in the unified exec activity feed.
 *
 * Mixes `CandidateActivityLog` rows (kind="activity_log") with synthetic
 * connection-source rows derived from Event / Peer / SubmissionCandidate /
 * Referrer joins. Activity-log items carry the rich fields (actor,
 * candidate, message, event_type); connection-source items carry
 * structured ``contact`` / ``company`` / ``event_ref`` refs.
 *
 * Message composition is the webapp's responsibility — backend exposes
 * only the components (ids, names, slugs) and the webapp builds the
 * localized string with linkable participants from i18n keys.
 */
export const zActivityFeedItemWritable = z.object({
    kind: z.enum([
        'activity_log',
        'event',
        'peer',
        'pipeline',
        'trending',
        'global_intro',
        'referral',
        'comment'
    ]),
    uuid: z.string().uuid(),
    date: z.string().datetime(),
    event_type: z.string().nullish(),
    actor: zPersonBasicResponseWritable.nullish(),
    candidate: zCandidateBasicResponseWritable.nullish(),
    message: zActivityLogMessage.nullish(),
    reference_type: z.string().nullish(),
    reference_id: z.string().uuid().nullish(),
    contact: zActivityFeedParticipant.nullish(),
    company: zActivityFeedCompanyRef.nullish(),
    event_ref: zActivityFeedEventRef.nullish(),
    referrer: zActivityFeedParticipant.nullish(),
    referred: zActivityFeedParticipant.nullish(),
    content: z.string().nullish()
});

/**
 * CandidateActivityEvent
 */
export const zCandidateActivityEventWritable = z.object({
    comment_uuid: z.string().uuid().nullish(),
    context: z.string().nullish(),
    external_introduction_request_person: zExternalPerson.nullish(),
    date: z.string().datetime(),
    event_type: zCandidateActivityEventType,
    pipeline: zPipelineBasicV2Response.nullish(),
    recommendation_uuid: z.string().uuid().nullish(),
    user: zPersonBasicResponseWritable,
    uuid: z.string().uuid(),
    team_uuid: z.string().uuid().nullish()
});

/**
 * CandidateActivityLogGroupMember
 */
export const zCandidateActivityLogGroupMemberWritable = z.object({
    actor: zPersonBasicResponseWritable.nullish(),
    date: z.string().datetime(),
    event_type: z.union([
        zCandidateActivityLogEventType,
        zCandidateActivityLogEventTypeHidden
    ]),
    uuid: z.string().uuid(),
    message: zActivityLogMessage,
    reference_id: z.string().uuid().nullish(),
    reference_type: zCandidateActivityLogReferenceType.nullish(),
    latest_recommendation: zCandidateActivityLatestRecommendation.nullish()
});

/**
 * CandidateActivityLogReferenceGroups
 */
export const zCandidateActivityLogReferenceGroupsWritable = z.object({
    global: z.array(zCandidateActivityLogGroupMemberWritable).nullish(),
    peer: z.array(zCandidateActivityLogGroupMemberWritable).nullish(),
    pipeline: z.array(zCandidateActivityLogGroupMemberWritable).nullish(),
    trending: z.array(zCandidateActivityLogGroupMemberWritable).nullish()
});

/**
 * CandidateActivityLogResponse
 */
export const zCandidateActivityLogResponseWritable = z.object({
    actor: zPersonBasicResponseWritable.nullish(),
    candidate: zCandidateBasicResponseWritable,
    date: z.string().datetime(),
    event_type: zCandidateActivityLogEventType,
    uuid: z.string().uuid(),
    message: zActivityLogMessage,
    reference_id: z.string().uuid().nullish(),
    reference_type: zCandidateActivityLogReferenceType.nullish(),
    recommendation_uuid: z.string().uuid().nullish()
});

/**
 * CandidateActivityLogResponseWithHidden
 */
export const zCandidateActivityLogResponseWithHiddenWritable = z.object({
    actor: zPersonBasicResponseWritable.nullish(),
    candidate: zCandidateBasicResponseWritable,
    date: z.string().datetime(),
    event_type: z.union([
        zCandidateActivityLogEventType,
        zCandidateActivityLogEventTypeHidden
    ]),
    uuid: z.string().uuid(),
    message: zActivityLogMessage,
    reference_id: z.string().uuid().nullish(),
    reference_type: zCandidateActivityLogReferenceType.nullish(),
    recommendation_uuid: z.string().uuid().nullish(),
    latest_recommendation: zCandidateActivityLatestRecommendation.nullish()
});

/**
 * CandidateCompanyRoleWithAdvisorResponse
 */
export const zCandidateCompanyRoleWithAdvisorResponseWritable = z.object({
    company: z.string().nullish(),
    role: z.string().nullish(),
    image: z.string().nullish(),
    name: z.string(),
    uuid: z.string().uuid(),
    advisor: zPersonBasicResponseWritable.nullish(),
    first_name: z.string().nullish(),
    is_client: z.boolean(),
    last_name: z.string().nullish(),
    linkedin_url: z.string().nullish()
});

/**
 * CandidateExternalFullResponseWithTeamContext
 *
 * Candidate response with team-specific context fields.
 *
 * This extends CandidateExternalFullResponse with fields that are only
 * meaningful in the context of a specific team. Use this schema for
 * endpoints that return a candidate in a team context.
 */
export const zCandidateExternalFullResponseWithTeamContextWritable = z.object({
    __linkedin_profile_last_synced__DO_NOT_USE__: z.string().datetime().nullish(),
    __manual_last_update__DO_NOT_USE__: z.string().datetime().nullish(),
    profile_updated_date: z.string().datetime().nullish(),
    __resume_last_uploaded__DO_NOT_USE__: z.string().datetime().nullish(),
    company: z.string().nullish(),
    role: z.string().nullish(),
    image: z.string().nullish(),
    is_client: z.boolean(),
    linkedin_url: z.string().nullish(),
    name: z.string(),
    uuid: z.string().uuid(),
    formatted_role: z.string().nullish(),
    location: z.string().nullish(),
    resume: zLinkedInResumeResponse.nullish(),
    identity_uuid: z.string().uuid().nullish(),
    interest_role_board_advisory: zInterestRole.nullish(),
    interest_role_operating: zInterestRole.nullish(),
    function_expertise: z.array(zFunction),
    industry_expertise: z.array(zIndustry),
    operating_highlights: z.array(zOperatingHighlights),
    source_company_tags: z.array(zSourceCompanyTags).nullish(),
    interests_personal: z.array(zInterestPersonal),
    interests_professional: z.array(zInterestProfessional),
    interests_notes: z.string().nullish(),
    wants_intros: z.boolean().nullish(),
    interest_relocation: z.boolean().nullish(),
    interest_relocation_notes: z.string().nullish(),
    email: z.string().nullish(),
    team_uuid: z.string().uuid(),
    global_introduction_status: zIntroductionStatus.nullish(),
    global_introduction_request_person: zPersonBasicResponseWritable.nullish(),
    pipelines_count: z.number().int().optional().default(0),
    date_recommended_last: z.string().datetime().nullish(),
    date_introduction_facilitated_last: z.string().datetime().nullish(),
    is_favorite: z.boolean().optional().default(false),
    company_metadata: z.array(zCandidateCompanyMetadataResponse).optional(),
    personal_tags: z.array(zPersonalContactTagItem).optional()
});

/**
 * CandidateGoal
 */
export const zCandidateGoalWritable = z.object({
    activities: z.array(zCandidateActivityLogResponseWithHiddenWritable).nullish(),
    completion_date: z.string().datetime().nullish(),
    created: z.string().datetime(),
    due_date: z.string().datetime().nullish(),
    id: z.string().uuid(),
    intro_stats: z.array(zIntroStats).nullish(),
    priority: zGoalPriority.nullish(),
    program: zCandidateType,
    notes: z.array(zCandidateGoalNotes).nullish(),
    latest_note: z.string().nullable(),
    status: zGoalStatus,
    tasks: z.array(zCandidateGoalTaskWritable).nullish(),
    title: z.string(),
    last_modified: z.string().datetime()
});

/**
 * CandidateGoalsResponse
 */
export const zCandidateGoalsResponseWritable = z.object({
    candidate_uuid: z.string().uuid(),
    goals: z.array(zCandidateGoalWritable)
});

/**
 * CandidateInternalFullResponse
 */
export const zCandidateInternalFullResponseWritable = z.object({
    first_name: z.string().min(1).nullish(),
    last_name: z.string().min(1).nullish(),
    company: z.string().nullish(),
    role: z.string().nullish(),
    image: z.string().nullish(),
    is_client: z.boolean(),
    linkedin_url: z.string().nullish(),
    name: z.string(),
    uuid: z.string().uuid(),
    active: z.boolean(),
    merged_into_uuid: z.string().uuid().nullish(),
    advisor: zPersonBasicResponseWritable.nullish(),
    client_owner: zPersonBasicResponseWritable.nullish(),
    is_urg: z.boolean().nullish(),
    email: z.string(),
    function_expertise: z.array(zFunction),
    function_target: z.array(zFunction),
    long_term_goals: z.array(z.string()),
    id: z.number().int(),
    person_id: z.string().uuid().nullish(),
    identity_uuid: z.string().uuid().nullish(),
    industry_expertise: z.array(zIndustry),
    industry_target: z.array(zIndustry),
    interest_role_board_advisory: zInterestRole.nullish(),
    interest_role_operating: zInterestRole.nullish(),
    interests_personal: z.array(zInterestPersonal),
    interests_professional: z.array(zInterestProfessional),
    interests_notes: z.string().nullish(),
    invoice_status: zHubSpotInvoiceStatus.nullish(),
    hubspot_id: z.string().nullish(),
    wants_intros: z.boolean().nullish(),
    interest_relocation: z.boolean().nullish(),
    interest_relocation_notes: z.string().nullish(),
    intro_email_type: zIntroEmailType,
    is_accepting_intros: z.boolean(),
    keywords: z.array(z.string()),
    kickoff_date: z.string().datetime().nullish(),
    location: z.string().nullish(),
    manual_last_update: z.string().datetime().nullish(),
    manual_update_person_id: z.string().uuid().nullish(),
    network_target: z.string().nullish(),
    not_accepting_start_date: z.string().datetime().nullish(),
    not_accepting_end_date: z.string().datetime().nullish(),
    notes: z.string().nullish(),
    operating_highlights: z.array(zOperatingHighlights),
    passions: z.string().nullish(),
    referrers: z.array(zReferrerBasicResponse),
    resume: zLinkedInResumeResponse.nullish(),
    profile_updated_date: z.string().datetime().nullish(),
    resume_last_uploaded: z.string().datetime().nullish(),
    short_term_goals: z.array(z.string()),
    source_company_tags: z.array(zSourceCompanyTags).nullish(),
    tier: zCandidateTier,
    type: zClientType.nullish(),
    pathway: zCandidatePathway.nullish()
});

/**
 * CandidateInternalFullResponseWithLinkedPerson
 */
export const zCandidateInternalFullResponseWithLinkedPersonWritable = z.object({
    first_name: z.string().min(1).nullish(),
    last_name: z.string().min(1).nullish(),
    company: z.string().nullish(),
    role: z.string().nullish(),
    image: z.string().nullish(),
    is_client: z.boolean(),
    linkedin_url: z.string().nullish(),
    name: z.string(),
    uuid: z.string().uuid(),
    active: z.boolean(),
    merged_into_uuid: z.string().uuid().nullish(),
    advisor: zPersonBasicResponseWritable.nullish(),
    client_owner: zPersonBasicResponseWritable.nullish(),
    is_urg: z.boolean().nullish(),
    email: z.string(),
    function_expertise: z.array(zFunction),
    function_target: z.array(zFunction),
    long_term_goals: z.array(z.string()),
    id: z.number().int(),
    person_id: z.string().uuid().nullish(),
    identity_uuid: z.string().uuid().nullish(),
    industry_expertise: z.array(zIndustry),
    industry_target: z.array(zIndustry),
    interest_role_board_advisory: zInterestRole.nullish(),
    interest_role_operating: zInterestRole.nullish(),
    interests_personal: z.array(zInterestPersonal),
    interests_professional: z.array(zInterestProfessional),
    interests_notes: z.string().nullish(),
    invoice_status: zHubSpotInvoiceStatus.nullish(),
    hubspot_id: z.string().nullish(),
    wants_intros: z.boolean().nullish(),
    interest_relocation: z.boolean().nullish(),
    interest_relocation_notes: z.string().nullish(),
    intro_email_type: zIntroEmailType,
    is_accepting_intros: z.boolean(),
    keywords: z.array(z.string()),
    kickoff_date: z.string().datetime().nullish(),
    location: z.string().nullish(),
    manual_last_update: z.string().datetime().nullish(),
    manual_update_person_id: z.string().uuid().nullish(),
    network_target: z.string().nullish(),
    not_accepting_start_date: z.string().datetime().nullish(),
    not_accepting_end_date: z.string().datetime().nullish(),
    notes: z.string().nullish(),
    operating_highlights: z.array(zOperatingHighlights),
    passions: z.string().nullish(),
    referrers: z.array(zReferrerBasicResponse),
    resume: zLinkedInResumeResponse.nullish(),
    profile_updated_date: z.string().datetime().nullish(),
    resume_last_uploaded: z.string().datetime().nullish(),
    short_term_goals: z.array(z.string()),
    source_company_tags: z.array(zSourceCompanyTags).nullish(),
    tier: zCandidateTier,
    type: zClientType.nullish(),
    pathway: zCandidatePathway.nullish(),
    person: zCandidateLinkedPersonResponse.nullish(),
    company_metadata: z.array(zCandidateCompanyMetadataResponse).optional()
});

/**
 * CandidateItem
 */
export const zCandidateItemWritable = z.object({
    search_metadata: zEsMeta.nullish(),
    is_favorite: z.boolean(),
    activity_count: z.number().int(),
    activity_last_on: z.string().datetime().nullish(),
    activity_last_viewed_on: z.string().datetime().nullish(),
    candidate: zCandidateExtendedResponseWritable,
    expires_on: z.string().datetime().nullish(),
    is_viewed: z.boolean(),
    published_on: z.string().datetime(),
    status: zRecommendationReviewState,
    uuid: z.string().uuid(),
    draft_mode: zRecommendationDraftMode.nullish(),
    draft_assignee: zPersonBasicResponseWritable.nullish()
});

/**
 * CandidatePerformanceResponse
 */
export const zCandidatePerformanceResponseWritable = z.object({
    candidate: zCandidateCompanyRoleResponseWritable,
    advisor: zPersonBasicResponseWritable,
    introductions_requested_count: z.number().int(),
    recommendation_count: z.number().int(),
    pipeline_count: z.number().int(),
    days_to_quarterly: z.number().int()
});

/**
 * CandidateRecommendationResponse
 */
export const zCandidateRecommendationResponseWritable = z.object({
    search_metadata: zEsMeta.nullish(),
    person: zPersonBasicEmailResponseWritable.nullish(),
    type: zIntroductionType,
    about: z.string().nullish(),
    advisor: zPersonBasicEmailResponseWritable.nullish(),
    already_known: z.boolean().nullish(),
    candidate: zCandidateExtendedResponseWritable,
    comment_author: zPersonBasicResponseWritable.nullish(),
    comment_date: z.string().datetime().nullish(),
    company: zCompanyBasicTypeResponse,
    sent_date: z.string().datetime(),
    date_introduction_facilitated: z.string().datetime().nullish(),
    date_last_viewed: z.string().datetime().nullish(),
    highlights: z.array(zCandidateHighlightResponse),
    introduction_date: z.string().datetime().nullish(),
    introduction_status: zIntroductionStatus.nullish(),
    is_liked: z.boolean().nullish(),
    comment: z.string().nullish(),
    make_introduction: z.boolean().nullish(),
    match: z.boolean().nullish(),
    pipeline: zPipelineBasicHiddenResponse.nullish(),
    review_status: zRecommendationReviewState,
    team: zTeamBasicResponse,
    submission: zSubmissionBasicResponse,
    uuid: z.string().uuid(),
    viewed_date: z.string().datetime().nullish()
});

/**
 * CandidatesCombinedPerformanceResponse
 */
export const zCandidatesCombinedPerformanceResponseWritable = z.object({
    candidate: zCandidateCompanyRoleResponseWritable,
    advisor: zPersonBasicResponseWritable,
    type: zClientType.nullish(),
    pathway: zCandidatePathway.nullish(),
    industry_expertise: z.array(zIndustry),
    function_expertise: z.array(zFunction),
    introductions_facilitated_count: z.number().int(),
    introductions_requested_count: z.number().int(),
    recommendation_count: z.number().int(),
    pipeline_count: z.number().int(),
    peer_activity_count: z.number().int(),
    rank: z.number().int(),
    calculated_rank: z.number()
});

/**
 * CandidatesCombinedPerformancePaginatedResponse
 */
export const zCandidatesCombinedPerformancePaginatedResponseWritable = z.object({
    page_count: z.number().int(),
    page: z.number().int(),
    results: z.array(zCandidatesCombinedPerformanceResponseWritable),
    size: z.number().int(),
    total_counts: zTotalCountsResponse
});

/**
 * CandidatesPerformancePaginatedResponse
 */
export const zCandidatesPerformancePaginatedResponseWritable = z.object({
    page_count: z.number().int(),
    page: z.number().int(),
    results: z.array(zCandidatePerformanceResponseWritable),
    size: z.number().int(),
    total_counts: zTotalCountsResponse
});

/**
 * CandidatesTableResponse
 */
export const zCandidatesTableResponseWritable = z.object({
    search_metadata: zEsMeta.nullish(),
    __linkedin_profile_last_synced__DO_NOT_USE__: z.string().datetime().nullish(),
    __manual_last_update__DO_NOT_USE__: z.string().datetime().nullish(),
    profile_updated_date: z.string().datetime().nullish(),
    __resume_last_uploaded__DO_NOT_USE__: z.string().datetime().nullish(),
    is_client: z.boolean().nullish(),
    company: z.string().nullish(),
    role: z.string().nullish(),
    image: z.string().nullish(),
    name: z.string(),
    uuid: z.string().uuid(),
    active: z.boolean(),
    advisor: zPersonBasicResponseWritable.nullish(),
    advisor_advisor_id: z.string().uuid().nullish(),
    advisor_advisor_image: z.string().nullish(),
    advisor_advisor_name: z.string().nullish(),
    referred_date: z.string().datetime().nullish(),
    email: z.string(),
    first_name: z.string().nullish(),
    function_expertise: z.array(zFunction),
    function_target: z.array(zFunction),
    industry_expertise: z.array(zIndustry),
    industry_target: z.array(zIndustry),
    interest_role_board_advisory: zInterestRole.nullish(),
    interest_role_operating: zInterestRole.nullish(),
    interests_personal: z.array(zInterestPersonal),
    interests_professional: z.array(zInterestProfessional),
    keywords: z.array(z.string()),
    last_name: z.string().nullish(),
    linkedin_url: z.string().nullish(),
    location: z.string().nullish(),
    tier: zCandidateTier,
    invoice_status: zHubSpotInvoiceStatus.nullish(),
    type: zClientType.nullish(),
    pathway: zCandidatePathway.nullish()
});

/**
 * CommentResponse
 */
export const zCommentResponseWritable = z.object({
    candidate: zUuidResponse.nullish(),
    person: zPersonBasicResponseWritable.nullish(),
    content: z.string(),
    created: z.string().datetime(),
    id: z.string().uuid(),
    last_modified: z.string().datetime(),
    pipeline: zUuidResponse.nullish(),
    recommendation: zUuidResponse.nullish(),
    subject_identity_uuid: z.string().uuid(),
    team: zUuidResponse
});

/**
 * EventGuestItemResponse
 *
 * A guest on an event's guest list (polymorphic on source type, like potential guests).
 *
 * Always includes resolved name, role, company, email for display, plus
 * source_type, person_uuid/candidate_uuid for linking, and event-guest fields (id, uuid, status).
 */
export const zEventGuestItemResponseWritable = z.object({
    source_type: zPotentialGuestSourceType,
    id: z.number().int(),
    uuid: z.string().uuid(),
    identity_uuid: z.string().uuid().nullish(),
    person_uuid: z.string().uuid().nullish(),
    candidate_uuid: z.string().uuid().nullish(),
    invoice_status: zHubSpotInvoiceStatus.nullish(),
    is_executive: z.boolean().optional().default(false),
    name: z.string().nullish(),
    role: z.string().nullish(),
    company: z.string().nullish(),
    email: z.string().nullish(),
    status: zEventGuestStatus,
    invite_sent_at: z.string().datetime().nullish(),
    created: z.string().datetime(),
    referrers: z.array(zPersonBasicResponseWritable).nullish(),
    client_types: z.array(zEventGuestClientType).optional()
});

/**
 * AddGuestsResponse
 *
 * Response after adding guests to an event.
 */
export const zAddGuestsResponseWritable = z.object({
    added: z.array(zEventGuestItemResponseWritable)
});

/**
 * EventGuestWithEventItemResponse
 *
 * An event guest with the event it belongs to (for listing all guests across events).
 */
export const zEventGuestWithEventItemResponseWritable = z.object({
    event_uuid: z.string().uuid(),
    event_title: z.string(),
    guest: zEventGuestItemResponseWritable
});

/**
 * EventGuestsPage[EventGuestItemResponse]
 */
export const zEventGuestsPageEventGuestItemResponseWritable = z.object({
    page_count: z.number().int().gte(0),
    page: z.number().int().gte(1),
    search_id: z.string().nullish(),
    results: z.array(zEventGuestItemResponseWritable),
    size: z.number().int().gte(1),
    total_counts: zEventGuestTotalCounts
});

/**
 * EventGuestsSelectionResponse
 *
 * All guests matching the selection filters (no pagination).
 */
export const zEventGuestsSelectionResponseWritable = z.object({
    results: z.array(zEventGuestItemResponseWritable),
    count: z.number().int()
});

/**
 * EventResponse
 *
 * Event with optional guest list.
 */
export const zEventResponseWritable = z.object({
    id: z.number().int(),
    uuid: z.string().uuid(),
    title: z.string(),
    categories: z.array(zEventCategory),
    category: zEventCategory.nullish(),
    draft: z.boolean(),
    rsvp_enabled: z.boolean(),
    description: z.string().nullish(),
    notes: z.string().nullish(),
    event_date: z.string().datetime().nullish(),
    event_timezone: z.string().nullish(),
    event_date_local: z.string().datetime().nullish(),
    location: z.string().nullish(),
    max_participants: z.number().int().nullish(),
    additional_link: z.string().nullish(),
    invite_email_subject: z.string().nullish(),
    invite_email_body: z.string().nullish(),
    invite_sender_email: z.string().nullish(),
    invite_sender_name: z.string().nullish(),
    landing_image: z.string().nullish(),
    created: z.string().datetime(),
    last_modified: z.string().datetime(),
    guests_count: z.number().int().optional().default(0),
    actual_guests_count: z.number().int().optional().default(0),
    guests: z.array(zEventGuestItemResponseWritable).nullish(),
    my_status: zEventGuestStatus.nullish(),
    is_past: z.boolean().nullish()
});

/**
 * ExecutiveContactDetailResponse
 *
 * Unified detail for one of the exec's contacts (BAN-5755).
 *
 * A single envelope that works whether the contact is candidate-backed or
 * person-only. The canonical relationship fields (``was_introduced``,
 * ``is_favorite``, ``source_types``, ``evidence``, ``personal_tags``) live at
 * the top level so the webapp reads them the same way regardless of type.
 *
 * ``candidate`` carries the full candidate profile when a candidate record
 * exists; ``person`` carries the linked person when one exists — both may be
 * present for a candidate who also has a ``Person`` row. The top-level
 * ``email`` prefers the candidate's (gated) email and falls back to the
 * person's; the same gated values appear on the sub-objects.
 */
export const zExecutiveContactDetailResponseWritable = z.object({
    candidate_uuid: z.string().nullish(),
    person_uuid: z.string().nullish(),
    identity_uuid: z.string().uuid().nullish(),
    email: z.string().nullish(),
    source_types: z.array(zContactSourceType).optional(),
    evidence: zContactEvidenceResponse.nullish(),
    personal_tags: z.array(zPersonalContactTagItem).optional(),
    is_favorite: z.boolean().optional().default(false),
    was_introduced: z.boolean().optional().default(false),
    is_represented: z.boolean().optional().default(false),
    candidate: zCandidateExternalFullResponseWithTeamContextWritable.nullish(),
    person: zExecutiveContactPerson.nullish()
});

/**
 * GroupedActivityLogResponse
 */
export const zGroupedActivityLogResponseWritable = z.object({
    totals: zCandidateActivityLogTotals,
    candidate: zCandidateBasicResponseWritable,
    logs: zCandidateActivityLogReferenceGroupsWritable
});

/**
 * HomeTeamActivityRecommendationResponse
 */
export const zHomeTeamActivityRecommendationResponseWritable = z.object({
    candidate: zCandidateExternalFullResponse,
    date_introduction_facilitated: z.string().datetime(),
    person: zPersonBasicResponseWritable,
    pipeline: zPipelineExternalResponse,
    team: zTeamBasicUuidResponse,
    uuid: z.string().uuid()
});

/**
 * HomeTeamActivityResponse
 */
export const zHomeTeamActivityResponseWritable = z.object({
    page_count: z.number().int().gte(0),
    page: z.number().int().gte(1),
    search_id: z.string().nullish(),
    results: z.array(z.union([zHomeTeamActivityPipelineResponseWritable, zHomeTeamActivityRecommendationResponseWritable])),
    size: z.number().int().gte(1),
    total_counts: zHomeTeamActivityCounts
});

/**
 * HomepageActivityLogResponse
 */
export const zHomepageActivityLogResponseWritable = z.object({
    actor: zPersonBasicResponseWritable.nullish(),
    candidate: zCandidateBasicResponseWritable.nullish(),
    date: z.string().datetime(),
    event_type: z.union([
        zActivityLogEventType,
        zCandidateActivityLogEventType
    ]),
    message: zActivityLogMessage,
    reference_id: z.string().uuid().nullish(),
    reference_type: zCandidateActivityLogReferenceType.nullish(),
    uuid: z.string().uuid()
});

/**
 * IdentityBasicResponse
 */
export const zIdentityBasicResponseWritable = z.object({
    uuid: z.string().uuid(),
    name: z.string().nullish(),
    candidate: zCandidateBasicResponseWritable.nullish(),
    executive_person: zPersonBasicResponseWritable.nullish()
});

/**
 * EventEmailEventItemResponse
 *
 * One email sent for an event, and what SendGrid has told us about it since.
 */
export const zEventEmailEventItemResponseWritable = z.object({
    sendgrid_message_id: z.string(),
    sendgrid_recipient_email: z.string(),
    recipient: zIdentityBasicResponseWritable.nullish(),
    email_event_type: zEmailEventType.nullish(),
    batch_uuid: z.string().uuid().nullish(),
    sent_at: z.string().datetime().nullish(),
    delivered_at: z.string().datetime().nullish(),
    first_opened_at: z.string().datetime().nullish(),
    last_opened_at: z.string().datetime().nullish(),
    open_count: z.number().int(),
    click_count: z.number().int(),
    failed_at: z.string().datetime().nullish(),
    failure: z.enum(['dropped', 'bounce']).nullish()
});

/**
 * EventEmailBatchResponse
 *
 * One send run for an event: the invites sent in one go, one reminder pass,
 * one RSVP confirmation. Counts are of emails, not of SendGrid events: an
 * email opened twice is one opened email.
 */
export const zEventEmailBatchResponseWritable = z.object({
    batch_uuid: z.string().uuid(),
    email_event_type: zEmailEventType.nullish(),
    sent_at: z.string().datetime().nullish(),
    email_count: z.number().int(),
    delivered_count: z.number().int(),
    opened_count: z.number().int(),
    clicked_count: z.number().int(),
    failed_count: z.number().int(),
    email_template: zEmailTemplateResponse.nullish(),
    first_emails: z.array(zEventEmailEventItemResponseWritable)
});

/**
 * IdentityEmailItemResponse
 *
 * One email sent to this human, and what SendGrid has told us about it since.
 */
export const zIdentityEmailItemResponseWritable = z.object({
    sendgrid_message_id: z.string(),
    sendgrid_recipient_email: z.string(),
    recipient: zIdentityBasicResponseWritable.nullish(),
    email_event_type: zEmailEventType.nullish(),
    batch_uuid: z.string().uuid().nullish(),
    sent_at: z.string().datetime().nullish(),
    delivered_at: z.string().datetime().nullish(),
    first_opened_at: z.string().datetime().nullish(),
    last_opened_at: z.string().datetime().nullish(),
    open_count: z.number().int(),
    click_count: z.number().int(),
    failed_at: z.string().datetime().nullish(),
    failure: z.enum(['dropped', 'bounce']).nullish()
});

/**
 * InternalCommentResponse
 */
export const zInternalCommentResponseWritable = z.object({
    candidate: zUuidResponse,
    person: zPersonBasicResponseWritable,
    content: z.string(),
    created: z.string().datetime(),
    id: z.string().uuid(),
    last_modified: z.string().datetime(),
    pipeline: zUuidResponse.nullish(),
    recommendation: zUuidResponse.nullish(),
    team: zUuidResponse
});

/**
 * Page[CandidateActivityEvent]
 */
export const zPageCandidateActivityEventWritable = z.object({
    page_count: z.number().int().gte(0),
    page: z.number().int().gte(1),
    search_id: z.string().nullish(),
    results: z.array(zCandidateActivityEventWritable),
    size: z.number().int().gte(1),
    total_counts: zTotalCounts
});

/**
 * Page[CandidateActivityLogResponse]
 */
export const zPageCandidateActivityLogResponseWritable = z.object({
    page_count: z.number().int().gte(0),
    page: z.number().int().gte(1),
    search_id: z.string().nullish(),
    results: z.array(zCandidateActivityLogResponseWritable),
    size: z.number().int().gte(1),
    total_counts: zTotalCounts
});

/**
 * Page[CandidateRecommendationResponse]
 */
export const zPageCandidateRecommendationResponseWritable = z.object({
    page_count: z.number().int().gte(0),
    page: z.number().int().gte(1),
    search_id: z.string().nullish(),
    results: z.array(zCandidateRecommendationResponseWritable),
    size: z.number().int().gte(1),
    total_counts: zTotalCounts
});

/**
 * Page[CandidatesTableResponse]
 */
export const zPageCandidatesTableResponseWritable = z.object({
    page_count: z.number().int().gte(0),
    page: z.number().int().gte(1),
    search_id: z.string().nullish(),
    results: z.array(zCandidatesTableResponseWritable),
    size: z.number().int().gte(1),
    total_counts: zTotalCounts
});

/**
 * Page[CommentResponse]
 */
export const zPageCommentResponseWritable = z.object({
    page_count: z.number().int().gte(0),
    page: z.number().int().gte(1),
    search_id: z.string().nullish(),
    results: z.array(zCommentResponseWritable),
    size: z.number().int().gte(1),
    total_counts: zTotalCounts
});

/**
 * Page[EventEmailBatchResponse]
 */
export const zPageEventEmailBatchResponseWritable = z.object({
    page_count: z.number().int().gte(0),
    page: z.number().int().gte(1),
    search_id: z.string().nullish(),
    results: z.array(zEventEmailBatchResponseWritable),
    size: z.number().int().gte(1),
    total_counts: zTotalCounts
});

/**
 * Page[EventEmailEventItemResponse]
 */
export const zPageEventEmailEventItemResponseWritable = z.object({
    page_count: z.number().int().gte(0),
    page: z.number().int().gte(1),
    search_id: z.string().nullish(),
    results: z.array(zEventEmailEventItemResponseWritable),
    size: z.number().int().gte(1),
    total_counts: zTotalCounts
});

/**
 * Page[EventGuestWithEventItemResponse]
 */
export const zPageEventGuestWithEventItemResponseWritable = z.object({
    page_count: z.number().int().gte(0),
    page: z.number().int().gte(1),
    search_id: z.string().nullish(),
    results: z.array(zEventGuestWithEventItemResponseWritable),
    size: z.number().int().gte(1),
    total_counts: zTotalCounts
});

/**
 * Page[EventResponse]
 */
export const zPageEventResponseWritable = z.object({
    page_count: z.number().int().gte(0),
    page: z.number().int().gte(1),
    search_id: z.string().nullish(),
    results: z.array(zEventResponseWritable),
    size: z.number().int().gte(1),
    total_counts: zTotalCounts
});

/**
 * Page[HomepageActivityLogResponse]
 */
export const zPageHomepageActivityLogResponseWritable = z.object({
    page_count: z.number().int().gte(0),
    page: z.number().int().gte(1),
    search_id: z.string().nullish(),
    results: z.array(zHomepageActivityLogResponseWritable),
    size: z.number().int().gte(1),
    total_counts: zTotalCounts
});

/**
 * Page[IdentityEmailItemResponse]
 */
export const zPageIdentityEmailItemResponseWritable = z.object({
    page_count: z.number().int().gte(0),
    page: z.number().int().gte(1),
    search_id: z.string().nullish(),
    results: z.array(zIdentityEmailItemResponseWritable),
    size: z.number().int().gte(1),
    total_counts: zTotalCounts
});

/**
 * Page[InternalCommentResponse]
 */
export const zPageInternalCommentResponseWritable = z.object({
    page_count: z.number().int().gte(0),
    page: z.number().int().gte(1),
    search_id: z.string().nullish(),
    results: z.array(zInternalCommentResponseWritable),
    size: z.number().int().gte(1),
    total_counts: zTotalCounts
});

/**
 * PeerActivityResponse
 */
export const zPeerActivityResponseWritable = z.object({
    context: z.string().nullish(),
    created: z.string().datetime(),
    creator: zPersonBasicResponseWritable,
    event: zPeerEvent,
    id: z.string().uuid(),
    last_modified: z.string().datetime()
});

/**
 * Page[PeerActivityResponse]
 */
export const zPagePeerActivityResponseWritable = z.object({
    page_count: z.number().int().gte(0),
    page: z.number().int().gte(1),
    search_id: z.string().nullish(),
    results: z.array(zPeerActivityResponseWritable),
    size: z.number().int().gte(1),
    total_counts: zTotalCounts
});

/**
 * PeerComparePeerToPeerResponse
 */
export const zPeerComparePeerToPeerResponseWritable = z.object({
    id: z.string().uuid(),
    created: z.string().datetime(),
    last_modified: z.string().datetime(),
    introduced_on: z.string().datetime().nullish(),
    candidate: zCandidateCompanyRoleWithAdvisorResponseWritable,
    status: zPeerStatus
});

/**
 * PeerCompareP2PResponse
 */
export const zPeerCompareP2pResponseWritable = z.object({
    candidate: zCandidateBasicResponseWritable,
    matches: z.array(zPeerComparePeerToPeerResponseWritable)
});

/**
 * PeerToPeerBasicESResponse
 */
export const zPeerToPeerBasicEsResponseWritable = z.object({
    assignees: z.array(zPersonBasicEmailResponseWritable),
    candidate: zCandidateCompanyRoleWithAdvisorResponseWritable,
    candidate_to: zCandidateCompanyRoleWithAdvisorResponseWritable,
    context: z.string().nullish(),
    created: z.string().datetime(),
    creator: zPersonBasicEmailResponseWritable,
    id: z.string().uuid(),
    introduced_on: z.string().datetime().nullish(),
    last_modified: z.string().datetime(),
    status: zPeerStatus,
    reviewers: z.array(zPersonBasicEmailResponseWritable),
    reviewers_statuses: z.array(zPeerToPeerReviewersStatus)
});

/**
 * PeerToPeerBasicResponse
 */
export const zPeerToPeerBasicResponseWritable = z.object({
    assignees: z.array(zPersonBasicEmailResponseWritable),
    candidate: zCandidateCompanyRoleWithAdvisorResponseWritable,
    candidate_to: zCandidateCompanyRoleWithAdvisorResponseWritable,
    context: z.string().nullish(),
    created: z.string().datetime(),
    creator: zPersonBasicEmailResponseWritable,
    id: z.string().uuid(),
    introduced_on: z.string().datetime().nullish(),
    last_modified: z.string().datetime(),
    status: zPeerStatus
});

/**
 * PeerCommentResponse
 */
export const zPeerCommentResponseWritable = z.object({
    context: z.string(),
    created: z.string().datetime(),
    creator: zPersonBasicResponseWritable,
    id: z.string().uuid(),
    last_modified: z.string().datetime(),
    peer: zPeerToPeerBasicResponseWritable
});

/**
 * PeerToPeerExtendedResponse
 */
export const zPeerToPeerExtendedResponseWritable = z.object({
    assignees: z.array(zPersonBasicEmailResponseWritable),
    candidate: zCandidateCompanyRoleWithAdvisorResponseWritable,
    candidate_to: zCandidateCompanyRoleWithAdvisorResponseWritable,
    context: z.string().nullish(),
    created: z.string().datetime(),
    creator: zPersonBasicEmailResponseWritable,
    id: z.string().uuid(),
    introduced_on: z.string().datetime().nullish(),
    last_modified: z.string().datetime(),
    status: zPeerStatus,
    email_body: z.string().nullish(),
    email_sender: zPersonBasicEmailResponseWritable.nullish(),
    email_subject: z.string().nullish(),
    email_cc: z.array(zPersonBasicEmailResponseWritable).nullish(),
    reviewers: z.array(zPersonBasicEmailResponseWritable),
    reviewers_status: z.record(zPeerStatus)
});

/**
 * PeerToPeerSelectResponse
 */
export const zPeerToPeerSelectResponseWritable = z.object({
    is_client: z.boolean(),
    company: z.string().nullish(),
    role: z.string().nullish(),
    image: z.string().nullish(),
    name: z.string(),
    uuid: z.string().uuid(),
    first_name: z.string().nullish(),
    function_expertise: z.array(zFunction),
    function_target: z.array(zFunction),
    industry_expertise: z.array(zIndustry),
    industry_target: z.array(zIndustry),
    interest_role_board_advisory: zInterestRole.nullish(),
    interest_role_operating: zInterestRole.nullish(),
    interests_personal: z.array(zInterestPersonal),
    interests_professional: z.array(zInterestProfessional),
    keywords: z.array(z.string()),
    last_name: z.string().nullish(),
    linkedin_url: z.string().nullish(),
    tier: zCandidateTier,
    type: zClientType.nullish(),
    pathway: zCandidatePathway.nullish(),
    advisor: zPersonBasicResponseWritable.nullish(),
    intros_count: z.number().int().optional().default(0),
    last_peer_introduced_on: z.string().datetime().nullish(),
    last_peer_status: zPeerStatus.nullish(),
    last_event_date: z.string().datetime().nullish(),
    last_event: zPeerToPeerLastEventResponse.nullish(),
    client_has_peer_as_referrer: z.boolean().optional().default(false),
    peer_has_client_as_referrer: z.boolean().optional().default(false),
    location: z.string().nullish(),
    invoice_status: zHubSpotInvoiceStatus.nullish()
});

/**
 * PeerToPeerTableExecutiveResponse
 */
export const zPeerToPeerTableExecutiveResponseWritable = z.object({
    page_count: z.number().int(),
    page: z.number().int(),
    results: z.array(zPeerToPeerBasicResponseWritable),
    size: z.number().int(),
    total_counts: zTotalCountsResponse,
    aggregations: zPeerToPeerTableExecutiveAggregationsResponse
});

/**
 * PeerToPeerTableResponse
 */
export const zPeerToPeerTableResponseWritable = z.object({
    page_count: z.number().int(),
    page: z.number().int(),
    results: z.array(zPeerToPeerBasicEsResponseWritable),
    size: z.number().int(),
    total_counts: zTotalCountsResponse,
    aggregations: zPeerToPeerTableFilterAggregationsResponse
});

/**
 * PeerToPeerTableSelectResponse
 */
export const zPeerToPeerTableSelectResponseWritable = z.object({
    page_count: z.number().int(),
    page: z.number().int(),
    results: z.array(zPeerToPeerSelectResponseWritable),
    size: z.number().int(),
    total_counts: zTotalCountsResponse,
    aggregations: zPeerToPeerTableSelectAggregationsResponse
});

/**
 * PersonInnerDocSchema
 */
export const zPersonInnerDocSchemaWritable = z.object({
    email: z.string().email(),
    first_name: z.string().nullish(),
    name: z.string(),
    last_name: z.string().nullish(),
    image: z.string().nullish(),
    uuid: z.string().uuid()
});

/**
 * ESCandidateIndexExternalResult
 */
export const zEsCandidateIndexExternalResultWritable = z.object({
    search_metadata: zEsMeta.nullish(),
    advisor: zPersonInnerDocSchemaWritable.nullish(),
    company: z.string().nullish(),
    role: z.string().nullish(),
    date_introduction_facilitated_last: z.string().datetime().nullish(),
    date_recommended_last: z.string().datetime().nullish(),
    email: z.string().email(),
    first_name: z.string().nullish(),
    function_expertise: z.array(zFunction),
    function_target: z.array(zFunction),
    global_introduction_request_person: zPersonInnerDocSchemaWritable.nullish(),
    global_introduction_status: zIntroductionStatus.nullish(),
    id: z.string().uuid(),
    image: z.string().nullish(),
    industry_expertise: z.array(zIndustry),
    industry_target: z.array(zIndustry),
    is_client: z.boolean(),
    is_favorite: z.boolean(),
    last_name: z.string().nullish(),
    linkedin_url: z.string().nullish(),
    location: z.string().nullish(),
    name: z.string(),
    operating_highlights: z.array(zOperatingHighlights).nullish(),
    resume: zLinkedInResumeResponse.nullish(),
    uuid: z.string().uuid()
});

/**
 * ESCandidateIndexResult
 */
export const zEsCandidateIndexResultWritable = z.object({
    search_metadata: zEsMeta.nullish(),
    active: z.boolean(),
    advisor: zPersonInnerDocSchemaWritable.nullish(),
    advisor_id: z.string().uuid().nullish(),
    company: z.string().nullish(),
    role: z.string().nullish(),
    date_introduction_facilitated_last: z.string().datetime().nullish(),
    date_recommended_last: z.string().datetime().nullish(),
    function_expertise: z.array(zFunction),
    function_target: z.array(zFunction),
    global_introduction_request_person: zPersonInnerDocSchemaWritable.nullish(),
    global_introduction_status: zIntroductionStatus.nullish(),
    industry_expertise: z.array(zIndustry),
    industry_target: z.array(zIndustry),
    interest_role_board_advisory: zInterestRole.nullish(),
    interest_role_operating: zInterestRole.nullish(),
    interests_personal: z.array(zInterestPersonal),
    interests_professional: z.array(zInterestProfessional),
    id: z.number().int(),
    is_client: z.boolean().nullish(),
    is_favorite: z.boolean(),
    is_referred: z.boolean().nullish(),
    keywords: z.array(z.string()),
    linkedin_profile_last_synced: z.string().datetime().nullish(),
    linkedin_url: z.string().nullish(),
    location: z.string().nullish(),
    manual_last_update: z.string().datetime().nullish(),
    notes: z.string().nullish(),
    operating_highlights: z.array(zOperatingHighlights).nullish(),
    email: z.string(),
    first_name: z.string().nullish(),
    name: z.string().nullish(),
    last_name: z.string().nullish(),
    image: z.string().nullish(),
    pipelines_count: z.number().int().nullish(),
    referred_date: z.string().datetime().nullish(),
    referrers: z.array(zPersonInnerDocSchemaWritable),
    resume: zLinkedInResumeResponse.nullish(),
    resume_last_uploaded: z.string().datetime().nullish(),
    profile_updated_date: z.string().datetime().nullish(),
    team_uuid: z.string().uuid(),
    tier: zCandidateTier,
    type: zClientType.nullish(),
    pathway: zCandidatePathway.nullish(),
    uuid: z.string().uuid()
});

/**
 * HomeCandidatesResponse
 */
export const zHomeCandidatesResponseWritable = z.object({
    results: z.array(zEsCandidateIndexExternalResultWritable),
    search_id: z.string(),
    total_counts: zTotalCountsResponse
});

/**
 * PersonMemberResponse
 */
export const zPersonMemberResponseWritable = z.object({
    first_name: z.string().min(1).nullish(),
    last_name: z.string().min(1).nullish(),
    email: z.string().email(),
    pending: z.boolean(),
    first_login: z.string().datetime().nullish(),
    name: z.string(),
    id: z.string().uuid(),
    image: z.string().nullish(),
    roles: z.array(zPersonMemberRole),
    permit_preregistration_notifications: z.boolean(),
    terms_accepted: z.string().datetime().nullish()
});

/**
 * PersonV1CurrentResponse
 *
 * GET ``/api/v1/people/current`` — legacy person payload with a signed profile image URL.
 */
export const zPersonV1CurrentResponseWritable = z.object({
    country: z.string().nullish(),
    email: z.string().email(),
    first_login: z.string().datetime().nullish(),
    first_name: z.string().nullish(),
    has_set_password: z.boolean().optional().default(true),
    id: z.string().uuid().nullish(),
    last_login: z.string().datetime().nullish(),
    last_name: z.string().nullish(),
    last_team_visit_slug: z.string().nullish(),
    name: z.string().nullish(),
    newly_invited: z.boolean().optional().default(false),
    notes_external: z.string().nullish(),
    linkedin_url: z.string().nullish(),
    person_image: z.string().nullish(),
    person_name: z.string().nullish(),
    is_executive: z.boolean().optional().default(false),
    roles: z.array(zPersonRole).optional(),
    uuid: z.string().uuid()
});

/**
 * PipelineCandidateSearchFilterSortResponse
 */
export const zPipelineCandidateSearchFilterSortResponseWritable = z.object({
    search_metadata: zEsMeta.nullish(),
    advisor: zPersonBasicResponseWritable.nullish(),
    client_owner: zPersonBasicResponseWritable.nullish(),
    created: z.string().datetime().nullish(),
    current_company: z.string().nullish(),
    current_role: z.string().nullish(),
    role: z.string().nullish(),
    location: z.string().nullish(),
    interest_role_board_advisory: zInterestRole.nullish(),
    interest_role_operating: zInterestRole.nullish(),
    keywords: z.array(z.string()).nullish(),
    notes: z.string().nullish(),
    function_expertise: z.array(zFunction).optional(),
    industry_expertise: z.array(zIndustry).optional(),
    is_urg: z.boolean().nullish(),
    operating_highlights: z.array(zOperatingHighlights).nullish(),
    email: z.string(),
    name: z.string(),
    image: z.string().nullish(),
    referrers: z.array(zPersonBasicResponseWritable).nullish(),
    tier: zCandidateTier,
    type: zClientType.nullish(),
    pathway: zCandidatePathway.nullish(),
    invoice_status: zHubSpotInvoiceStatus.nullish(),
    warm: z.boolean().nullish(),
    recsys_score: z.number().nullish(),
    suggestion_sources: z.array(z.string()).nullish(),
    suggestion_reasons: z.array(z.string()).nullish(),
    match_score: z.number().nullish(),
    match_breakdown: zMatchScoreBreakdown.nullish(),
    team_status: zPipelineCandidateTeamStatus.nullish(),
    pipeline_status: zCandidatePipelineStatus.nullish(),
    recommendation_uuid: z.string().uuid().nullish(),
    recommendation: zRecommendationDraftBasicResponse.nullish(),
    intro_email_type: zIntroEmailType,
    draft_assignee: zPersonBasicResponseWritable.nullish(),
    recommender: zPersonBasicResponseWritable.nullish(),
    recommended_on: z.string().datetime().nullish(),
    autosuggested: z.boolean().optional().default(false),
    internal_comments_count: z.number().int().nullish().default(0),
    is_accepting_intros: z.boolean().nullish(),
    not_accepting_start_date: z.string().datetime().nullish(),
    not_accepting_end_date: z.string().datetime().nullish(),
    pipeline_off_limits: zOffLimitsTeamSchema.nullish(),
    uuid: z.string().uuid()
});

/**
 * PipelineCandidatesFilterResponse
 */
export const zPipelineCandidatesFilterResponseWritable = z.object({
    search_metadata: zEsMeta.nullish(),
    email: z.string(),
    name: z.string().nullish(),
    image: z.string().nullish(),
    uuid: z.string().optional().default(''),
    current_company: z.string().nullish(),
    current_role: z.string().nullish(),
    function_expertise: z.array(zFunction).optional(),
    industry_expertise: z.array(zIndustry).optional(),
    interest_role_operating: zInterestRole.nullish(),
    operating_highlights: z.array(zOperatingHighlights).optional(),
    interest_role_board_advisory: zInterestRole.nullish(),
    tier: zCandidateTier.nullish(),
    advisor: zPersonBasicResponseWritable.nullish(),
    connection_status: zRecommendationStatusOutput.nullish(),
    pipeline_status: zRecommendationStatusOutput.nullish(),
    warm: z.boolean().optional().default(false),
    created: z.string().datetime().nullish(),
    keywords: z.array(z.string()).optional(),
    notes: z.string().nullish(),
    is_urg: z.boolean().optional().default(false),
    referrers: z.array(zPersonBasicResponseWritable).optional()
});

/**
 * PipelineCandidatesFilterPaginatedResponse
 */
export const zPipelineCandidatesFilterPaginatedResponseWritable = z.object({
    page_count: z.number().int(),
    page: z.number().int(),
    results: z.array(zPipelineCandidatesFilterResponseWritable),
    size: z.number().int(),
    total_counts: zTotalCountsResponse
});

/**
 * PipelineFullResponse
 */
export const zPipelineFullResponseWritable = z.object({
    is_visible_to_team: z.boolean().nullish(),
    keywords: z.array(z.string()).nullish(),
    placed_candidate: zCandidateBasicResponseWritable.nullish(),
    pipeline_type: zPipelineType.optional().default('OTHER'),
    active: z.boolean(),
    attendees: zPipelineAttendees.nullish(),
    company: z.string().nullish(),
    company_size: zCompanySize.nullish(),
    company_type: zCompanyType.nullish(),
    created: z.string().datetime(),
    creator: zPersonBasicResponseWritable.nullish(),
    event_date: z.string().datetime().nullish(),
    event_name: z.string().nullish(),
    formatted_name: z.string(),
    function_expertise: z.array(zFunction),
    industry_expertise: z.array(zIndustry),
    is_urg: z.boolean(),
    location: z.string().nullish(),
    name: z.string(),
    notes: z.string().nullish(),
    point_of_contact: zPersonBasicResponseWritable.nullish(),
    purpose: z.string().nullish(),
    is_proactive: z.boolean(),
    role_type: zPipelineRoleType,
    role: z.string(),
    team: zTeamCompanyResponse,
    slug: z.string(),
    uuid: z.string().uuid()
});

/**
 * PostPage[ActivityFeedItem]
 */
export const zPostPageActivityFeedItemWritable = z.object({
    page_count: z.number().int().gte(0),
    page: z.number().int().gte(1),
    search_id: z.string().nullish(),
    results: z.array(zActivityFeedItemWritable),
    size: z.number().int().gte(1),
    total_counts: zTotalCounts
});

/**
 * PostPersonClerkUserResponse
 */
export const zPostPersonClerkUserResponseWritable = z.object({
    person: zPersonBasicResponseWritable,
    clerk_user_id: z.string()
});

/**
 * PotentialGuestItem
 *
 * A single potential guest for event guest lists.
 *
 * Drawn from B4B users (non-advisory), candidates, or standalone event
 * guests from previous events. When a person is both a user and a candidate,
 * they appear once (as user) with optional candidate_uuid set.
 */
export const zPotentialGuestItemWritable = z.object({
    source_type: zPotentialGuestSourceType,
    identity_uuid: z.string().uuid().nullish(),
    person_uuid: z.string().uuid().nullish(),
    candidate_uuid: z.string().uuid().nullish(),
    is_executive: z.boolean().optional().default(false),
    name: z.string().nullish(),
    role: z.string().nullish(),
    company: z.string().nullish(),
    email: z.string().nullish(),
    created: z.string().datetime().nullish(),
    last_event_date: z.string().datetime().nullish(),
    events_attended_count: z.number().int().optional().default(0),
    events_invited_count: z.number().int().optional().default(0),
    tier: zCandidateTier.nullish(),
    candidate_type: zClientType.nullish(),
    pathway: zCandidatePathway.nullish(),
    industry: z.array(zIndustry).nullish(),
    function: z.array(zFunction).nullish(),
    operating_highlights: z.array(zOperatingHighlights).nullish(),
    interest_role_operating: zInterestRole.nullish(),
    interest_role_board: zInterestRole.nullish(),
    keywords: z.array(z.string()).nullish(),
    underrepresented: z.boolean().nullish(),
    warm: z.boolean().nullish(),
    invoice_status: zHubSpotInvoiceStatus.nullish(),
    referrers: z.array(zPersonBasicResponseWritable).nullish(),
    advisor: zPersonBasicResponseWritable.nullish(),
    client_types: z.array(zEventGuestClientType).optional()
});

/**
 * PotentialGuestsSearchResponse
 *
 * Paginated response for potential guests search with optional aggregations.
 */
export const zPotentialGuestsSearchResponseWritable = z.object({
    results: z.array(zPotentialGuestItemWritable),
    page: z.number().int().gte(1),
    page_count: z.number().int().gte(0),
    size: z.number().int().gte(1),
    total_counts: z.record(z.number().int()),
    aggregations: zPotentialGuestsAggregationsResponse.nullish()
});

/**
 * RecommendationBioResponse
 */
export const zRecommendationBioResponseWritable = z.object({
    about: z.string().nullish(),
    candidate: zCandidateShareResponse,
    highlights: z.array(z.string()),
    presenter: zPersonBasicResponseWritable.nullish()
});

/**
 * RecommendationCandidateBasicResponse
 */
export const zRecommendationCandidateBasicResponseWritable = z.object({
    candidate: zCandidateBasicResponseWritable
});

/**
 * RecommendationCandidatePipelinesResponse
 */
export const zRecommendationCandidatePipelinesResponseWritable = z.object({
    candidate: zCandidateBasicResponseWritable,
    pipeline: zPipelineBasicV2Response.nullish(),
    uuid: z.string().uuid()
});

/**
 * RecommendationExternalFullResponse
 */
export const zRecommendationExternalFullResponseWritable = z.object({
    introduction_status: zIntroductionStatus.nullish(),
    about: z.string().nullish(),
    candidate: zCandidateExternalFullResponse,
    company: zCompanyBasicResponse,
    highlights: z.array(z.string()),
    introduction_request_person: zPersonBasicResponseWritable.nullish(),
    external_introduction_request_person: zExternalPerson.nullish(),
    intro_email_type: zIntroEmailType,
    is_liked: z.boolean().nullish(),
    pipeline: zPipelineBasicResponse.nullable(),
    team: zTeamBasicResponse,
    uuid: z.string().uuid(),
    draft_mode: zRecommendationDraftMode.nullish(),
    draft_assignee: zPersonBasicResponseWritable.nullish()
});

/**
 * RecommendationIntroductionResponse
 */
export const zRecommendationIntroductionResponseWritable = z.object({
    advisor: zPersonBasicResponseWritable.nullish(),
    date: z.string().datetime().nullish(),
    status_context: zIntroductionStatusContext.nullish(),
    resolved_date: z.string().datetime().nullish(),
    person: zPersonBasicResponseWritable.nullish(),
    introduction_status: zIntroductionStatus.nullish(),
    already_known: z.boolean().nullish(),
    is_liked: z.boolean().nullish(),
    uuid: z.string().uuid()
});

/**
 * RecommendationPreviewResponse
 *
 * Preview/guest version of a recommendation with limited fields for unauthenticated access.
 */
export const zRecommendationPreviewResponseWritable = z.object({
    candidate: zCandidateBasicResponseWritable,
    uuid: z.string().uuid()
});

/**
 * RecommendationsHistoryRecommendation
 */
export const zRecommendationsHistoryRecommendationWritable = z.object({
    advisor: zPersonBasicResponseWritable.nullish(),
    date: z.string().datetime().nullish(),
    status_context: zIntroductionStatusContext.nullish(),
    resolved_date: z.string().datetime().nullish(),
    person: zPersonBasicResponseWritable.nullish(),
    status: zIntroductionStatus.nullish(),
    type: zIntroductionType,
    created: z.string().datetime(),
    pipeline: zPipelineBasicResponse.nullish(),
    team: zTeamBasicResponse
});

/**
 * RecommendationsHistoryResponse
 */
export const zRecommendationsHistoryResponseWritable = z.object({
    candidate: zCandidateBasicResponseWritable,
    recommendations: z.array(zRecommendationsHistoryRecommendationWritable)
});

/**
 * RecsysCandidateOpportunityItem
 */
export const zRecsysCandidateOpportunityItemWritable = z.object({
    pipeline: zRecsysOpportunityPipeline,
    rank: z.number().int(),
    fit_score: z.number().int().nullish(),
    provenance: zRecsysOpportunityProvenance.optional(),
    recommendation_id: z.string().nullish(),
    rationale: z.unknown().nullish(),
    has_rationale: z.boolean().optional().default(false),
    reviewed: z.boolean().optional().default(false),
    assessment: z.string().nullish(),
    warm: z.boolean().optional().default(false),
    last_action: zPipelineCandidateTeamStatus.nullish(),
    already_recommended: z.boolean().optional().default(false),
    recommendation_uuid: z.string().uuid().nullish(),
    pipeline_status: zCandidatePipelineStatus.nullish(),
    draft_assignee: zPersonBasicResponseWritable.nullish()
});

/**
 * RecsysCandidateOpportunitiesResponse
 */
export const zRecsysCandidateOpportunitiesResponseWritable = z.object({
    total: z.number().int().optional().default(0),
    already_recommended_count: z.number().int().optional().default(0),
    items: z.array(zRecsysCandidateOpportunityItemWritable).optional()
});

/**
 * RecsysPipelineRecommendationItem
 */
export const zRecsysPipelineRecommendationItemWritable = z.object({
    candidate: zRecsysRecommendationCandidate,
    recommendation_id: z.string().nullish(),
    rank: z.number().int().nullish(),
    tier: z.string().nullish(),
    score: z.number().nullish(),
    reasons: z.array(z.string()).optional(),
    cautions: z.array(z.string()).optional(),
    rationale: z.unknown().nullish(),
    already_on_pipeline: z.boolean().optional().default(false),
    recommendation_uuid: z.string().uuid().nullish(),
    pipeline_status: zCandidatePipelineStatus.nullish(),
    draft_assignee: zPersonBasicResponseWritable.nullish()
});

/**
 * RecsysPipelineRecommendationsResponse
 */
export const zRecsysPipelineRecommendationsResponseWritable = z.object({
    total: z.number().int().optional().default(0),
    computed_at: z.string().nullish(),
    algorithm_version: z.string().nullish(),
    run_id: z.string().nullish(),
    already_on_pipeline_count: z.number().int().optional().default(0),
    items: z.array(zRecsysPipelineRecommendationItemWritable).optional()
});

/**
 * ResolvePersonCandidateByEmailResult
 */
export const zResolvePersonCandidateByEmailResultWritable = z.object({
    email: z.string().email(),
    person_uuid: z.string().uuid().nullish(),
    candidate_uuid: z.string().uuid().nullish(),
    person: zPersonBasicResponseWritable.nullish(),
    candidate: zCandidateBasicResponseWritable.nullish(),
    person_active: z.boolean().nullish(),
    identity_uuid: z.string().uuid().nullish()
});

/**
 * ResolvePersonCandidateByEmailResponse
 */
export const zResolvePersonCandidateByEmailResponseWritable = z.object({
    results: z.array(zResolvePersonCandidateByEmailResultWritable)
});

/**
 * SubmissionCandidatePipelinesResponse
 */
export const zSubmissionCandidatePipelinesResponseWritable = z.object({
    recommendations: z.array(zRecommendationCandidatePipelinesResponseWritable),
    uuid: z.string().uuid()
});

/**
 * SubmissionCheckSharedResponse
 */
export const zSubmissionCheckSharedResponseWritable = z.object({
    candidate: zCandidateExtendedResponseWritable,
    uuid: z.string().uuid()
});

/**
 * SubmissionSearchFilterSortResponse
 */
export const zSubmissionSearchFilterSortResponseWritable = z.object({
    emails_delivered: z.number().int().default(0),
    emails_opened: z.number().int().default(0),
    advisor: zPersonBasicEmailResponseWritable.nullish(),
    candidate: zPersonBasicEmailResponseWritable.nullish(),
    introduction_request_count: z.number().int().default(0),
    last_executed_in_summary_cron: z.string().datetime().nullish(),
    last_modified: z.string().datetime(),
    name: z.string().nullish(),
    notification_type: zRecommendationPublishedNotificationType.nullish(),
    published_on: z.string().datetime().nullish(),
    recommendations_count: z.number().int(),
    status: zSubmissionStatus,
    type: zSubmissionType.nullish(),
    uuid: z.string().uuid()
});

/**
 * SubmissionV3RecommendationResponse
 */
export const zSubmissionV3RecommendationResponseWritable = z.object({
    candidate: zCandidateSearchResponseWritable,
    team: zTeamsSearchTeamResponse,
    uuid: z.string().uuid(),
    published_on: z.string().datetime().nullish(),
    status: zRecommendationStatusOutput
});

/**
 * SubmissionV3InternalEmailStatsResponse
 */
export const zSubmissionV3InternalEmailStatsResponseWritable = z.object({
    emails_delivered: z.number().int().default(0),
    emails_opened: z.number().int().default(0),
    about: z.string().nullish(),
    advisor: zPersonBasicEmailResponseWritable.nullish(),
    candidate: zCandidateSearchResponseWritable.nullish(),
    recommendations: z.array(zSubmissionV3RecommendationResponseWritable),
    highlights_with_selected: z.array(zHighlightWithSelectedResponse),
    last_executed_in_summary_cron: z.string().datetime().nullish(),
    notification_type: zRecommendationPublishedNotificationType,
    publish_email_body: z.string().nullish(),
    publish_email_subject: z.string().nullish(),
    published_on: z.string().datetime().nullish(),
    status: zSubmissionStatus,
    type: zSubmissionType.nullish(),
    uuid: z.string().uuid()
});

/**
 * SubmissionV3InternalResponse
 */
export const zSubmissionV3InternalResponseWritable = z.object({
    about: z.string().nullish(),
    advisor: zPersonBasicEmailResponseWritable.nullish(),
    candidate: zCandidateSearchResponseWritable.nullish(),
    recommendations: z.array(zSubmissionV3RecommendationResponseWritable),
    highlights_with_selected: z.array(zHighlightWithSelectedResponse),
    last_executed_in_summary_cron: z.string().datetime().nullish(),
    notification_type: zRecommendationPublishedNotificationType,
    publish_email_body: z.string().nullish(),
    publish_email_subject: z.string().nullish(),
    published_on: z.string().datetime().nullish(),
    status: zSubmissionStatus,
    type: zSubmissionType.nullish(),
    uuid: z.string().uuid()
});

/**
 * SubmissionsSearchFilterSortPaginatedResponse
 */
export const zSubmissionsSearchFilterSortPaginatedResponseWritable = z.object({
    page_count: z.number().int(),
    page: z.number().int(),
    results: z.array(zSubmissionSearchFilterSortResponseWritable),
    size: z.number().int(),
    total_counts: zTotalCountsResponse,
    search_id: z.string().nullish()
});

/**
 * TaskBasicResponse
 */
export const zTaskBasicResponseWritable = z.object({
    assignee: zPersonBasicEmailResponseWritable,
    candidate: zCandidateBasicResponseWritable,
    created: z.string().datetime(),
    creator: zPersonBasicEmailResponseWritable,
    completion_date: z.string().datetime().nullish(),
    description: z.string().nullish(),
    due_date: z.string().datetime().nullish(),
    id: z.string().uuid(),
    is_completed: z.boolean(),
    last_modified: z.string().datetime(),
    task_module: zTaskModuleBasicResponse.nullable(),
    title: z.string()
});

/**
 * CandidateOnboardingStatus
 */
export const zCandidateOnboardingStatusWritable = z.object({
    show_onboarding_section: z.boolean().nullish().default(true),
    candidate: zCandidateBasicResponseWritable,
    tasks: z.array(zTaskBasicResponseWritable).nullish()
});

/**
 * CandidateTaskModuleResponse
 */
export const zCandidateTaskModuleResponseWritable = z.object({
    module: zCandidateTaskModuleWritable.nullish(),
    tasks: z.array(zTaskBasicResponseWritable).nullish().default([])
});

/**
 * CandidateTaskModulesResponse
 */
export const zCandidateTaskModulesResponseWritable = z.object({
    page_count: z.number().int(),
    page: z.number().int(),
    results: z.array(zCandidateTaskModuleResponseWritable),
    size: z.number().int(),
    total_counts: zTotalCountsResponse
});

/**
 * TaskModuleResponse
 */
export const zTaskModuleResponseWritable = z.object({
    assignee: zPersonBasicEmailResponseWritable,
    candidate: zCandidateBasicResponseWritable,
    created: z.string().datetime(),
    creator: zPersonBasicEmailResponseWritable,
    description: z.string().nullish(),
    due_date: z.string().datetime(),
    id: z.string().uuid(),
    last_modified: z.string().datetime(),
    start_date: z.string().datetime(),
    status: zTaskModuleStatus,
    tasks: z.array(zTaskBasicResponseWritable).nullish(),
    type: zTaskModuleType
});

/**
 * TasksTableResponse
 */
export const zTasksTableResponseWritable = z.object({
    page_count: z.number().int(),
    page: z.number().int(),
    results: z.array(zTaskBasicResponseWritable),
    size: z.number().int(),
    total_counts: zTotalCountsResponse,
    aggregations: zTasksTableFilterAggregationsResponse
});

/**
 * TeamCandidatesFilterResponse
 */
export const zTeamCandidatesFilterResponseWritable = z.object({
    aggregations: zAppSchemasEsCandidateSchemaElasticsearchAggregationsResponse,
    page_count: z.number().int(),
    page: z.number().int(),
    results: z.array(zEsCandidateIndexResultWritable),
    search_id: z.string().nullish(),
    size: z.number().int(),
    total_counts: zTotalCountsResponse
});

/**
 * TeamPipelineCandidatesResponse
 */
export const zTeamPipelineCandidatesResponseWritable = z.object({
    search_id: z.string().nullish(),
    pipeline: zPipelineFullResponseWritable,
    recommendations: z.array(zCandidateItemWritable)
});

/**
 * TeamPipelineCandidatesSearchFilterSortResponse
 */
export const zTeamPipelineCandidatesSearchFilterSortResponseWritable = z.object({
    search_id: z.string().nullish(),
    page_count: z.number().int(),
    page: z.number().int(),
    aggregations: zTeamPipelineCandidatesSearchAggregations,
    results: z.array(zPipelineCandidateSearchFilterSortResponseWritable),
    size: z.number().int(),
    total_counts: zTotalCountsResponse,
    suggestion_basis: z.string().nullish(),
    suggestion_picks: z.array(zSuggestionPick).nullish()
});

/**
 * TeamTrendingCandidatesResponse
 */
export const zTeamTrendingCandidatesResponseWritable = z.object({
    search_id: z.string().nullish(),
    recommendations: z.array(zCandidateItemWritable)
});

/**
 * TeamWithMembersBasicResponse
 */
export const zTeamWithMembersBasicResponseWritable = z.object({
    members: z.array(zPersonBasicEmailResponseWritable),
    active: z.boolean().optional().default(true),
    slug: z.string(),
    name: z.string()
});

/**
 * PipelineSearchResponse
 */
export const zPipelineSearchResponseWritable = z.object({
    active: z.boolean(),
    company: z.string().nullish(),
    function_expertise: z.array(z.string()).nullish(),
    id: z.number().int(),
    industry_expertise: z.array(z.string()).nullish(),
    keywords: z.array(z.string()).nullish(),
    name: z.string(),
    candidates: z.array(zRecommendationCandidateBasicResponseWritable),
    slug: z.string(),
    search_team: zTeamWithMembersBasicResponseWritable,
    team_type: zOrgType,
    uuid: z.string().uuid()
});

/**
 * Page[PipelineSearchResponse]
 */
export const zPagePipelineSearchResponseWritable = z.object({
    page_count: z.number().int().gte(0),
    page: z.number().int().gte(1),
    search_id: z.string().nullish(),
    results: z.array(zPipelineSearchResponseWritable),
    size: z.number().int().gte(1),
    total_counts: zTotalCounts
});

/**
 * TrendingCandidateResponse
 */
export const zTrendingCandidateResponseWritable = z.object({
    candidate: zCandidateCompanyRoleResponseWritable,
    advisor: zPersonBasicResponseWritable,
    favorite_count: z.number().int(),
    introductions_facilitated_count: z.number().int(),
    introductions_requested_count: z.number().int(),
    recommendation_count: z.number().int(),
    rank: z.number()
});

/**
 * TrendingCandidatesPaginatedResponse
 */
export const zTrendingCandidatesPaginatedResponseWritable = z.object({
    page_count: z.number().int(),
    page: z.number().int(),
    results: z.array(zTrendingCandidateResponseWritable),
    size: z.number().int(),
    total_counts: zTotalCountsResponse
});

/**
 * TrendingMessageResponse
 *
 * A message an advisor wrote for one candidate's Trending campaigns.
 * Campaigns that sent the same body text count as one message.
 */
export const zTrendingMessageResponseWritable = z.object({
    advisor: zPersonBasicResponseWritable.nullish(),
    body: z.string(),
    last_used_on: z.string().datetime(),
    subject: z.string().nullish(),
    submission_uuid: z.string().uuid(),
    times_used: z.number().int()
});

/**
 * UserDetailedResponse
 *
 * Detailed user response including company and role information
 */
export const zUserDetailedResponseWritable = z.object({
    id: z.string().uuid(),
    uuid: z.string().uuid(),
    email: z.string().email(),
    first_name: z.string().nullish(),
    last_name: z.string().nullish(),
    full_name: z.string().nullish(),
    company: zCompanyExtendedResponse.nullish(),
    created: z.string().datetime(),
    first_login: z.string().datetime().nullish(),
    last_login: z.string().datetime().nullish(),
    active: z.boolean(),
    pending: z.boolean(),
    permit_preregistration_notifications: z.boolean(),
    notes_external: z.string().nullish(),
    notes_internal: z.string().nullish(),
    linkedin_url: z.string().nullish(),
    wants_intros: z.boolean().nullish(),
    wants_intro_followups: z.boolean().nullish(),
    handle_intros_as_exec: z.boolean().nullish(),
    teams_count: z.number().int(),
    teams: z.array(zUserTeamBasicResponse).optional().default([]),
    roles: z.array(zUserRoleResponse).optional().default([]),
    identity_uuid: z.string().uuid().nullish(),
    candidate_uuid: z.string().uuid().nullish(),
    candidate: zCandidateBasicResponseWritable.nullish(),
    user_type: zUserType,
    search_metadata: zEsMeta.nullish()
});

/**
 * UsersPostPage[UserDetailedResponse]
 */
export const zUsersPostPageUserDetailedResponseWritable = z.object({
    page_count: z.number().int().gte(0),
    page: z.number().int().gte(1),
    search_id: z.string().nullish(),
    results: z.array(zUserDetailedResponseWritable),
    size: z.number().int().gte(1),
    total_counts: zTotalCounts,
    aggregations: zUsersAggregationsResponse.nullish()
});

export const zGetVerifyEmailOneTimeCodeQuery = z.object({
    code: z.string()
});

/**
 * Successful Response
 */
export const zGetVerifyEmailOneTimeCodeResponse = zVerificationResponse;

export const zPostEmailResponseFeedbackQuery = z.object({
    code: z.string()
});

/**
 * Successful Response
 */
export const zPostEmailResponseFeedbackResponse = zFeedbackResponse;

/**
 * Successful Response
 */
export const zGetCountriesResponse = zCountriesResponse;

export const zPostTokenBody = zBodyPostToken;

/**
 * Successful Response
 */
export const zPostTokenResponse = zAccessToken;

export const zPosthogProxyPath = z.object({
    posthog_path: z.string()
});

export const zPosthogJsPath = z.object({
    filename: z.string()
});

export const zPostCandidatesFilterBody = zCandidateSearchData;

export const zPostCandidatesFilterQuery = z.object({
    page: z.number().int().gte(1).optional().default(1),
    size: z.number().int().gte(1).lte(1000).optional().default(10)
});

/**
 * Successful Response
 */
export const zPostCandidatesFilterResponse = zPageCandidatesTableResponse;

export const zGetCandidatesFindQuery = z.object({
    is_client: z.boolean().nullish(),
    is_referred: z.boolean().nullish(),
    include_inactive: z.boolean().optional().default(false),
    page: z.number().int().gte(1).optional().default(1),
    size: z.number().int().gte(1).lte(1000).optional().default(10),
    order: z.enum(['asc', 'desc']).optional().default('asc'),
    phrase: z.string().nullish(),
    row: z.string().nullish(),
    search_id: z.string().nullish(),
    search_by_name_only: z.boolean().optional().default(false)
});

/**
 * Successful Response
 */
export const zGetCandidatesFindResponse = zPageCandidateSearchResponseWithLinkedPerson;

export const zPostCandidatesPerformanceInRedBody = zCandidatePerformanceFilterSortPayload;

export const zPostCandidatesPerformanceInRedQuery = z.object({
    intro_check_type: zIntroCheckType
});

/**
 * Successful Response
 */
export const zPostCandidatesPerformanceInRedResponse = zCandidatesPerformancePaginatedResponse;

export const zPostCandidatesPerformanceFilterBody = zCandidatesCombinedPerformanceFilterSortPayload;

export const zPostCandidatesPerformanceFilterQuery = z.object({
    date_from: z.string().datetime().nullish(),
    date_to: z.string().datetime().nullish()
});

/**
 * Successful Response
 */
export const zPostCandidatesPerformanceFilterResponse = zCandidatesCombinedPerformancePaginatedResponse;

export const zGetCandidateCommentaryPath = z.object({
    candidate_uuid: z.string()
});

/**
 * Successful Response
 */
export const zGetCandidateCommentaryResponse = zCandidateCommentaryResponseSchema;

export const zPutCandidateCommentaryBody = zCandidateCommentary;

export const zPutCandidateCommentaryPath = z.object({
    candidate_uuid: z.string()
});

/**
 * Successful Response
 */
export const zPutCandidateCommentaryResponse = zCandidateCommentaryResponseSchema;

export const zPostCandidateHighlightsPath = z.object({
    candidate_uuid: z.string()
});

/**
 * Successful Response
 */
export const zPostCandidateHighlightsResponse = zHighlightGeneratorResponse;

export const zGetCandidateImagePath = z.object({
    candidate_uuid: z.string()
});

export const zGetCandidateImageQuery = z.object({
    size: z.number().int().nullish().default(128)
});

export const zGetCandidateIntroductionsTeamHistoryPath = z.object({
    candidate_uuid: z.string(),
    team_slug: z.string()
});

/**
 * Successful Response
 */
export const zGetCandidateIntroductionsTeamHistoryResponse = zRecommendationsHistoryResponse;

export const zGetCandidateIntroductionTemplatesPath = z.object({
    candidate_uuid: z.string()
});

/**
 * Response Get Candidate Introduction Templates
 *
 * Successful Response
 */
export const zGetCandidateIntroductionTemplatesResponse = z.array(zCandidateIntroductionTemplateResponse);

export const zGetCandidateOffLimitsCompaniesPath = z.object({
    candidate_uuid: z.string()
});

/**
 * Response Get Candidate Off Limits Companies
 *
 * Successful Response
 */
export const zGetCandidateOffLimitsCompaniesResponse = z.array(zOffLimitsCompanyResponseSchema);

/**
 * Payload
 */
export const zPutCandidateOffLimitsCompaniesBody = z.array(zCandidateOffLimitsCompany);

export const zPutCandidateOffLimitsCompaniesPath = z.object({
    candidate_uuid: z.string()
});

/**
 * Response Put Candidate Off Limits Companies
 *
 * Successful Response
 */
export const zPutCandidateOffLimitsCompaniesResponse = z.array(zOffLimitsCompanyResponseSchema);

export const zGetCandidateOffLimitsIdentitiesPath = z.object({
    candidate_uuid: z.string()
});

/**
 * Response Get Candidate Off Limits Identities
 *
 * Successful Response
 */
export const zGetCandidateOffLimitsIdentitiesResponse = z.array(zOffLimitsIdentityResponseSchema);

/**
 * Payload
 */
export const zPutCandidateOffLimitsIdentitiesBody = z.array(zCandidateOffLimitsIdentity);

export const zPutCandidateOffLimitsIdentitiesPath = z.object({
    candidate_uuid: z.string()
});

/**
 * Response Put Candidate Off Limits Identities
 *
 * Successful Response
 */
export const zPutCandidateOffLimitsIdentitiesResponse = z.array(zOffLimitsIdentityResponseSchema);

export const zGetCandidateRecommendationsPath = z.object({
    candidate_uuid: z.string()
});

export const zGetCandidateRecommendationsQuery = z.object({
    category: zRecommendationsFilter.nullish().default('all'),
    filter: zRecommendationsFilter.nullish().default('all'),
    sort: zRecommendationsSorter.nullish().default(''),
    page: z.number().int().gte(1).optional().default(1),
    size: z.number().int().gte(1).lte(1000).optional().default(10),
    order: z.enum(['asc', 'desc']).optional().default('asc'),
    phrase: z.string().nullish(),
    row: z.string().nullish(),
    search_id: z.string().nullish()
});

/**
 * Successful Response
 */
export const zGetCandidateRecommendationsResponse = zPageCandidateRecommendationResponse;

export const zGetCandidateRecommendationsCompareBackgroundPath = z.object({
    candidate_uuid: z.string()
});

export const zGetCandidateRecommendationsCompareBackgroundQuery = z.object({
    peer_uuid: z.string()
});

/**
 * Successful Response
 */
export const zGetCandidateRecommendationsCompareBackgroundResponse = zCandidatePeerBackgroundComparisonResponse;

export const zGetCandidateRecommendationsComparePerformancePath = z.object({
    candidate_uuid: z.string()
});

export const zGetCandidateRecommendationsComparePerformanceQuery = z.object({
    date_from: z.string().datetime().nullish(),
    date_to: z.string().datetime().nullish(),
    peer_uuid: z.string()
});

/**
 * Successful Response
 */
export const zGetCandidateRecommendationsComparePerformanceResponse = zCandidatePeerPerformanceComparisonResponse;

export const zGetCandidateRecommendationsCompareRecommendationsPath = z.object({
    candidate_uuid: z.string()
});

export const zGetCandidateRecommendationsCompareRecommendationsQuery = z.object({
    company_type: z.array(zOrgType).nullish(),
    filter_presets: zFilterPresets.nullish(),
    recommendation_type: zRecommendationType.nullish().default('trendings'),
    response_type: z.array(zResponseType).nullish(),
    date_from: z.string().datetime().nullish(),
    date_to: z.string().datetime().nullish(),
    peer_uuid: z.string()
});

/**
 * Successful Response
 */
export const zGetCandidateRecommendationsCompareRecommendationsResponse = zCandidatePeerRecommendationComparisonResponse;

export const zGetCandidateRecommendationsComparePipelinesPath = z.object({
    candidate_uuid: z.string()
});

export const zGetCandidateRecommendationsComparePipelinesQuery = z.object({
    company_type: z.array(zOrgType).nullish(),
    filter_presets: zFilterPresets.nullish(),
    response_type: z.array(zResponseType).nullish(),
    date_from: z.string().datetime().nullish(),
    date_to: z.string().datetime().nullish(),
    peer_uuid: z.string()
});

/**
 * Successful Response
 */
export const zGetCandidateRecommendationsComparePipelinesResponse = zCandidatePeerRecommendationComparisonResponse;

export const zGetCandidateResumePath = z.object({
    candidate_uuid: z.string()
});

/**
 * Successful Response
 */
export const zGetCandidateResumeResponse = zAdminResumeView;

export const zPatchCandidateBody = zCandidateUpdateActive;

export const zPatchCandidatePath = z.object({
    candidate_uuid: z.string()
});

export const zGetCompaniesQuery = z.object({
    filter: zCompaniesFilter.nullish().default('all'),
    type: z.array(zOrgType).nullish(),
    sort: zCompaniesSorter.nullish().default(''),
    page: z.number().int().gte(1).optional().default(1),
    size: z.number().int().gte(1).lte(1000).optional().default(10),
    order: z.enum(['asc', 'desc']).optional().default('asc'),
    phrase: z.string().nullish(),
    row: z.string().nullish(),
    search_id: z.string().nullish()
});

/**
 * Successful Response
 */
export const zGetCompaniesResponse = zPageCompanyTableResponse;

export const zPostCompaniesBody = zCompanyCreateV1;

/**
 * Successful Response
 */
export const zPostCompaniesResponse = zCustomerCompany;

export const zPutCompaniesBody = zCustomerCompany;

/**
 * Successful Response
 */
export const zPutCompaniesResponse = zCustomerCompany;

export const zGetCompanyByNameQuery = z.object({
    name: z.string(),
    case_insensitive: z.boolean().optional().default(false)
});

/**
 * Successful Response
 */
export const zGetCompanyByNameResponse = zCompanyExtendedResponseWithFeatures;

export const zGetCompaniesFindQuery = z.object({
    id: z.array(z.number().int()).nullish(),
    page: z.number().int().gte(1).optional().default(1),
    size: z.number().int().gte(1).lte(1000).optional().default(10),
    order: z.enum(['asc', 'desc']).optional().default('asc'),
    phrase: z.string().nullish(),
    row: z.string().nullish(),
    search_id: z.string().nullish()
});

/**
 * Successful Response
 */
export const zGetCompaniesFindResponse = zPageCompanyTableResponse;

export const zGetCompaniesSectorsQuery = z.object({
    industry: zIcbIndustry
});

/**
 * Response Get Companies Sectors
 *
 * Successful Response
 */
export const zGetCompaniesSectorsResponse = z.array(zCompanySector);

export const zDeleteCompanyPath = z.object({
    company_slug: z.string()
});

/**
 * Successful Response
 */
export const zDeleteCompanyResponse = zCompanyExtendedResponseWithFeatures;

export const zGetCompanyPath = z.object({
    company_slug: z.string()
});

/**
 * Successful Response
 */
export const zGetCompanyResponse = zCompanyExtendedResponseWithFeatures;

export const zPatchCompanyBody = zCompanyPatchPayload;

export const zPatchCompanyPath = z.object({
    company_slug: z.string()
});

/**
 * Successful Response
 */
export const zPatchCompanyResponse = zCompanyExtendedResponseWithFeatures;

export const zGetCompanyMembersPath = z.object({
    company_slug: z.string()
});

/**
 * Successful Response
 */
export const zGetCompanyMembersResponse = zCompanyDetailedResponse;

export const zGetContactsFindQuery = z.object({
    page: z.number().int().gte(1).optional().default(1),
    size: z.number().int().gte(1).lte(1000).optional().default(10),
    order: z.enum(['asc', 'desc']).optional().default('asc'),
    phrase: z.string().nullish(),
    row: z.string().nullish(),
    search_id: z.string().nullish()
});

/**
 * Successful Response
 */
export const zGetContactsFindResponse = zPageContactSearchResult;

export const zGetFilesImageQuery = z.object({
    name: z.string(),
    size: z.number().int()
});

export const zPostFilesImageBody = zBodyPostFilesImage;

/**
 * Successful Response
 */
export const zPostFilesImageResponse = zImageUploadResponse;

export const zPostFilesLinkedinResumeBody = zBodyPostFilesLinkedinResume;

/**
 * Successful Response
 */
export const zPostFilesLinkedinResumeResponse = zLinkedInResumeUploadResponseOutput;

export const zGetFindQuery = z.object({
    page: z.number().int().gte(1).optional().default(1),
    size: z.number().int().gte(1).lte(1000).optional().default(10),
    order: z.enum(['asc', 'desc']).optional().default('asc'),
    phrase: z.string().nullish(),
    row: z.string().nullish(),
    search_id: z.string().nullish()
});

/**
 * Successful Response
 */
export const zGetFindResponse = zPageGeneralSearchResponse;

export const zGetHomeTeamActivityPath = z.object({
    team_uuid: z.union([
        z.string().uuid(),
        z.string()
    ])
});

export const zGetHomeTeamActivityQuery = z.object({
    type: zHomeTeamActivityType,
    page: z.number().int().gte(1).optional().default(1),
    size: z.number().int().gte(1).lte(1000).optional().default(10)
});

/**
 * Successful Response
 */
export const zGetHomeTeamActivityResponse = zHomeTeamActivityResponse;

export const zGetHomeTeamCandidatesPath = z.object({
    team_uuid: z.union([
        z.string().uuid(),
        z.string()
    ])
});

/**
 * Successful Response
 */
export const zGetHomeTeamCandidatesResponse = zHomeCandidatesResponse;

export const zPostHomeTeamCandidateFeedbackBody = zHomeCandidateFeedbackActionPayload;

export const zPostHomeTeamCandidateFeedbackPath = z.object({
    candidate_uuid: z.string(),
    team_uuid: z.union([
        z.string().uuid(),
        z.string()
    ])
});

export const zPostHomeTeamCandidateFeedbackQuery = z.object({
    search_id: z.string().nullish()
});

export const zGetHomeTeamStatsPath = z.object({
    team_uuid: z.union([
        z.string().uuid(),
        z.string()
    ])
});

export const zGetHomeTeamStatsQuery = z.object({
    date_from: z.string().datetime().nullish(),
    date_to: z.string().datetime().nullish()
});

/**
 * Successful Response
 */
export const zGetHomeTeamStatsResponse = zTeamStatsResponse;

export const zPostHomeTeamViewsPath = z.object({
    team_uuid: z.union([
        z.string().uuid(),
        z.string()
    ])
});

export const zPostHomeTeamViewsQuery = z.object({
    type: zHomeTeamActivityType
});

export const zGetJobsFacilitatedIntroReminderQuery = z.object({
    test_mode: z.boolean().optional().default(false)
});

export const zGetJobsResendinviteQuery = z.object({
    older_than_days: z.number().int().nullish().default(14)
});

export const zGetJobsScheduledIntrosQuery = z.object({
    date: z.string().datetime().nullish()
});

/**
 * Response Get Jobs Scheduled Intros
 *
 * Successful Response
 */
export const zGetJobsScheduledIntrosResponse = z.boolean();

export const zGetJobsScheduledP2pIntrosQuery = z.object({
    date: z.string().datetime().nullish()
});

/**
 * Response Get Jobs Scheduled P2P Intros
 *
 * Successful Response
 */
export const zGetJobsScheduledP2pIntrosResponse = z.boolean();

/**
 * Response Get Jobs Auto Introductions
 *
 * Successful Response
 */
export const zGetJobsAutoIntroductionsResponse = z.record(z.string());

export const zGetJobsDraftStatusChangeEmailsQuery = z.object({
    minutes_lookback: z.number().int().optional().default(30)
});

/**
 * Response Get Jobs Draft Status Change Emails
 *
 * Successful Response
 */
export const zGetJobsDraftStatusChangeEmailsResponse = z.record(z.unknown());

export const zGetJobsLinkedinBatchSyncQuery = z.object({
    dry_run: z.boolean().optional().default(false),
    batch_size: z.number().int().gte(1).nullish()
});

/**
 * Successful Response
 */
export const zGetJobsLinkedinBatchSyncResponse = zLinkedInBatchSyncResponse;

export const zGetJobsHubspotFieldSyncQuery = z.object({
    dry_run: z.boolean().optional().default(false),
    batch_size: z.number().int().gte(1).nullish()
});

/**
 * Successful Response
 */
export const zGetJobsHubspotFieldSyncResponse = zHubSpotFieldSyncResponse;

export const zGetJobsMarketSearchResolveSweepQuery = z.object({
    limit: z.number().int().gte(1).optional().default(200),
    dry_run: z.boolean().optional().default(false)
});

/**
 * Successful Response
 */
export const zGetJobsMarketSearchResolveSweepResponse = zMarketSearchJobResponse;

export const zGetJobsMarketSearchClosureVerificationQuery = z.object({
    limit: z.number().int().gte(1).optional().default(200),
    dry_run: z.boolean().optional().default(false)
});

/**
 * Successful Response
 */
export const zGetJobsMarketSearchClosureVerificationResponse = zMarketSearchJobResponse;

export const zGetJobsMarketSearchClassificationCatchupQuery = z.object({
    limit: z.number().int().gte(1).optional().default(200),
    dry_run: z.boolean().optional().default(false)
});

/**
 * Successful Response
 */
export const zGetJobsMarketSearchClassificationCatchupResponse = zMarketSearchJobResponse;

export const zGetJobsRefreshTeamInsightsQuery = z.object({
    limit: z.number().int().gte(1).nullish()
});

/**
 * Successful Response
 */
export const zGetJobsRefreshTeamInsightsResponse = zRefreshTeamInsightsResponse;

export const zPostUtilsMailSendBody = zBodyPostUtilsMailSend;

/**
 * Response Post Utils Mail Send
 *
 * Successful Response
 */
export const zPostUtilsMailSendResponse = z.record(z.unknown());

export const zGetPeopleAdvisorsQuery = z.object({
    page: z.number().int().gte(1).optional().default(1),
    size: z.number().int().gte(1).lte(1000).optional().default(10)
});

/**
 * Successful Response
 */
export const zGetPeopleAdvisorsResponse = zPagePersonBasicEmailResponse;

/**
 * Successful Response
 */
export const zGetPeopleCurrentResponse = zPersonV1CurrentResponse;

/**
 * Response Get People Current Teams
 *
 * Successful Response
 */
export const zGetPeopleCurrentTeamsResponse = z.array(zTeamExtendedResponse);

export const zGetPeopleFindQuery = z.object({
    users_only: z.boolean().nullish().default(false),
    page: z.number().int().gte(1).optional().default(1),
    size: z.number().int().gte(1).lte(1000).optional().default(10),
    order: z.enum(['asc', 'desc']).optional().default('asc'),
    phrase: z.string().nullish(),
    row: z.string().nullish(),
    search_id: z.string().nullish()
});

/**
 * Successful Response
 */
export const zGetPeopleFindResponse = zPagePersonSearchResponse;

export const zDeletePersonImagePath = z.object({
    person_uuid: z.string()
});

export const zGetPersonImagePath = z.object({
    person_uuid: z.string()
});

export const zGetPersonImageQuery = z.object({
    size: z.number().int().nullish().default(128)
});

export const zPostPersonImageBody = zBodyPostPersonImage;

export const zPostPersonImagePath = z.object({
    person_uuid: z.string()
});

/**
 * Successful Response
 */
export const zPostPersonImageResponse = zImageUploadResponse;

export const zPutPersonPasswordBody = zPersonClerkPasswordPut;

export const zPutPersonPasswordPath = z.object({
    person_uuid: z.string()
});

/**
 * Successful Response
 */
export const zPutPersonPasswordResponse = zPersonPasswordUpdatedResponse;

export const zGetPipelinesFindQuery = z.object({
    company_id: z.number().int().nullish(),
    page: z.number().int().gte(1).optional().default(1),
    size: z.number().int().gte(1).lte(1000).optional().default(10),
    order: z.enum(['asc', 'desc']).optional().default('asc'),
    phrase: z.string().nullish(),
    row: z.string().nullish(),
    search_id: z.string().nullish()
});

/**
 * Successful Response
 */
export const zGetPipelinesFindResponse = zPagePipelineSearchResponse;

export const zDeleteAPipelinePath = z.object({
    pipeline_slug: z.string()
});

/**
 * Successful Response
 */
export const zDeleteAPipelineResponse = zDeleteTeamEntityResponse;

export const zGetRecommendationsFindQuery = z.object({
    company_id: z.number().int().nullish(),
    candidate_uuid: z.string().uuid(),
    person_id: z.string().uuid().nullish(),
    type: zIntroductionType.nullish(),
    page: z.number().int().gte(1).optional().default(1),
    size: z.number().int().gte(1).lte(1000).optional().default(10),
    order: z.enum(['asc', 'desc']).optional().default('asc'),
    phrase: z.string().nullish(),
    row: z.string().nullish(),
    search_id: z.string().nullish()
});

/**
 * Successful Response
 */
export const zGetRecommendationsFindResponse = zPageEsRecommendationCandidateIndexResult;

export const zGetV1RecommendationPath = z.object({
    recommendation_uuid: z.string().uuid()
});

/**
 * Successful Response
 */
export const zGetV1RecommendationResponse = zRecommendationExternalFullResponse;

export const zGetV1RecommendationPreviewPath = z.object({
    recommendation_uuid: z.string()
});

export const zGetV1RecommendationPreviewQuery = z.object({
    token: z.string()
});

/**
 * Successful Response
 */
export const zGetV1RecommendationPreviewResponse = zRecommendationPreviewResponse;

export const zPostRecommendationOffLimitsBody = zRecommendationOffLimits;

export const zPostRecommendationOffLimitsPath = z.object({
    candidate_uuid: z.string()
});

/**
 * Response Post Recommendation Off Limits
 *
 * Successful Response
 */
export const zPostRecommendationOffLimitsResponse = z.array(zOffLimitsTeamSchema);

export const zPutRecommendationStatusBody = zRecommendationStatusInput;

export const zPutRecommendationStatusPath = z.object({
    submission_candidate_uuid: z.string()
});

export const zPostShareRecommendationsBody = zShareRecommendations;

/**
 * Successful Response
 */
export const zPostShareRecommendationsResponse = zShareRecommendationsResponse;

export const zPostTeamsBody = zTeamCreate;

/**
 * Successful Response
 */
export const zPostTeamsResponse = zTeamExtendedResponse;

export const zGetTeamsFindQuery = z.object({
    company_slug: z.string().nullish(),
    person_id: z.string().uuid().nullish(),
    page: z.number().int().gte(1).optional().default(1),
    size: z.number().int().gte(1).lte(1000).optional().default(10),
    order: z.enum(['asc', 'desc']).optional().default('asc'),
    phrase: z.string().nullish(),
    row: z.string().nullish(),
    search_id: z.string().nullish()
});

/**
 * Successful Response
 */
export const zGetTeamsFindResponse = zPageTeamSearchResponse;

export const zDeleteTeamPath = z.object({
    team_slug: z.string()
});

export const zGetTeamPath = z.object({
    team_slug: z.string()
});

/**
 * Successful Response
 */
export const zGetTeamResponse = zTeamExtendedResponse;

export const zPatchTeamBody = zTeamUpdate;

export const zPatchTeamPath = z.object({
    team_slug: z.string()
});

/**
 * Successful Response
 */
export const zPatchTeamResponse = zTeamSearchResponse;

export const zGetTeamMembersPath = z.object({
    team_slug: z.string()
});

export const zGetTeamMembersQuery = z.object({
    team_uuids: z.array(z.string().uuid()).nullish().default([])
});

/**
 * Response Get Team Members
 *
 * Successful Response
 */
export const zGetTeamMembersResponse = z.array(zPersonMemberResponse);

export const zDeleteTeamMemberPath = z.object({
    team_slug: z.string(),
    person_uuid: z.string()
});

/**
 * Successful Response
 */
export const zDeleteTeamMemberResponse = zPersonBasicResponse;

export const zGetTeamPipelinesPath = z.object({
    team_slug: z.string()
});

export const zGetTeamPipelinesQuery = z.object({
    filter: z.array(zTeamPipelinesFilter).optional().default(['all']),
    pipeline_type: z.array(zPipelineTypeFilter).optional().default([]),
    team_uuids: z.array(z.string().uuid()).nullish().default([]),
    sort: zTeamPipelinesSorter.nullish().default(''),
    page: z.number().int().gte(1).optional().default(1),
    size: z.number().int().gte(1).lte(1000).optional().default(10),
    order: z.enum(['asc', 'desc']).optional().default('asc'),
    phrase: z.string().nullish(),
    row: z.string().nullish(),
    search_id: z.string().nullish()
});

/**
 * Successful Response
 */
export const zGetTeamPipelinesResponse = zPageTeamPipelinesTableResponse;

export const zPatchTeamPipelineBody = zPipelineActive;

export const zPatchTeamPipelinePath = z.object({
    team_slug: z.string(),
    pipeline_slug: z.string()
});

/**
 * Successful Response
 */
export const zPatchTeamPipelineResponse = zPipelineBasicResponse;

export const zGetTeamPipelineRecommendationBioPath = z.object({
    candidate_uuid: z.string(),
    pipeline_slug: z.string(),
    team_slug: z.string()
});

/**
 * Successful Response
 */
export const zGetTeamPipelineRecommendationBioResponse = zRecommendationBioResponse;

export const zGetTeamPipelineRecommendationChecksSharedPath = z.object({
    candidate_uuid: z.string(),
    team_slug: z.string(),
    pipeline_slug: z.string()
});

/**
 * Response Get Team Pipeline Recommendation Checks Shared
 *
 * Successful Response
 */
export const zGetTeamPipelineRecommendationChecksSharedResponse = z.array(zSubmissionCheckSharedResponse);

export const zGetTeamPipelineRecommendationIntroductionPath = z.object({
    candidate_uuid: z.string(),
    pipeline_slug: z.string(),
    team_slug: z.string()
});

/**
 * Successful Response
 */
export const zGetTeamPipelineRecommendationIntroductionResponse = zRecommendationIntroductionResponse;

export const zPostTeamPipelineRecommendationIntroductionBody = zRecommendationIntroduction;

export const zPostTeamPipelineRecommendationIntroductionPath = z.object({
    candidate_uuid: z.string(),
    pipeline_slug: z.string(),
    team_slug: z.string()
});

export const zGetTeamRecommendationBioPath = z.object({
    candidate_uuid: z.string(),
    team_slug: z.string()
});

/**
 * Successful Response
 */
export const zGetTeamRecommendationBioResponse = zRecommendationBioResponse;

export const zGetTeamRecommendationIntroductionPath = z.object({
    candidate_uuid: z.string(),
    team_slug: z.string()
});

/**
 * Successful Response
 */
export const zGetTeamRecommendationIntroductionResponse = zRecommendationIntroductionResponse;

export const zPostTeamRecommendationIntroductionBody = zRecommendationIntroduction;

export const zPostTeamRecommendationIntroductionPath = z.object({
    candidate_uuid: z.string(),
    team_slug: z.string()
});

export const zPostTrendingScheduleBody = zTrendingSchedulePayload;

/**
 * Successful Response
 */
export const zPostTrendingScheduleResponse = zTrendingScheduleResponse;

/**
 * Successful Response
 */
export const zPostClerkWebhookResponse = z.void();

export const zPostWebhooksEsEventsBody = zEsClickEventPayload;

export const zPostCandidatesImportFromCsvBody = zBodyPostCandidatesImportFromCsv;

export const zPostCandidatesImportFromCsvQuery = z.object({
    skip_linkedin_sync: z.boolean().optional().default(false)
});

/**
 * Successful Response
 */
export const zPostCandidatesImportFromCsvResponse = zCandidateAsyncImportResponse;

export const zPostCandidatesExportFailedBody = zFailedCandidatesImportRequest;

export const zPostEsReindexQuery = z.object({
    index: zSearchIndex
});

/**
 * Successful Response
 */
export const zPostEsReindexResponse = zReindexAsyncResponse;

export const zGetReindexStatusPath = z.object({
    task_id: z.string()
});

/**
 * Successful Response
 */
export const zGetReindexStatusResponse = zReindexStatusResponse;

export const zGetEsIndexQuery = z.object({
    index: zSearchIndex
});

/**
 * Successful Response
 */
export const zGetEsIndexResponse = zCurrentEsIndexResponse;

export const zPatchAliasToEsIndexQuery = z.object({
    index_name: z.string(),
    index: zSearchIndex
});

/**
 * Successful Response
 */
export const zPatchAliasToEsIndexResponse = zIndexAliasUpdateResponse;

export const zCreateMarketSearchBody = zMarketSearchCreatePayload;

/**
 * Successful Response
 */
export const zCreateMarketSearchResponse = zMarketSearchCreateResponse;

export const zLinkMarketSearchBody = zMarketSearchLinkPayload;

export const zLinkMarketSearchPath = z.object({
    market_search_uuid: z.string().uuid()
});

/**
 * Successful Response
 */
export const zLinkMarketSearchResponse = zMarketSearchResponse;

export const zCloseMarketSearchBody = zMarketSearchClosePayload;

export const zCloseMarketSearchPath = z.object({
    market_search_uuid: z.string().uuid()
});

/**
 * Successful Response
 */
export const zCloseMarketSearchResponse = zMarketSearchResponse;

export const zSearchMarketSearchesBody = zMarketSearchSearchPayload;

export const zSearchMarketSearchesQuery = z.object({
    page: z.number().int().gte(1).optional().default(1),
    size: z.number().int().gte(1).lte(1000).optional().default(10)
});

/**
 * Successful Response
 */
export const zSearchMarketSearchesResponse = zPostPageMarketSearchRowResponse;

export const zGetMarketSearchContactOptionsQuery = z.object({
    phrase: z.string().nullish(),
    company_id: z.number().int().nullish(),
    search_team_id: z.number().int().nullish(),
    limit: z.number().int().gte(1).lte(100).optional().default(50)
});

/**
 * Response Get Market Search Contact Options
 *
 * Successful Response
 */
export const zGetMarketSearchContactOptionsResponse = z.array(zMarketSearchContactOption);

export const zGetMarketSearchTeamOptionsQuery = z.object({
    phrase: z.string().nullish(),
    company_id: z.number().int().nullish(),
    limit: z.number().int().gte(1).lte(100).optional().default(50)
});

/**
 * Response Get Market Search Team Options
 *
 * Successful Response
 */
export const zGetMarketSearchTeamOptionsResponse = z.array(zMarketSearchTeamOption);

export const zGetMarketSearchPipelineOptionsQuery = z.object({
    phrase: z.string().nullish(),
    company_id: z.number().int().nullish(),
    limit: z.number().int().gte(1).lte(100).optional().default(50)
});

/**
 * Response Get Market Search Pipeline Options
 *
 * Successful Response
 */
export const zGetMarketSearchPipelineOptionsResponse = z.array(zMarketSearchPipelineOption);

export const zDeleteMarketSearchPath = z.object({
    market_search_uuid: z.string().uuid()
});

/**
 * Successful Response
 */
export const zDeleteMarketSearchResponse = z.void();

export const zGetMarketSearchPath = z.object({
    market_search_uuid: z.string().uuid()
});

/**
 * Successful Response
 */
export const zGetMarketSearchResponse = zMarketSearchDetailResponse;

export const zUpdateMarketSearchBody = zMarketSearchUpdatePayload;

export const zUpdateMarketSearchPath = z.object({
    market_search_uuid: z.string().uuid()
});

/**
 * Successful Response
 */
export const zUpdateMarketSearchResponse = zMarketSearchUpdateResponse;

export const zPostCandidatesBody = zCreateCandidate;

/**
 * Successful Response
 */
export const zPostCandidatesResponse = zCandidateInternalFullResponse;

export const zGetCandidateV2Path = z.object({
    candidate_uuid: z.string()
});

/**
 * Successful Response
 */
export const zGetCandidateV2Response = zCandidateInternalFullResponseWithLinkedPerson;

export const zPatchCandidateV2Body = zUpdateCandidate;

export const zPatchCandidateV2Path = z.object({
    candidate_uuid: z.string()
});

/**
 * Successful Response
 */
export const zPatchCandidateV2Response = zCandidateInternalFullResponse;

export const zPutCandidateBody = zCreateCandidate;

export const zPutCandidatePath = z.object({
    candidate_uuid: z.string()
});

/**
 * Successful Response
 */
export const zPutCandidateResponse = zCandidateInternalFullResponse;

export const zDeleteCandidateReferrerPath = z.object({
    identity_uuid: z.string().uuid(),
    candidate_uuid: z.string()
});

/**
 * Successful Response
 */
export const zDeleteCandidateReferrerResponse = z.void();

export const zPutCandidateReferrerPath = z.object({
    identity_uuid: z.string().uuid(),
    candidate_uuid: z.string()
});

/**
 * Successful Response
 */
export const zPutCandidateReferrerResponse = zReferrerBasicResponse;

export const zDeleteCandidateFavoritePath = z.object({
    candidate_uuid: z.string()
});

/**
 * Successful Response
 */
export const zDeleteCandidateFavoriteResponse = zCandidateFavoriteResponse;

export const zPostCandidateFavoritePath = z.object({
    candidate_uuid: z.string()
});

/**
 * Successful Response
 */
export const zPostCandidateFavoriteResponse = zCandidateFavoriteResponse;

export const zGetCandidateGoalsPath = z.object({
    candidate_uuid: z.string()
});

/**
 * Successful Response
 */
export const zGetCandidateGoalsResponse = zCandidateGoalResponse;

export const zPatchCandidateGoalsBody = zCandidateGoalsLegacyPayload;

export const zPatchCandidateGoalsPath = z.object({
    candidate_uuid: z.string()
});

/**
 * Successful Response
 */
export const zPatchCandidateGoalsResponse = zCandidateInternalFullResponse;

export const zGetCandidateGoalsWithActivitiesPath = z.object({
    candidate_uuid: z.string()
});

export const zGetCandidateGoalsWithActivitiesQuery = z.object({
    goal_status: z.array(zGoalStatusFilter).optional().default(['all'])
});

/**
 * Successful Response
 */
export const zGetCandidateGoalsWithActivitiesResponse = zCandidateGoalsResponse;

export const zPostCandidatesGoalsV2Body = zCandidateGoalsPayload;

export const zPostCandidatesGoalsV2Path = z.object({
    candidate_uuid: z.string()
});

/**
 * Successful Response
 */
export const zPostCandidatesGoalsV2Response = zCandidateGoalsResponse;

export const zPostCandidateShowOnboardingSectionBody = zCandidateShowOnboardingSection;

export const zPostCandidateShowOnboardingSectionPath = z.object({
    candidate_uuid: z.string()
});

export const zPostCandidateFeedbackV2Body = zCandidateFeedbackPayload;

export const zPostCandidateFeedbackV2Path = z.object({
    candidate_uuid: z.string()
});

/**
 * Successful Response
 */
export const zPostCandidateFeedbackV2Response = zCandidateFeedbackResult;

export const zPostCandidateFeedbackFilterBody = zCandidateFeedbackFilterPayload;

export const zPostCandidateFeedbackFilterPath = z.object({
    candidate_uuid: z.string()
});

/**
 * Successful Response
 */
export const zPostCandidateFeedbackFilterResponse = zCandidateFeedbackFilterResponse;

export const zDeleteCandidateFeedbackPath = z.object({
    feedback_uuid: z.string().uuid(),
    candidate_uuid: z.string()
});

/**
 * Successful Response
 */
export const zDeleteCandidateFeedbackResponse = zCandidateFeedbackResult;

export const zPutCandidateFeedbackBody = zCandidateFeedbackPayload;

export const zPutCandidateFeedbackPath = z.object({
    feedback_uuid: z.string().uuid(),
    candidate_uuid: z.string()
});

/**
 * Successful Response
 */
export const zPutCandidateFeedbackResponse = zCandidateFeedbackResult;

export const zDeleteCandidateGoalPath = z.object({
    candidate_uuid: z.string(),
    goal_id: z.string()
});

/**
 * Successful Response
 */
export const zDeleteCandidateGoalResponse = zCandidateGoal;

export const zGetCandidateGoalV2Path = z.object({
    candidate_uuid: z.string(),
    goal_id: z.string()
});

/**
 * Successful Response
 */
export const zGetCandidateGoalV2Response = zCandidateGoal;

export const zPatchCandidateGoalV2Body = zCandidateGoalsPatchPayload;

export const zPatchCandidateGoalV2Path = z.object({
    candidate_uuid: z.string(),
    goal_id: z.string()
});

/**
 * Successful Response
 */
export const zPatchCandidateGoalV2Response = zCandidateGoal;

export const zDeleteCandidateGoalActivityBody = zCandidateGoalActivitiesPayload;

export const zDeleteCandidateGoalActivityPath = z.object({
    candidate_uuid: z.string(),
    goal_id: z.string()
});

/**
 * Successful Response
 */
export const zDeleteCandidateGoalActivityResponse = zCandidateGoal;

export const zPostCandidateGoalActivityBody = zCandidateGoalActivitiesPayload;

export const zPostCandidateGoalActivityPath = z.object({
    candidate_uuid: z.string(),
    goal_id: z.string()
});

/**
 * Successful Response
 */
export const zPostCandidateGoalActivityResponse = zCandidateGoal;

export const zPostCandidateGoalTasksBody = zTaskCreateUpdateManyPayload;

export const zPostCandidateGoalTasksPath = z.object({
    candidate_uuid: z.string(),
    goal_id: z.string()
});

/**
 * Successful Response
 */
export const zPostCandidateGoalTasksResponse = zCandidateGoal;

export const zPostCandidateRecommendationsFilterBody = zCandidateRecommendationsFilterPayload;

export const zPostCandidateRecommendationsFilterPath = z.object({
    candidate_uuid: z.string()
});

/**
 * Successful Response
 */
export const zPostCandidateRecommendationsFilterResponse = zCandidateRecommendationsFilterResponse;

export const zPostCandidateIntroTemplatesBody = zCandidateIntroductionTemplateCreate;

export const zPostCandidateIntroTemplatesPath = z.object({
    candidate_uuid: z.string()
});

/**
 * Introduction template with uuid if successfully created
 */
export const zPostCandidateIntroTemplatesResponse = zCandidateIntroductionTemplateResponse;

export const zPostCandidateHighlightsV2Body = zCandidateHighlightCreate;

export const zPostCandidateHighlightsV2Path = z.object({
    candidate_uuid: z.string()
});

/**
 * Highlight with uuid if successfully created
 */
export const zPostCandidateHighlightsV2Response = zHighlightResponse;

export const zGetCandidateStatsPath = z.object({
    candidate_uuid: z.string()
});

export const zGetCandidateStatsQuery = z.object({
    date_from: z.string().datetime().nullish(),
    date_to: z.string().datetime().nullish(),
    type: zTypeFilter
});

/**
 * Response Get Candidate Stats
 *
 * Successful Response
 */
export const zGetCandidateStatsResponse = z.union([
    zCandidateRecommendationsStatsRoleResponse,
    zCandidateRecommendationsStatsSubmissionResponse,
    zCandidateRecommendationsStatsTeamResponse
]);

export const zGetRecsysCandidateOpportunitiesPath = z.object({
    candidate_uuid: z.string()
});

export const zGetRecsysCandidateOpportunitiesQuery = z.object({
    limit: z.number().int().gte(1).lte(100).optional().default(10),
    offset: z.number().int().gte(0).optional().default(0)
});

/**
 * Successful Response
 */
export const zGetRecsysCandidateOpportunitiesResponse = zRecsysCandidateOpportunitiesResponse;

export const zGetRecsysOpportunityRationalePath = z.object({
    pipeline_uuid: z.string().uuid(),
    candidate_uuid: z.string()
});

/**
 * Successful Response
 */
export const zGetRecsysOpportunityRationaleResponse = zRecsysOpportunityRationaleResponse;

export const zPostRecsysOpportunityReviewedBody = zRecsysOpportunityReviewPayload;

export const zPostRecsysOpportunityReviewedPath = z.object({
    pipeline_uuid: z.string().uuid(),
    candidate_uuid: z.string()
});

/**
 * Successful Response
 */
export const zPostRecsysOpportunityReviewedResponse = z.void();

export const zPostRecsysOpportunityBadMatchBody = zRecsysOpportunityBadMatchPayload;

export const zPostRecsysOpportunityBadMatchPath = z.object({
    pipeline_uuid: z.string().uuid(),
    candidate_uuid: z.string()
});

/**
 * Successful Response
 */
export const zPostRecsysOpportunityBadMatchResponse = z.void();

export const zPostCandidatesTrendingFilterBody = zTrendingCandidateFilterSortPayload;

/**
 * Successful Response
 */
export const zPostCandidatesTrendingFilterResponse = zTrendingCandidatesPaginatedResponse;

export const zPostCompaniesSearchV2Body = zCompaniesSearchFilterSortPayload.default({
    page: 1,
    page_size: -1,
    sort_rules: []
});

export const zPostCompaniesSearchV2Query = z.object({
    page: z.number().int().gte(1).optional().default(1),
    size: z.number().int().gte(1).lte(1000).optional().default(10)
});

/**
 * Successful Response
 */
export const zPostCompaniesSearchV2Response = zPostPageCompanyDetailedResponse;

export const zPostCompanyTeamsBody = zCompanyTeamCreate;

export const zPostCompanyTeamsPath = z.object({
    company_slug: z.string()
});

/**
 * Successful Response
 */
export const zPostCompanyTeamsResponse = zTeamExtendedResponse;

export const zDeleteCommentPath = z.object({
    comment_uuid: z.string().uuid()
});

/**
 * Successful Response
 */
export const zDeleteCommentResponse = zCommentResponse;

export const zPutCommentBody = zCommentPayload;

export const zPutCommentPath = z.object({
    comment_uuid: z.string().uuid()
});

/**
 * Successful Response
 */
export const zPutCommentResponse = zCommentResponse;

export const zDeleteInternalCommentPath = z.object({
    comment_uuid: z.string().uuid()
});

/**
 * Successful Response
 */
export const zDeleteInternalCommentResponse = zInternalCommentResponse;

export const zPutInternalCommentBody = zCommentPayload;

export const zPutInternalCommentPath = z.object({
    comment_uuid: z.string().uuid()
});

/**
 * Successful Response
 */
export const zPutInternalCommentResponse = zInternalCommentResponse;

export const zPutEvaluationHistoryIntroductionBody = zIntroductionSubjectPayload;

export const zPutEvaluationHistoryIntroductionPath = z.object({
    evaluation_history_uuid: z.string().uuid()
});

/**
 * Response Put Evaluation History Introduction
 *
 * Successful Response
 */
export const zPutEvaluationHistoryIntroductionResponse = z.record(z.unknown());

export const zRevertEvaluationHistoryPath = z.object({
    evaluation_history_uuid: z.string().uuid()
});

/**
 * Response Revert Evaluation History
 *
 * Successful Response
 */
export const zRevertEvaluationHistoryResponse = z.record(z.unknown());

export const zDeleteHighlightPath = z.object({
    highlight_uuid: z.string()
});

/**
 * Successful Response
 */
export const zDeleteHighlightResponse2 = zDeleteHighlightResponse;

export const zPutHighlightBody = zCandidateHighlightCreate;

export const zPutHighlightPath = z.object({
    highlight_uuid: z.string()
});

/**
 * Successful Response
 */
export const zPutHighlightResponse2 = zPutHighlightResponse;

export const zDeleteIntroductionTemplatePath = z.object({
    template_uuid: z.string()
});

/**
 * Successful Response
 */
export const zDeleteIntroductionTemplateResponse = zCandidateIntroductionTemplateResponse;

export const zPutIntroductionTemplateBody = zPutIntroductionTemplatePayload;

export const zPutIntroductionTemplatePath = z.object({
    template_uuid: z.string()
});

/**
 * Successful Response
 */
export const zPutIntroductionTemplateResponse = zCandidateIntroductionTemplateResponse;

/**
 * Body
 */
export const zPostLinkedinSyncCandidateBody = zLinkedInSyncRequest.nullable();

export const zPostLinkedinSyncCandidatePath = z.object({
    candidate_id: z.union([
        z.number().int(),
        z.string().uuid()
    ])
});

export const zPostLinkedinSyncCandidateResponse = z.union([
    zLinkedInResumeUploadResponseOutput,
    z.void()
]);

export const zPostLinkedinPreviewBody = zLinkedInPreviewRequest;

/**
 * Successful Response
 */
export const zPostLinkedinPreviewResponse = zLinkedInPreviewResponse;

export const zPostAutotagPreviewBody = zAutotagPreviewRequest;

/**
 * Successful Response
 */
export const zPostAutotagPreviewResponse = zAutotagPreviewQueued;

export const zGetAutotagPreviewStatusPath = z.object({
    task_id: z.string()
});

/**
 * Successful Response
 */
export const zGetAutotagPreviewStatusResponse = zAutotagPreviewStatus;

export const zPostPipelinesFilterBody = zPipelinesSearchData;

/**
 * Successful Response
 */
export const zPostPipelinesFilterResponse = zPaginatedPipelinesTableResponse;

export const zPutMultipleRecommendationDraftsBody = zUpdateMultipleRecommendationDraftPayload;

/**
 * Response Put Multiple Recommendation Drafts
 *
 * Successful Response
 */
export const zPutMultipleRecommendationDraftsResponse = z.array(zRecommendationExternalFullResponse);

export const zDeleteRecommendationPath = z.object({
    recommendation_uuid: z.string().uuid()
});

/**
 * Successful Response
 */
export const zDeleteRecommendationResponse = zRecommendationExternalFullResponse;

export const zGetRecommendationPath = z.object({
    recommendation_uuid: z.string().uuid()
});

/**
 * Successful Response
 */
export const zGetRecommendationResponse = zRecommendationExternalFullResponse;

export const zPutRecommendationCommentaryBody = zRecommendationCommentaryPayload;

export const zPutRecommendationCommentaryPath = z.object({
    recommendation_uuid: z.string().uuid()
});

/**
 * Successful Response
 */
export const zPutRecommendationCommentaryResponse = zRecommendationExternalFullResponse;

export const zPutRecommendationStatusV2Body = zIntroductionStatusPayload;

export const zPutRecommendationStatusV2Path = z.object({
    recommendation_uuid: z.string().uuid()
});

/**
 * Successful Response
 */
export const zPutRecommendationStatusV2Response = zRecommendationExternalFullResponse;

export const zDeleteRecommendationAssigneePath = z.object({
    recommendation_uuid: z.string().uuid()
});

/**
 * Successful Response
 */
export const zDeleteRecommendationAssigneeResponse = zRecommendationExternalFullResponse;

export const zPostRecsysRecommendationsBody = zRecsysSuggestedRecommendations;

/**
 * Successful Response
 */
export const zPostRecsysRecommendationsResponse = zRecsysSuggestedRecommendationsResponse;

export const zPostRecsysCandidateContextBody = zRecsysCandidateContextRequest;

/**
 * Successful Response
 */
export const zPostRecsysCandidateContextResponse = zRecsysCandidateContextResponse;

/**
 * Successful Response
 */
export const zGetRecsysAssigneesResponse = zRecsysAssigneesResponse;

export const zPostSubmissionsFilterBody = zSubmissionSearchFilterSortPayload;

/**
 * Successful Response
 */
export const zPostSubmissionsFilterResponse = zSubmissionsSearchFilterSortPaginatedResponse;

export const zPostSubmissionFilterBody = zSubmissionFilterPayload;

export const zPostSubmissionFilterPath = z.object({
    submission_uuid: z.string().uuid()
});

/**
 * Successful Response
 */
export const zPostSubmissionFilterResponse = zSubmissionFilterResponse;

export const zPostTeamsV2Body = zTeamAndCompanyCreate;

/**
 * Successful Response
 */
export const zPostTeamsV2Response = zTeamExtendedResponse;

export const zPutTeamBody = zTeamUpdateV2;

export const zPutTeamPath = z.object({
    team_uuid: z.union([
        z.string().uuid(),
        z.string()
    ])
});

/**
 * Successful Response
 */
export const zPutTeamResponse = zTeamExtendedResponse;

export const zPostTeamsFilterBody = zTeamsSearchFilterPayload;

/**
 * Successful Response
 */
export const zPostTeamsFilterResponse = zTeamsSearchFilterPaginatedResponse;

export const zPostTeamsSuggestedBody = zTeamsSuggestedPayload;

/**
 * Successful Response
 */
export const zPostTeamsSuggestedResponse = zTeamsSuggestedResponse;

export const zPostTeamTeamsBody = zTeamCreateV2;

export const zPostTeamTeamsPath = z.object({
    team_uuid: z.union([
        z.string().uuid(),
        z.string()
    ])
});

/**
 * Successful Response
 */
export const zPostTeamTeamsResponse = zTeamExtendedResponse;

export const zGetTeamCandidatePath = z.object({
    candidate_uuid: z.string(),
    team_uuid: z.union([
        z.string().uuid(),
        z.string()
    ])
});

/**
 * Successful Response
 */
export const zGetTeamCandidateResponse = zCandidateExternalFullResponseWithTeamContext;

export const zGetTeamCandidateActivityPath = z.object({
    candidate_uuid: z.string(),
    team_uuid: z.union([
        z.string().uuid(),
        z.string()
    ])
});

export const zGetTeamCandidateActivityQuery = z.object({
    team_uuids: z.array(z.string().uuid()).nullish().default([]),
    page: z.number().int().gte(1).optional().default(1),
    size: z.number().int().gte(1).lte(1000).optional().default(10)
});

/**
 * Successful Response
 */
export const zGetTeamCandidateActivityResponse = zPageCandidateActivityEvent;

export const zPostTeamCandidateFavoriteBody = zCandidateFavoritePayload;

export const zPostTeamCandidateFavoritePath = z.object({
    candidate_uuid: z.string(),
    team_uuid: z.union([
        z.string().uuid(),
        z.string()
    ])
});

/**
 * Successful Response
 */
export const zPostTeamCandidateFavoriteResponse = zCandidateExternalResponse;

export const zPostTeamCandidatePipelinesBody = zTeamCandidatePipelinesPayload;

export const zPostTeamCandidatePipelinesPath = z.object({
    candidate_uuid: z.string(),
    team_uuid: z.union([
        z.string().uuid(),
        z.string()
    ])
});

/**
 * Successful Response
 */
export const zPostTeamCandidatePipelinesResponse = zSubmissionCandidatePipelinesResponse;

export const zGetTeamCandidateRecommendationsPath = z.object({
    candidate_uuid: z.string(),
    team_uuid: z.union([
        z.string().uuid(),
        z.string()
    ])
});

export const zGetTeamCandidateRecommendationsQuery = z.object({
    team_uuids: z.array(z.string().uuid()).nullish().default([])
});

/**
 * Response Get Team Candidate Recommendations
 *
 * Successful Response
 */
export const zGetTeamCandidateRecommendationsResponse = z.array(zRecommendationPipelinesResponse);

export const zPostTeamCandidateStatusBody = zIntroductionStatusPayload;

export const zPostTeamCandidateStatusPath = z.object({
    candidate_uuid: z.string(),
    team_uuid: z.union([
        z.string().uuid(),
        z.string()
    ])
});

/**
 * Successful Response
 */
export const zPostTeamCandidateStatusResponse = zActivityEventResponse;

export const zPutTeamCandidateStatusBody = zIntroductionStatusPayload;

export const zPutTeamCandidateStatusPath = z.object({
    candidate_uuid: z.string(),
    team_uuid: z.union([
        z.string().uuid(),
        z.string()
    ])
});

/**
 * Successful Response
 */
export const zPutTeamCandidateStatusResponse = zActivityEventResponse;

/**
 * Payload
 */
export const zPostTeamCandidateViewsBody = zCandidateViewPayload.nullable();

export const zPostTeamCandidateViewsPath = z.object({
    candidate_uuid: z.string(),
    team_uuid: z.union([
        z.string().uuid(),
        z.string()
    ])
});

export const zGetTeamContactCommentsPath = z.object({
    identity_uuid: z.string().uuid(),
    team_uuid: z.union([
        z.string().uuid(),
        z.string()
    ])
});

/**
 * Response Get Team Contact Comments
 *
 * Successful Response
 */
export const zGetTeamContactCommentsResponse = z.array(zCommentResponse);

export const zPostTeamContactCommentBody = zCommentPayload;

export const zPostTeamContactCommentPath = z.object({
    identity_uuid: z.string().uuid(),
    team_uuid: z.union([
        z.string().uuid(),
        z.string()
    ])
});

/**
 * Successful Response
 */
export const zPostTeamContactCommentResponse = zCommentResponse;

export const zDeleteTeamContactCommentPath = z.object({
    comment_uuid: z.string().uuid(),
    identity_uuid: z.string().uuid(),
    team_uuid: z.union([
        z.string().uuid(),
        z.string()
    ])
});

/**
 * Successful Response
 */
export const zDeleteTeamContactCommentResponse = zCommentResponse;

export const zPutTeamContactCommentBody = zCommentPayload;

export const zPutTeamContactCommentPath = z.object({
    comment_uuid: z.string().uuid(),
    identity_uuid: z.string().uuid(),
    team_uuid: z.union([
        z.string().uuid(),
        z.string()
    ])
});

/**
 * Successful Response
 */
export const zPutTeamContactCommentResponse = zCommentResponse;

export const zListCompanyContactTagsPath = z.object({
    company_id: z.number().int()
});

export const zListCompanyContactTagsQuery = z.object({
    include_deleted: z.boolean().optional().default(false),
    include_usage_count: z.boolean().optional().default(false)
});

/**
 * Response List Company Contact Tags
 *
 * Successful Response
 */
export const zListCompanyContactTagsResponse = z.array(zCompanyTagDefinitionResponse);

export const zAddCompanyContactTagBody = zCompanyTagAssociationCreatePayload;

export const zAddCompanyContactTagPath = z.object({
    company_id: z.number().int(),
    candidate_uuid: z.string().uuid()
});

/**
 * Successful Response
 */
export const zAddCompanyContactTagResponse = zCompanyTagOnContactResponse;

export const zRemoveCompanyContactTagPath = z.object({
    company_id: z.number().int(),
    candidate_uuid: z.string().uuid(),
    tag_definition_uuid: z.string().uuid()
});

/**
 * Successful Response
 */
export const zRemoveCompanyContactTagResponse = z.void();

export const zPostTeamPipelinesBody = zCreatePipelinePayload;

export const zPostTeamPipelinesPath = z.object({
    team_uuid: z.union([
        z.string().uuid(),
        z.string()
    ])
});

/**
 * Successful Response
 */
export const zPostTeamPipelinesResponse = zPipelineFullResponse;

export const zGetTeamPipelinePath = z.object({
    pipeline_uuid: z.union([
        z.string().uuid(),
        z.string()
    ]),
    team_uuid: z.string()
});

/**
 * Successful Response
 */
export const zGetTeamPipelineResponse = zPipelineFullResponse;

export const zPutTeamPipelineBody = zUpdatePipelinePayload;

export const zPutTeamPipelinePath = z.object({
    pipeline_uuid: z.union([
        z.string().uuid(),
        z.string()
    ]),
    team_uuid: z.string()
});

/**
 * Successful Response
 */
export const zPutTeamPipelineResponse = zPipelineFullResponse;

export const zPostTeamPipelineViewsPath = z.object({
    pipeline_uuid: z.union([
        z.string().uuid(),
        z.string()
    ]),
    team_uuid: z.string()
});

export const zGetTeamPipelineCandidatesPath = z.object({
    pipeline_uuid: z.union([
        z.string().uuid(),
        z.string()
    ]),
    team_uuid: z.string()
});

export const zGetTeamPipelineCandidatesQuery = z.object({
    search_id: z.string().nullish()
});

/**
 * Successful Response
 */
export const zGetTeamPipelineCandidatesResponse = zTeamPipelineCandidatesResponse;

export const zPostPipelineCandidatesBody = zPipelineCandidateSearchFilterSortPayload;

export const zPostPipelineCandidatesPath = z.object({
    pipeline_uuid: z.union([
        z.string().uuid(),
        z.string()
    ]),
    team_uuid: z.string()
});

/**
 * Successful Response
 */
export const zPostPipelineCandidatesResponse = zTeamPipelineCandidatesSearchFilterSortResponse;

export const zGetTeamPipelineCandidatesOffLimitsPath = z.object({
    pipeline_uuid: z.union([
        z.string().uuid(),
        z.string()
    ]),
    team_uuid: z.string()
});

export const zGetTeamPipelineCandidatesOffLimitsQuery = z.object({
    candidate_uuids: z.array(z.string().uuid()).nullish()
});

/**
 * Response Get Team Pipeline Candidates Off Limits
 *
 * Successful Response
 */
export const zGetTeamPipelineCandidatesOffLimitsResponse = z.array(zOffLimitsTeamSchema);

export const zPostTeamPipelineSubmissionBody = zSubmissionDraftV2;

export const zPostTeamPipelineSubmissionPath = z.object({
    pipeline_uuid: z.union([
        z.string().uuid(),
        z.string()
    ]),
    team_uuid: z.string()
});

/**
 * Response Post Team Pipeline Submission
 *
 * Successful Response
 */
export const zPostTeamPipelineSubmissionResponse = z.array(zSubmissionV3InternalResponse);

export const zPostTailoredHighlightsBody = zTailoredHighlightsRequest;

export const zPostTailoredHighlightsPath = z.object({
    pipeline_uuid: z.union([
        z.string().uuid(),
        z.string()
    ]),
    team_uuid: z.string()
});

/**
 * Successful Response
 */
export const zPostTailoredHighlightsResponse = zTailoredHighlightsQueued;

export const zGetTailoredHighlightsStatusPath = z.object({
    task_id: z.string(),
    pipeline_uuid: z.union([
        z.string().uuid(),
        z.string()
    ]),
    team_uuid: z.string()
});

/**
 * Successful Response
 */
export const zGetTailoredHighlightsStatusResponse = zTailoredHighlightsStatus;

export const zGetTeamPipelineRecommendationPath = z.object({
    pipeline_uuid: z.string(),
    recommendation_uuid: z.string(),
    team_uuid: z.union([
        z.string().uuid(),
        z.string()
    ])
});

/**
 * Successful Response
 */
export const zGetTeamPipelineRecommendationResponse = zRecommendationExternalFullResponse;

export const zPutTeamPipelineRecommendationIntroEmailTypeBody = zRecommendationIntroEmailType;

export const zPutTeamPipelineRecommendationIntroEmailTypePath = z.object({
    pipeline_uuid: z.string(),
    recommendation_uuid: z.string(),
    team_uuid: z.union([
        z.string().uuid(),
        z.string()
    ])
});

/**
 * Successful Response
 */
export const zPutTeamPipelineRecommendationIntroEmailTypeResponse = zRecommendationExternalFullResponse;

export const zPostTeamPipelineRecommendationCommentsBody = zRecommendationCommentsPayload;

export const zPostTeamPipelineRecommendationCommentsPath = z.object({
    pipeline_uuid: z.string(),
    recommendation_uuid: z.string(),
    team_uuid: z.union([
        z.string().uuid(),
        z.string()
    ])
});

/**
 * Successful Response
 */
export const zPostTeamPipelineRecommendationCommentsResponse = zCommentResponse;

export const zPostTeamPipelineRecommendationDislikeBody = zRecommendationIsLiked;

export const zPostTeamPipelineRecommendationDislikePath = z.object({
    pipeline_uuid: z.string(),
    recommendation_uuid: z.string(),
    team_uuid: z.union([
        z.string().uuid(),
        z.string()
    ])
});

/**
 * Successful Response
 */
export const zPostTeamPipelineRecommendationDislikeResponse = zRecommendationExternalFullResponse;

export const zPostTeamPipelineRecommendationFavoriteBody = zCandidateFavoritePayload;

export const zPostTeamPipelineRecommendationFavoritePath = z.object({
    pipeline_uuid: z.string(),
    recommendation_uuid: z.string(),
    team_uuid: z.union([
        z.string().uuid(),
        z.string()
    ])
});

/**
 * Successful Response
 */
export const zPostTeamPipelineRecommendationFavoriteResponse = zRecommendationExternalFullResponse;

/**
 * Payload
 */
export const zPostTeamPipelineRecommendationViewsBody = zCandidateViewPayload.nullable();

export const zPostTeamPipelineRecommendationViewsPath = z.object({
    pipeline_uuid: z.string(),
    recommendation_uuid: z.string(),
    team_uuid: z.union([
        z.string().uuid(),
        z.string()
    ])
});

export const zGetTeamPipelineRecommendationInternalCommentsPath = z.object({
    pipeline_uuid: z.string(),
    recommendation_uuid: z.string(),
    team_uuid: z.union([
        z.string().uuid(),
        z.string()
    ])
});

export const zGetTeamPipelineRecommendationInternalCommentsQuery = z.object({
    page: z.number().int().gte(1).optional().default(1),
    size: z.number().int().gte(1).lte(1000).optional().default(10)
});

/**
 * Successful Response
 */
export const zGetTeamPipelineRecommendationInternalCommentsResponse = zPageInternalCommentResponse;

export const zPostTeamPipelineRecommendationInternalCommentsBody = zCommentPayload;

export const zPostTeamPipelineRecommendationInternalCommentsPath = z.object({
    pipeline_uuid: z.string(),
    recommendation_uuid: z.string(),
    team_uuid: z.union([
        z.string().uuid(),
        z.string()
    ])
});

/**
 * Successful Response
 */
export const zPostTeamPipelineRecommendationInternalCommentsResponse = zInternalCommentResponse;

export const zGetRecsysPipelineRecommendationsPath = z.object({
    pipeline_uuid: z.union([
        z.string().uuid(),
        z.string()
    ]),
    team_uuid: z.string()
});

export const zGetRecsysPipelineRecommendationsQuery = z.object({
    limit: z.number().int().gte(1).lte(100).optional().default(10),
    offset: z.number().int().gte(0).optional().default(0)
});

/**
 * Successful Response
 */
export const zGetRecsysPipelineRecommendationsResponse = zRecsysPipelineRecommendationsResponse;

export const zPostRecsysRecommendationFeedbackBody = zRecsysFeedbackPayload;

export const zPostRecsysRecommendationFeedbackPath = z.object({
    recommendation_id: z.string(),
    pipeline_uuid: z.union([
        z.string().uuid(),
        z.string()
    ]),
    team_uuid: z.string()
});

export const zGetTeamTrendingPath = z.object({
    team_uuid: z.union([
        z.string().uuid(),
        z.string()
    ])
});

export const zGetTeamTrendingQuery = z.object({
    team_uuids: z.array(z.string().uuid()).nullish().default([]),
    search_id: z.string().nullish()
});

/**
 * Successful Response
 */
export const zGetTeamTrendingResponse = zTeamTrendingCandidatesResponse;

export const zGetTeamTrendingRecommendationPath = z.object({
    recommendation_uuid: z.string(),
    team_uuid: z.union([
        z.string().uuid(),
        z.string()
    ])
});

/**
 * Successful Response
 */
export const zGetTeamTrendingRecommendationResponse = zRecommendationExternalFullResponse;

export const zGetTeamTrendingRecommendationActivityPath = z.object({
    recommendation_uuid: z.string(),
    team_uuid: z.union([
        z.string().uuid(),
        z.string()
    ])
});

export const zGetTeamTrendingRecommendationActivityQuery = z.object({
    team_uuids: z.array(z.string().uuid()).nullish().default([]),
    page: z.number().int().gte(1).optional().default(1),
    size: z.number().int().gte(1).lte(1000).optional().default(10)
});

/**
 * Successful Response
 */
export const zGetTeamTrendingRecommendationActivityResponse = zPageCandidateActivityEvent;

export const zGetTeamTrendingRecommendationCommentsPath = z.object({
    team_uuid: z.string().uuid(),
    recommendation_uuid: z.string().uuid()
});

export const zGetTeamTrendingRecommendationCommentsQuery = z.object({
    team_uuids: z.array(z.string().uuid()).nullish().default([]),
    page: z.number().int().gte(1).optional().default(1),
    size: z.number().int().gte(1).lte(1000).optional().default(10)
});

/**
 * Successful Response
 */
export const zGetTeamTrendingRecommendationCommentsResponse = zPageCommentResponse;

export const zPostTeamTrendingRecommendationCommentsBody = zCommentPayload;

export const zPostTeamTrendingRecommendationCommentsPath = z.object({
    recommendation_uuid: z.string(),
    team_uuid: z.union([
        z.string().uuid(),
        z.string()
    ])
});

/**
 * Successful Response
 */
export const zPostTeamTrendingRecommendationCommentsResponse = zCommentResponse;

export const zPostTeamTrendingRecommendationDislikeBody = zRecommendationIsLiked;

export const zPostTeamTrendingRecommendationDislikePath = z.object({
    recommendation_uuid: z.string(),
    team_uuid: z.union([
        z.string().uuid(),
        z.string()
    ])
});

/**
 * Successful Response
 */
export const zPostTeamTrendingRecommendationDislikeResponse = zRecommendationExternalFullResponse;

export const zPostTeamTrendingRecommendationFavoriteBody = zCandidateFavoritePayload;

export const zPostTeamTrendingRecommendationFavoritePath = z.object({
    recommendation_uuid: z.string(),
    team_uuid: z.union([
        z.string().uuid(),
        z.string()
    ])
});

/**
 * Successful Response
 */
export const zPostTeamTrendingRecommendationFavoriteResponse = zRecommendationExternalFullResponse;

/**
 * Payload
 */
export const zPostTeamTrendingRecommendationViewsBody = zCandidateViewPayload.nullable();

export const zPostTeamTrendingRecommendationViewsPath = z.object({
    recommendation_uuid: z.string(),
    team_uuid: z.union([
        z.string().uuid(),
        z.string()
    ])
});

export const zPostCandidateMergeBody = zCandidateMergePayload;

export const zPostCandidateMergePath = z.object({
    candidate_uuid: z.string().uuid()
});

/**
 * Successful Response
 */
export const zPostCandidateMergeResponse = zCandidateMergeResponse;

export const zGetNewCandidatesQuery = z.object({
    page: z.number().int().gte(1).optional().default(1),
    size: z.number().int().gte(1).lte(1000).optional().default(10)
});

/**
 * Successful Response
 */
export const zGetNewCandidatesResponse = zPageCandidateExtendedResponse;

export const zFindIdentityQuery = z.object({
    person_uuid: z.string().uuid().nullish(),
    candidate_uuid: z.string().uuid().nullish()
});

/**
 * Successful Response
 */
export const zFindIdentityResponse = zIdentityResponse;

export const zPostIdentityBody = zLoginCreatePayload;

/**
 * Successful Response
 */
export const zPostIdentityResponse = zIdentityResponse;

export const zGetIdentityPath = z.object({
    identity_uuid: z.string().uuid()
});

/**
 * Successful Response
 */
export const zGetIdentityResponse = zIdentityResponse;

export const zGetIdentityEmailEventsPath = z.object({
    identity_uuid: z.string().uuid()
});

export const zGetIdentityEmailEventsQuery = z.object({
    page: z.number().int().gte(1).optional().default(1),
    size: z.number().int().gte(1).lte(1000).optional().default(10),
    event_uuid: z.string().uuid().nullish(),
    batch_uuid: z.string().uuid().nullish(),
    email_event_type: z.array(zEmailEventType).nullish(),
    sendgrid_event: z.array(zSendGridEmailEvent).nullish()
});

/**
 * Successful Response
 */
export const zGetIdentityEmailEventsResponse = zPageIdentityEmailItemResponse;

export const zPostIdentityPersonBody = zIdentityPersonPayload;

export const zPostIdentityPersonPath = z.object({
    identity_uuid: z.string().uuid()
});

/**
 * Successful Response
 */
export const zPostIdentityPersonResponse = zIdentityResponse;

export const zDeleteIdentityPersonPath = z.object({
    identity_uuid: z.string().uuid(),
    person_uuid: z.string().uuid()
});

/**
 * Successful Response
 */
export const zDeleteIdentityPersonResponse = zIdentityResponse;

export const zDeleteIdentityCandidatePath = z.object({
    identity_uuid: z.string().uuid()
});

/**
 * Successful Response
 */
export const zDeleteIdentityCandidateResponse = zIdentityResponse;

export const zPutIdentityCandidateBody = zIdentityCandidatePayload;

export const zPutIdentityCandidatePath = z.object({
    identity_uuid: z.string().uuid()
});

/**
 * Successful Response
 */
export const zPutIdentityCandidateResponse = zIdentityResponse;

export const zPostIdentityMergeBody = zIdentityMergePayload;

export const zPostIdentityMergePath = z.object({
    identity_uuid: z.string().uuid()
});

/**
 * Successful Response
 */
export const zPostIdentityMergeResponse = zIdentityMergeResponse;

export const zPostIdentityLoginBody = zLoginCreatePayload;

export const zPostIdentityLoginPath = z.object({
    identity_uuid: z.string().uuid()
});

/**
 * Successful Response
 */
export const zPostIdentityLoginResponse = zIdentityResponse;

/**
 * Successful Response
 */
export const zPostContactListsResponse = zContactListsPushResponse;

/**
 * Successful Response
 */
export const zGetPathwayActivityDefaultsResponse = zPathwayActivityDefaultsListResponse;

export const zPutPathwayActivityDefaultsBody = zPathwayActivityDefaultsPutPayload;

/**
 * Successful Response
 */
export const zPutPathwayActivityDefaultsResponse = zPathwayActivityDefaultsListResponse;

export const zGetCandidateActivityLogsPath = z.object({
    candidate_uuid: z.string()
});

export const zGetCandidateActivityLogsQuery = z.object({
    phrase: z.string().nullish(),
    page: z.number().int().gte(1).optional().default(1),
    size: z.number().int().gte(1).lte(1000).optional().default(10)
});

/**
 * Successful Response
 */
export const zGetCandidateActivityLogsResponse = zPageCandidateActivityLogResponse;

export const zPostCandidateActivityLogBody = zCandidateActivityLogPayload;

export const zPostCandidateActivityLogPath = z.object({
    candidate_uuid: z.string()
});

/**
 * Successful Response
 */
export const zPostCandidateActivityLogResponse = zCandidateActivityLogResponse;

export const zGetCandidateActivityLogsSearchPath = z.object({
    candidate_uuid: z.string()
});

export const zGetCandidateActivityLogsSearchQuery = z.object({
    phrase: z.string().nullish(),
    activity_type: zEventTypeFilter.nullish(),
    has_goal: z.boolean().nullish()
});

/**
 * Successful Response
 */
export const zGetCandidateActivityLogsSearchResponse = zGroupedActivityLogResponse;

export const zPostCandidateTasksFilterBody = zCandidateTasksFilterPayload;

export const zPostCandidateTasksFilterPath = z.object({
    candidate_uuid: z.string()
});

/**
 * Successful Response
 */
export const zPostCandidateTasksFilterResponse = zCandidateTaskModulesResponse;

export const zGetCandidateTasksOnboardingPath = z.object({
    candidate_uuid: z.string()
});

/**
 * Successful Response
 */
export const zGetCandidateTasksOnboardingResponse = zCandidateOnboardingStatus;

export const zDeleteAllCandidatePathwayActivityTargetsPath = z.object({
    candidate_uuid: z.string()
});

/**
 * Successful Response
 */
export const zDeleteAllCandidatePathwayActivityTargetsResponse = zCandidatePathwayActivityTargetsResponse;

export const zGetCandidatePathwayActivityTargetsPath = z.object({
    candidate_uuid: z.string()
});

/**
 * Successful Response
 */
export const zGetCandidatePathwayActivityTargetsResponse = zCandidatePathwayActivityTargetsResponse;

export const zPutCandidatePathwayActivityTargetsBody = zCandidatePathwayActivityTargetsPutPayload;

export const zPutCandidatePathwayActivityTargetsPath = z.object({
    candidate_uuid: z.string()
});

/**
 * Successful Response
 */
export const zPutCandidatePathwayActivityTargetsResponse = zCandidatePathwayActivityTargetsResponse;

export const zDeleteCandidatePathwayActivityTargetPath = z.object({
    activity_type: zPathwayActivityType,
    candidate_uuid: z.string()
});

/**
 * Successful Response
 */
export const zDeleteCandidatePathwayActivityTargetResponse = zCandidatePathwayActivityTargetsResponse;

export const zGetHomeActivityLogsQuery = z.object({
    page: z.number().int().gte(1).optional().default(1),
    size: z.number().int().gte(1).lte(1000).optional().default(10)
});

/**
 * Successful Response
 */
export const zGetHomeActivityLogsResponse = zPageHomepageActivityLogResponse;

export const zGetHomeAllIntrosQuery = z.object({
    page: z.number().int().gte(1).optional().default(1),
    size: z.number().int().gte(1).lte(1000).optional().default(10)
});

/**
 * Successful Response
 */
export const zGetHomeAllIntrosResponse = zPageAllIntrosResponse;

export const zPostAdminPeersFilterBody = zPeerToPeerTableFilterPayload;

/**
 * Successful Response
 */
export const zPostAdminPeersFilterResponse = zPeerToPeerTableResponse;

export const zPostCandidateCompareAboutBody = zPeerComparePayload;

/**
 * Response Post Candidate Compare About
 *
 * Successful Response
 */
export const zPostCandidateCompareAboutResponse = z.array(zPeerCompareAboutResponse);

export const zPostCandidateCompareGoalsBody = zPeerComparePayload;

/**
 * Response Post Candidate Compare Goals
 *
 * Successful Response
 */
export const zPostCandidateCompareGoalsResponse = z.array(zPeerCompareGoalsResponse);

export const zPostCandidateCompareP2pBody = zPeerComparePayload;

/**
 * Response Post Candidate Compare P2P
 *
 * Successful Response
 */
export const zPostCandidateCompareP2pResponse = z.array(zPeerCompareP2pResponse);

export const zPostAdminPeersMatchesBody = zPeerToPeerTableExecutivePayload;

export const zPostAdminPeersMatchesPath = z.object({
    candidate_uuid: z.string()
});

/**
 * Successful Response
 */
export const zPostAdminPeersMatchesResponse = zPeerToPeerTableExecutiveResponse;

export const zPostAdminPeersCandidatesFilterBody = zPeerToPeerTableSelectFilterPayload;

export const zPostAdminPeersCandidatesFilterPath = z.object({
    candidate_uuid: z.string()
});

/**
 * Successful Response
 */
export const zPostAdminPeersCandidatesFilterResponse = zPeerToPeerTableSelectResponse;

/**
 * Payload
 */
export const zPostAdminPeersPublishBody = z.array(zPeerToPeerPublishCandidates).min(1);

export const zPostAdminPeersPublishPath = z.object({
    candidate_uuid: z.string()
});

/**
 * Response Post Admin Peers Publish
 *
 * Successful Response
 */
export const zPostAdminPeersPublishResponse = z.array(zPeerToPeerExtendedResponse);

export const zDeletePeerPath = z.object({
    peer_id: z.string().uuid()
});

/**
 * Successful Response
 */
export const zDeletePeerResponse = zPeerToPeerExtendedResponse;

export const zGetPeerPath = z.object({
    peer_id: z.string().uuid()
});

/**
 * Successful Response
 */
export const zGetPeerResponse = zPeerToPeerExtendedResponse;

export const zPutPeerStatusBody = zPeerStatusUpdatePayload;

export const zPutPeerStatusPath = z.object({
    peer_id: z.string().uuid()
});

/**
 * Successful Response
 */
export const zPutPeerStatusResponse = zPeerToPeerExtendedResponse;

export const zPutPeerAssigneesBody = zPeerAssigneesUpdatePayload;

export const zPutPeerAssigneesPath = z.object({
    peer_id: z.string().uuid()
});

/**
 * Successful Response
 */
export const zPutPeerAssigneesResponse = zPeerToPeerExtendedResponse;

export const zPutPeerIntroductionBody = zPeerIntroductionPayload;

export const zPutPeerIntroductionPath = z.object({
    peer_id: z.string().uuid()
});

/**
 * Successful Response
 */
export const zPutPeerIntroductionResponse = zPeerToPeerExtendedResponse;

export const zGetPeerActivityPath = z.object({
    peer_id: z.string().uuid()
});

export const zGetPeerActivityQuery = z.object({
    page: z.number().int().gte(1).optional().default(1),
    size: z.number().int().gte(1).lte(1000).optional().default(10)
});

/**
 * Successful Response
 */
export const zGetPeerActivityResponse = zPagePeerActivityResponse;

export const zPostPeerCommentBody = zPeerCommentPayload;

export const zPostPeerCommentPath = z.object({
    peer_id: z.string().uuid()
});

/**
 * Successful Response
 */
export const zPostPeerCommentResponse = zPeerCommentResponse;

export const zDeletePeerCommentPath = z.object({
    peer_id: z.string().uuid(),
    peer_comment_id: z.string().uuid()
});

/**
 * Successful Response
 */
export const zDeletePeerCommentResponse = zPeerCommentResponse;

export const zPostTasksBody = zTaskCreateUpdatePayload;

/**
 * Successful Response
 */
export const zPostTasksResponse = zTaskBasicResponse;

export const zPostTasksFilterBody = zTasksTableFilterPayload;

/**
 * Successful Response
 */
export const zPostTasksFilterResponse = zTasksTableResponse;

export const zDeleteTaskPath = z.object({
    task_id: z.string().uuid()
});

/**
 * Successful Response
 */
export const zDeleteTaskResponse = zTaskBasicResponse;

export const zGetTaskPath = z.object({
    task_id: z.string().uuid()
});

/**
 * Successful Response
 */
export const zGetTaskResponse = zTaskBasicResponse;

export const zPutTaskBody = zTaskCreateUpdatePayload;

export const zPutTaskPath = z.object({
    task_id: z.string().uuid()
});

/**
 * Successful Response
 */
export const zPutTaskResponse = zTaskBasicResponse;

export const zPutTaskStatusBody = zTaskStatusPayload;

export const zPutTaskStatusPath = z.object({
    task_id: z.string().uuid()
});

/**
 * Successful Response
 */
export const zPutTaskStatusResponse = zTaskBasicResponse;

export const zPostTeamTransferToCompanyBody = zTeamTransferPayload;

export const zPostTeamTransferToCompanyPath = z.object({
    team_uuid: z.union([
        z.string().uuid(),
        z.string()
    ])
});

/**
 * Successful Response
 */
export const zPostTeamTransferToCompanyResponse = zTeamExtendedResponse;

export const zPostTeamMergeBody = zTeamMergePayload;

export const zPostTeamMergePath = z.object({
    team_uuid: z.union([
        z.string().uuid(),
        z.string()
    ])
});

/**
 * Successful Response
 */
export const zPostTeamMergeResponse = zTeamExtendedResponse;

export const zPostTaskModulesBody = zTaskModuleCreateUpdatePayload;

/**
 * Successful Response
 */
export const zPostTaskModulesResponse = zTaskModuleResponse;

export const zDeleteTaskModulePath = z.object({
    task_module_id: z.string().uuid()
});

/**
 * Successful Response
 */
export const zDeleteTaskModuleResponse = zTaskModuleResponse;

export const zGetTaskModulePath = z.object({
    task_module_id: z.string().uuid()
});

/**
 * Successful Response
 */
export const zGetTaskModuleResponse = zTaskModuleResponse;

export const zPutTaskModuleBody = zTaskModuleCreateUpdatePayload;

export const zPutTaskModulePath = z.object({
    task_module_id: z.string().uuid()
});

/**
 * Successful Response
 */
export const zPutTaskModuleResponse = zTaskModuleResponse;

export const zPutTaskModuleStatusBody = zTaskModuleStatusPayload;

export const zPutTaskModuleStatusPath = z.object({
    task_module_id: z.string().uuid()
});

/**
 * Successful Response
 */
export const zPutTaskModuleStatusResponse = zTaskModuleResponse;

export const zPostAdminPipelineCandidatesFilterBody = zPipelineCandidateFilterPayload;

export const zPostAdminPipelineCandidatesFilterPath = z.object({
    pipeline_uuid: z.string()
});

/**
 * Successful Response
 */
export const zPostAdminPipelineCandidatesFilterResponse = zPipelineCandidatesFilterPaginatedResponse;

export const zPostPipelineTransferToTeamBody = zPipelineTransferPayload;

/**
 * Successful Response
 */
export const zPostPipelineTransferToTeamResponse = zPipelineTransferResponse;

export const zPatchUserRoleRemoveCompanyPath = z.object({
    role_id: z.number().int(),
    person_uuid: z.string()
});

/**
 * Successful Response
 */
export const zPatchUserRoleRemoveCompanyResponse = zPersonBasicResponse;

export const zPatchUserBody = zUserUpdatePayload;

export const zPatchUserPath = z.object({
    person_uuid: z.string()
});

/**
 * Successful Response
 */
export const zPatchUserResponse = zPersonBasicResponse;

export const zPostUserCompanyBody = zUserCompanyPayload;

export const zPostUserCompanyPath = z.object({
    person_uuid: z.string()
});

/**
 * Successful Response
 */
export const zPostUserCompanyResponse = zPersonBasicResponse;

export const zPostUserTeamBody = zUserTeamPayload;

export const zPostUserTeamPath = z.object({
    person_uuid: z.string()
});

/**
 * Successful Response
 */
export const zPostUserTeamResponse = zPersonBasicResponse;

export const zDeleteCandidateCompanyMetadataPath = z.object({
    company_id: z.number().int(),
    candidate_uuid: z.string().uuid()
});

/**
 * Successful Response
 */
export const zDeleteCandidateCompanyMetadataResponse = zCandidateCompanyMetadataResponse;

export const zGetCandidateCompanyMetadataPath = z.object({
    company_id: z.number().int(),
    candidate_uuid: z.string().uuid()
});

/**
 * Successful Response
 */
export const zGetCandidateCompanyMetadataResponse = zCandidateCompanyMetadataResponse;

export const zUpsertCandidateCompanyMetadataBody = zCandidateCompanyMetadataPayload;

export const zUpsertCandidateCompanyMetadataPath = z.object({
    company_id: z.number().int(),
    candidate_uuid: z.string().uuid()
});

/**
 * Successful Response
 */
export const zUpsertCandidateCompanyMetadataResponse = zCandidateCompanyMetadataResponse;

export const zImportCandidateCompanyMetadataBody = zCandidateCompanyMetadataImportPayload;

export const zImportCandidateCompanyMetadataPath = z.object({
    company_id: z.number().int()
});

/**
 * Successful Response
 */
export const zImportCandidateCompanyMetadataResponse = zCandidateCompanyMetadataImportResponse;

export const zListCandidateCompanyMetadataPath = z.object({
    company_id: z.number().int()
});

export const zListCandidateCompanyMetadataQuery = z.object({
    page: z.number().int().gte(1).optional().default(1),
    size: z.number().int().gte(1).lte(1000).optional().default(10)
});

/**
 * Successful Response
 */
export const zListCandidateCompanyMetadataResponse = zPageCandidateCompanyMetadataWithCandidateResponse;

export const zPostCompanyPeopleFilterBody = zCompanyPeopleFilterPayload;

export const zPostCompanyPeopleFilterPath = z.object({
    company_id: z.number().int()
});

/**
 * Successful Response
 */
export const zPostCompanyPeopleFilterResponse = zCompanyPeopleFilterResponse;

/**
 * Payload
 */
export const zPostActivateExecutiveBody = zActivateExecutivePayload.nullable();

export const zPostActivateExecutivePath = z.object({
    candidate_uuid: z.string().uuid()
});

/**
 * Successful Response
 */
export const zPostActivateExecutiveResponse = zExecutiveResponse;

export const zPostBulkActivateExecutivesBody = zBulkActivateExecutivePayload;

/**
 * Successful Response
 */
export const zPostBulkActivateExecutivesResponse = zBulkActivateResponse;

export const zDeleteExecutiveActivationPath = z.object({
    person_uuid: z.string().uuid()
});

/**
 * Successful Response
 */
export const zDeleteExecutiveActivationResponse = z.void();

export const zPostSendExecutiveInvitationPath = z.object({
    person_uuid: z.string().uuid()
});

/**
 * Successful Response
 */
export const zPostSendExecutiveInvitationResponse = zExecutiveResponse;

/**
 * Successful Response
 */
export const zGetExecutivesResponse = zExecutiveListResponse;

export const zGetExecutivePath = z.object({
    person_uuid: z.string().uuid()
});

/**
 * Successful Response
 */
export const zGetExecutiveResponse = zExecutiveResponse;

export const zPatchExecutiveSettingsBody = zUpdateExecutiveSettingsPayload;

export const zPatchExecutiveSettingsPath = z.object({
    person_uuid: z.string().uuid()
});

/**
 * Successful Response
 */
export const zPatchExecutiveSettingsResponse = zExecutiveResponse;

export const zGetExecutiveClientSettingsPath = z.object({
    person_uuid: z.string().uuid()
});

/**
 * Successful Response
 */
export const zGetExecutiveClientSettingsResponse = zExecutiveClientSettingsResponse;

export const zPatchExecutiveClientSettingsBody = zUpdateExecutiveClientSettingsPayload;

export const zPatchExecutiveClientSettingsPath = z.object({
    person_uuid: z.string().uuid()
});

/**
 * Successful Response
 */
export const zPatchExecutiveClientSettingsResponse = zExecutiveClientSettingsResponse;

export const zGetExecutiveClientTeamPath = z.object({
    person_uuid: z.string().uuid()
});

/**
 * Successful Response
 */
export const zGetExecutiveClientTeamResponse = zExecutiveTeamResponse;

export const zPostExecutiveClientContactPipelinesBody = zTeamCandidatePipelinesPayload;

export const zPostExecutiveClientContactPipelinesPath = z.object({
    person_uuid: z.string().uuid(),
    contact_uuid: z.string().uuid()
});

/**
 * Successful Response
 */
export const zPostExecutiveClientContactPipelinesResponse = zSubmissionCandidatePipelinesResponse;

export const zGetExecutiveClientPersonDetailPath = z.object({
    contact_person_uuid: z.string().uuid(),
    person_uuid: z.string().uuid()
});

/**
 * Successful Response
 */
export const zGetExecutiveClientPersonDetailResponse = zExecutivePeopleDetailResponse;

export const zPostExecutiveClientPeopleSearchBody = zExecutiveClientPeopleSearchPayload;

export const zPostExecutiveClientPeopleSearchPath = z.object({
    person_uuid: z.string().uuid()
});

/**
 * Successful Response
 */
export const zPostExecutiveClientPeopleSearchResponse = zExecutivePeopleSearchResponse;

export const zGetExecutiveClientCandidatePath = z.object({
    person_uuid: z.string().uuid(),
    candidate_uuid: z.string()
});

/**
 * Successful Response
 */
export const zGetExecutiveClientCandidateResponse = zCandidateExternalFullResponseWithTeamContext;

export const zGetExecutiveClientContactPath = z.object({
    contact_uuid: z.string().uuid(),
    person_uuid: z.string().uuid()
});

/**
 * Successful Response
 */
export const zGetExecutiveClientContactResponse = zExecutiveContactDetailResponse;

export const zGetExecutiveClientTrendingPath = z.object({
    person_uuid: z.string().uuid()
});

export const zGetExecutiveClientTrendingQuery = z.object({
    search_id: z.string().nullish()
});

/**
 * Successful Response
 */
export const zGetExecutiveClientTrendingResponse = zTeamTrendingCandidatesResponse;

export const zGetExecutiveClientTrendingRecommendationPath = z.object({
    recommendation_uuid: z.string(),
    person_uuid: z.string().uuid()
});

/**
 * Successful Response
 */
export const zGetExecutiveClientTrendingRecommendationResponse = zRecommendationExternalFullResponse;

export const zPostAdminExecutiveClientActivityBody = zExecutiveActivityFilter;

export const zPostAdminExecutiveClientActivityPath = z.object({
    person_uuid: z.string().uuid()
});

export const zPostAdminExecutiveClientActivityQuery = z.object({
    page: z.number().int().gte(1).optional().default(1),
    size: z.number().int().gte(1).lte(1000).optional().default(10)
});

/**
 * Successful Response
 */
export const zPostAdminExecutiveClientActivityResponse = zPostPageActivityFeedItem;

export const zPostExecutiveClientActivityBody = zExecutiveActivityFilter;

export const zPostExecutiveClientActivityPath = z.object({
    contact_uuid: z.string().uuid(),
    person_uuid: z.string().uuid()
});

export const zPostExecutiveClientActivityQuery = z.object({
    page: z.number().int().gte(1).optional().default(1),
    size: z.number().int().gte(1).lte(1000).optional().default(10)
});

/**
 * Successful Response
 */
export const zPostExecutiveClientActivityResponse = zPostPageActivityFeedItem;

export const zListExecutiveClientEventsPath = z.object({
    person_uuid: z.string().uuid()
});

export const zListExecutiveClientEventsQuery = z.object({
    sort: z.enum(['event_date', 'title']).optional().default('event_date'),
    direction: z.enum(['asc', 'desc']).optional().default('desc'),
    page: z.number().int().gte(1).optional().default(1),
    size: z.number().int().gte(1).lte(1000).optional().default(10)
});

/**
 * Successful Response
 */
export const zListExecutiveClientEventsResponse = zPageExecutiveClientEventListItem;

export const zGetExecutiveClientEventPath = z.object({
    event_uuid: z.string().uuid(),
    person_uuid: z.string().uuid()
});

/**
 * Successful Response
 */
export const zGetExecutiveClientEventResponse = zExecutiveClientEventResponse;

export const zUpdateExecutiveClientEventRsvpBody = zExecutiveClientRsvpUpdatePayload;

export const zUpdateExecutiveClientEventRsvpPath = z.object({
    event_uuid: z.string().uuid(),
    person_uuid: z.string().uuid()
});

/**
 * Successful Response
 */
export const zUpdateExecutiveClientEventRsvpResponse = zExecutiveClientEventResponse;

export const zPostPeopleV2Body = zPeoplePost;

/**
 * Successful Response
 */
export const zPostPeopleV2Response = zUserInviteResponse;

export const zUpdatePersonMetadataV2Body = zClerkUserPublicMetadataUpdate;

/**
 * Successful Response
 */
export const zUpdatePersonMetadataV2Response = zClerkUserPublicMetadataUpdate;

export const zPatchPeopleCurrentBody = zPersonCurrentExternalPatch;

/**
 * Successful Response
 */
export const zPatchPeopleCurrentResponse = zPersonCurrentExternalResponse;

export const zPutPeopleCurrentPasswordBody = zPersonClerkPasswordPut;

/**
 * Successful Response
 */
export const zPutPeopleCurrentPasswordResponse = zPersonPasswordUpdatedResponse;

export const zPostPersonClerkUserBody = zCreateClerkUserRequest;

export const zPostPersonClerkUserPath = z.object({
    person_uuid: z.string()
});

/**
 * Successful Response
 */
export const zPostPersonClerkUserResponse2 = zPostPersonClerkUserResponse;

export const zPatchPersonEmailNotificationsBody = zPersonEmailNotificationsPatch;

export const zPatchPersonEmailNotificationsPath = z.object({
    person_uuid: z.string()
});

/**
 * Successful Response
 */
export const zPatchPersonEmailNotificationsResponse = zPersonBasicResponse;

export const zPatchPersonBody = zPersonPatch;

export const zPatchPersonPath = z.object({
    person_uuid: z.string()
});

/**
 * Successful Response
 */
export const zPatchPersonResponse = zPersonBasicResponse;

/**
 * Response Get People Internal
 *
 * Successful Response
 */
export const zGetPeopleInternalResponse = z.array(zPersonBasicResponse);

export const zResolvePersonCandidateByEmailBody = zResolvePersonCandidateByEmailRequest;

/**
 * Successful Response
 */
export const zResolvePersonCandidateByEmailResponse2 = zResolvePersonCandidateByEmailResponse;

export const zListPersonContactTagsPath = z.object({
    person_uuid: z.string()
});

export const zListPersonContactTagsQuery = z.object({
    include_deleted: z.boolean().optional().default(false),
    include_usage_count: z.boolean().optional().default(false),
    q: z.string().max(255).nullish()
});

/**
 * Response List Person Contact Tags
 *
 * Successful Response
 */
export const zListPersonContactTagsResponse = z.array(zPersonalTagDefinitionResponse);

export const zCreatePersonContactTagDefinitionBody = zPersonalTagDefinitionCreatePayload;

export const zCreatePersonContactTagDefinitionPath = z.object({
    person_uuid: z.string()
});

/**
 * Successful Response
 */
export const zCreatePersonContactTagDefinitionResponse = zPersonalTagDefinitionResponse;

export const zDeletePersonContactTagDefinitionPath = z.object({
    tag_definition_uuid: z.string().uuid(),
    person_uuid: z.string()
});

/**
 * Successful Response
 */
export const zDeletePersonContactTagDefinitionResponse = z.void();

export const zPatchPersonContactTagDefinitionBody = zPersonalTagDefinitionPatchPayload;

export const zPatchPersonContactTagDefinitionPath = z.object({
    tag_definition_uuid: z.string().uuid(),
    person_uuid: z.string()
});

/**
 * Successful Response
 */
export const zPatchPersonContactTagDefinitionResponse = zPersonalTagDefinitionResponse;

export const zAddPersonContactTagBody = zPersonalTagAssociationCreatePayload;

export const zAddPersonContactTagPath = z.object({
    person_uuid: z.string(),
    contact_uuid: z.string().uuid()
});

/**
 * Successful Response
 */
export const zAddPersonContactTagResponse = zPersonalTagOnContactResponse;

export const zRemovePersonContactTagPath = z.object({
    contact_uuid: z.string().uuid(),
    person_uuid: z.string(),
    tag_definition_uuid: z.string().uuid()
});

/**
 * Successful Response
 */
export const zRemovePersonContactTagResponse = z.void();

export const zPostPersonContactFavoriteBody = zCandidateFavoritePayload;

export const zPostPersonContactFavoritePath = z.object({
    person_uuid: z.string(),
    contact_uuid: z.string().uuid()
});

/**
 * Successful Response
 */
export const zPostPersonContactFavoriteResponse = zContactFavoriteResponse;

export const zGetUserEventsPath = z.object({
    user_uuid: z.string().uuid()
});

export const zGetUserEventsQuery = z.object({
    draft: z.boolean().nullish(),
    event_date_after: z.string().datetime().nullish(),
    event_date_before: z.string().datetime().nullish(),
    sort_event_date: z.enum(['asc', 'desc']).optional().default('desc'),
    page: z.number().int().gte(1).optional().default(1),
    size: z.number().int().gte(1).lte(1000).optional().default(10)
});

/**
 * Successful Response
 */
export const zGetUserEventsResponse = zPageEventResponse;

export const zDeleteUserV2Path = z.object({
    user_uuid: z.string()
});

/**
 * Successful Response
 */
export const zDeleteUserV2Response = z.void();

export const zGetUserV2Path = z.object({
    user_uuid: z.string()
});

/**
 * Successful Response
 */
export const zGetUserV2Response = zAdminUserDetailedResponse;

export const zPostUsersBulkDeleteV2Body = zUsersBulkDeletePayload;

/**
 * Successful Response
 */
export const zPostUsersBulkDeleteV2Response = zUsersBulkDeleteResponse;

export const zPostUsersSearchV2Body = zUsersSearchFilterSortPayload.default({
    page: 1,
    page_size: -1,
    sort_rules: [],
    include_aggregations: false
});

export const zPostUsersSearchV2Query = z.object({
    page: z.number().int().gte(1).optional().default(1),
    size: z.number().int().gte(1).lte(1000).optional().default(10)
});

/**
 * Successful Response
 */
export const zPostUsersSearchV2Response = zUsersPostPageUserDetailedResponse;

export const zListEmailTemplatesQuery = z.object({
    template_type: zEmailTemplateType.nullish(),
    category: zEmailCategory.nullish(),
    page: z.number().int().gte(1).optional().default(1),
    size: z.number().int().gte(1).lte(1000).optional().default(10)
});

/**
 * Successful Response
 */
export const zListEmailTemplatesResponse = zPageEmailTemplateResponse;

export const zCreateEmailTemplateBody = zEmailTemplateCreatePayload;

/**
 * Successful Response
 */
export const zCreateEmailTemplateResponse = zEmailTemplateResponse;

export const zListEmailTemplateDefaultsQuery = z.object({
    category: zEmailCategory.nullish()
});

/**
 * Response List Email Template Defaults
 *
 * Successful Response
 */
export const zListEmailTemplateDefaultsResponse = z.array(zEmailTemplateDefaultResponse);

export const zDeleteEmailTemplateDefaultPath = z.object({
    template_type: zEmailTemplateType
});

/**
 * Successful Response
 */
export const zDeleteEmailTemplateDefaultResponse = z.void();

export const zPutEmailTemplateDefaultBody = zEmailTemplateDefaultPayload;

export const zPutEmailTemplateDefaultPath = z.object({
    template_type: zEmailTemplateType
});

/**
 * Successful Response
 */
export const zPutEmailTemplateDefaultResponse = zEmailTemplateDefaultResponse;

export const zDeleteEmailTemplatePath = z.object({
    template_uuid: z.string().uuid()
});

/**
 * Successful Response
 */
export const zDeleteEmailTemplateResponse = z.void();

export const zGetEmailTemplatePath = z.object({
    template_uuid: z.string().uuid()
});

/**
 * Successful Response
 */
export const zGetEmailTemplateResponse = zEmailTemplateResponse;

export const zUpdateEmailTemplateBody = zEmailTemplateUpdatePayload;

export const zUpdateEmailTemplatePath = z.object({
    template_uuid: z.string().uuid()
});

/**
 * Successful Response
 */
export const zUpdateEmailTemplateResponse = zEmailTemplateResponse;

/**
 * Response List Email Types
 *
 * Successful Response
 */
export const zListEmailTypesResponse = z.array(zEmailTypeResponse);

export const zGetEmailPreviewPath = z.object({
    key: z.string()
});

/**
 * Successful Response
 */
export const zGetEmailPreviewResponse = zEmailPreviewResponse;

export const zListEventEmailTemplatesPath = z.object({
    event_uuid: z.string().uuid()
});

export const zListEventEmailTemplatesQuery = z.object({
    template_type: zEmailTemplateType.nullish()
});

/**
 * Response List Event Email Templates
 *
 * Successful Response
 */
export const zListEventEmailTemplatesResponse = z.array(zEmailTemplateResponse);

export const zCreateEventEmailTemplateBody = zEventEmailTemplateCreatePayload;

export const zCreateEventEmailTemplatePath = z.object({
    event_uuid: z.string().uuid()
});

/**
 * Successful Response
 */
export const zCreateEventEmailTemplateResponse = zEmailTemplateResponse;

export const zDeleteEventEmailTemplatePath = z.object({
    event_uuid: z.string().uuid(),
    template_uuid: z.string().uuid()
});

/**
 * Successful Response
 */
export const zDeleteEventEmailTemplateResponse = z.void();

export const zUpdateEventEmailTemplateBody = zEventEmailTemplateUpdatePayload;

export const zUpdateEventEmailTemplatePath = z.object({
    event_uuid: z.string().uuid(),
    template_uuid: z.string().uuid()
});

/**
 * Successful Response
 */
export const zUpdateEventEmailTemplateResponse = zEmailTemplateResponse;

export const zPreviewEventEmailBody = zEventEmailPreviewPayload;

export const zPreviewEventEmailPath = z.object({
    event_uuid: z.string().uuid()
});

/**
 * Successful Response
 */
export const zPreviewEventEmailResponse = zQueuedMessageResponse;

export const zPostPotentialGuestsBody = zPotentialGuestsSearchPayload.default({
    page: 1,
    page_size: -1,
    include_inactive: false,
    include_total: true,
    include_aggregations: false,
    include_results: true
});

/**
 * Successful Response
 */
export const zPostPotentialGuestsResponse = zPotentialGuestsSearchResponse;

export const zPostPotentialGuestsSelectionBody = zPotentialGuestsEmailsPayload;

/**
 * Successful Response
 */
export const zPostPotentialGuestsSelectionResponse = zPotentialGuestsEmailsResponse;

export const zGetEventsQuery = z.object({
    draft: z.boolean().nullish(),
    event_date_after: z.string().datetime().nullish(),
    event_date_before: z.string().datetime().nullish(),
    sort_event_date: z.enum(['asc', 'desc']).optional().default('desc'),
    phrase: z.string().nullish(),
    page: z.number().int().gte(1).optional().default(1),
    size: z.number().int().gte(1).lte(1000).optional().default(10)
});

/**
 * Successful Response
 */
export const zGetEventsResponse = zPageEventResponse;

export const zPostEventBody = zEventCreatePayload;

/**
 * Successful Response
 */
export const zPostEventResponse = zEventResponse;

export const zGetAllEventGuestsQuery = z.object({
    page: z.number().int().gte(1).optional().default(1),
    size: z.number().int().gte(1).lte(1000).optional().default(10)
});

/**
 * Successful Response
 */
export const zGetAllEventGuestsResponse = zPageEventGuestWithEventItemResponse;

export const zGetEventRsvpLandingQuery = z.object({
    token: z.string()
});

/**
 * Successful Response
 */
export const zGetEventRsvpLandingResponse = zEventRsvpLandingResponse;

export const zPatchEventRsvpBody = zRsvpUpdatePayload;

/**
 * Successful Response
 */
export const zPatchEventRsvpResponse = z.void();

export const zGetEventRsvpLandingImageQuery = z.object({
    token: z.string()
});

export const zGetEventRsvpPreviewPath = z.object({
    event_uuid: z.string().uuid()
});

/**
 * Successful Response
 */
export const zGetEventRsvpPreviewResponse = zEventRsvpLandingResponse;

export const zPostEventRsvpPreviewBody = zRsvpPreviewPayload;

export const zPostEventRsvpPreviewPath = z.object({
    event_uuid: z.string().uuid()
});

/**
 * Successful Response
 */
export const zPostEventRsvpPreviewResponse = z.void();

export const zDeleteEventPath = z.object({
    event_uuid: z.string().uuid()
});

/**
 * Successful Response
 */
export const zDeleteEventResponse = z.void();

export const zGetEventPath = z.object({
    event_uuid: z.string().uuid()
});

/**
 * Successful Response
 */
export const zGetEventResponse = zEventResponse;

export const zPatchEventBody = zEventUpdatePayload;

export const zPatchEventPath = z.object({
    event_uuid: z.string().uuid()
});

/**
 * Successful Response
 */
export const zPatchEventResponse = zEventResponse;

export const zGetEventLandingImagePublicPath = z.object({
    event_uuid: z.string().uuid()
});

export const zDeleteEventLandingImagePath = z.object({
    event_uuid: z.string().uuid()
});

/**
 * Successful Response
 */
export const zDeleteEventLandingImageResponse = z.void();

export const zPostEventLandingImageBody = zBodyPostEventLandingImage;

export const zPostEventLandingImagePath = z.object({
    event_uuid: z.string().uuid()
});

/**
 * Successful Response
 */
export const zPostEventLandingImageResponse = zImageUploadResponse;

export const zPostEventInviteSendBody = zSendInvitePayload;

export const zPostEventInviteSendPath = z.object({
    event_uuid: z.string().uuid()
});

/**
 * Successful Response
 */
export const zPostEventInviteSendResponse = zQueuedMessageResponse;

export const zPostEventInvitePreviewBody = zInvitePreviewPayload;

export const zPostEventInvitePreviewPath = z.object({
    event_uuid: z.string().uuid()
});

/**
 * Successful Response
 */
export const zPostEventInvitePreviewResponse = zQueuedMessageResponse;

export const zPostEventReminderPreviewBody = zReminderPreviewPayload;

export const zPostEventReminderPreviewPath = z.object({
    event_uuid: z.string().uuid()
});

/**
 * Successful Response
 */
export const zPostEventReminderPreviewResponse = zQueuedMessageResponse;

export const zPostEventReminderSendBody = zSendReminderPayload;

export const zPostEventReminderSendPath = z.object({
    event_uuid: z.string().uuid()
});

/**
 * Successful Response
 */
export const zPostEventReminderSendResponse = zQueuedMessageResponse;

export const zPostEventAnnouncementSendBody = zSendAnnouncementPayload;

export const zPostEventAnnouncementSendPath = z.object({
    event_uuid: z.string().uuid()
});

/**
 * Successful Response
 */
export const zPostEventAnnouncementSendResponse = zQueuedMessageResponse;

export const zGetEventEmailEventsPath = z.object({
    event_uuid: z.string().uuid()
});

export const zGetEventEmailEventsQuery = z.object({
    page: z.number().int().gte(1).optional().default(1),
    size: z.number().int().gte(1).lte(1000).optional().default(10),
    to_identity_uuid: z.string().uuid().nullish(),
    batch_uuid: z.string().uuid().nullish(),
    email_event_type: z.array(zEmailEventType).nullish(),
    sendgrid_event: z.array(zSendGridEmailEvent).nullish()
});

/**
 * Successful Response
 */
export const zGetEventEmailEventsResponse = zPageEventEmailEventItemResponse;

export const zGetEventEmailBatchesPath = z.object({
    event_uuid: z.string().uuid()
});

export const zGetEventEmailBatchesQuery = z.object({
    page: z.number().int().gte(1).optional().default(1),
    size: z.number().int().gte(1).lte(1000).optional().default(10),
    to_identity_uuid: z.string().uuid().nullish(),
    batch_uuid: z.string().uuid().nullish(),
    email_event_type: z.array(zEmailEventType).nullish(),
    sendgrid_event: z.array(zSendGridEmailEvent).nullish()
});

/**
 * Successful Response
 */
export const zGetEventEmailBatchesResponse = zPageEventEmailBatchResponse;

export const zGetEventGuestsPath = z.object({
    event_uuid: z.string().uuid()
});

export const zGetEventGuestsQuery = z.object({
    status: zEventGuestStatus.nullish(),
    client_type: z.array(zEventGuestClientType).nullish(),
    phrase: z.string().nullish(),
    sort: zEventGuestsSortColumn.nullish(),
    order: zSortDirection.optional().default('asc'),
    page: z.number().int().gte(1).optional().default(1),
    size: z.number().int().gte(1).lte(1000).optional().default(10)
});

/**
 * Successful Response
 */
export const zGetEventGuestsResponse = zEventGuestsPageEventGuestItemResponse;

export const zPatchEventGuestsBody = zEventGuestsBulkStatusPayload;

export const zPatchEventGuestsPath = z.object({
    event_uuid: z.string().uuid()
});

/**
 * Successful Response
 */
export const zPatchEventGuestsResponse = z.void();

export const zPostEventGuestsBody = zAddGuestsPayload;

export const zPostEventGuestsPath = z.object({
    event_uuid: z.string().uuid()
});

/**
 * Successful Response
 */
export const zPostEventGuestsResponse = zAddGuestsResponse;

export const zPostEventGuestsSelectionBody = zEventGuestsSelectionPayload;

export const zPostEventGuestsSelectionPath = z.object({
    event_uuid: z.string().uuid()
});

/**
 * Successful Response
 */
export const zPostEventGuestsSelectionResponse = zEventGuestsSelectionResponse;

export const zDeleteEventGuestPath = z.object({
    event_uuid: z.string().uuid(),
    guest_uuid: z.string().uuid()
});

/**
 * Successful Response
 */
export const zDeleteEventGuestResponse = z.void();

export const zPatchEventGuestBody = zEventGuestPatchPayload;

export const zPatchEventGuestPath = z.object({
    event_uuid: z.string().uuid(),
    guest_uuid: z.string().uuid()
});

/**
 * Successful Response
 */
export const zPatchEventGuestResponse = zEventGuestItemResponse;

export const zPostTeamMembersV2Body = zTeamMembersPost;

export const zPostTeamMembersV2Path = z.object({
    team_slug: z.string()
});

export const zPostTeamMembersBulkV2Body = zTeamMembersBulkInvitePayload;

export const zPostTeamMembersBulkV2Path = z.object({
    team_slug: z.string()
});

export const zGetTeamIntroInsightPath = z.object({
    team_uuid: z.union([
        z.string().uuid(),
        z.string()
    ])
});

/**
 * Successful Response
 */
export const zGetTeamIntroInsightResponse = zTeamIntroInsight;

export const zPostSubmissionsBody = zSubmissionV3Payload;

/**
 * Successful Response
 */
export const zPostSubmissionsResponse = zSubmissionV3InternalResponse;

export const zPostSubmissionEmailPreviewBody = zSubmissionV3Payload;

export const zPostSubmissionEmailPreviewQuery = z.object({
    team_uuid: z.string().uuid().nullish()
});

/**
 * Successful Response
 */
export const zPostSubmissionEmailPreviewResponse = z.string();

/**
 * Successful Response
 */
export const zGetTrendingMessageKeysResponse = zTrendingMessageKeysResponse;

export const zGetTrendingMessagesQuery = z.object({
    candidate_uuid: z.string().uuid()
});

/**
 * Response Get Trending Messages
 *
 * Successful Response
 */
export const zGetTrendingMessagesResponse = z.array(zTrendingMessageResponse);

export const zPostSubmissionCancelRecommendationsPath = z.object({
    submission_uuid: z.string()
});

/**
 * Successful Response
 */
export const zPostSubmissionCancelRecommendationsResponse = zSubmissionV3InternalResponse;

export const zDeleteSubmissionPath = z.object({
    submission_uuid: z.string()
});

/**
 * Successful Response
 */
export const zDeleteSubmissionResponse = zSubmissionV3InternalResponse;

export const zGetSubmissionPath = z.object({
    submission_uuid: z.string()
});

/**
 * Successful Response
 */
export const zGetSubmissionResponse = zSubmissionV3InternalEmailStatsResponse;

export const zPutSubmissionBody = zSubmissionV3Payload;

export const zPutSubmissionPath = z.object({
    submission_uuid: z.string()
});

/**
 * Successful Response
 */
export const zPutSubmissionResponse = zSubmissionV3InternalResponse;

export const zPutSubmissionStatusBody = zSubmissionStatusPayload;

export const zPutSubmissionStatusPath = z.object({
    submission_uuid: z.string()
});

/**
 * Successful Response
 */
export const zPutSubmissionStatusResponse = zSubmissionV3InternalResponse;

export const zPostTeamCandidatesFilterV3Body = zTeamCandidatesFilterPayloadV3;

export const zPostTeamCandidatesFilterV3Path = z.object({
    team_uuid: z.union([
        z.string().uuid(),
        z.string()
    ])
});

/**
 * Successful Response
 */
export const zPostTeamCandidatesFilterV3Response = zTeamCandidatesFilterResponse;
